{
  "selection": [
    {
      "order": 3463,
      "name": "credit-card-virtual"
    },
    {
      "order": 3462,
      "name": "cancel-stop-payment"
    },
    {
      "order": 3461,
      "name": "stop-payment"
    },
    {
      "order": 3460,
      "name": "ai-insight-recommend"
    },
    {
      "order": 3459,
      "name": "Desktop-Edit-brand-theme"
    },
    {
      "order": 3458,
      "name": "user-multiple-new"
    },
    {
      "order": 3457,
      "name": "Data-Transfer-Refresh"
    },
    {
      "order": 3062,
      "name": "round-corners-radius"
    },
    {
      "order": 3063,
      "name": "Power-Cable--SIcons_Mix"
    },
    {
      "order": 3064,
      "name": "Smartphone-Action-Money-Fund"
    },
    {
      "order": 3065,
      "name": "Atm-Socket-Money-Withdraw"
    },
    {
      "order": 3066,
      "name": "cursor-focus-target-zoom-highlight"
    },
    {
      "order": 3067,
      "name": "credit-card"
    },
    {
      "order": 3068,
      "name": "edit-Arrow"
    },
    {
      "order": 3069,
      "name": "password-settings"
    },
    {
      "order": 3070,
      "name": "shield-Check"
    },
    {
      "order": 3071,
      "name": "document-video-file"
    },
    {
      "order": 3072,
      "name": "document-video-upload"
    },
    {
      "order": 3073,
      "name": "common-file---files-&-folders"
    },
    {
      "order": 3074,
      "name": "common-file-text---files-&-folders"
    },
    {
      "order": 3075,
      "name": "document-image-file"
    },
    {
      "order": 3076,
      "name": "document-audio-music"
    },
    {
      "order": 3077,
      "name": "document-file-upload"
    },
    {
      "order": 3078,
      "name": "document-image-upload"
    },
    {
      "order": 3079,
      "name": "document-text-upload"
    },
    {
      "order": 3080,
      "name": "phone-forward-arrow"
    },
    {
      "order": 3081,
      "name": "document-audio-music-upload"
    },
    {
      "order": 3082,
      "name": "document-folder-list"
    },
    {
      "order": 3083,
      "name": "hourglass-loading-clock-time-pending"
    },
    {
      "order": 3084,
      "name": "user-contact"
    },
    {
      "order": 3085,
      "name": "calendar-interface-edit-date"
    },
    {
      "order": 3086,
      "name": "Icons_loader"
    },
    {
      "order": 3087,
      "name": "Changed"
    },
    {
      "order": 3088,
      "name": "Created"
    },
    {
      "order": 3089,
      "name": "Decreased"
    },
    {
      "order": 3090,
      "name": "Disabled"
    },
    {
      "order": 3091,
      "name": "Enabled"
    },
    {
      "order": 3092,
      "name": "Increased"
    },
    {
      "order": 3093,
      "name": "delivery-truck"
    },
    {
      "order": 3094,
      "name": "delivery-truck"
    },
    {
      "order": 3095,
      "name": "flash-enable-allow-2--interface-essential 3"
    },
    {
      "order": 3096,
      "name": "Return"
    },
    {
      "order": 3097,
      "name": "email-clock"
    },
    {
      "order": 3098,
      "name": "Astra"
    },
    {
      "order": 3099,
      "name": "Plaid"
    },
    {
      "order": 3100,
      "name": "Linked-accounts"
    },
    {
      "order": 3101,
      "name": "award-flag-rewards-rating-filled"
    },
    {
      "order": 3102,
      "name": "award-flag-10-rewards-rating"
    },
    {
      "order": 3103,
      "name": "award-flag-rewards-rating"
    },
    {
      "order": 3104,
      "name": "Analytic Percentage--double"
    },
    {
      "order": 3105,
      "name": "Analytic Percentage"
    },
    {
      "order": 3106,
      "name": "Graph Stats Ascend"
    },
    {
      "order": 3107,
      "name": "Percentage Decrease"
    },
    {
      "order": 3108,
      "name": "Percentage Increase"
    },
    {
      "order": 3109,
      "name": "credit-account"
    },
    {
      "order": 3110,
      "name": "graph-analytics"
    },
    {
      "order": 3111,
      "name": "view-enable-allow-2-interface-essential-24"
    },
    {
      "order": 3112,
      "name": "view-off-disable-interface-essential-24"
    },
    {
      "order": 3113,
      "name": "down-arrow-filter-chevron-small"
    },
    {
      "order": 3114,
      "name": "down-arrow-filter-sort"
    },
    {
      "order": 3115,
      "name": "up-arrow-filter-chevron-small"
    },
    {
      "order": 3116,
      "name": "up-arrow-filter-sort"
    },
    {
      "order": 3117,
      "name": "add-plus-small"
    },
    {
      "order": 3118,
      "name": "add-plus"
    },
    {
      "order": 3119,
      "name": "approve-v-check-validation"
    },
    {
      "order": 3120,
      "name": "arrow-down-chevron"
    },
    {
      "order": 3121,
      "name": "arrow-left-chevron"
    },
    {
      "order": 3122,
      "name": "arrow-right-chevron"
    },
    {
      "order": 3123,
      "name": "arrow-up-chevron"
    },
    {
      "order": 3124,
      "name": "delete-close-x-circle"
    },
    {
      "order": 3125,
      "name": "delete-close-x-small"
    },
    {
      "order": 3126,
      "name": "delete-close-x"
    },
    {
      "order": 3127,
      "name": "menu-horizontal-dots"
    },
    {
      "order": 3128,
      "name": "menu-vertical-dots"
    },
    {
      "order": 3129,
      "name": "payment-box-reserve"
    },
    {
      "order": 3130,
      "name": "money-recurring-payment"
    },
    {
      "order": 3131,
      "name": "Plaid_logo"
    },
    {
      "order": 3132,
      "name": "page-coding-3"
    },
    {
      "order": 3133,
      "name": "code-simple"
    },
    {
      "order": 3134,
      "name": "dashboard-displa-data"
    },
    {
      "order": 3135,
      "name": "icon-page-coding"
    },
    {
      "order": 3136,
      "name": "programming-code-terminal-2"
    },
    {
      "order": 3137,
      "name": "programming-code-terminal"
    },
    {
      "order": 3138,
      "name": "payment-box-incoming"
    },
    {
      "order": 3139,
      "name": "paginate-filter-document-copy"
    },
    {
      "order": 3140,
      "name": "cursor-double-click"
    },
    {
      "order": 3141,
      "name": "employment-employee-idea-brainstorm"
    },
    {
      "order": 3142,
      "name": "video-call-monitor"
    },
    {
      "order": 3143,
      "name": "target-goal"
    },
    {
      "order": 3144,
      "name": "business-target-check-approve"
    },
    {
      "order": 3145,
      "name": "flash-enable-allow-1--full"
    },
    {
      "order": 3146,
      "name": "file-code-download"
    },
    {
      "order": 3147,
      "name": "file-download"
    },
    {
      "order": 3148,
      "name": "down-arrow"
    },
    {
      "order": 3149,
      "name": "left-arrow"
    },
    {
      "order": 3150,
      "name": "right-arrow",
      "prevSize": 32
    },
    {
      "order": 3151,
      "name": "trend-up",
      "prevSize": 32
    },
    {
      "order": 3152,
      "name": "trend-down",
      "prevSize": 32
    },
    {
      "order": 3153,
      "name": "up-arrow"
    },
    {
      "order": 3154,
      "name": "interface-delete-interface-essential"
    },
    {
      "order": 3155,
      "name": "user-hierachy2"
    },
    {
      "order": 3156,
      "name": "move-snap-down--interface-essential"
    },
    {
      "order": 3157,
      "name": "money-security"
    },
    {
      "order": 3158,
      "name": "payment-hand-coin"
    },
    {
      "order": 3159,
      "name": "toolbox"
    },
    {
      "order": 3160,
      "name": "document-list-edi"
    },
    {
      "order": 3161,
      "name": "shield-lock"
    },
    {
      "order": 3162,
      "name": "Sort-down"
    },
    {
      "order": 3163,
      "name": "Sort-none"
    },
    {
      "order": 3164,
      "name": "Sort-up"
    },
    {
      "order": 3165,
      "name": "icon-keyboard-down-arrow"
    },
    {
      "order": 3166,
      "name": "icon-keyboard-up-arrow"
    },
    {
      "order": 3167,
      "name": "streamline-icon-navigation-arrows-right-2@20x20 (1)"
    },
    {
      "order": 3168,
      "name": "credit-card-unlock"
    },
    {
      "order": 3169,
      "name": "credit-card-add"
    },
    {
      "order": 3170,
      "name": "credit-card-clock"
    },
    {
      "order": 3171,
      "name": "credit-card-lock-1"
    },
    {
      "order": 3172,
      "name": "credit-card-lock"
    },
    {
      "order": 3173,
      "name": "credit-card-remove-cross"
    },
    {
      "order": 3174,
      "name": "credit-card-restrict"
    },
    {
      "order": 3175,
      "name": "credit-card-return"
    },
    {
      "order": 3176,
      "name": "payment-coin"
    },
    {
      "order": 3177,
      "name": "navigation-right-3"
    },
    {
      "order": 3178,
      "name": "file-code-download",
      "prevSize": 32
    },
    {
      "order": 3179,
      "name": "file-download",
      "prevSize": 32
    },
    {
      "order": 3180,
      "name": "bank",
      "prevSize": 32
    },
    {
      "order": 3181,
      "name": "common-files",
      "prevSize": 32
    },
    {
      "order": 3182,
      "name": "doc-layer-copy",
      "prevSize": 32
    },
    {
      "order": 3183,
      "name": "expand-diagonal",
      "prevSize": 32
    },
    {
      "order": 3184,
      "name": "file-code-download"
    },
    {
      "order": 3185,
      "name": "file-download"
    },
    {
      "order": 3186,
      "name": "hierarchy-square-4",
      "prevSize": 32
    },
    {
      "order": 3187,
      "name": "interface-add-1",
      "prevSize": 32
    },
    {
      "order": 3188,
      "name": "layer-select-front",
      "prevSize": 32
    },
    {
      "order": 3189,
      "name": "layer-select",
      "prevSize": 32
    },
    {
      "order": 3190,
      "name": "list-bullet-point-square1",
      "prevSize": 32
    },
    {
      "order": 3191,
      "name": "money-fund-move-found--business-products",
      "prevSize": 32
    },
    {
      "order": 3192,
      "name": "paginate-filter-document",
      "prevSize": 32
    },
    {
      "order": 3193,
      "name": "programming-code--programing-apps-websites",
      "prevSize": 32
    },
    {
      "order": 3194,
      "name": "shrink-diagonal",
      "prevSize": 32
    },
    {
      "order": 3195,
      "name": "zigzag-split-arrow",
      "prevSize": 32
    },
    {
      "order": 3196,
      "name": "account-credit-card-replace",
      "prevSize": 32
    },
    {
      "order": 3197,
      "name": "design-tool-rotate-clockwise",
      "prevSize": 32
    },
    {
      "order": 3198,
      "name": "file-code-lock",
      "prevSize": 32
    },
    {
      "order": 3199,
      "name": "security-password-check",
      "prevSize": 32
    },
    {
      "order": 3200,
      "name": "shield-lock",
      "prevSize": 32
    },
    {
      "order": 3201,
      "name": "streamline-icon-settings-cog-120x20-1",
      "prevSize": 32
    },
    {
      "order": 3202,
      "name": "user-geometric-action-check-approve",
      "prevSize": 32
    },
    {
      "order": 3203,
      "name": "user-geometric-action-cross-remove",
      "prevSize": 32
    },
    {
      "order": 3204,
      "name": "zoom-in",
      "prevSize": 32
    },
    {
      "order": 3205,
      "name": "zoom-out",
      "prevSize": 32
    },
    {
      "order": 3206,
      "name": "account-credit-card-mobile-smartphone-wiring--business-products",
      "prevSize": 32
    },
    {
      "order": 3207,
      "name": "account-mobile-payment-wiring--business-products",
      "prevSize": 32
    },
    {
      "order": 3208,
      "name": "account-setting-optimization",
      "prevSize": 32
    },
    {
      "order": 3209,
      "name": "alert-circle--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3210,
      "name": "alert-daimond--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3211,
      "name": "alert-triangle--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3212,
      "name": "analytic-currency--business-products",
      "prevSize": 32
    },
    {
      "order": 3213,
      "name": "analytic-percentage--business-products",
      "prevSize": 32
    },
    {
      "order": 3214,
      "name": "archive-locker--content",
      "prevSize": 32
    },
    {
      "order": 3215,
      "name": "astronomy-rocket-1--school-science",
      "prevSize": 32
    },
    {
      "order": 3216,
      "name": "award-badge-certification--rewards-rating",
      "prevSize": 32
    },
    {
      "order": 3217,
      "name": "award-banner-check--rewards-rating",
      "prevSize": 32
    },
    {
      "order": 3218,
      "name": "bank-account--business-products",
      "prevSize": 32
    },
    {
      "order": 3219,
      "name": "bank-branch-client",
      "prevSize": 32
    },
    {
      "order": 3220,
      "name": "bell-notification--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3221,
      "name": "bell-notification-snooze-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3222,
      "name": "billing-account--business-products",
      "prevSize": 32
    },
    {
      "order": 3223,
      "name": "billing-check--business-products",
      "prevSize": 32
    },
    {
      "order": 3224,
      "name": "billing-warning--business-products",
      "prevSize": 32
    },
    {
      "order": 3225,
      "name": "bin-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3226,
      "name": "blob-brush--design",
      "prevSize": 32
    },
    {
      "order": 3227,
      "name": "boardcasting-wifi-signal--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3228,
      "name": "book-open-1",
      "prevSize": 32
    },
    {
      "order": 3229,
      "name": "book-open-bookmark",
      "prevSize": 32
    },
    {
      "order": 3230,
      "name": "book-open",
      "prevSize": 32
    },
    {
      "order": 3231,
      "name": "bookmark-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3232,
      "name": "business-anouncement-podium--business-products",
      "prevSize": 32
    },
    {
      "order": 3233,
      "name": "business-email-promotion--business-products",
      "prevSize": 32
    },
    {
      "order": 3234,
      "name": "business-startup--business-products",
      "prevSize": 32
    },
    {
      "order": 3235,
      "name": "business-target-goal-mountain--business-products",
      "prevSize": 32
    },
    {
      "order": 3236,
      "name": "calendar-2--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3237,
      "name": "camera--images-videos",
      "prevSize": 32
    },
    {
      "order": 3238,
      "name": "camera-refresh-flip--images-videos",
      "prevSize": 32
    },
    {
      "order": 3239,
      "name": "check-shield--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3240,
      "name": "check-write--business-products-1",
      "prevSize": 32
    },
    {
      "order": 3241,
      "name": "check-write--business-products",
      "prevSize": 32
    },
    {
      "order": 3242,
      "name": "checklist-pen--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3243,
      "name": "clock--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3244,
      "name": "clock-cycle-twenty-four-hour--business-products",
      "prevSize": 32
    },
    {
      "order": 3245,
      "name": "coin-bank-note--business-products-1",
      "prevSize": 32
    },
    {
      "order": 3246,
      "name": "coin-bank-note--business-products",
      "prevSize": 32
    },
    {
      "order": 3247,
      "name": "coins-dollar--business-products",
      "prevSize": 32
    },
    {
      "order": 3248,
      "name": "common-file-add---files--folders",
      "prevSize": 32
    },
    {
      "order": 3249,
      "name": "common-file-check---files--folders",
      "prevSize": 32
    },
    {
      "order": 3250,
      "name": "common-file-download---files--folders",
      "prevSize": 32
    },
    {
      "order": 3251,
      "name": "common-file-horizontal-codes---files--folders",
      "prevSize": 32
    },
    {
      "order": 3252,
      "name": "common-file-horizontal-images---files--folders",
      "prevSize": 32
    },
    {
      "order": 3253,
      "name": "common-file-lock---files--folders",
      "prevSize": 32
    },
    {
      "order": 3254,
      "name": "common-file-money-fund---files--folders-1",
      "prevSize": 32
    },
    {
      "order": 3255,
      "name": "common-file-money-fund---files--folders",
      "prevSize": 32
    },
    {
      "order": 3256,
      "name": "common-file-refresh---files--folders",
      "prevSize": 32
    },
    {
      "order": 3257,
      "name": "common-file-upload---files--folders",
      "prevSize": 32
    },
    {
      "order": 3258,
      "name": "common-file-warning---files--folders",
      "prevSize": 32
    },
    {
      "order": 3259,
      "name": "common-files---files--folders",
      "prevSize": 32
    },
    {
      "order": 3260,
      "name": "conversation-chat-bubble--messages-chat",
      "prevSize": 32
    },
    {
      "order": 3261,
      "name": "credit-card-check-approved--business-products",
      "prevSize": 32
    },
    {
      "order": 3262,
      "name": "credit-card-download--business-products",
      "prevSize": 32
    },
    {
      "order": 3263,
      "name": "credit-card-edit--business-products",
      "prevSize": 32
    },
    {
      "order": 3264,
      "name": "credit-card-information--business-products",
      "prevSize": 32
    },
    {
      "order": 3265,
      "name": "credit-card-lock--business-products",
      "prevSize": 32
    },
    {
      "order": 3266,
      "name": "credit-card-money-fund--business-products-1",
      "prevSize": 32
    },
    {
      "order": 3267,
      "name": "credit-card-money-fund--business-products-2",
      "prevSize": 32
    },
    {
      "order": 3268,
      "name": "credit-card-money-fund--business-products",
      "prevSize": 32
    },
    {
      "order": 3269,
      "name": "credit-card-search--business-products",
      "prevSize": 32
    },
    {
      "order": 3270,
      "name": "credit-card-setting",
      "prevSize": 32
    },
    {
      "order": 3271,
      "name": "currency-exchange--business-products",
      "prevSize": 32
    },
    {
      "order": 3272,
      "name": "currency-exchange-booth----business-products",
      "prevSize": 32
    },
    {
      "order": 3273,
      "name": "currency-usd-dollar--business-products",
      "prevSize": 32
    },
    {
      "order": 3274,
      "name": "cypto-currency-exchange-rate--business-products",
      "prevSize": 32
    },
    {
      "order": 3275,
      "name": "dashboard-speed-guage--transportation",
      "prevSize": 32
    },
    {
      "order": 3276,
      "name": "design-file-ai--design",
      "prevSize": 32
    },
    {
      "order": 3277,
      "name": "design-file-text-image--design",
      "prevSize": 32
    },
    {
      "order": 3278,
      "name": "dialpad--business-products",
      "prevSize": 32
    },
    {
      "order": 3279,
      "name": "disable-delete--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3280,
      "name": "dislike--rewards-rating",
      "prevSize": 32
    },
    {
      "order": 3281,
      "name": "document-list-edit--work-office",
      "prevSize": 32
    },
    {
      "order": 3282,
      "name": "document-list-quill--work-office",
      "prevSize": 32
    },
    {
      "order": 3283,
      "name": "document-paragraph-text--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3284,
      "name": "document-paragraph-text-image-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3285,
      "name": "document-stamp-approvement--work-office",
      "prevSize": 32
    },
    {
      "order": 3286,
      "name": "earning-per-page--business-products",
      "prevSize": 32
    },
    {
      "order": 3287,
      "name": "electronics-resistor--computers-devices-electronics",
      "prevSize": 32
    },
    {
      "order": 3288,
      "name": "email-envelope-1--emails",
      "prevSize": 32
    },
    {
      "order": 3289,
      "name": "email-envelopes--emails",
      "prevSize": 32
    },
    {
      "order": 3290,
      "name": "email-image--emails",
      "prevSize": 32
    },
    {
      "order": 3291,
      "name": "email-inbox-audio-music--emails",
      "prevSize": 32
    },
    {
      "order": 3292,
      "name": "email-inbox-home--emails",
      "prevSize": 32,
      "codes": [
        59762,
        59763,
        59764
      ]
    },
    {
      "order": 3293,
      "name": "email-inbox-image--emails",
      "prevSize": 32
    },
    {
      "order": 3294,
      "name": "email-inbox-money-fund--emails",
      "prevSize": 32
    },
    {
      "order": 3295,
      "name": "email-inbox-read--emails",
      "prevSize": 32
    },
    {
      "order": 3296,
      "name": "email-inbox-recieve--emails",
      "prevSize": 32
    },
    {
      "order": 3297,
      "name": "email-inbox-send--emails",
      "prevSize": 32
    },
    {
      "order": 3298,
      "name": "email-read--emails",
      "prevSize": 32
    },
    {
      "order": 3299,
      "name": "email-recieve--emails",
      "prevSize": 32
    },
    {
      "order": 3300,
      "name": "email-recieve-box--emails",
      "prevSize": 32
    },
    {
      "order": 3301,
      "name": "email-refresh-sync--emails",
      "prevSize": 32
    },
    {
      "order": 3302,
      "name": "email-reply-1--emails",
      "prevSize": 32
    },
    {
      "order": 3303,
      "name": "email-search-1--emails",
      "prevSize": 32
    },
    {
      "order": 3304,
      "name": "email-send-1--emails",
      "prevSize": 32
    },
    {
      "order": 3305,
      "name": "email-send-2--emails",
      "prevSize": 32
    },
    {
      "order": 3306,
      "name": "email-send-3--emails",
      "prevSize": 32
    },
    {
      "order": 3307,
      "name": "email-send-envelope--emails",
      "prevSize": 32
    },
    {
      "order": 3308,
      "name": "email-send",
      "prevSize": 32
    },
    {
      "order": 3309,
      "name": "email-share--emails",
      "prevSize": 32
    },
    {
      "order": 3310,
      "name": "email-sync-refresh--emails",
      "prevSize": 32
    },
    {
      "order": 3311,
      "name": "employment-employee-idea--work-office",
      "prevSize": 32
    },
    {
      "order": 3312,
      "name": "employment-employee-idea-brainstorm--work-office",
      "prevSize": 32
    },
    {
      "order": 3313,
      "name": "employment-employee-previous--work-office",
      "prevSize": 32
    },
    {
      "order": 3314,
      "name": "employment-recuit-search--work-office",
      "prevSize": 32
    },
    {
      "order": 3315,
      "name": "expand-diagonal-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3316,
      "name": "expand-diagonal-2--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3317,
      "name": "expand-diagonal-4--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3318,
      "name": "expand-vertical-7--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3319,
      "name": "face-id-user--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3320,
      "name": "fast-payment--business-products-1",
      "prevSize": 32
    },
    {
      "order": 3321,
      "name": "fast-payment--business-products",
      "prevSize": 32
    },
    {
      "order": 3322,
      "name": "file-apk--programing-apps-websites",
      "prevSize": 32
    },
    {
      "order": 3323,
      "name": "file-code--programing-apps-websites",
      "prevSize": 32
    },
    {
      "order": 3324,
      "name": "filter-3--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3325,
      "name": "flash-enable-allow-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3326,
      "name": "flash-enable-allow-2--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3327,
      "name": "flowchart",
      "prevSize": 32
    },
    {
      "order": 3328,
      "name": "folder-money-fund---files--folders",
      "prevSize": 32
    },
    {
      "order": 3329,
      "name": "global-exchange-rate-transaction-2--business-products",
      "prevSize": 32
    },
    {
      "order": 3330,
      "name": "globe-1--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3331,
      "name": "globe-wireframe--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3332,
      "name": "hierarchy-circle-triangle",
      "prevSize": 32
    },
    {
      "order": 3333,
      "name": "hierarchy-square",
      "prevSize": 32
    },
    {
      "order": 3334,
      "name": "home-button",
      "prevSize": 32
    },
    {
      "order": 3335,
      "name": "hyperlink-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3336,
      "name": "hyperlink-2--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3337,
      "name": "icon-settings-slider-horizontal",
      "prevSize": 32
    },
    {
      "order": 3338,
      "name": "information-circle--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3339,
      "name": "interface-arrows-button-down--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3340,
      "name": "interface-arrows-button-left--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3341,
      "name": "interface-arrows-button-right--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3342,
      "name": "interface-arrows-button-up--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3343,
      "name": "interface-delete-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3344,
      "name": "interface-validation-check--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3345,
      "name": "investment-agreement-document--business-products",
      "prevSize": 32
    },
    {
      "order": 3346,
      "name": "investment-location-area-circle--business-products",
      "prevSize": 32
    },
    {
      "order": 3347,
      "name": "keyboard-left-arrow--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3348,
      "name": "keyboard-right-arrow--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3349,
      "name": "law-hammer--business-products",
      "prevSize": 32
    },
    {
      "order": 3350,
      "name": "layers--design",
      "prevSize": 32
    },
    {
      "order": 3351,
      "name": "layout-thumbnail",
      "prevSize": 32
    },
    {
      "order": 3352,
      "name": "like--rewards-rating",
      "prevSize": 32
    },
    {
      "order": 3353,
      "name": "list-bullet-point-square",
      "prevSize": 32
    },
    {
      "order": 3354,
      "name": "lock-square-circle--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3355,
      "name": "lock-square-lock-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3356,
      "name": "lock-square-unlock-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3357,
      "name": "magnifier--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3358,
      "name": "man-business---users",
      "prevSize": 32
    },
    {
      "order": 3359,
      "name": "man-business-man---users",
      "prevSize": 32
    },
    {
      "order": 3360,
      "name": "man-business-suitcase---users",
      "prevSize": 32
    },
    {
      "order": 3361,
      "name": "map-pin-home--maps-navigation-1",
      "prevSize": 32
    },
    {
      "order": 3362,
      "name": "map-pin-home--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3363,
      "name": "map-pin-information--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3364,
      "name": "maps-flag--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3365,
      "name": "maps-location-pin--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3366,
      "name": "maps-location-pin-3--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3367,
      "name": "maps-pin--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3368,
      "name": "maps-your-location-pin--maps-navigation",
      "prevSize": 32
    },
    {
      "order": 3369,
      "name": "maximize-square-2--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3370,
      "name": "maximize-square-4--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3371,
      "name": "medical-doctor-diagnostic--health-beauty",
      "prevSize": 32
    },
    {
      "order": 3372,
      "name": "megaphone-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3373,
      "name": "megaphone-2--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3374,
      "name": "messages-people-man-bubble-square--messages-chat",
      "prevSize": 32
    },
    {
      "order": 3375,
      "name": "mobile-payment_1--business-products",
      "prevSize": 32
    },
    {
      "order": 3376,
      "name": "mobile-payment--business-products",
      "prevSize": 32
    },
    {
      "order": 3377,
      "name": "module-three--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3378,
      "name": "money-exchange-schedule-1--business-products",
      "prevSize": 32
    },
    {
      "order": 3379,
      "name": "money-fund-cycle--business-products",
      "prevSize": 32
    },
    {
      "order": 3380,
      "name": "money-fund-remove-not-found--business-products",
      "prevSize": 32
    },
    {
      "order": 3381,
      "name": "money-note-1--business-products",
      "prevSize": 32
    },
    {
      "order": 3382,
      "name": "money-note-2--business-products",
      "prevSize": 32
    },
    {
      "order": 3383,
      "name": "money-transfer--business-products",
      "prevSize": 32
    },
    {
      "order": 3384,
      "name": "money-transfer-correction--business-products",
      "prevSize": 32
    },
    {
      "order": 3385,
      "name": "move-snap-top--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3386,
      "name": "move-up-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3387,
      "name": "move-up-2--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3388,
      "name": "move-up-4--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3389,
      "name": "music-player-button-pause--music-audio",
      "prevSize": 32
    },
    {
      "order": 3390,
      "name": "music-player-button-play--music-audio",
      "prevSize": 32
    },
    {
      "order": 3391,
      "name": "navigation-menu-horizontal--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3392,
      "name": "navigation-menu-vertical--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3393,
      "name": "object-ladder--furnitures-tools",
      "prevSize": 32
    },
    {
      "order": 3394,
      "name": "page-profile-account-detail--programing-apps-websites",
      "prevSize": 32
    },
    {
      "order": 3395,
      "name": "paperclip-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3396,
      "name": "pencil-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3397,
      "name": "percentage--business-products",
      "prevSize": 32
    },
    {
      "order": 3398,
      "name": "phone-money-fund-transaction--business-products",
      "prevSize": 32
    },
    {
      "order": 3399,
      "name": "phone-money-fund-transaction-1--business-products",
      "prevSize": 32
    },
    {
      "order": 3400,
      "name": "phone-receipt-register--shopping-ecommerce",
      "prevSize": 32
    },
    {
      "order": 3401,
      "name": "piggy-bank--business-products",
      "prevSize": 32
    },
    {
      "order": 3402,
      "name": "programming-book",
      "prevSize": 32
    },
    {
      "order": 3403,
      "name": "programming-flag--programing-apps-websites",
      "prevSize": 32
    },
    {
      "order": 3404,
      "name": "programming-hold-code-2--programing-apps-websites",
      "prevSize": 32
    },
    {
      "order": 3405,
      "name": "programming-language-code--programing-apps-websites",
      "prevSize": 32
    },
    {
      "order": 3406,
      "name": "question-circle",
      "prevSize": 32
    },
    {
      "order": 3407,
      "name": "radio-antenna-signal-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3408,
      "name": "radio-tower-signal-3--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3409,
      "name": "radio-tower-signal",
      "prevSize": 32
    },
    {
      "order": 3410,
      "name": "real-estate-building-5--building-construction",
      "prevSize": 32
    },
    {
      "order": 3411,
      "name": "receipt-dollar--shopping-ecommerce",
      "prevSize": 32
    },
    {
      "order": 3412,
      "name": "saving-profit-interest",
      "prevSize": 32
    },
    {
      "order": 3413,
      "name": "scale--business-products",
      "prevSize": 32
    },
    {
      "order": 3414,
      "name": "security-password-lock--programing-apps-websites",
      "prevSize": 32
    },
    {
      "order": 3415,
      "name": "settings-cog-1",
      "prevSize": 32
    },
    {
      "order": 3416,
      "name": "shape-3d-box",
      "prevSize": 32
    },
    {
      "order": 3417,
      "name": "share--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3418,
      "name": "share-box-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3419,
      "name": "shipment-product-box-edit--shopping-ecommerce",
      "prevSize": 32
    },
    {
      "order": 3420,
      "name": "shrink-horizontal-4--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3421,
      "name": "smartphone-action-money-fund--phones-mobile-devices",
      "prevSize": 32
    },
    {
      "order": 3422,
      "name": "sport-golf-hole--sports",
      "prevSize": 32
    },
    {
      "order": 3423,
      "name": "star--rewards-rating",
      "prevSize": 32
    },
    {
      "order": 3424,
      "name": "streamline-icon-email-forward20x20-1",
      "prevSize": 32
    },
    {
      "order": 3425,
      "name": "synchronize-arrow-time--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3426,
      "name": "synchronize-arrows-1--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3427,
      "name": "team-approve-disapprove--work-office",
      "prevSize": 32
    },
    {
      "order": 3428,
      "name": "temperature-snow-flake--weather",
      "prevSize": 32
    },
    {
      "order": 3429,
      "name": "text-document-money-fund---files--folders",
      "prevSize": 32
    },
    {
      "order": 3430,
      "name": "tool-box--furnitures-tools",
      "prevSize": 32
    },
    {
      "order": 3431,
      "name": "tool-screwdriver-wrench--furnitures-tools",
      "prevSize": 32
    },
    {
      "order": 3432,
      "name": "tool-wrench-hand--furnitures-tools",
      "prevSize": 32
    },
    {
      "order": 3433,
      "name": "toolbox--interface-essential",
      "prevSize": 32,
      "codes": [
        59906,
        59907,
        59908,
        59909
      ]
    },
    {
      "order": 3434,
      "name": "travel-passport-1--travel",
      "prevSize": 32
    },
    {
      "order": 3435,
      "name": "undo-arrow--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3436,
      "name": "user-cash-scale--business-products",
      "prevSize": 32
    },
    {
      "order": 3437,
      "name": "user-geometric-action---users",
      "prevSize": 32
    },
    {
      "order": 3438,
      "name": "user-geometric-action-add",
      "prevSize": 32
    },
    {
      "order": 3439,
      "name": "user-geometric-action-location---users",
      "prevSize": 32
    },
    {
      "order": 3440,
      "name": "user-geometric-action-lock---users",
      "prevSize": 32
    },
    {
      "order": 3441,
      "name": "user-geometric-action-money-fund---users",
      "prevSize": 32
    },
    {
      "order": 3442,
      "name": "user-group-chat---users",
      "prevSize": 32
    },
    {
      "order": 3443,
      "name": "user-group",
      "prevSize": 32
    },
    {
      "order": 3444,
      "name": "user-home",
      "prevSize": 32
    },
    {
      "order": 3445,
      "name": "user-id-card---users-1",
      "prevSize": 32
    },
    {
      "order": 3446,
      "name": "user-id-card---users",
      "prevSize": 32
    },
    {
      "order": 3447,
      "name": "user-id-card",
      "prevSize": 32
    },
    {
      "order": 3448,
      "name": "user-id-cards---users",
      "prevSize": 32
    },
    {
      "order": 3449,
      "name": "user-multiple",
      "prevSize": 32
    },
    {
      "order": 3450,
      "name": "wallet--business-products",
      "prevSize": 32
    },
    {
      "order": 3451,
      "name": "wayfinding-money-pass--travel",
      "prevSize": 32
    },
    {
      "order": 3452,
      "name": "weather-moon-crescent--weather",
      "prevSize": 32
    },
    {
      "order": 3453,
      "name": "weather-moon-crescent-1--weather",
      "prevSize": 32
    },
    {
      "order": 3454,
      "name": "weather-sun--weather",
      "prevSize": 32
    },
    {
      "order": 3455,
      "name": "zoom-in-page-selection--interface-essential",
      "prevSize": 32
    },
    {
      "order": 3456,
      "name": "zoom-out-page--interface-essential",
      "prevSize": 32
    }
  ],
  "metadata": {
    "name": "20.8.25",
    "importSize": {
      "width": 20,
      "height": 20
    },
    "iconsHash": 1157181567
  },
  "height": 1024,
  "prevSize": 32,
  "icons": [
    {
      "paths": [
        "M968.812 287.875c8.003 8.002 12.503 18.871 12.503 30.188v387.873c-0.005 11.315-4.506 22.185-12.503 30.188l-232.689 232.689c-8.003 8.003-18.872 12.503-30.188 12.503h-387.873c-11.316 0-22.186-4.5-30.188-12.503l-57.062-57.062 60.375-60.314 44.562 44.564h352.501l207.749-207.749v-352.501l-44.564-44.562 60.314-60.375 57.062 57.062z",
        "M956.252 62.125l-106.752 106.438-17.5 23.437-42.875 36.875-219.561 219.125-57.564 64-48.937 42.25-234.812 234.25-36.25 43.5-24.125 16.814-107.625 107.438-60.25-60.252 107.625-107.438-52.438-52.439c-8-8.003-12.498-18.872-12.5-30.188v-387.873c0-11.316 4.499-22.186 12.5-30.188l232.688-232.75c8.001-7.998 18.874-12.5 30.188-12.5h387.873c11.315 0 22.185 4.503 30.188 12.5l53.125 53.188 106.752-106.438 60.252 60.25zM128 335.75v352.501l40 39.997 174.437-173.998h-86.437v-106.25h192.937l279.935-279.375-40.622-40.625h-352.501l-207.75 207.75z",
        "M768 554.25h-179.625l106.25-106.25h73.375v106.25z"
      ],
      "grid": 0,
      "tags": [
        "cancel-stop-payment"
      ]
    },
    {
      "paths": [
        "M705.935 42.687c11.315 0 22.2 4.499 30.203 12.5l232.699 232.7c8.003 8.002 12.498 18.884 12.498 30.2v387.848c0 11.315-4.495 22.2-12.498 30.203l-232.699 232.699c-8.003 8.003-18.888 12.498-30.203 12.498h-387.848c-11.316 0-22.198-4.495-30.2-12.498l-232.7-232.699c-8.001-8.003-12.5-18.888-12.5-30.203v-387.848c0-11.316 4.499-22.198 12.5-30.2l232.7-232.7c8.002-8.001 18.884-12.5 30.2-12.5h387.848zM255.988 447.988v106.252h512.002v-106.252h-512.002z"
      ],
      "grid": 0,
      "tags": [
        "stop-payment"
      ]
    },
    {
      "paths": [
        "M 469.312 512v 409.6h 85.376V 102.4H 469.312V 512m -394.24 -274.368c -8.448 2.816 -22.656 17.6 -25.216 26.24C 48.256 269.248 47.808 328.064 47.808 513.92v 243.008l 3.968 8.512a 40.96 40.96 0 0 0 56.704 19.392c 4.224 -2.24 69.824 -58.432 145.792 -124.928C 407.552 525.76 400.256 533.12 400.128 511.872a 31.68 31.68 0 0 0 -4.864 -19.328c -3.584 -6.144 -37.312 -36.608 -143.232 -129.28C 175.808 296.576 111.168 240.832 108.416 239.36c -6.464 -3.328 -25.472 -4.288 -33.344 -1.728m 844.224 0.384a 38.336 38.336 0 0 0 -10.24 5.632c -1.984 1.856 -65.216 57.088 -140.352 122.816 -150.656 131.712 -144.832 125.824 -144.832 145.728 -0.064 20.928 -6.72 14.208 146.112 147.968 75.84 66.368 141.504 122.56 145.984 124.928a 34.56 34.56 0 0 0 19.264 4.16 38.784 38.784 0 0 0 37.44 -24.64c 3.456 -7.616 3.456 -9.92 3.52 -250.88 0 -168.704 -0.576 -245.248 -1.856 -249.856 -2.56 -9.344 -15.232 -22.336 -25.024 -25.664a 48.128 48.128 0 0 0 -30.016 -0.192M 212.224 440.832a 6320.256 6320.256 0 0 1 79.488 70.144c 1.472 1.792 -15.232 17.216 -78.336 72.448a 4599.488 4599.488 0 0 1 -81.088 70.208c -0.512 0 -0.896 -63.424 -0.896 -140.928 0 -86.4 0.64 -140.736 1.6 -140.352 0.896 0.32 36.544 31.104 79.232 68.48m 680.384 72.128c 0 112.256 -0.448 140.608 -2.176 139.584 -2.176 -1.344 -149.12 -129.472 -156.352 -136.32l -4.032 -3.84 80 -70.08a 3671.872 3671.872 0 0 1 81.28 -70.208c 0.704 0 1.28 63.36 1.28 140.864"
      ],
      "grid": 0,
      "tags": [
        "flip-element"
      ]
    },
    {
      "paths": [
        "M493.772 35.589c7.61-14.858 28.847-14.858 36.455-0l152.177 297.114c1.961 3.823 5.069 6.934 8.893 8.892l297.114 152.177c14.858 7.61 14.858 28.847 0 36.455l-297.114 152.177c-3.825 1.961-6.932 5.069-8.893 8.893l-152.177 297.114c-7.608 14.858-28.845 14.858-36.455 0l-152.177-297.114c-1.958-3.825-5.069-6.932-8.892-8.893l-297.114-152.177c-14.858-7.608-14.858-28.845-0-36.455l297.114-152.177c3.823-1.958 6.934-5.069 8.892-8.892l152.177-297.114z"
      ],
      "grid": 0,
      "tags": [
        "ai-insight-recommend"
      ]
    },
    {
      "paths": [
        "M682.665 469.334h-128v-128l341.335-341.334 128 128-341.335 341.334zM42.667 170.666c-23.564 0-42.667 19.103-42.667 42.667v597.331c0 23.567 19.103 42.67 42.667 42.67h341.333v85.33h-128v85.335h341.335v-85.335h-128.002v-85.33h341.331c23.567 0 42.67-19.103 42.67-42.67v-298.665h-85.335v256h-682.666v-512h426.666v-85.334h-469.333z"
      ],
      "grid": 0,
      "tags": [
        "Desktop-Edit-brand-theme"
      ]
    },
    {
      "paths": [
        "M-10944-4531.2h18688v7936h-20736v-6144h2048v-1792zM-10901.35-4488.535v1792h-2048v6058.67h20650.701v-7850.67h-18602.701z",
        "M298.666 482.134c33.755 0 66.751-10.010 94.817-28.763s49.941-45.408 62.858-76.593c12.917-31.185 16.297-65.501 9.712-98.607s-22.84-63.516-46.708-87.384c-23.868-23.868-54.278-40.122-87.385-46.708s-67.421-3.206-98.607 9.712c-31.185 12.917-57.84 34.792-76.593 62.858s-28.763 61.063-28.763 94.818c0 45.263 17.981 88.673 49.987 120.679s75.416 49.987 120.679 49.987zM298.666 226.134c16.878 0 33.376 5.005 47.409 14.381s24.971 22.704 31.429 38.297c6.459 15.592 8.148 32.75 4.856 49.304s-11.42 31.758-23.354 43.692c-11.934 11.934-27.139 20.061-43.692 23.354s-33.711 1.603-49.303-4.856c-15.593-6.458-28.92-17.396-38.297-31.429s-14.381-30.532-14.381-47.409c0-22.632 8.99-44.337 24.993-60.34s37.708-24.993 60.34-24.993zM298.666 524.8c-79.183 0.092-155.098 31.585-211.089 87.578s-87.487 131.907-87.577 211.087v85.335h597.335v-85.335c-0.092-79.181-31.585-155.095-87.579-211.087-55.991-55.992-131.906-87.485-211.089-87.578zM85.334 823.465c0-56.576 22.476-110.838 62.483-150.845s94.27-62.484 150.85-62.484c56.58 0 110.842 22.477 150.85 62.484s62.484 94.269 62.484 150.845h-426.666zM896 311.467c0-33.755-10.010-66.751-28.764-94.818-18.749-28.066-45.404-49.94-76.59-62.858s-65.5-16.297-98.606-9.712c-33.106 6.585-63.519 22.84-87.388 46.708-23.864 23.868-40.12 54.278-46.705 87.384s-3.205 67.422 9.713 98.607c12.918 31.185 34.79 57.84 62.858 76.593 28.063 18.753 61.061 28.763 94.817 28.763 45.261 0 88.673-17.981 120.678-49.987s49.987-75.416 49.987-120.679zM640 311.467c0-16.878 5.002-33.376 14.382-47.409 9.375-14.033 22.702-24.97 38.298-31.429 15.59-6.459 32.748-8.149 49.3-4.856s31.759 11.42 43.694 23.354c11.935 11.934 20.060 27.139 23.352 43.692s1.603 33.711-4.854 49.304c-6.461 15.592-17.398 28.92-31.432 38.297s-30.531 14.381-47.406 14.381c-22.636 0-44.339-8.99-60.339-24.993-16.005-16.003-24.996-37.708-24.996-60.34zM725.335 524.8c-33.91-0.010-67.574 5.76-99.543 17.065l28.416 80.471c32.179-11.331 66.601-14.781 100.388-10.071 33.787 4.705 65.956 17.444 93.809 37.135 27.858 19.697 50.586 45.778 66.289 76.063 15.708 30.285 23.926 63.887 23.972 98.002h-256v85.335h341.335v-85.335c-0.092-79.181-31.585-155.095-87.578-211.087s-131.907-87.485-211.087-87.578z"
      ],
      "grid": 0,
      "tags": [
        "user-multiple-new"
      ]
    },
    {
      "paths": [
        "M707.661 213.334l-97.833-97.83 60.339-60.34 170.67 170.667c16.66 16.663 16.66 43.677 0 60.34l-170.67 170.666-60.339-60.34 97.833-97.83h-280.994c-79.212 0-155.178 31.466-211.189 87.477s-87.478 131.979-87.478 211.19h-85.333c0-101.842 40.457-199.516 112.471-271.53s169.686-112.471 271.529-112.471h280.994zM316.339 725.335l97.83-97.833-60.34-60.339-170.667 170.67c-16.662 16.66-16.662 43.674 0 60.339l170.667 170.665 60.34-60.339-97.83-97.833h280.996c101.837 0 199.511-40.453 271.529-112.466 72.013-72.018 112.471-169.692 112.471-271.532h-85.335c0 79.21-31.468 155.18-87.48 211.187-56.008 56.013-131.978 87.48-211.185 87.48h-280.996z"
      ],
      "tags": [
        "Data-Transfer-Refresh"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M170.687 848v5.315h5.313v85.371h-48c-23.564 0-42.687-19.123-42.687-42.685v-48h85.375zM368 853.315v85.371h-96v-85.371h96zM560 853.315v85.371h-96v-85.371h96zM752 853.315v85.371h-96v-85.371h96zM938.685 853.315v42.685l-0.87 8.627c-3.988 19.43-21.202 34.058-41.815 34.058h-48v-85.371h90.685zM938.685 682.685v85.315h-85.371v-85.315h85.371zM170.687 656v96h-85.375v-96h85.375zM938.685 554.685v42.629h-85.371v-42.629h85.371zM170.687 464v96h-85.375v-96h85.375zM170.687 272v96h-85.375v-96h85.375zM170.687 85.313v90.687h-85.375v-48l0.875-8.625c3.987-19.431 21.202-34.062 41.812-34.062h42.687zM341.313 85.313v85.375h-85.313v-85.375h85.313zM469.313 85.313v85.375h-42.625v-85.375h42.625z",
        "M853.315 384c0-117.821-95.493-213.313-213.315-213.313h-256v-85.375h256c164.951 0 298.685 133.738 298.685 298.687v256h-85.371v-256z"
      ],
      "tags": [
        "round-corners-radius"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M341.334 0h85.333v256h170.669v-256h85.33v256h128c23.567 0 42.67 19.103 42.67 42.666v213.334c0 90.527-35.963 177.347-99.973 241.362-53.878 53.873-123.899 87.875-198.697 97.295v173.343h-85.331v-173.343c-74.795-9.421-144.821-43.423-198.692-97.295-64.013-64.015-99.975-150.835-99.975-241.362v-213.334c0-23.564 19.103-42.666 42.667-42.666h128v-256zM256 341.334v170.666c0 67.896 26.971 133.007 74.981 181.018s113.124 74.982 181.019 74.982c67.896 0 133.007-26.972 181.018-74.982s74.982-113.121 74.982-181.018v-170.666h-512z"
      ],
      "tags": [
        "Power-Cable--SIcons_Mix"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M896 512h128v85.299h-256v85.35h213.299c23.552 0 42.68 19.103 42.701 42.65v170.701c-0.010 23.557-19.139 42.65-42.701 42.65h-85.299v85.35h-85.299v-85.35h-128.051v-85.35h256v-85.299h-213.35c-23.547-0.020-42.65-19.149-42.65-42.701v-170.65l0.2-4.352c2.186-21.504 20.372-38.282 42.45-38.298h85.402v-85.35h85.299v85.35zM469.3 0c22.48 0 44.558 7.678 61.101 24.2 16.538 16.537 24.243 38.616 24.248 61.1v682.7c-0.005 22.492-7.711 44.559-24.248 61.102-16.543 16.532-38.613 24.197-61.101 24.197h-384c-22.484-0.005-44.563-7.66-61.1-24.197-16.529-16.543-24.196-38.62-24.2-61.102v-682.7l0.35-8.4c1.702-19.51 9.379-38.229 23.85-52.7 16.537-16.537 38.616-24.192 61.1-24.2h384zM85.3 768h384v-85.35h-384v85.35zM85.3 597.35h384v-341.35h-384v341.35zM85.3 170.7h384v-85.4h-384v85.4z"
      ],
      "tags": [
        "Smartphone-Action-Money-Fund"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 127.999v256c0 23.564 19.103 42.666 42.667 42.666h106.667v-85.333h-64v-170.667h128v725.334c0 23.562 19.102 42.665 42.666 42.665h512c23.562 0 42.665-19.103 42.665-42.665v-725.334h128v170.667h-64v85.333h106.67c23.562 0 42.665-19.102 42.665-42.666v-256c0-23.564-19.103-42.666-42.665-42.666h-938.668c-23.564 0-42.667 19.103-42.667 42.666zM298.666 170.666h426.669v682.669h-426.669v-682.669zM426.666 341.333c-23.564 0-42.666 19.103-42.666 42.666v128c0 23.563 19.102 42.665 42.666 42.665h127.998v42.67h-170.665v85.33h85.334v64h85.331v-64h42.67c23.562 0 42.665-19.103 42.665-42.665v-128.001c0-23.565-19.103-42.666-42.665-42.666h-128.002v-42.667h170.666v-85.333h-85.335v-64h-85.331v64h-42.667z"
      ],
      "tags": [
        "Atm-Socket-Money-Withdraw"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M469.334 341.334h85.331v-168.026c154.399 19.253 276.777 141.627 296.028 296.026h-168.028v85.331h168.028c-19.251 154.399-141.629 276.777-296.028 296.028v-168.028h-85.331v168.028c-154.399-19.251-276.773-141.629-296.026-296.028h168.026v-85.331h-168.026c19.253-154.399 141.627-276.773 296.026-296.026v168.026zM87.44 554.665c20.013 201.574 180.318 361.882 381.893 381.896v87.439h85.331v-87.439c201.574-20.014 361.882-180.321 381.896-381.896h87.439v-85.331h-87.439c-20.014-201.575-180.321-361.88-381.896-381.893v-87.44h-85.331v87.44c-201.575 20.013-361.88 180.318-381.893 381.893h-87.44v85.331h87.44z"
      ],
      "tags": [
        "cursor-focus-target-zoom-highlight"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M921.636 256.001v511.999h-810.669v-511.999h810.669zM921.636 170.667h-810.669c-22.611 0.068-44.277 9.080-60.265 25.069s-25.001 37.654-25.068 60.265v511.999c0.068 22.61 9.080 44.278 25.068 60.268 15.988 15.985 37.654 25.001 60.265 25.068h810.669c22.61-0.067 44.273-9.083 60.262-25.068 15.99-15.99 25.001-37.658 25.068-60.268v-511.999c-0.067-22.611-9.078-44.277-25.068-60.265s-37.652-25.001-60.262-25.069z",
        "M76.85 367.36h857.601v84.48h-857.601v-84.48z",
        "M204.85 537.6h128c14.138 0 25.6 11.462 25.6 25.6v76.8c0 14.138-11.462 25.6-25.6 25.6h-128c-14.138 0-25.6-11.462-25.6-25.6v-76.8c0-14.138 11.462-25.6 25.6-25.6z"
      ],
      "tags": [
        "credit-card"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M642.432 906.163c-51.722 21.519-107.197 32.568-163.212 32.502-113.159 0-221.683-44.948-301.699-124.964s-124.967-188.544-124.967-301.701c0-113.159 44.952-221.683 124.968-301.699s188.539-124.968 301.699-124.967v85.333c-56.181-0.11-111.52 13.649-161.108 40.056s-91.891 64.646-123.156 111.324c-31.265 46.678-50.525 100.35-56.071 156.257-5.546 55.907 2.793 112.319 24.278 164.226 21.485 51.912 55.45 97.715 98.884 133.35s94.99 60.001 150.098 70.932c55.107 10.931 112.062 8.090 165.807-8.274 53.745-16.358 102.62-45.732 142.295-85.514l-113.024-113.024h256v256l-82.688-82.688c-39.444 39.777-86.385 71.337-138.102 92.851z",
        "M856.1 79.505c-14.648-18.457-41.482-21.544-59.94-6.896l-392.020 311.124c-6.155 4.886-10.842 11.376-13.543 18.756l-56.226 153.62c-5.107 13.952-2.587 29.558 6.651 41.196s23.865 17.628 38.613 15.821l162.358-19.922c7.798-0.957 15.176-4.050 21.33-8.934l391.982-311.144c18.458-14.65 21.54-41.486 6.892-59.943l-106.097-133.677zM748.923 219.037l66.862-53.064 53.048 66.84-66.842 53.057-53.069-66.833zM682.086 272.086l53.069 66.838-215.475 171.042-81.198 9.965 28.118-76.828 215.486-171.018z"
      ],
      "tags": [
        "edit-Arrow"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M290.713 383.194c44.884 0 81.27-36.386 81.27-81.27s-36.386-81.27-81.27-81.27c-44.884 0-81.27 36.386-81.27 81.27s36.386 81.27 81.27 81.27z",
        "M534.523 383.194c44.885 0 81.271-36.386 81.271-81.27s-36.386-81.27-81.271-81.27c-44.885 0-81.27 36.386-81.27 81.27s36.385 81.27 81.27 81.27z",
        "M778.333 383.194c44.885 0 81.271-36.386 81.271-81.27s-36.386-81.27-81.271-81.27c-44.885 0-81.271 36.386-81.271 81.27s36.386 81.27 81.271 81.27z",
        "M476.738 748.91v-81.271h44.697c5.242-25.454 15.355-49.659 29.789-71.275l-31.861-31.856 57.539-57.456 31.9 31.856c21.563-14.414 45.709-24.517 71.109-29.745v-44.698h81.271v44.698c25.439 5.208 49.625 15.297 71.231 29.706l31.817-31.817 57.5 57.539-31.817 31.817c14.409 21.606 24.513 45.792 29.745 71.231h44.7v81.271h-44.7c-5.232 25.439-15.336 49.625-29.745 71.231l31.817 31.9-57.5 57.417-31.817-31.861c-21.592 14.443-45.787 24.556-71.231 29.789v44.695h-81.271v-44.695c-25.444-5.232-49.635-15.345-71.231-29.789l-31.856 31.817-57.417-57.539 31.856-31.773c-14.434-21.592-24.561-45.763-29.828-71.192h-44.697zM720.55 789.543c16.072 0 31.783-4.764 45.149-13.697 13.366-8.928 23.781-21.621 29.935-36.469 6.149-14.853 7.758-31.193 4.623-46.958s-10.879-30.247-22.24-41.613c-11.366-11.366-25.849-19.105-41.613-22.24s-32.105-1.526-46.958 4.623c-14.848 6.154-27.541 16.569-36.469 29.935-8.933 13.366-13.697 29.077-13.697 45.149 0 21.558 8.563 42.228 23.806 57.471 15.238 15.238 35.913 23.801 57.466 23.801z",
        "M46.905 98.766c0-22.442 18.193-40.635 40.635-40.635h893.969c22.44 0 40.633 18.193 40.633 40.635v406.349h-81.271v-365.714h-812.696v325.079h325.080v81.268h-365.714c-22.442 0-40.635-18.193-40.635-40.633v-406.349z"
      ],
      "tags": [
        "password-settings"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M170.666 702.5v-546.591c108.074-45.314 223.982-69.312 341.334-70.575 117.35 1.263 233.257 25.262 341.335 70.575v546.591l-341.335 227.553-341.334-227.553zM511.561 0c-138.498 1.424-275.167 31.795-401.233 89.163-15.223 6.927-24.994 22.11-24.994 38.835v597.332c0 14.269 7.13 27.587 18.999 35.502l384 256c14.332 9.554 33.001 9.554 47.332 0l384-256c11.873-7.916 19-21.233 19-35.502v-597.332c0-16.725-9.769-31.907-24.991-38.835-126.070-57.368-262.738-87.739-401.234-89.163h-0.88zM499.503 627.502l255.999-256.001-60.339-60.34-225.829 225.829-97.83-97.831-60.34 60.344 128.001 127.999c16.661 16.66 43.678 16.66 60.339 0z"
      ],
      "tags": [
        "shield-Check"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M130.923 0c-23.564 0-42.667 19.103-42.667 42.667v938.668c0 23.562 19.103 42.665 42.667 42.665h768.001c23.562 0 42.665-19.103 42.665-42.665v-725.335c0-11.316-4.495-22.168-12.498-30.17l-213.33-213.333c-8.003-8.002-18.857-12.497-30.172-12.497h-554.665zM173.59 938.665v-853.331h469.334v213.332h213.335v639.999h-682.669z",
        "M390.252 411v351.727l307.758-175.862-307.758-175.865z"
      ],
      "width": 1075,
      "tags": [
        "document-video-file"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 53.914c0-23.564 19.103-42.667 42.667-42.667h554.668c11.136 0 21.832 4.354 29.798 12.133l213.335 208.221c8.228 8.029 12.867 19.038 12.867 30.533v166.577h-85.335v-141.295h-213.335v-190.836h-469.331v830.836h384v85.335h-426.667c-23.564 0-42.667-19.103-42.667-42.67v-916.168z",
        "M512.010 756.664c0 67.891 26.972 133.007 74.982 181.018 48.005 48.010 113.121 74.982 181.018 74.982s133.007-26.972 181.018-74.982c48.010-48.010 74.982-113.126 74.982-181.018 0-67.896-26.972-133.012-74.982-181.023s-113.121-74.979-181.018-74.979c-67.896 0-133.012 26.969-181.018 74.979-48.010 48.010-74.982 113.126-74.982 181.023zM768.015 628.746l128 128h-85.335v128h-85.33v-128h-85.335l128-128z",
        "M284.929 411v351.727l192.35-109.916v-131.896l-192.35-109.914z"
      ],
      "tags": [
        "document-video-upload"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M127.999 0c-23.564 0-42.666 19.103-42.666 42.667v938.668c0 23.562 19.102 42.665 42.666 42.665h768.001c23.562 0 42.665-19.103 42.665-42.665v-725.335c0-11.316-4.495-22.168-12.498-30.17l-213.33-213.333c-8.003-8.002-18.857-12.497-30.172-12.497h-554.665zM170.666 938.665v-853.331h469.334v213.332h213.335v639.999h-682.669z"
      ],
      "tags": [
        "common-file---files-&-folders"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M85.333 42.667c0-23.564 19.102-42.667 42.666-42.667h554.665c11.315 0 22.17 4.495 30.172 12.497l213.33 213.333c8.003 8.002 12.498 18.854 12.498 30.17v725.335c0 23.562-19.103 42.665-42.665 42.665h-768.001c-23.564 0-42.666-19.103-42.666-42.665v-938.668zM170.666 85.334v853.331h682.669v-639.999h-213.335v-213.332h-469.334zM603.986 537.052h-305.299v85.335h305.299v-85.335zM705.751 707.722h-407.064v85.33h407.064v-85.33z"
      ],
      "tags": [
        "common-file-text---files-&-folders"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M129.95 0c-23.564 0-42.666 19.103-42.666 42.667v938.668c0 23.562 19.103 42.665 42.666 42.665h768.001c23.562 0 42.665-19.103 42.665-42.665v-725.335c0-11.316-4.495-22.168-12.498-30.17l-213.33-213.333c-8.003-8.002-18.857-12.497-30.172-12.497h-554.666zM172.617 938.665v-853.331h469.334v213.332h213.33v639.999h-682.664zM468.769 715.228l135.611-196.337 205.271 297.185h-564.451l146.616-212.28 76.953 111.432zM386.275 486.815c51.957 0 94.075-42.117 94.075-94.075 0-51.956-42.118-94.075-94.075-94.075-51.956 0-94.075 42.119-94.075 94.075 0 51.958 42.119 94.075 94.075 94.075z"
      ],
      "width": 1075,
      "tags": [
        "document-image-file"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M66.0533 66.0533C66.0533 43.9147 85.1467 24.8213 107.2853 24.8213H639.9999C650.7733 24.8213 660.2437 29.3696 667.6325 36.7584L868.3733 237.4992C875.7621 244.888 880.3104 254.3584 880.3104 265.1317V355.1251H781.9733V295.4667H566.3999V84.8213H180.2667V355.1251H81.92V66.0533ZM180.2667 919.4667V817.0667H81.92V962.9867C81.92 985.1253 101.0133 1004.2187 123.152 1004.2187H864.852C886.9907 1004.2187 906.084 985.1253 906.084 962.9867V817.0667H807.736V919.4667H180.2667ZM42.4533 430.1867V511.9999H123.1467V758.4H204.84V511.9999H286.5333V430.1867H42.4533ZM329.7067 430.1867V758.4H411.4V430.1867H329.7067ZM468.4267 474.9867C468.4267 453.1747 486.5525 435.048 508.3645 435.048H653.9723V516.8613H560.7595V556.3147H653.9723V637.9893H560.7595V758.4H468.4267V474.9867ZM692.4267 474.9867C692.4267 453.1747 710.5525 435.048 732.3645 435.048H878.0V516.8613H784.7873V556.3147H878.0V637.9893H784.7873V758.4H692.4267V474.9867Z"
      ],
      "tags": ["document-tiff-mage-file"],
      "grid": 0
    },
    {
      "paths": [
        "M86.308 42.667c0-23.564 19.103-42.667 42.667-42.667h554.668c11.315 0 22.17 4.495 30.167 12.497l213.335 213.333c8.003 8.002 12.498 18.854 12.498 30.17v725.335c0 23.562-19.103 42.665-42.67 42.665h-767.997c-23.564 0-42.667-19.103-42.667-42.665v-938.668zM171.642 85.334v853.331h682.666v-639.999h-213.335v-213.332h-469.331zM490.561 304.775c12.579-7.774 28.285-8.481 41.515-1.868l170.665 85.334-38.164 76.324-108.918-54.459v297.058h-0.102c-1.812 57.324-48.85 103.24-106.614 103.24-58.91 0-106.667-47.759-106.667-106.67s47.757-106.665 106.667-106.665c7.324 0 14.475 0.737 21.383 2.145v-258.144c0-14.787 7.656-28.52 20.235-36.295z"
      ],
      "width": 1075,
      "tags": [
        "document-audio-music"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 53.914c0-23.564 19.103-42.667 42.667-42.667h554.668c11.136 0 21.832 4.354 29.798 12.133l213.335 208.221c8.228 8.029 12.867 19.038 12.867 30.533v166.577h-85.335v-141.295h-213.335v-190.836h-469.331v830.836h384v85.335h-426.667c-23.564 0-42.667-19.103-42.667-42.67v-916.168z",
        "M512.010 756.664c0 67.891 26.972 133.007 74.982 181.018 48.005 48.010 113.121 74.982 181.018 74.982s133.007-26.972 181.018-74.982c48.010-48.010 74.982-113.126 74.982-181.018 0-67.896-26.972-133.012-74.982-181.023s-113.121-74.979-181.018-74.979c-67.896 0-133.012 26.969-181.018 74.979-48.010 48.010-74.982 113.126-74.982 181.023zM768.015 628.746l128 128h-85.335v128h-85.33v-128h-85.335l128-128z"
      ],
      "tags": [
        "document-file-upload"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 53.914c0-23.564 19.103-42.667 42.667-42.667h554.668c11.136 0 21.832 4.354 29.798 12.133l213.335 208.221c8.228 8.029 12.867 19.038 12.867 30.533v166.577h-85.335v-141.295h-213.335v-190.836h-469.331v830.836h384v85.335h-426.667c-23.564 0-42.667-19.103-42.667-42.67v-916.168zM512.010 756.664c0 67.891 26.972 133.007 74.982 181.018 48.005 48.010 113.121 74.982 181.018 74.982s133.007-26.972 181.018-74.982c48.010-48.010 74.982-113.126 74.982-181.018 0-67.896-26.972-133.012-74.982-181.023s-113.121-74.979-181.018-74.979c-67.896 0-133.012 26.969-181.018 74.979-48.010 48.010-74.982 113.126-74.982 181.023zM768.015 628.746l128 128h-85.335v128h-85.33v-128h-85.335l128-128zM298.667 526.848c47.128 0 85.333-38.204 85.333-85.334 0-47.128-38.205-85.333-85.333-85.333s-85.334 38.205-85.334 85.333c0 47.13 38.205 85.334 85.334 85.334zM426.666 659.118v166.4h-256l132.267-192 72.533 102.4 51.2-76.8z"
      ],
      "tags": [
        "document-image-upload"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 53.914c0-23.564 19.103-42.667 42.667-42.667h554.668c11.136 0 21.832 4.354 29.798 12.133l213.335 208.221c8.228 8.029 12.867 19.038 12.867 30.533v166.577h-85.335v-141.295h-213.335v-190.836h-469.331v830.836h384v85.335h-426.667c-23.564 0-42.667-19.103-42.667-42.67v-916.168zM512.010 756.664c0 67.891 26.972 133.007 74.982 181.018 48.005 48.010 113.121 74.982 181.018 74.982s133.007-26.972 181.018-74.982c48.010-48.010 74.982-113.126 74.982-181.018 0-67.896-26.972-133.012-74.982-181.023s-113.121-74.979-181.018-74.979c-67.896 0-133.012 26.969-181.018 74.979-48.010 48.010-74.982 113.126-74.982 181.023zM768.015 628.746l128 128h-85.335v128h-85.33v-128h-85.335l128-128zM596.541 387.6h-425.874v85.334h425.874v-85.334zM170.667 558.269h256v85.335h-256v-85.335z"
      ],
      "tags": [
        "document-text-upload"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M920.673 256.033h-195.528c-11.315 0-22.17 4.495-30.172 12.497s-12.498 18.854-12.498 30.17v170.667h-85.33v-170.667c0-33.948 13.486-66.505 37.489-90.509s56.561-37.491 90.511-37.491h195.789l-97.961-97.96 60.339-60.34 170.665 170.667c16.66 16.663 16.66 43.678 0 60.34l-170.665 170.667-60.339-60.34 97.7-97.7z",
        "M204.097 185.205c-42.865 0-83.974 17.028-114.284 47.337s-47.338 71.419-47.338 114.284v116.95c0 148.556 59.013 291.025 164.058 396.072 105.044 105.042 247.515 164.055 396.071 164.055h77.312c42.865 0 83.973-17.029 114.284-47.34 30.31-30.305 47.34-71.419 47.34-114.284v-158.377c0-23.562-19.103-42.665-42.67-42.665h-277.545c-23.565 0-42.667 19.103-42.667 42.665v31.683c-10.933-2.442-21.66-5.832-32.060-10.138-23.689-9.81-45.213-24.192-63.344-42.322s-32.511-39.654-42.32-63.345c-9.424-22.758-14.453-47.084-14.83-71.695h36.585c23.564 0 42.666-19.103 42.666-42.668v-277.546c0-23.564-19.103-42.666-42.666-42.666h-158.592zM320.022 270.538v192.214h-36.608c-23.564 0-42.666 19.103-42.666 42.666v39.632c-0.006 36.844 7.247 73.339 21.345 107.382 14.098 34.043 34.766 64.978 60.822 91.034s56.99 46.725 91.035 60.82c34.045 14.1 70.534 21.35 107.381 21.345 23.562-0.005 42.66-19.103 42.66-42.665v-36.398h192.215v115.712c0 20.234-8.038 39.639-22.344 53.944-14.305 14.31-33.71 22.344-53.944 22.344h-77.312c-125.924 0-246.69-50.022-335.731-139.064-89.041-89.037-139.064-209.802-139.064-335.728v-116.95c0-20.233 8.037-39.637 22.344-53.944s33.711-22.344 53.944-22.344h115.925z"
      ],
      "width": 1075,
      "tags": [
        "phone-forward-arrow"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 53.866c0-23.564 19.103-42.666 42.667-42.666h554.668c11.136 0 21.832 4.354 29.798 12.133l213.335 208.22c8.228 8.029 12.867 19.038 12.867 30.534v166.576h-85.335v-141.295h-213.335v-190.835h-469.331v830.837h384v85.335h-426.667c-23.564 0-42.667-19.103-42.667-42.67v-916.169z",
        "M244.575 768.128c-20.004-20.004-31.242-47.135-31.242-75.428 0-28.288 11.238-55.419 31.242-75.423s47.135-31.242 75.425-31.242c7.22 0 14.364 0.732 21.334 2.156v-215.49c0-14.788 7.656-28.52 20.235-36.295s28.286-8.481 41.512-1.868l170.666 85.334-38.164 76.324-108.917-54.459v272.298h-2.154c-4.152 20.342-14.189 39.194-29.087 54.093-20.004 20.004-47.135 31.242-75.425 31.242s-55.421-11.238-75.425-31.242z",
        "M512.010 756.613c0 67.896 26.972 133.012 74.977 181.023 48.010 48.010 113.126 74.977 181.023 74.977s133.007-26.967 181.018-74.977c48.010-48.010 74.982-113.126 74.982-181.023 0-67.891-26.972-133.007-74.982-181.018s-113.121-74.98-181.018-74.98c-67.896 0-133.012 26.97-181.023 74.98-48.005 48.010-74.977 113.126-74.977 181.018zM768.015 628.7l128 128h-85.335v128h-85.33v-128h-85.335l128-128z"
      ],
      "tags": [
        "document-audio-music-upload"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M493.568 0.582c5.913-1.011 43.003 0.37 52.209 1.943 68.731 11.739 125.88 53.614 156.913 114.978l5.309 10.498 96.814 0.012c103.076 0.013 101.581-0.054 111.406 4.97 6.108 3.121 14.874 12.227 18.074 18.774 1.49 3.042 3.159 8.273 3.707 11.623 1.362 8.333 1.362 816.904 0 825.24-1.388 8.474-5.448 16.189-11.919 22.666-6.042 6.036-11.484 9.226-19.328 11.32-7.613 2.038-781.889 2.038-789.504 0-7.844-2.094-13.288-5.284-19.327-11.32-6.473-6.477-10.532-14.193-11.919-22.666-1.365-8.335-1.365-816.906 0-825.24 0.549-3.351 2.215-8.581 3.704-11.623 3.203-6.547 11.97-15.653 18.074-18.774 9.829-5.025 8.323-4.957 111.517-4.97l96.927-0.012 3.139-6.705c16.83-35.967 48.316-70.437 83.29-91.184 24.788-14.705 53.085-24.696 79.141-27.944 5.069-0.632 10.368-1.346 11.776-1.585zM502.008 86.159c-53.925 3.869-100.482 42.994-113.762 95.602-1.754 6.947-4.246 24.353-4.246 29.656 0 1.41 13.448 1.576 128 1.576 114.55 0 128-0.166 128-1.576 0-0.867-0.492-6.052-1.091-11.52-4.915-44.892-31.872-82.703-72.74-102.034-20.091-9.5-41.201-13.351-64.162-11.703zM171.008 575.995v363.013h681.984v-726.030l-127.488 0.527-0.568 26.624c-0.348 16.378-1.039 28.034-1.792 30.289-3.261 9.776-14.735 21.344-25.446 25.666l-5.985 2.414-175.104 0.286c-109.116 0.178-177.525-0.087-181.528-0.703-12.445-1.918-23.062-8.848-29.915-19.53-5.195-8.095-5.511-10.086-6.108-38.42l-0.561-26.624-127.488-0.527v363.017zM256 469.505v42.495h84.992v-84.991h-84.992v42.496zM427.008 469.505v42.495h340.992v-84.991h-340.992v42.496zM256 640v43.008h84.992v-86.016h-84.992v43.008zM427.008 640v43.008h340.992v-86.016h-340.992v43.008zM256 810.496v42.496h84.992v-84.992h-84.992v42.496zM427.008 810.496v42.496h340.992v-84.992h-340.992v42.496z"
      ],
      "tags": [
        "document-folder-list"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M185.738 154.734v-85.334h720.001v85.334h-77.332v215.006l-142.326 142.327 142.326 142.326v215.009h77.332v85.33h-720.001v-85.33h77.334v-215.009l142.327-142.326-142.327-142.327v-215.006h-77.334zM348.405 334.393l135.006 135.007h124.655l135.004-135.007v-179.66h-394.665v179.66zM483.411 554.732l-135.006 135.009v179.661h394.665v-179.661l-135.004-135.009h-124.655z"
      ],
      "width": 1075,
      "tags": [
        "hourglass-loading-clock-time-pending"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M426.666 682.665c-1.326-17.147 1.076-34.376 7.039-50.509 5.964-16.128 15.348-30.781 27.51-42.941s26.81-21.545 42.941-27.51c16.132-5.96 33.361-8.366 50.508-7.040 17.147-1.326 34.381 1.080 50.509 7.040 16.133 5.965 30.781 15.35 42.947 27.51 12.16 12.16 21.545 26.813 27.505 42.941 5.965 16.133 8.366 33.362 7.040 50.509h-255.998z",
        "M469.334 426.666c0 22.632 8.99 44.337 24.993 60.34s37.708 24.994 60.338 24.994c22.636 0 44.339-8.991 60.339-24.994 16.005-16.003 24.996-37.708 24.996-60.34s-8.991-44.337-24.996-60.34c-16-16.003-37.704-24.993-60.339-24.993-22.63 0-44.335 8.99-60.338 24.993s-24.993 37.708-24.993 60.34z",
        "M810.665 85.333h-511.998c-22.631 0-44.337 8.99-60.34 24.993s-24.993 37.708-24.993 60.34v85.334h-85.334v85.334h85.334v128h-85.334v85.332h85.334v128h-85.334v85.335h85.334v85.335c0 22.63 8.99 44.334 24.993 60.339 16.003 16 37.708 24.991 60.34 24.991h511.998c22.636 0 44.339-8.991 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-682.669c0-22.631-8.991-44.337-24.996-60.34-16-16.003-37.704-24.993-60.339-24.993zM298.666 853.335v-85.335h42.667v-85.335h-42.667v-128h42.667v-85.332h-42.667v-128h42.667v-85.334h-42.667v-85.334h511.998v682.669h-511.998z"
      ],
      "tags": [
        "user-contact"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M317.129 93.866c0-23.564-19.103-42.666-42.667-42.666s-42.666 19.103-42.666 42.666v135.42h-96.97c-23.564 0-42.666 19.103-42.666 42.666v641.112c0 23.567 19.102 42.67 42.666 42.67h315.734v-85.335h-273.067v-377.693h682.668v19.293h85.335v-240.047c0-23.564-19.103-42.666-42.67-42.666h-96.968v-135.42c0-23.564-19.103-42.666-42.67-42.666-23.562 0-42.665 19.103-42.665 42.666v135.42h-403.393v-135.42zM177.492 407.374v-92.753h682.668v92.753h-682.668z",
        "M554.665 1024h128l341.335-341.335-128-128-341.335 341.335v128z"
      ],
      "tags": [
        "calendar-interface-edit-date"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M211.173 359.95c-31.661 62.639-42.978 133.599-32.373 202.98s42.603 133.72 91.529 184.041c48.927 50.32 112.342 84.112 181.396 96.661 69.053 12.553 140.304 3.235 203.806-26.657 63.507-29.887 116.098-78.853 150.435-140.065v0c34.337-61.212 48.714-131.617 41.118-201.388-7.596-69.776-36.785-135.438-83.489-187.827-46.708-52.389-108.605-88.892-177.050-104.415l20.759-91.542c87.51 19.846 166.642 66.514 226.355 133.492s97.024 150.926 106.738 240.131c9.709 89.204-8.667 179.214-52.568 257.475-43.902 78.257-111.137 140.861-192.326 179.070-81.189 38.214-172.279 50.125-260.564 34.081s-169.359-59.248-231.911-123.583c-62.552-64.335-103.461-146.59-117.019-235.292s0.911-179.422 41.389-259.505l83.773 42.343z"
      ],
      "tags": [
        "Icons_loader"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M749.032 42.667c11.316 0 22.169 4.495 30.17 12.497l189.629 189.634c16.666 16.662 16.666 43.677 0 60.34l-595.971 595.974c-5.342 5.342-12.006 9.173-19.312 11.093l-257.358 67.721c-14.675 3.866-30.298-0.358-41.028-11.085-10.73-10.735-14.954-26.359-11.092-41.028l67.723-257.361c1.923-7.306 5.751-13.97 11.092-19.312l595.976-595.976c8.002-8.002 18.854-12.497 30.17-12.497zM191.383 703.322l-46.175 175.466 175.469-46.171 422.202-422.202-129.295-129.295-422.202 422.202zM673.925 220.78l129.294 129.295 75.109-75.108-129.295-129.294-75.107 75.107z"
      ],
      "tags": [
        "Changed"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M580.163 2.085c17.524 5.746 29.373 22.101 29.373 40.543v298.666h286.464c16.085 0 30.805 9.047 38.067 23.398s5.837 31.568-3.686 44.531l-438.866 597.334c-10.919 14.865-30.153 21.026-47.677 15.283-17.525-5.751-29.374-22.101-29.374-40.55v-298.662h-286.464c-16.085 0-30.803-9.047-38.067-23.398s-5.84-31.568 3.684-44.531l438.869-597.333c10.919-14.862 30.152-21.027 47.677-15.281zM212.292 597.294h244.838c23.564 0 42.667 19.103 42.667 42.668v211.199l311.91-424.533h-244.838c-23.564 0-42.667-19.102-42.667-42.666v-211.2l-311.91 424.532z"
      ],
      "tags": [
        "Created"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M750.327 810.665l-609.83-609.83 60.34-60.34 609.83 609.83v-238.327h85.332v341.333c0 23.562-19.098 42.668-42.667 42.668h-341.332v-85.335h238.327z"
      ],
      "tags": [
        "Decreased"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M512 42.667c-124.475 0-243.852 49.447-331.869 137.464s-137.464 207.394-137.464 331.869c0 124.475 49.447 243.852 137.464 331.869 88.017 88.014 207.394 137.464 331.869 137.464s243.852-49.451 331.869-137.464c88.014-88.017 137.464-207.394 137.464-331.869s-49.451-243.852-137.464-331.869c-88.017-88.017-207.394-137.464-331.869-137.464zM240.471 240.471c72.014-72.014 169.686-112.471 271.529-112.471 87.518 0 171.956 29.876 239.678 83.981l-539.697 539.697c-54.105-67.722-83.981-152.16-83.981-239.678 0-101.843 40.457-199.515 112.471-271.529zM272.321 812.017l539.697-539.697c54.107 67.722 83.983 152.16 83.983 239.679 0 101.843-40.457 199.515-112.471 271.529s-169.686 112.471-271.529 112.471c-87.519 0-171.957-29.875-239.679-83.983z"
      ],
      "tags": [
        "Disabled"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M343.234 765.99l560.992-605.876 68.881 63.774-563.871 608.978c-33.403 36.075-89.637 38.498-126.016 5.424l-229.457-208.597 63.142-69.456 226.329 205.754z"
      ],
      "tags": [
        "Enabled"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M512.001 128h341.332c23.561 0 42.667 19.103 42.667 42.667v341.333h-85.332v-238.327l-609.83 609.834-60.34-60.343 609.83-609.83h-238.327v-85.333z"
      ],
      "tags": [
        "Increased"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M383.917 831.98c0-82.478-66.859-149.335-149.333-149.335s-149.334 66.857-149.334 149.335c0 82.473 66.86 149.33 149.334 149.33s149.333-66.857 149.333-149.33zM234.584 767.98c35.345 0 64 28.652 64 64 0 35.343-28.655 64-64 64s-64-28.657-64-64c0-35.348 28.654-64 64-64z",
        "M895.918 831.98c0-82.478-66.862-149.335-149.335-149.335s-149.335 66.857-149.335 149.335c0 82.473 66.862 149.33 149.335 149.33s149.335-66.857 149.335-149.33zM746.583 767.98c35.348 0 64 28.652 64 64 0 35.343-28.652 64-64 64-35.343 0-64-28.657-64-64 0-35.348 28.657-64 64-64z",
        "M554.665 170.646c11.315 0 22.17 4.495 30.172 12.496 7.997 8.002 12.498 18.854 12.498 30.17v512.002h-362.669c51.606 0 94.652 36.644 104.534 85.33h300.8c0.722 0 1.434-0.015 2.145-0.051 5.294-26.010 20.050-48.579 40.52-63.954v-362.66h214.994c9.861 0.003 19.425 3.421 27.049 9.674 6.723 5.511 11.576 12.923 13.957 21.224v54.435h-170.665v85.332h170.665v170.67h-106.665v42.655c9.318 12.406 16 26.911 19.2 42.675h130.135c23.562 0 42.665-19.103 42.665-42.665v-358.059c0-2.808-0.276-5.609-0.829-8.362-5.796-29.017-21.473-55.128-44.355-73.891s-51.558-29.018-81.147-29.021h-215.004v-85.334c0-33.948-13.486-66.505-37.489-90.51s-56.566-37.49-90.511-37.49h-426.665c-33.95 0-66.505 13.486-90.509 37.49s-37.491 56.562-37.491 90.51v554.667c0 23.562 19.102 42.665 42.667 42.665h87.467c9.882-48.686 52.928-85.33 104.533-85.33h-149.333v-512.002c0-11.316 4.497-22.168 12.497-30.17 8-8.001 18.854-12.496 30.17-12.496h426.665z"
      ],
      "tags": [
        "delivery-truck"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M234.584 938.644c-58.91 0-106.667-47.754-106.667-106.665s47.757-106.665 106.667-106.665c58.91 0 106.666 47.754 106.666 106.665s-47.757 106.665-106.666 106.665z",
        "M746.583 938.644c-58.911 0-106.665-47.754-106.665-106.665s47.754-106.665 106.665-106.665c58.911 0 106.665 47.754 106.665 106.665s-47.754 106.665-106.665 106.665z",
        "M554.665 170.646c11.315 0 22.17 4.495 30.172 12.496 7.997 8.002 12.498 18.854 12.498 30.17v512.002h-362.669c51.606 0 94.652 36.644 104.534 85.33h300.8c0.722 0 1.434-0.015 2.145-0.051 5.294-26.010 20.050-48.579 40.52-63.954v-362.66h214.994c9.861 0.003 19.425 3.421 27.049 9.674 6.723 5.511 11.576 12.923 13.957 21.224v54.435h-170.665v85.332h170.665v170.67h-106.665v42.655c9.318 12.406 16 26.911 19.2 42.675h130.135c23.562 0 42.665-19.103 42.665-42.665v-358.059c0-2.808-0.276-5.609-0.829-8.362-5.796-29.017-21.473-55.128-44.355-73.891s-51.558-29.018-81.147-29.021h-215.004v-85.334c0-33.948-13.486-66.505-37.489-90.51s-56.566-37.49-90.511-37.49h-426.665c-33.95 0-66.505 13.486-90.509 37.49s-37.491 56.562-37.491 90.51v554.667c0 23.562 19.102 42.665 42.667 42.665h87.467c9.882-48.686 52.928-85.33 104.533-85.33h-149.333v-512.002c0-11.316 4.497-22.168 12.497-30.17 8-8.001 18.854-12.496 30.17-12.496h426.665z"
      ],
      "attrs": [
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        },
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        },
        {}
      ],
      "isMulticolor2": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "s": 0
          },
          {
            "s": 0
          },
          {}
        ]
      },
      "tags": [
        "delivery-truck"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M580.163 2.083c17.526 5.746 29.373 22.101 29.373 40.543v298.667h286.464c16.087 0 30.802 9.046 38.067 23.397s5.842 31.569-3.681 44.532l-438.872 597.335c-10.919 14.863-30.152 21.023-47.677 15.278s-29.374-22.098-29.374-40.54v-298.67h-286.464c-16.085 0-30.803-9.047-38.068-23.398s-5.84-31.565 3.684-44.529l438.87-597.334c10.921-14.862 30.152-21.027 47.677-15.281zM212.292 597.294h244.838c23.564 0 42.666 19.103 42.666 42.665v211.2l311.912-424.534h-244.838c-23.567 0-42.67-19.102-42.67-42.666v-211.199l-311.909 424.535z"
      ],
      "tags": [
        "flash-enable-allow-2--interface-essential 3"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M481.83 33.828c16.663-16.662 43.676-16.662 60.342 0l448 448c16.66 16.663 16.66 43.679 0 60.339l-448 448c-16.666 16.666-43.679 16.666-60.342 0l-448-448c-16.662-16.66-16.662-43.677 0-60.339l448-448zM124.34 511.998l387.66 387.658 387.661-387.658-387.661-387.66-387.66 387.66z",
        "M512.358 392.115c-45.492 0-79.192 33.696-79.192 79.146v203.094h-85.334v-203.094c0-92.618 71.944-164.48 164.525-164.48 92.595 0 164.48 71.881 164.48 164.48v121.855h-85.335v-121.855c0-45.471-33.674-79.146-79.145-79.146z",
        "M755.871 511.8l-121.856 162.473-121.815-162.473h243.671z"
      ],
      "tags": [
        "Return"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M-0.042 554.624c0-23.562 19.103-42.664 42.667-42.664h341.334v85.335h-298.667v341.33h511.998v-256h85.335v298.67c0 23.562-19.103 42.665-42.665 42.665h-597.335c-23.564 0-42.667-19.103-42.667-42.665v-426.67z",
        "M318.959 829.947l-298.666-183.47 44.665-72.709 276.23 169.687 190.954-118.395 44.964 72.525-213.332 132.27c-13.718 8.504-31.062 8.54-44.815 0.092z",
        "M682.706 298.666v-170.666h85.335v128h85.335v85.334h-128c-23.567 0-42.67-19.103-42.67-42.667z",
        "M426.708 298.626c0-164.949 133.717-298.667 298.668-298.667 164.946 0 298.665 133.718 298.665 298.667s-133.719 298.668-298.665 298.668c-164.951 0-298.668-133.72-298.668-298.668zM725.376 85.293c-117.821 0-213.335 95.513-213.335 213.334s95.514 213.334 213.335 213.334c117.816 0 213.33-95.513 213.33-213.334s-95.508-213.334-213.33-213.334z"
      ],
      "tags": [
        "email-clock"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M1024 655.078l-321.233-152.585 236.975-293.667-343.881 163.29-83.204-372.117-83.627 372.276-344.772-163.716 236.976 293.665-321.234 152.853 362.837 8.896-79.835 357.79 228.499-282.91 19.853 24.179 211.383 260.966-80.943-360.188 362.206-8.734zM232.974 325.942l225.181 106.941 54.502-242.112 44.501 199.506-196.744 93.417-127.441-157.753zM178.259 616.892l527.405-250.42-323.764 255.639-203.641-5.218zM362.573 856.128l45.026-201.050 323.708-255.374-368.733 456.423zM662.741 858.368l-105.323-129.685-19.063-23.275 136.922-169.417 170.359 80.9-235.977 5.751 53.082 235.725z",
        "M557.419 728.683l7.526 9.267-26.918 33.327-6.673-8.243-19.853-24.179 26.854-33.446 19.063 23.275zM659.059 621.436l-38.844 48.094-10.556-46.886 49.399-1.207zM702.767 502.494l37.845 17.975-27.162 33.626-38.174-18.103 27.49-33.498z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(211, 211, 211)"
        }
      ],
      "isMulticolor": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "f": 0
          },
          {
            "f": 3
          }
        ]
      },
      "tags": [
        "Astra"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M406.014 0l-316.912 82.182-87.337 315.55 109.232 111.042-110.996 109.21 82.196 316.932 315.54 87.292 111.017-109.231 109.231 111.023 316.915-82.18 87.313-315.575-109.21-110.997 110.997-109.21-82.197-316.952-315.584-87.294-110.972 109.21-109.233-111zM211.536 142.881l166.941-43.313 73.004 74.201-106.467 104.745-133.479-135.633zM578.010 174.761l74.18-72.972 166.221 45.988-135.659 133.455-104.742-106.47zM101.781 371.826l45.989-166.198 133.436 135.633-106.444 104.746-72.981-74.181zM745.472 345.015l135.659-133.498 43.268 166.953-74.159 72.995-104.768-106.45zM407.757 342.275l106.466-104.745 104.721 106.47-106.445 104.746-104.742-106.471zM237.526 509.769l106.443-104.746 104.786 106.47-106.485 104.747-104.744-106.47zM575.266 512.508l106.441-104.745 104.747 106.469-106.466 104.747-104.721-106.47zM99.559 645.53l74.201-73.015 104.722 106.492-135.614 133.436-43.309-166.912zM405.012 680l106.463-104.747 104.747 106.47-106.445 104.747-104.765-106.47zM742.729 682.761l106.466-104.747 73.003 74.18-45.969 166.199-133.5-135.633zM205.588 876.245l135.636-133.5 104.787 106.47-74.201 73.015-166.223-45.986zM572.518 850.231l106.445-104.747 133.457 135.654-166.921 43.294-72.981-74.202z"
      ],
      "tags": [
        "Plaid"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M393.089 6.673c13.977-8.895 31.84-8.895 45.817 0l371.539 236.459c16.005 10.185 23.363 29.712 18.058 47.925s-21.996 30.737-40.965 30.737h-743.082c-18.969 0-35.661-12.524-40.965-30.737s2.053-37.74 18.057-47.925l371.541-236.459zM190.964 236.46h450.065l-225.032-143.217-225.034 143.217z",
        "M448 778.665h-448v-85.33h448v85.33z",
        "M290.133 640v-256h85.333v256h-85.333z",
        "M110.933 640v-256h85.333v256h-85.333z",
        "M469.334 640v-256h85.331v256h-85.331z",
        "M596.040 802.314c-30.843 30.848-30.843 80.86 0 111.708 30.848 30.843 80.86 30.843 111.708 0l77.353-77.353 60.191 60.186-77.353 77.353c-64.087 64.092-167.997 64.092-232.084 0-64.089-64.087-64.089-167.992 0-232.084l77.353-77.353 60.186 60.191-77.353 77.353z",
        "M664.771 613.207l77.353-77.353c64.092-64.089 167.997-64.089 232.084 0 64.092 64.087 64.092 167.997 0 232.084l-77.353 77.353-60.186-60.191 77.353-77.353c30.848-30.848 30.848-80.86 0-111.708-30.848-30.843-80.86-30.843-111.708 0l-77.353 77.353-60.191-60.186z",
        "M888.259 681.994l-206.275 206.275-60.186-60.186 206.275-206.275 60.186 60.186z"
      ],
      "tags": [
        "Linked-accounts"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M234.666 0c5.696-0 11.416 1.139 16.807 3.45l597.33 256c15.693 6.724 25.861 22.149 25.861 39.217s-10.168 32.494-25.861 39.217l-597.33 255.995c-5.391 2.314-11.111 3.456-16.807 3.456v426.665h-128v-1024h127.989c0.004 0 0.007 0 0.011 0z"
      ],
      "tags": [
        "award-flag-rewards-rating-filled"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 1024v-1024h85.334v1024h-85.334z",
        "M170.667 42.667c0-23.564 19.103-42.667 42.667-42.667h768.001c15.734 0 30.193 8.661 37.617 22.534s6.61 30.707-2.115 43.8l-154.89 232.333 154.89 232.334c8.724 13.092 9.539 29.926 2.115 43.796-7.424 13.875-21.883 22.538-37.617 22.538h-768.001c-23.564 0-42.667-19.103-42.667-42.67v-511.998zM256.001 85.334v426.666h645.611l-126.444-189.666c-9.554-14.331-9.554-33.002 0-47.334l126.444-189.666h-645.611z"
      ],
      "tags": [
        "award-flag-10-rewards-rating"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M213.333 1024v-1024h85.333v1024h-85.333z",
        "M232.512 7.047c11.973-7.895 27.112-9.247 40.295-3.597l597.332 256c15.688 6.724 25.861 22.149 25.861 39.217s-10.173 32.493-25.861 39.217l-597.332 256.001c-13.182 5.647-28.322 4.296-40.295-3.599s-19.179-21.274-19.179-35.62v-511.998c0-14.342 7.205-27.725 19.179-35.62zM298.666 107.373v382.588l446.355-191.294-446.355-191.294z"
      ],
      "tags": [
        "award-flag-rewards-rating"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M710.477 93.466c-52.127-11.87-106.394-10.491-157.85 4.009s-98.458 41.66-136.715 79.001l-59.603-61.068c48.459-47.297 107.996-81.7 173.171-100.067 65.178-18.367 133.919-20.113 199.941-5.078 66.028 15.035 127.232 46.372 178.028 91.149 50.801 44.776 89.569 101.566 112.773 165.182 23.199 63.616 30.095 132.031 20.055 198.998-10.045 66.966-36.705 130.351-77.548 184.362l-68.065-51.471c32.246-42.639 53.294-92.678 61.22-145.546 7.931-52.869 2.488-106.881-15.831-157.104s-48.927-95.057-89.027-130.407c-40.105-35.35-88.428-60.089-140.549-71.96z",
        "M426.218 298.668c-176.731 0-320 143.269-320 320.003 0 176.727 143.269 320 320 320 176.733 0 320.001-143.273 320.001-320 0-176.734-143.268-320.003-320.001-320.003zM20.885 618.67c0-223.862 181.474-405.336 405.333-405.336 223.858 0 405.331 181.474 405.331 405.336 0 223.857-181.473 405.33-405.331 405.33-223.859 0-405.333-181.473-405.333-405.33z",
        "M635.284 742.4c0 42.414-34.386 76.8-76.8 76.8s-76.799-34.386-76.799-76.8c0-42.414 34.385-76.8 76.799-76.8s76.8 34.386 76.8 76.8z",
        "M246.715 737.828l307.197-307.198 60.344 60.34-307.202 307.197-60.34-60.339z",
        "M379.285 486.4c0 42.414-34.384 76.8-76.8 76.8s-76.8-34.386-76.8-76.8c0-42.416 34.385-76.8 76.8-76.8s76.8 34.384 76.8 76.8z"
      ],
      "width": 1075,
      "tags": [
        "Analytic Percentage--double"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M556.913 938.665c-235.64 0-426.665-191.022-426.665-426.665 0-235.641 191.025-426.666 426.665-426.666 235.643 0 426.67 191.025 426.67 426.666 0 235.643-191.027 426.665-426.67 426.665zM556.913 1024c282.772 0 512-229.233 512-512 0-282.77-229.228-512-512-512-282.768 0-511.999 229.23-511.999 512 0 282.767 229.23 512 511.999 512z",
        "M313.412 695.163l426.669-426.666 60.339 60.34-426.669 426.665-60.34-60.339z",
        "M343.581 384.001c0-47.128 38.205-85.334 85.333-85.334s85.334 38.205 85.334 85.334c0 47.128-38.206 85.334-85.334 85.334s-85.333-38.205-85.333-85.334z",
        "M599.583 640c0-47.13 38.2-85.335 85.33-85.335s85.335 38.205 85.335 85.335c0 47.13-38.205 85.335-85.335 85.335s-85.33-38.205-85.33-85.335z"
      ],
      "width": 1075,
      "tags": [
        "Analytic Percentage"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M1059.558 286.17l-414.167 414.17-213.335-213.333-311.163 311.161-60.34-60.339 371.503-371.502 213.335 213.335 353.828-353.831 60.339 60.34z",
        "M986.721 298.666h-213.33v-85.333h298.665v298.666h-85.335v-213.334z"
      ],
      "width": 1075,
      "tags": [
        "Graph Stats Ascend"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M450.695 85.336c59.166 0.018 117.313 15.415 168.728 44.681 51.425 29.265 94.356 71.395 124.585 122.254s46.72 108.704 47.852 167.859c1.132 59.156-13.128 117.588-41.39 169.571l67.159 53.714c33.372-56.479 53.263-119.895 58.132-185.317 4.864-65.424-5.432-131.087-30.080-191.882-24.653-60.795-63.002-115.083-112.056-158.64s-107.5-75.209-170.783-92.493c-63.289-17.284-129.708-19.735-194.095-7.162s-125.005 39.832-177.138 79.656c-52.133 39.823-94.375 91.138-123.441 149.95s-44.171 123.538-44.14 189.142c0.003 102.683 37.233 201.883 104.79 279.21l60.33-60.288c-41.747-49.746-68.421-110.382-76.886-174.775-8.464-64.391 1.634-129.86 29.106-188.708s71.177-108.628 125.974-143.486c54.797-34.858 118.408-53.345 183.352-53.287z",
        "M962.693 768v110.336l-183.168-183.127c-7.997-7.997-18.847-12.493-30.162-12.493s-22.17 4.495-30.167 12.493l-183.168 183.127-225.835-225.792-60.33 60.329 256 256c8.001 8.003 18.85 12.493 30.166 12.493s22.164-4.49 30.167-12.493l183.168-183.168 153.001 152.96h-110.336v85.335h256v-256h-85.335z",
        "M674.365 530.637c0 42.414-34.386 76.8-76.8 76.8s-76.8-34.386-76.8-76.8c0-42.415 34.386-76.799 76.8-76.799s76.8 34.385 76.8 76.799z",
        "M418.365 274.637c0 42.416-34.384 76.8-76.8 76.8s-76.8-34.384-76.8-76.8c0-42.415 34.385-76.8 76.8-76.8s76.8 34.385 76.8 76.8z",
        "M285.795 526.070l307.198-307.203 60.344 60.34-307.203 307.202-60.34-60.339z"
      ],
      "width": 1075,
      "tags": [
        "Percentage Decrease"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M391.785 761.042c-64.91-7.286-126.18-33.736-175.999-75.976-49.82-42.245-85.933-98.365-103.735-161.208-17.802-62.844-16.488-129.567 3.776-191.662s58.559-116.748 110.004-156.995c51.444-40.246 113.709-64.262 178.855-68.986s130.226 10.058 186.94 42.462c56.709 32.404 102.487 80.962 131.497 139.483 29.015 58.522 39.936 124.356 31.391 189.11h82.514c7.869-77.588-6.615-155.812-41.743-225.441s-89.431-127.76-156.518-167.536c-67.082-39.777-144.14-59.539-222.086-56.956s-153.527 27.403-217.829 71.533c-64.302 44.13-114.642 105.729-145.083 177.531s-39.713 150.812-26.722 227.71c12.991 76.901 47.703 148.478 100.041 206.299 52.339 57.815 120.12 99.461 195.351 120.018l69.348-69.386z",
        "M647.885 556.774c0 42.414-34.386 76.8-76.8 76.8-42.419 0-76.802-34.386-76.802-76.8 0-42.419 34.383-76.803 76.802-76.803 42.414 0 76.8 34.383 76.8 76.803z",
        "M391.883 300.772c0 42.416-34.384 76.8-76.8 76.8s-76.8-34.384-76.8-76.8c0-42.416 34.384-76.8 76.8-76.8s76.8 34.384 76.8 76.8z",
        "M259.314 552.202l307.198-307.201 60.339 60.34-307.198 307.2-60.34-60.339z",
        "M757.335 559.048v81.782h105.733l-146.627 146.627-93.757-93.716c-7.665-7.67-18.063-11.976-28.908-11.976s-21.243 4.306-28.908 11.976l-245.335 245.33 57.817 57.82 216.425-216.428 93.757 93.763c7.67 7.66 18.068 11.971 28.908 11.971 10.844 0 21.243-4.311 28.913-11.971l175.534-175.539v105.697h81.777v-245.335h-245.33z"
      ],
      "tags": [
        "Percentage Increase"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M256 0h727.040c20.48 0 40.96 20.48 40.96 40.96v491.52c0 25.6-20.48 40.96-40.96 40.96h-256v-81.92h215.040v-235.521h-645.12v174.081h-81.92v-389.12c0-20.48 15.36-40.96 40.96-40.96zM942.080 168.959v-81.919h-645.12v81.919h645.12z",
        "M40.96 512h168.96c25.6 0 46.080 20.48 46.080 40.96v5.12h302.080c20.48 0 35.84 15.36 40.96 30.72l35.84 138.24h184.32c20.48 0 46.080 5.12 61.44 15.36 20.48 10.24 35.84 30.72 46.080 46.080 10.24 20.48 15.36 40.96 15.36 66.56 0 20.48-10.24 46.080-20.48 61.44-5.12 10.24-15.36 15.36-25.6 20.48l-460.8 87.040h-10.24c-5.12 0-15.36 0-20.48-5.12l-159.255-94.797c-7.847 8.31-19.016 12.877-30.185 12.877h-174.080c-20.48 0-40.96-15.36-40.96-40.96v-343.040c0-20.48 20.48-40.96 40.96-40.96zM256 645.12v186.158l179.2 105.682 419.84-76.8v-5.12c0-5.12 0-15.36-5.12-20.48l-15.36-15.36c-5.12-5.12-15.36-5.12-20.48-5.12h-430.080v-87.040h159.478l-21.238-81.92h-266.24zM87.040 855.040h87.040v-256h-87.040v256z"
      ],
      "tags": [
        "credit-account"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 725.33c0-23.562 19.103-42.665 42.667-42.665h192c23.564 0 42.667 19.103 42.667 42.665v256c0 23.567-19.103 42.67-42.667 42.67h-192c-23.564 0-42.667-19.103-42.667-42.67v-256zM85.334 768v170.665h106.666v-170.665h-106.666z",
        "M373.333 469.332c0-23.564 19.102-42.667 42.666-42.667h192.001c23.562 0 42.665 19.103 42.665 42.667v511.997c0 23.567-19.103 42.67-42.665 42.67h-192.001c-23.564 0-42.666-19.103-42.666-42.67v-511.997zM458.666 511.999v426.666h106.669v-426.666h-106.669z",
        "M746.665 597.33c0-23.562 19.103-42.665 42.67-42.665h192c23.562 0 42.665 19.103 42.665 42.665v384c0 23.567-19.103 42.67-42.665 42.67h-192c-23.567 0-42.67-19.103-42.67-42.67v-384zM832 640v298.665h106.665v-298.665h-106.665z",
        "M1024 85.334c0 47.128-38.2 85.333-85.33 85.333-8.468 0-16.645-1.233-24.366-3.529l-108.6 102.78c3.215 8.982 4.961 18.66 4.961 28.746 0 47.129-38.2 85.334-85.33 85.334-37.228 0-68.884-23.836-80.548-57.077l-277.548-62.788c-15.548 20.954-40.475 34.534-68.572 34.534-10.781 0-21.094-1.999-30.591-5.647l-193.718 214.906-63.383-57.134 203.201-225.427c-0.555-3.931-0.842-7.948-0.842-12.031 0-47.129 38.205-85.334 85.333-85.334 34.832 0 64.79 20.87 78.051 50.787l283.92 64.229c15.647-18.177 38.825-29.685 64.696-29.685 5.007 0 9.912 0.431 14.684 1.259l115.63-109.433c-1.516-6.362-2.314-12.999-2.314-19.824 0-47.128 38.205-85.334 85.335-85.334s85.33 38.205 85.33 85.334z"
      ],
      "tags": [
        "graph-analytics"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M96.355 511.999c4.497-5.611 9.757-12.022 15.733-19.067 22.778-26.854 55.693-62.597 96.216-98.222 82.425-72.461 189.817-138.711 303.696-138.711s221.271 66.25 303.698 138.711c40.52 35.625 73.436 71.367 96.215 98.222 5.975 7.045 11.233 13.456 15.734 19.067-4.5 5.613-9.759 12.023-15.734 19.068-22.779 26.854-55.695 62.597-96.215 98.222-82.427 72.458-189.819 138.711-303.698 138.711s-221.271-66.253-303.696-138.711c-40.523-35.625-73.438-71.368-96.216-98.222-5.976-7.045-11.235-13.455-15.733-19.068zM981.335 511.999c34.893-24.551 34.888-24.562 34.877-24.574l-0.077-0.111-0.174-0.243-0.573-0.804c-0.486-0.675-1.172-1.627-2.058-2.835-1.772-2.418-4.337-5.868-7.654-10.203-6.636-8.666-16.302-20.893-28.687-35.496-24.719-29.145-60.539-68.070-104.95-107.111-87.444-76.872-214.717-159.956-360.038-159.956s-272.595 83.084-360.037 159.956c-44.41 39.042-80.229 77.966-104.951 107.111-12.387 14.603-22.054 26.831-28.688 35.496-3.319 4.335-5.883 7.785-7.654 10.203-0.886 1.209-1.573 2.16-2.058 2.835l-0.574 0.804-0.229 0.323c-0.009 0.012-0.038 0.053 34.858 24.605l-34.895-24.551c-10.362 14.728-10.362 34.373 0 49.103l34.895-24.551c-34.895 24.551-34.904 24.541-34.895 24.551l0.094 0.133 0.172 0.246 0.574 0.804c0.485 0.671 1.172 1.623 2.058 2.831 1.771 2.417 4.335 5.868 7.654 10.204 6.634 8.668 16.302 20.895 28.688 35.497 24.722 29.143 60.541 68.070 104.951 107.11 87.442 76.872 214.716 159.954 360.037 159.954s272.594-83.082 360.038-159.954c44.411-39.040 80.23-77.967 104.95-107.11 12.385-14.602 22.052-26.829 28.687-35.497 3.318-4.337 5.883-7.788 7.654-10.204 0.886-1.208 1.572-2.161 2.058-2.831l0.573-0.804 0.174-0.246 0.056-0.082c0.010-0.010 0.036-0.051-34.857-24.603zM981.335 511.999l34.877-24.574c10.363 14.728 10.378 34.396 0.015 49.126l-34.893-24.551z",
        "M341.334 512c0-94.258 76.408-170.665 170.666-170.665 94.259 0 170.665 76.408 170.665 170.665 0 94.259-76.406 170.67-170.665 170.67-94.258 0-170.666-76.411-170.666-170.67zM512 426.668c-47.13 0-85.333 38.203-85.333 85.332s38.203 85.335 85.333 85.335c47.13 0 85.335-38.205 85.335-85.335s-38.205-85.332-85.335-85.332z"
      ],
      "tags": [
        "view-enable-allow-2-interface-essential-24"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M78.713 402.041c44.246-47.62 108.12-107.641 185.207-154.556l44.363 72.895c-68.016 41.394-125.861 95.408-167.056 139.746-18.899 20.34-34.067 38.397-44.872 51.875 4.498 5.612 9.757 12.022 15.733 19.067 22.778 26.854 55.693 62.597 96.217 98.222 82.424 72.463 189.817 138.711 303.695 138.711 70.912 0 139.622-25.646 202.092-63.391l44.124 73.042c-70.748 42.742-154.767 75.684-246.216 75.684-145.321 0-272.595-83.082-360.037-159.954-44.41-39.045-80.229-77.967-104.951-107.116-12.387-14.602-22.054-26.829-28.688-35.492-3.319-4.337-5.883-7.788-7.654-10.204-0.886-1.208-1.573-2.161-2.058-2.836l-0.746-1.044-0.057-0.082c-0.009-0.010-0.038-0.051 34.858-24.607-34.895-24.549-34.89-24.557-34.885-24.565l0.138-0.196 0.293-0.413 1.016-1.414c0.866-1.199 2.109-2.901 3.717-5.061 3.214-4.318 7.888-10.471 13.923-18.080 12.059-15.205 29.609-36.299 51.844-60.231zM42.667 512l-34.885-24.565c-10.362 14.728-10.373 34.39-0.011 49.12l34.895-24.556z",
        "M431.672 179.494c26.561-5.84 55.967-8.829 80.328-8.829 145.321 0 272.594 83.084 360.038 159.956 44.411 39.042 80.23 77.966 104.95 107.111 12.385 14.603 22.052 26.831 28.687 35.496 3.318 4.335 5.883 7.785 7.654 10.203 0.886 1.209 1.572 2.16 2.058 2.835l0.573 0.804 0.174 0.243 0.056 0.080 0.020 0.030c0.010 0.012 0.015 0.023-34.877 24.574 34.893 24.551 34.888 24.557 34.888 24.562l-0.031 0.046-0.061 0.082-0.179 0.256-0.609 0.85c-0.512 0.712-1.239 1.72-2.176 2.995-1.874 2.56-4.593 6.205-8.11 10.783-7.025 9.155-17.265 22.057-30.377 37.402-26.158 30.628-64.041 71.352-110.909 111.59l-55.583-64.748c42.685-36.649 77.481-74.015 101.612-102.267 6.856-8.023 12.826-15.288 17.848-21.551-4.5-5.611-9.759-12.022-15.734-19.067-22.779-26.854-55.695-62.597-96.215-98.222-82.427-72.461-189.819-138.711-303.698-138.711-18.306 0-41.566 2.344-62.005 6.838-10.179 2.238-18.747 4.812-25.204 7.443-5.998 2.445-8.119 4.114-8.143 4.084-0.005-0.006 0.062-0.069 0.189-0.196l-60.34-60.34c10.814-10.814 24.483-17.841 36.087-22.57 12.252-4.993 25.766-8.836 39.088-11.764zM981.335 511.999l34.893 24.551c10.363-14.725 10.363-34.375 0-49.103l-34.893 24.551z",
        "M943.165 1014.17l-936.002-935.998 60.34-60.34 936.002 935.999-60.339 60.339z",
        "M421.491 602.511c49.985 49.987 131.029 49.987 181.021 0l-181.021-181.021c-49.988 49.989-49.988 131.029 0 181.021z"
      ],
      "tags": [
        "view-off-disable-interface-essential-24"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M505.752 530.744l-140.497-140.496-60.34 60.34 170.667 170.668c8.002 8.003 18.854 12.498 30.17 12.498 11.317 0 22.166-4.495 30.169-12.498l170.67-170.668-60.344-60.34-140.494 140.496z"
      ],
      "tags": [
        "down-arrow-filter-chevron-small"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M531.348 656.087c-8.602 12.682-30.097 12.682-38.696 0l-182.426-269.142c-8.599-12.687 2.15-28.545 19.348-28.545h364.851c17.198 0 27.945 15.858 19.348 28.545l-182.426 269.142z"
      ],
      "tags": [
        "down-arrow-filter-sort"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M518.246 493.255l140.498 140.499 60.339-60.344-170.665-170.664c-16.666-16.663-43.678-16.663-60.341 0l-170.666 170.664 60.34 60.344 140.495-140.499z"
      ],
      "tags": [
        "up-arrow-filter-chevron-small"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M492.652 367.915c8.599-12.687 30.095-12.687 38.696 0l182.426 269.141c8.596 12.687-2.15 28.544-19.348 28.544h-364.851c-17.198 0-27.947-15.857-19.348-28.544l182.426-269.141z"
      ],
      "tags": [
        "up-arrow-filter-sort"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M465.070 465.066h-312.354v93.869h312.354v312.351h93.865v-312.351h312.356v-93.869h-312.356v-312.355h-93.865v312.355z"
      ],
      "tags": [
        "add-plus-small"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M465.070 465.066h-414.755v93.869h414.755v414.751h93.865v-414.751h414.756v-93.869h-414.756v-414.755l-93.865-0v414.755z"
      ],
      "tags": [
        "add-plus"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M343.233 765.988l560.995-605.875 68.874 63.774-563.866 608.978c-33.403 36.076-89.637 38.497-126.016 5.422l-229.457-208.594 63.141-69.458 226.329 205.752z"
      ],
      "tags": [
        "approve-v-check-validation"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M514.468 658.012l-350.814-350.812-66.374 66.374 353.83 353.83c34.991 34.99 91.723 34.99 126.713 0l353.833-353.83-66.376-66.374-350.812 350.812z"
      ],
      "tags": [
        "arrow-down-chevron"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M365.987 512l350.813-350.813-66.376-66.374-353.828 353.83c-34.991 34.991-34.991 91.721 0 126.711l353.828 353.833 66.376-66.376-350.813-350.812z"
      ],
      "tags": [
        "arrow-left-chevron"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M658.012 512l-350.812-350.813 66.374-66.374 353.83 353.83c34.99 34.991 34.99 91.721 0 126.711l-353.83 353.833-66.374-66.376 350.812-350.812z"
      ],
      "tags": [
        "arrow-right-chevron"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M514.468 365.987l-350.814 350.813-66.374-66.376 353.83-353.828c34.991-34.991 91.723-34.991 126.713 0l353.833 353.828-66.376 66.376-350.812-350.813z"
      ],
      "tags": [
        "arrow-up-chevron"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M512 1024c282.767 0 512-229.233 512-512 0-282.77-229.233-512-512-512-282.77 0-512 229.23-512 512 0 282.767 229.23 512 512 512zM224.759 732.867l220.868-220.867-220.868-220.868 66.374-66.374 220.868 220.868 220.867-220.868 66.376 66.374-220.867 220.868 220.867 220.867-66.376 66.376-220.867-220.867-220.868 220.867-66.374-66.376z"
      ],
      "tags": [
        "delete-close-x-circle"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M445.627 512l-257.072 257.070 66.374 66.376 257.072-257.070 257.070 257.070 66.376-66.376-257.070-257.070 257.070-257.072-66.376-66.374-257.070 257.072-257.072-257.072-66.374 66.374 257.072 257.072z"
      ],
      "tags": [
        "delete-close-x-small"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M445.626 512l-329.48 329.482 66.374 66.371 329.479-329.477 329.482 329.477 66.371-66.371-329.477-329.482 329.477-329.48-66.371-66.374-329.482 329.48-329.479-329.48-66.374 66.374 329.48 329.48z"
      ],
      "tags": [
        "delete-close-x"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M768 597.334c-47.128 0-85.334-38.205-85.334-85.334s38.205-85.334 85.334-85.334c47.128 0 85.334 38.205 85.334 85.334s-38.205 85.334-85.334 85.334z",
        "M512 597.334c-47.128 0-85.334-38.205-85.334-85.334s38.205-85.334 85.334-85.334c47.128 0 85.334 38.205 85.334 85.334s-38.205 85.334-85.334 85.334z",
        "M256.001 597.334c-47.128 0-85.334-38.205-85.334-85.334s38.205-85.334 85.334-85.334c47.128 0 85.334 38.205 85.334 85.334s-38.205 85.334-85.334 85.334z"
      ],
      "tags": [
        "menu-horizontal-dots"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M597.334 256c0 47.128-38.205 85.334-85.334 85.334s-85.334-38.205-85.334-85.334c0-47.128 38.205-85.334 85.334-85.334s85.334 38.205 85.334 85.334z",
        "M597.334 512c0 47.128-38.205 85.334-85.334 85.334s-85.334-38.205-85.334-85.334c0-47.128 38.205-85.334 85.334-85.334s85.334 38.205 85.334 85.334z",
        "M597.334 768c0 47.128-38.205 85.334-85.334 85.334s-85.334-38.205-85.334-85.334c0-47.128 38.205-85.334 85.334-85.334s85.334 38.205 85.334 85.334z"
      ],
      "tags": [
        "menu-vertical-dots"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M554.665 399.359v93.866h-85.331v-93.866h85.331z",
        "M554.665 774.825v93.865h-85.331v-93.865h85.331z",
        "M85.334 298.665c0-23.564 19.102-42.666 42.666-42.666h768c23.562 0 42.665 19.103 42.665 42.666v682.664c0 23.567-19.103 42.67-42.665 42.67h-768c-23.564 0-42.666-19.103-42.666-42.67v-682.664zM170.666 341.332v597.332h682.669v-597.332h-682.669z",
        "M375.466 493.225c0-23.564 19.103-42.666 42.667-42.666h187.732c23.567 0 42.67 19.102 42.67 42.666v62.591h-85.335v-19.927h-102.401v46.336l152.085 25.375c20.572 3.43 35.651 21.228 35.651 42.081v125.143c0 23.562-19.103 42.665-42.67 42.665h-187.732c-23.564 0-42.667-19.103-42.667-42.665v-62.592h85.334v19.927h102.401v-46.336l-152.088-25.37c-20.571-3.436-35.646-21.233-35.646-42.086v-125.143z",
        "M217.838 23.586c7.227-14.455 22.002-23.586 38.162-23.586h512c16.159 0 30.935 9.131 38.164 23.586l128 256c6.61 13.226 5.903 28.933-1.869 41.512-7.777 12.579-21.509 20.236-36.296 20.236h-768c-14.787 0-28.52-7.657-36.295-20.236s-8.481-28.286-1.868-41.512l128-256zM282.37 85.334l-85.334 170.666h629.926l-85.33-170.666h-459.262z",
        "M554.665 42.667v256h-85.331v-256h85.331z"
      ],
      "tags": [
        "payment-box-reserve"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M432.151 105.836c80.664-15.841 164.222-7.3 240.013 24.535 75.796 31.834 140.39 85.518 185.554 154.208 45.158 68.689 68.844 149.274 68.029 231.477l-76.8-0.763c0.666-66.948-18.621-132.577-55.404-188.521s-89.39-99.666-151.117-125.593c-61.732-25.927-129.782-32.883-195.478-19.982-65.697 12.901-126.064 45.074-173.404 92.419l-53.122 53.088-54.288-54.324 53.102-53.067c0.003-0.003-0.004 0.004 0 0 58.124-58.126 132.252-97.637 212.913-113.476z",
        "M379.132 326.138h-212.412v-212.378l212.412 212.378z",
        "M166.298 739.395c-45.161-68.68-68.846-149.258-68.038-231.452l76.796 0.755c-0.658 66.943 18.632 132.567 55.412 188.497 36.78 55.941 89.384 99.656 151.106 125.583zM166.298 739.395c45.16 68.68 109.749 122.358 185.534 154.194 75.785 31.831 159.334 40.371 239.994 24.54 80.655-15.831 154.772-55.322 212.9-113.439-0.005 0.005 0 0 0 0l53.11-53.074-54.287-54.323-53.115 53.074c-47.34 47.334-107.709 79.508-173.399 92.401-65.692 12.897-133.739 5.934-195.461-19.988z",
        "M857.211 910.3v-212.378h-212.408l212.408 212.378z",
        "M542.72 460.8h-61.44c-8.147 0-15.962-3.238-21.722-8.998s-8.998-13.575-8.998-21.722c0-8.147 3.238-15.962 8.998-21.722s13.575-8.998 21.722-8.998h122.88v-61.44h-61.44v-30.72h-61.44v30.72c-24.441 0-47.883 9.711-65.166 26.994s-26.994 40.726-26.994 65.166c0 24.441 9.711 47.883 26.994 65.166 17.283 17.281 40.726 26.994 65.166 26.994h61.44c8.146 0 15.964 3.236 21.724 8.996s8.996 13.578 8.996 21.724c0 8.146-3.236 15.964-8.996 21.724s-13.578 8.996-21.724 8.996h-122.88v61.44h61.44v30.72h61.44v-30.72c24.443 0 47.882-9.713 65.167-26.993 17.28-17.285 26.993-40.724 26.993-65.167s-9.713-47.883-26.993-65.166c-17.285-17.283-40.724-26.994-65.167-26.994z",
        "M614.4 409.6v-81.92h-61.44v-30.72h-81.92v31.233c-23.396 2.351-45.393 12.706-62.167 29.48-19.203 19.204-29.993 45.251-29.993 72.407s10.79 53.204 29.993 72.407c19.203 19.205 45.25 29.993 72.407 29.993h61.44c5.432 0 10.639 2.161 14.479 6.001s6.001 9.047 6.001 14.479c0 5.432-2.161 10.639-6.001 14.479s-9.047 6.001-14.479 6.001h-133.12v81.92h61.44v30.72h81.92v-31.232c23.398-2.35 45.394-12.708 62.167-29.481 19.205-19.205 29.993-45.251 29.993-72.407s-10.788-53.203-29.993-72.407c-19.205-19.203-45.251-29.993-72.407-29.993h-61.44c-5.431 0-10.641-2.159-14.481-5.999s-5.999-9.051-5.999-14.481c0-5.431 2.159-10.641 5.999-14.481s9.051-5.999 14.481-5.999h133.12zM604.16 337.92v61.44h-122.88c-8.147 0-15.962 3.238-21.722 8.998s-8.998 13.575-8.998 21.722c0 8.147 3.238 15.962 8.998 21.722s13.575 8.998 21.722 8.998h61.44c24.443 0 47.882 9.711 65.167 26.994 17.28 17.283 26.993 40.723 26.993 65.166s-9.713 47.882-26.993 65.167c-17.285 17.28-40.724 26.993-65.167 26.993v30.72h-61.44v-30.72h-61.44v-61.44h122.88c8.146 0 15.964-3.236 21.724-8.996s8.996-13.578 8.996-21.724c0-8.146-3.236-15.964-8.996-21.724s-13.578-8.996-21.724-8.996h-61.44c-24.441 0-47.883-9.713-65.166-26.994-17.283-17.283-26.994-40.726-26.994-65.166s9.711-47.883 26.994-65.166c17.283-17.283 40.726-26.994 65.166-26.994v-30.72h61.44v30.72h61.44z"
      ],
      "tags": [
        "money-recurring-payment"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M406.027 0l-316.939 81.28-87.345 312.086 109.241 109.824-111.006 108.010 82.203 313.452 315.567 86.333 111.028-108.032 109.239 109.804 316.938-81.28 87.327-312.105-109.22-109.782 111.007-108.011-82.207-313.472-315.607-86.336-110.986 108.011-109.24-109.782zM211.532 141.312l166.956-42.838 73.009 73.387-106.474 103.594-133.49-134.144zM578.038 172.842l74.184-72.17 166.236 45.482-135.67 131.99-104.75-105.302zM101.768 367.744l45.993-164.374 133.447 134.144-106.452 103.595-72.987-73.366zM745.513 341.226l135.67-132.032 43.269 165.12-74.163 72.192-104.776-105.28zM407.77 338.518l106.473-103.595 104.735 105.302-106.455 103.594-104.753-105.301zM237.524 504.17l106.452-103.594 104.796 105.302-106.496 103.592-104.753-105.299zM575.293 506.88l106.45-103.594 104.755 105.301-106.476 103.597-104.73-105.303zM99.546 638.444l74.208-72.212 104.731 105.318-135.626 131.968-43.313-165.074zM405.025 672.532l106.474-103.593 104.755 105.298-106.454 103.598-104.775-105.303zM742.769 675.261l106.476-103.593 73.011 73.364-45.972 164.372-133.514-134.144zM205.584 866.621l135.647-132.029 104.797 105.303-74.207 72.212-166.237-45.486zM572.549 840.893l106.45-103.593 133.468 134.164-166.932 42.819-72.986-73.39z"
      ],
      "tags": [
        "Plaid_logo"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 146.838c0-52.819 42.738-95.638 95.458-95.638h833.085c52.721 0 95.457 42.819 95.457 95.638v730.326c0 52.818-42.737 95.636-95.457 95.636h-833.085c-52.72 0-95.458-42.819-95.458-95.636v-730.326zM95.458 138.143c-4.793 0-8.678 3.893-8.678 8.694v730.326c0 4.803 3.885 8.694 8.678 8.694h833.085c4.792 0 8.678-3.891 8.678-8.694v-730.326c0-4.802-3.886-8.694-8.678-8.694h-833.085z",
        "M768 648.535h-256v-85.335h256v85.335z",
        "M366.327 520.53l-97.83-97.828 60.34-60.34 128 128c16.663 16.663 16.663 43.679 0 60.34l-128 128-60.34-60.339 97.83-97.833z"
      ],
      "tags": [
        "page-coding-3"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M179.698 511.982l188.246-166.424-67.825-76.718-231.634 204.783c-10.993 9.718-17.288 23.686-17.288 38.359 0 14.671 6.295 28.639 17.288 38.356l231.634 204.785 67.825-76.718-188.246-166.423z",
        "M844.288 512.020l-188.247 166.42 67.825 76.718 231.634-204.78c10.993-9.723 17.285-23.69 17.285-38.359 0-14.675-6.292-28.643-17.285-38.361l-231.634-204.783-67.825 76.718 188.247 166.426z"
      ],
      "tags": [
        "code-simple"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h938.668c23.562 0 42.665 19.103 42.665 42.667v938.668c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-938.668zM85.334 85.334v853.331h853.331v-853.331h-853.331zM853.335 682.665h-170.67v-85.33h170.67v85.33zM853.335 853.335h-512.002v-85.335h512.002v85.335z",
        "M403.414 217.215c-46.036-0.008-91.041 13.636-129.323 39.207s-68.12 61.921-85.741 104.452c-17.622 42.53-22.234 89.332-13.255 134.484 8.979 45.155 31.147 86.627 63.7 119.18s74.028 54.723 119.181 63.703c45.152 8.975 91.953 4.362 134.484-13.256 42.53-17.623 78.882-47.462 104.451-85.745 25.569-38.277 39.214-83.285 39.209-129.321h-232.706v-232.704z",
        "M490.666 128v232.746h232.749c0-61.728-24.525-120.928-68.173-164.577s-102.845-68.17-164.576-68.17v0z"
      ],
      "tags": [
        "dashboard-displa-data"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 85.332c0-23.564 19.103-42.667 42.667-42.667h938.668c23.562 0 42.665 19.103 42.665 42.667v853.332c0 23.567-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.098-42.667-42.665v-853.332zM85.334 127.999v768.001h853.331v-768.001h-853.331z",
        "M213.333 255.999c23.564 0 42.666-19.103 42.666-42.666s-19.103-42.667-42.666-42.667c-23.564 0-42.666 19.103-42.666 42.667s19.103 42.666 42.666 42.666z",
        "M384.001 255.999c23.564 0 42.666-19.103 42.666-42.666s-19.103-42.667-42.666-42.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.666 42.667 42.666z",
        "M981.335 383.999h-938.669v-85.334h938.669v85.334z",
        "M768 768h-256v-85.335h256v85.335z",
        "M366.327 640l-97.83-97.833 60.34-60.339 128 127.999c16.663 16.66 16.663 43.679 0 60.339l-128 128-60.34-60.339 97.83-97.828z"
      ],
      "tags": [
        "icon-page-coding"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M8.533 204.798c0-80.118 64.948-145.066 145.067-145.066h716.801c80.118 0 145.065 64.948 145.065 145.066v614.402c0 80.118-64.947 145.065-145.065 145.065h-716.801c-80.118 0-145.067-64.947-145.067-145.065v-614.402zM153.599 145.064c-32.99 0-59.734 26.744-59.734 59.734v614.402c0 32.988 26.744 59.73 59.734 59.73h716.801c32.988 0 59.735-26.742 59.735-59.73v-614.402c0-32.99-26.747-59.734-59.735-59.734h-716.801z",
        "M666.926 512l-99.763-95.004 61.532-58.596 130.524 124.302c16.993 16.181 16.993 42.416 0 58.595l-130.524 124.303-61.532-58.598 99.763-95.002z",
        "M361.039 521.139l99.761 95.007-61.531 58.593-130.526-124.298c-16.991-16.184-16.991-42.418 0-58.598l130.526-124.302 61.531 58.596-99.761 95.002z"
      ],
      "tags": [
        "programming-code-terminal-2"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M8.533 204.798c0-80.118 64.948-145.066 145.067-145.066h716.801c80.118 0 145.065 64.948 145.065 145.066v614.402c0 80.118-64.947 145.065-145.065 145.065h-716.801c-80.118 0-145.067-64.947-145.067-145.065v-614.402zM153.599 145.064c-32.99 0-59.734 26.744-59.734 59.734v614.402c0 32.988 26.744 59.73 59.734 59.73h716.801c32.988 0 59.735-26.742 59.735-59.73v-614.402c0-32.99-26.747-59.734-59.735-59.734h-716.801z",
        "M776.53 657.065h-256v-85.335h256v85.335z",
        "M374.86 529.065l-97.83-97.831 60.34-60.34 128 128c16.662 16.665 16.662 43.678 0 60.338l-128 128-60.34-60.339 97.83-97.828z"
      ],
      "tags": [
        "programming-code-terminal"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M513.193 1023.693c-3.483 0.471-7.012 0.471-10.493 0h-3.815l-319.53-123.305c-7.541-2.913-14.035-8.059-18.631-14.761-4.596-6.707-7.078-14.659-7.122-22.81v-320.799c-0.046-6.533 1.495-12.979 4.488-18.775s7.347-10.757 12.681-14.459l119.227-79.958 46.737 65.99-54.845 37.090 231.303 86.221 231.301-87.67-54.369-37.086 43.878-66.471 119.224 79.958c5.335 3.701 9.687 8.665 12.682 14.46 2.99 5.791 4.531 12.242 4.49 18.775v320.794c0.087 8.187-2.34 16.2-6.953 22.932-4.613 6.728-11.182 11.848-18.801 14.638l-317.624 120.422-13.829 4.813zM552.776 689.894v235.54l238.454-90.076v-235.535l-238.454 90.071zM235.153 834.396l238.455 90.076v-234.578l-238.455-90.071v234.573z",
        "M513.147 450.312c-5.214 0.066-10.391-0.923-15.223-2.908s-9.223-4.927-12.912-8.652l-158.812-160.88 56.275-56.356 91.090 92v-211.116h79.17v211.116l91.090-92 56.274 56.356-158.812 160.88c-3.692 3.725-8.079 6.667-12.913 8.652s-10.010 2.974-15.227 2.908z",
        "M238.905 0h-68.21v32.256c-20.721 3.79-39.14 14.38-51.68 29.714s-18.308 34.319-16.183 53.268c2.125 18.949 11.991 36.511 27.683 49.277s36.089 19.824 57.233 19.805h34.104c4.522 0 8.86 1.618 12.058 4.499s4.995 6.788 4.995 10.861c0 4.074-1.797 7.981-4.995 10.861s-7.536 4.499-12.058 4.499h-119.366v61.44h68.209v30.72h68.21v-32.256c20.721-3.79 39.14-14.38 51.68-29.714s18.308-34.319 16.183-53.268c-2.125-18.949-11.991-36.511-27.683-49.277s-36.089-19.824-57.233-19.805h-34.104c-4.523 0-8.86-1.618-12.058-4.499s-4.995-6.788-4.995-10.861c0-4.074 1.797-7.981 4.995-10.861s7.535-4.499 12.058-4.499h119.366v-61.44h-68.209v-30.72z"
      ],
      "tags": [
        "payment-box-incoming"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M170.667 42.667c0-23.564 19.103-42.667 42.667-42.667h768.001c23.562 0 42.665 19.103 42.665 42.667v767.998c0 23.567-19.103 42.67-42.665 42.67h-768.001c-23.564 0-42.667-19.103-42.667-42.67v-767.998zM256.001 85.334v682.666h682.664v-682.666h-682.664z",
        "M0 981.335v-810.669h85.334v767.998h768.002v85.335h-810.668c-23.564 0-42.667-19.103-42.667-42.665z"
      ],
      "tags": [
        "paginate-filter-document-copy"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M512 512l93.865 469.335 375.47-375.47-469.335-93.865z",
        "M542.075 293.721c-34.733-14.387-72.952-18.151-109.824-10.817s-70.741 25.438-97.324 52.021c-26.583 26.583-44.686 60.452-52.021 97.324s-3.57 75.091 10.817 109.826c14.387 34.729 38.75 64.415 70.008 85.304 31.259 20.884 68.008 32.031 105.603 32.031v85.335c-54.471 0-107.72-16.154-153.011-46.413-45.292-30.264-80.592-73.277-101.437-123.602-20.845-50.33-26.299-105.703-15.672-159.129s36.857-102.499 75.375-141.016c38.517-38.517 87.591-64.748 141.016-75.375s108.803-5.173 159.127 15.672c50.324 20.846 93.338 56.146 123.602 101.437s46.413 98.54 46.413 153.011h-85.33c0-37.594-11.151-74.344-32.036-105.603s-50.57-55.622-85.304-70.008zM951.163 1011.502l-234.665-234.665 60.339-60.339 234.665 234.665-60.339 60.339zM392.949 845.65c25.147 5.1 50.742 7.675 76.401 7.68l-0.032 85.335c-31.344-0.010-62.608-3.154-93.327-9.385l16.958-83.63z",
        "M443.991 86.379c-21.316 1.419-42.55 4.62-63.479 9.606s-41.325 11.703-60.991 20.047l-33.329-78.555c24.037-10.198 48.967-18.408 74.545-24.502s51.532-10.005 77.585-11.74l5.669 85.145zM571.31 99.273c-20.746-5.704-41.856-9.634-63.111-11.787l8.599-84.899c25.979 2.631 51.784 7.435 77.138 14.406 25.349 6.971 49.981 16.035 73.656 27.056l-36.019 77.36c-19.364-9.017-39.521-16.433-60.262-22.137zM262.708 145.968c-18.001 11.505-35.073 24.531-51.017 38.975s-30.589 30.15-43.811 46.93l-67.027-52.812c16.16-20.51 34.059-39.706 53.546-57.359s40.353-33.575 62.355-47.636l45.954 71.903zM736.963 193.997c-15.437-14.985-32.046-28.592-49.644-40.71l48.404-70.277c21.504 14.811 41.81 31.442 60.677 49.757s36.096 38.116 51.538 59.17l-68.808 50.471c-12.636-17.226-26.732-33.427-42.168-48.412zM132.493 285.462c-10.241 18.749-18.934 38.385-25.957 58.72s-12.299 41.151-15.811 62.224l-84.172-14.028c4.292-25.756 10.741-51.197 19.325-76.052s19.209-48.854 31.725-71.769l74.89 40.905zM836.572 356.764c-6.318-20.566-14.331-40.489-23.921-59.58l76.257-38.3c11.72 23.333 21.509 47.685 29.23 72.82l-81.567 25.059zM85.502 470.41c0.049 21.363 1.881 42.757 5.513 63.964s9.028 41.989 16.093 62.152l-80.531 28.221c-8.635-24.643-15.229-50.048-19.67-75.965-4.44-25.912-6.679-52.065-6.739-78.177l85.333-0.195zM133.34 655.14c10.326 18.703 22.231 36.577 35.622 53.417 13.391 16.835 28.125 32.456 44.023 46.73l-57.003 63.498c-19.431-17.439-37.439-36.536-53.807-57.114-16.367-20.582-30.917-42.424-43.538-65.285l74.703-41.247zM264.193 794.035c18.053 11.423 37.091 21.361 56.934 29.67l-32.972 78.71c-24.252-10.163-47.521-22.303-69.587-36.265l45.625-72.115z",
        "M853.335 469.349c-0.010-25.659-2.586-51.253-7.685-76.401l83.635-16.957c6.226 30.718 9.37 61.983 9.38 93.326l-85.33 0.032z"
      ],
      "tags": [
        "cursor-double-click"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M423.655 192.634c32.431-14.755 68.041-21.153 103.582-18.609 35.538 2.544 69.873 13.949 99.871 33.174s54.702 45.656 71.859 76.882c17.162 31.226 26.225 66.253 26.368 101.882v0.14c0.020 30.419-6.426 60.495-18.913 88.233-12.472 27.7-30.679 52.435-53.422 72.572-0.031 0.031-0.067 0.056-0.097 0.082l-28.262-31.959 28.421 31.821c-0.020 0.020-0.041 0.036-0.061 0.056-7.071 6.333-12.728 14.080-16.599 22.748-3.881 8.689-5.883 18.104-5.873 27.622 0.015 11.325-4.475 22.19-12.477 30.203-8.003 8.018-18.862 12.518-30.188 12.518h-151.725c-11.331 0-22.196-4.506-30.199-12.529-8.004-8.018-12.489-18.893-12.467-30.223 0.019-9.508-1.978-18.918-5.858-27.602-3.863-8.643-9.504-16.374-16.556-22.687 0.047 0.041 0.094 0.082 0.141 0.123l28.161-32.051-28.4 31.841c0.033 0.026 0.066 0.056 0.098 0.087-26.698-23.496-47.098-53.297-59.345-86.688-12.268-33.451-15.963-69.442-10.747-104.688s19.177-68.624 40.608-97.088c21.431-28.464 49.65-51.106 82.081-65.861zM521.139 259.141c-21.321-1.526-42.687 2.312-62.146 11.165s-36.39 22.439-49.249 39.517c-12.858 17.078-21.235 37.105-24.365 58.252s-0.913 42.742 6.448 62.813c7.361 20.070 19.632 37.978 35.692 52.087l0.241 0.211-0.001 0.001c16.094 14.354 28.964 31.955 37.763 51.647 2.883 6.451 5.307 13.076 7.262 19.83h78.445c1.956-6.748 4.383-13.373 7.265-19.825 8.791-19.676 21.647-37.275 37.724-51.633l0.159-0.141v0.001c13.722-12.137 24.709-27.054 32.23-43.761 7.511-16.685 11.397-34.774 11.392-53.070-0.097-21.354-5.535-42.346-15.816-61.062-10.296-18.736-25.119-34.595-43.121-46.13-17.997-11.534-38.6-18.377-59.924-19.904zM577.623 810.665h-131.245v-85.33h131.245v85.33z",
        "M176 853.335c58.91 0 106.666-47.759 106.666-106.67s-47.756-106.665-106.666-106.665c-58.91 0-106.666 47.754-106.666 106.665s47.756 106.67 106.666 106.67z",
        "M352 1024c-8.15-71.767-83.754-128-176-128s-167.851 56.233-176 128h352z",
        "M848 853.335c58.911 0 106.665-47.759 106.665-106.67s-47.754-106.665-106.665-106.665c-58.911 0-106.665 47.754-106.665 106.665s47.754 106.67 106.665 106.67z",
        "M1024 1024c-8.151-71.767-83.753-128-176-128s-167.849 56.233-176 128h352z",
        "M469.334 85.334v-85.334h85.331v85.334h-85.331zM270.63 202.97l-60.33-60.331 60.34-60.34 60.331 60.33-60.34 60.34zM693.028 142.63l60.334-60.33 60.339 60.34-60.329 60.331-60.344-60.34zM213.334 426.666h-85.334v-85.333h85.334v85.333zM810.665 341.334h85.335v85.333h-85.335v-85.333z"
      ],
      "tags": [
        "employment-employee-idea-brainstorm"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M512 0h341.335v298.666h-341.335v-298.666zM853.335 106.666l170.665-106.666v298.666l-170.665-106.666z",
        "M512 640c70.692 0 128-57.308 128-128s-57.308-128-128-128c-70.692 0-128 57.308-128 128s57.308 128 128 128z",
        "M746.665 810.665c-10.834-95.657-111.698-170.665-234.665-170.665-122.966 0-223.83 75.008-234.667 170.665h469.332z",
        "M0 127.999c0-23.564 19.103-42.666 42.667-42.666h384v85.333h-341.333v597.334h853.331v-384.001h85.335v426.665c0 23.567-19.103 42.67-42.665 42.67h-426.67v85.33h170.67v85.335h-426.669v-85.335h170.667v-85.33h-426.667c-23.564 0-42.667-19.103-42.667-42.67v-682.665z"
      ],
      "tags": [
        "video-call-monitor"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M584.561 188.255c-81.886-25.687-170.023-23.17-250.312 7.15s-148.089 86.689-192.558 160.093c-44.468 73.403-63.035 159.6-52.731 244.802s48.886 164.485 109.572 225.172c60.686 60.687 139.97 99.267 225.172 109.573 85.202 10.301 171.4-8.264 244.8-52.731 73.405-44.472 129.777-112.271 160.092-192.558 30.321-80.292 32.84-168.428 7.153-250.317l81.423-25.541c31.401 100.108 28.324 207.854-8.745 306.004-37.064 98.15-105.974 181.033-195.707 235.392-89.733 54.364-195.108 77.061-299.262 64.466-104.157-12.6-201.080-59.761-275.267-133.949s-121.35-171.11-133.947-275.267c-12.597-104.156 10.1-209.528 64.462-299.262s137.246-158.644 235.396-195.708c98.15-37.065 205.896-40.143 306.002-8.741l-25.544 81.422z",
        "M439.163 524.493l313.303-313.299 60.339 60.34-313.302 313.304-60.34-60.344zM503.507 387.411c-35.885-7.289-73.164-2.825-106.313 12.731s-60.407 41.376-77.733 73.635c-17.327 32.259-23.802 69.24-18.465 105.469s22.2 69.77 48.093 95.662c25.893 25.897 59.438 42.757 95.665 48.097 36.227 5.335 73.207-1.142 105.468-18.468s58.081-44.585 73.636-77.732c15.555-33.152 20.019-70.431 12.728-106.317l83.63-16.984c10.936 53.853 4.239 109.799-19.108 159.55s-62.095 90.655-110.51 116.659c-48.41 26.004-103.913 35.717-158.281 27.709s-104.71-33.316-143.568-72.172c-38.859-38.861-64.167-89.201-72.175-143.57s1.709-109.87 27.711-158.283c26.003-48.413 66.909-87.162 116.659-110.508s105.695-30.045 159.551-19.106l-16.987 83.625z",
        "M873.129 331.862l-150.825-30.166-30.167-150.826 150.83-150.87 30.162 150.87 150.871 30.165-150.871 150.827z"
      ],
      "tags": [
        "target-goal"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M951.168 620.498l-183.168 183.168-55.168-55.168-60.329 60.334 85.33 85.33c8.003 8.003 18.852 12.493 30.167 12.493s22.164-4.49 30.167-12.493l213.33-213.33-60.329-60.334zM448 869.842c-90.527 0-177.347-35.958-241.359-99.973-64.013-64.010-99.974-150.83-99.974-241.357 0-90.529 35.961-177.348 99.974-241.361s150.832-99.974 241.359-99.974c25.539 0.031 50.996 2.893 75.904 8.534l18.857-83.2c-58.554-13.345-119.268-14.178-178.168-2.444s-114.659 35.771-163.631 70.538c-48.971 34.767-90.051 79.48-120.552 131.216s-49.737 109.328-56.448 169.010c-6.712 59.683-0.748 120.11 17.501 177.326s48.372 109.937 88.398 154.716c40.026 44.774 89.054 80.594 143.877 105.114 54.823 24.525 114.205 37.197 174.263 37.192 62.872 0.148 124.989-13.696 181.847-40.535l-36.439-77.225c-45.45 21.499-95.129 32.579-145.408 32.425v0zM872.192 572.672c5.98-58.056 0.072-116.721-17.367-172.418l-81.408 25.6c10.429 33.22 15.724 67.837 15.703 102.658-0.005 11.868-0.62 23.731-1.833 35.538l84.905 8.622z",
        "M448 357.846c9.216 0.009 18.417 0.737 27.52 2.176l13.568-84.224c-13.587-2.185-27.326-3.283-41.088-3.286-50.632 0-100.127 15.014-142.226 43.144s-74.911 68.111-94.287 114.889c-19.376 46.778-24.445 98.253-14.567 147.912s34.259 95.273 70.062 131.072c35.802 35.804 81.417 60.186 131.076 70.062 49.659 9.882 101.132 4.808 147.909-14.566 46.781-19.374 86.758-52.188 114.893-94.285 28.129-42.102 43.141-91.597 43.141-142.228 0.046-15.969-1.382-31.909-4.265-47.615l-83.84 15.744c1.956 10.511 2.944 21.181 2.944 31.871 0 33.756-10.010 66.749-28.764 94.817s-45.409 49.94-76.595 62.858c-31.183 12.918-65.498 16.297-98.605 9.713s-63.516-22.84-87.384-46.71c-23.868-23.864-40.122-54.277-46.708-87.383s-3.205-67.421 9.712-98.606c12.917-31.185 34.792-57.84 62.858-76.593s61.062-28.762 94.817-28.762h-0.171z",
        "M438.955 477.012c-4.235 3.892-7.639 8.601-10.008 13.842s-3.654 10.908-3.777 16.658c-0.123 5.753 0.918 11.467 3.060 16.807 2.142 5.335 5.342 10.184 9.406 14.254s8.909 7.276 14.244 9.426c5.335 2.15 11.049 3.2 16.8 3.087 5.751-0.118 11.419-1.393 16.664-3.753 5.244-2.365 9.958-5.76 13.856-9.989l222.167-222.167h110.633l134.272-134.229c2.99-2.984 5.028-6.789 5.857-10.932 0.824-4.143 0.404-8.439-1.213-12.342s-4.362-7.237-7.875-9.581c-3.517-2.343-7.649-3.591-11.873-3.583h-119.168v-119.168c-0.010-4.212-1.265-8.328-3.61-11.828s-5.673-6.227-9.564-7.837c-3.896-1.611-8.177-2.033-12.308-1.214s-7.931 2.844-10.911 5.818l-134.272 134.229v110.336l-222.38 222.166z"
      ],
      "tags": [
        "business-target-check-approve"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M580.163 2.123c17.526 5.746 29.373 22.101 29.373 40.543v298.667h286.464c16.087 0 30.802 9.047 38.067 23.398s5.842 31.568-3.681 44.531l-438.872 597.335c-10.919 14.858-30.152 21.023-47.677 15.278s-29.374-22.098-29.374-40.54v-298.67h-286.464c-16.085 0-30.803-9.047-38.068-23.398s-5.84-31.565 3.684-44.529l438.87-597.334c10.921-14.862 30.152-21.026 47.677-15.281z"
      ],
      "tags": [
        "flash-enable-allow-1--full"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M768 1024c141.384 0 256-114.616 256-256s-114.616-256-256-256c-141.384 0-256 114.616-256 256s114.616 256 256 256zM716.8 768v-128h102.4v128h76.8l-128 128-128-128h76.8z",
        "M757.76 184.32l-168.96-168.96c-10.24-10.24-20.48-15.36-35.84-15.36h-512c-20.48 0-40.96 20.48-40.96 40.96v768c0 25.6 20.48 40.96 40.96 40.96h384v-81.92h-337.92v-680.96h424.96v168.96h168.96v168.96h87.040v-209.92c0-15.36-5.12-25.6-10.24-30.72z",
        "M291.839 373.759l-107.52 107.52c-10.24 10.24-15.36 20.48-15.36 30.72s5.12 20.481 10.24 30.721l107.52 107.52 61.44-61.44-76.8-76.801 76.8-76.8-56.32-61.44z",
        "M481.415 372.991l-61.546 61.546 104.993 104.993 61.542-61.549-104.989-104.99z"
      ],
      "tags": [
        "file-code-download"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M426.666 853.335h-384c-25.6 0-42.667-17.070-42.667-42.67v-767.998c0-25.6 17.067-42.667 42.667-42.667h511.998c12.8 0 21.335 4.267 29.87 12.8l170.665 170.666c8.535 8.534 12.8 17.067 12.8 29.867v213.333h-85.335v-196.266l-145.065-145.066h-452.266v682.666h341.333v85.335z",
        "M512 42.666v213.333h213.335l-213.335-213.333zM170.667 341.332h85.334v128h-85.334v-128zM362.667 554.665h85.334v128h-85.334v-128zM512 341.332h85.335v128h-85.335v-128zM320.001 341.332h128v128h-128v-128zM170.667 554.665h128v128h-128v-128z",
        "M768 1024c141.384 0 256-114.616 256-256s-114.616-256-256-256c-141.384 0-256 114.616-256 256s114.616 256 256 256zM725.335 768v-128h85.33v128h85.335l-128 128-128-128h85.335z"
      ],
      "tags": [
        "file-download"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M557.481 169.113v607.095h-78.324v-607.095h78.324z",
        "M256.001 607.995l54.86-54.856 207.581 207.616 207.58-207.616 54.861 54.856-262.441 262.405-262.44-262.405z"
      ],
      "tags": [
        "down-arrow"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M870.4 558.797h-607.097v-78.323h607.097v78.323z",
        "M431.515 257.317l54.86 54.86-207.618 207.58 207.618 207.58-54.86 54.861-262.403-262.441 262.403-262.44z"
      ],
      "tags": [
        "left-arrow"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M153.6 480.715h607.099v78.323h-607.099v-78.323z",
        "M592.486 782.198l-54.861-54.861 207.616-207.58-207.616-207.581 54.861-54.86 262.4 262.44-262.4 262.441z"
      ],
      "tags": [
        "right-arrow"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M480.962 258.56c13.795-23.894 48.283-23.894 62.076 0l292.649 506.88c13.793 23.895-3.451 53.76-31.037 53.76h-585.296c-27.59 0-44.833-29.865-31.038-53.76l292.647-506.88z"
      ],
      "tags": [
        "tren up"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M543.037 765.44c-13.793 23.895-48.281 23.895-62.076 0l-292.647-506.88c-13.795-23.894 3.449-53.76 31.038-53.76h585.296c27.587 0 44.831 29.866 31.037 53.76l-292.649 506.88z"
      ],
      "tags": [
        "tren-down"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M479.398 870.4v-607.097h78.323v607.097h-78.323z",
        "M780.882 431.515l-54.861 54.86-207.58-207.618-207.581 207.618-54.86-54.86 262.441-262.403 262.441 262.403z"
      ],
      "tags": [
        "up-arrow"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M634.419 524.698c-3.476-3.753-5.412-8.678-5.412-13.786 0-5.109 1.935-10.031 5.412-13.784l262.006-261.165c7.398-7.166 13.276-15.738 17.29-25.208s6.077-19.646 6.077-29.926c0-10.28-2.063-20.457-6.077-29.927s-9.892-18.042-17.29-25.208c-7.188-7.371-15.785-13.23-25.288-17.231s-19.712-6.062-30.024-6.062c-10.312 0-20.521 2.061-30.024 6.062-9.498 4.001-18.099 9.86-25.288 17.231l-262.006 261.166c-3.768 3.467-8.704 5.392-13.83 5.392s-10.063-1.926-13.828-5.392l-262.007-261.166c-14.725-13.935-34.369-21.521-54.669-21.114s-39.622 8.776-53.772 23.29c-7.395 7.166-13.273 15.738-17.287 25.208s-6.082 19.646-6.082 29.926c0 10.281 2.068 20.457 6.082 29.927s9.892 18.042 17.287 25.208l262.007 261.165c3.479 3.753 5.41 8.674 5.41 13.786 0 5.105-1.931 10.030-5.41 13.783l-262.007 261.161c-7.395 7.168-13.273 15.739-17.287 25.211s-6.082 19.645-6.082 29.926c0 10.281 2.068 20.454 6.082 29.926s9.892 18.043 17.287 25.211c7.19 7.368 15.789 13.23 25.289 17.229s19.71 6.062 30.023 6.062c10.314 0 20.523-2.063 30.023-6.062s18.1-9.861 25.29-17.229l262.007-261.166c3.765-3.466 8.702-5.391 13.827-5.391s10.066 1.925 13.829 5.391l262.006 261.166c14.669 14.623 34.565 22.835 55.311 22.835s40.648-8.212 55.316-22.835c14.669-14.623 22.912-34.458 22.912-55.137s-8.243-40.515-22.912-55.137l-264.192-263.337z"
      ],
      "tags": [
        "interface-delete-interface-essential"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M721.92 752.64v168.96c0 10.24 5.12 20.48 10.24 30.72 10.24 10.24 20.48 10.24 30.72 10.24h168.96c10.24 0 20.48-5.12 30.72-10.24 10.24-10.24 10.24-20.48 10.24-30.72v-168.96c0-10.24-5.12-20.48-10.24-30.72-10.24-10.24-20.48-10.24-30.72-10.24h-40.96v-128c0-10.24-5.12-20.48-10.24-30.72-10.24-10.24-20.48-10.24-30.72-10.24h-291.84v-81.92h-87.040v81.92h-291.84c-10.24 0-20.48 5.12-30.72 10.24-10.24 10.24-10.24 20.48-10.24 30.72v128h-46.080c-10.24 0-20.48 5.12-30.72 10.24-5.12 10.24-10.24 20.48-10.24 30.72v168.96c0 10.24 5.12 20.48 10.24 30.72 10.24 10.24 20.48 10.24 30.72 10.24h168.96c10.24 0 20.48-5.12 30.72-10.24 10.24-10.24 10.24-20.48 10.24-30.72v-168.96c0-10.24-5.12-20.48-10.24-30.72-10.24-10.24-20.48-10.24-30.72-10.24h-40.96v-81.92h250.88v81.92h-40.96c-10.24 0-20.48 5.12-30.72 10.24-10.24 10.24-10.24 20.48-10.24 30.72v168.96c0 10.24 5.12 20.48 10.24 30.72 10.24 10.24 20.48 10.24 30.72 10.24h168.96c10.24 0 20.48-5.12 30.72-10.24 10.24-10.24 10.24-20.48 10.24-30.72v-168.96c0-10.24-5.12-20.48-10.24-30.72-10.24-10.24-20.48-10.24-30.72-10.24h-40.96v-81.92h250.88v81.92h-40.96c-10.24 0-20.48 5.12-30.72 10.24-10.24 10.24-15.36 20.48-15.36 30.72zM890.88 793.6v81.92h-81.92v-81.92h81.92zM220.16 793.6v81.92h-87.040v-81.92h87.040zM552.96 793.6v81.92h-81.92v-81.92h81.92z",
        "M512 256c56.32 0 102.4-46.080 102.4-102.4s-46.080-102.4-102.4-102.4c-56.32 0-102.4 46.080-102.4 102.4s46.080 102.4 102.4 102.4z",
        "M716.8 419.84c-10.24-81.92-97.28-148.48-204.8-148.48s-194.56 66.56-204.8 148.48h409.6z"
      ],
      "tags": [
        "user-hierachy2"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M853.335 1024h-682.669v-85.335h682.669v85.335zM511.999 853.335c-11.316 0-22.168-4.495-30.17-12.498l-213.334-213.335 60.34-60.339 140.497 140.498v-664.994l85.332-0v664.994l140.498-140.498 60.339 60.339-213.335 213.335c-7.997 8.003-18.852 12.498-30.168 12.498z"
      ],
      "tags": [
        "move-snap-down--interface-essential"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M128 199.787v501.387l384 230.4 384-230.4v-501.387c-114.012-74.597-247.434-114.462-384-114.462-136.563 0-269.99 39.865-384 114.462zM60.866 142.198c132.229-92.56 289.729-142.207 451.134-142.207 161.408 0 318.904 49.647 451.133 142.207 11.407 7.984 18.202 21.031 18.202 34.954v548.183c0 14.986-7.864 28.872-20.716 36.582l-426.67 256.005c-13.512 8.105-30.389 8.105-43.901 0l-426.667-256.005c-12.851-7.711-20.715-21.596-20.715-36.582v-548.183c0-13.923 6.793-26.97 18.199-34.954z",
        "M469.334 273.067h-59.734c-23.564 0-42.666 19.102-42.666 42.666v136.534c0 20.857 15.079 38.657 35.652 42.086l169.149 28.189v57.723h-119.468v-25.6h-85.334v68.27c0 23.562 19.103 42.665 42.666 42.665h59.734v59.735h85.331v-59.735h59.735c23.562 0 42.665-19.103 42.665-42.665v-136.535c0-20.857-15.078-38.658-35.651-42.086l-169.147-28.191v-57.722h119.468v25.6h85.33v-68.267c0-23.564-19.103-42.666-42.665-42.666h-59.735v-59.734h-85.331v59.734z"
      ],
      "tags": [
        "money-security"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M424.96 1024c-5.12 0-15.36 0-20.48-5.12l-158.72-97.28c-10.24 10.24-20.48 15.36-30.72 15.36h-174.080c-20.48 0-40.96-15.36-40.96-40.96v-343.040c0-20.48 20.48-40.96 40.96-40.96h168.96c25.6 0 46.080 20.48 46.080 40.96v0h296.96c20.48 0 35.84 15.36 40.96 30.72l35.84 138.24h184.32c20.48 0 46.080 5.12 66.56 15.36s35.84 30.72 46.080 46.080c10.24 20.48 15.36 40.96 15.36 66.56 0 20.48-10.24 46.080-20.48 61.44-5.12 10.24-15.36 15.36-25.6 20.48l-460.8 92.16c-5.12 0-5.12 0-10.24 0zM256 829.44l179.2 107.52 419.84-76.8c0 0 0-5.12 0-5.12 0-5.12 0-15.36-5.12-20.48s-10.24-10.24-15.36-15.36c-5.12-5.12-15.36-5.12-20.48-5.12h-430.080v-87.040h158.72l-20.48-87.040h-266.24v189.44zM87.040 855.040h87.040v-256h-87.040v256z",
        "M808.96 614.4h-87.040v-61.44h-56.32c-25.6 0-40.96-20.48-40.96-40.96v-66.56h87.040v25.6h117.76v-61.44l-168.96-30.72c-20.48-5.12-35.84-20.48-35.84-40.96v-133.12c0-25.6 20.48-40.96 40.96-40.96h61.44v-61.44h87.040v61.44h56.32c25.6 0 40.96 20.48 40.96 40.96v71.68h-87.040v-30.72h-117.76v61.44l168.96 30.72c20.48 5.12 35.84 20.48 35.84 40.96v133.12c0 25.6-20.48 40.96-40.96 40.96h-61.44v61.44z"
      ],
      "tags": [
        "payment-hand-coin"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M0 256.001v383.999c0 23.567 19.103 42.67 42.667 42.67v298.665c0 23.562 19.103 42.665 42.667 42.665h853.331c23.567 0 42.67-19.103 42.67-42.665v-298.665c23.562 0 42.665-19.103 42.665-42.67v-383.999c0-23.564-19.103-42.666-42.665-42.666h-938.668c-23.564 0-42.667 19.102-42.667 42.666zM128 682.67h256v42.665c0 23.562 19.103 42.665 42.666 42.665h170.669c23.562 0 42.665-19.103 42.665-42.665v-42.665h256v256h-768v-256zM938.665 597.335h-298.665v-42.67c0-23.562-19.103-42.665-42.665-42.665h-170.669c-23.564 0-42.666 19.103-42.666 42.665v42.67h-298.666v-298.668h853.331v298.668zM563.236 588.805l-0.046 102.426-102.424-0.046 0.045-102.42 102.425 0.041z",
        "M298.667 42.667c0-23.564 19.102-42.667 42.666-42.667h341.331c23.567 0 42.67 19.103 42.67 42.667v213.333h-85.335v-170.666h-256v170.666h-85.333v-213.333z"
      ],
      "tags": [
        "toolbox"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M448 896h-362.666v-810.666h515.667l124.334 124.33v281.002h85.33v-316.33l-174.336-174.336h-636.329v981.335h448v-85.335z",
        "M277.334 429.27l-86.614-86.656 45.226-45.226 41.387 41.344 105.386-105.344 45.226 45.226-150.613 150.656zM277.334 685.271l-86.614-86.656 45.226-45.225 41.387 41.339 105.386-105.341 45.226 45.228-150.613 150.656zM490.666 309.334h127.998v64h-127.998v-64zM490.666 565.335h127.998v64h-127.998v-64zM618.368 1016.535c-7.153 1.792-14.643 1.7-21.745-0.266-7.107-1.966-13.578-5.74-18.79-10.952s-8.986-11.689-10.952-18.79c-1.966-7.107-2.058-14.597-0.266-21.75l19.666-78.761c3.753-15.002 11.51-28.703 22.446-39.639l260.649-260.603c16.973-16.978 39.997-26.511 64-26.511s47.027 9.533 64 26.511c16.973 16.973 26.511 39.992 26.511 64 0 24.003-9.539 47.022-26.511 64l-260.649 260.603c-10.936 10.936-24.637 18.693-39.639 22.446l-78.72 19.712z"
      ],
      "tags": [
        "document-list-edi"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M896 127.999v597.331l-384 256-384-256v-597.331c120.651-54.904 251.451-83.971 384-85.333 132.552 1.363 263.347 30.43 384 85.333z",
        "M682.665 426.665h-341.331c-23.564 0-42.667 19.103-42.667 42.667v170.668c0 23.562 19.103 42.665 42.667 42.665h341.331c23.567 0 42.67-19.103 42.67-42.665v-170.668c0-23.564-19.103-42.667-42.67-42.667z",
        "M384 426.666v-42.666c0-33.948 13.486-66.505 37.49-90.51s56.562-37.49 90.51-37.49c33.946 0 66.504 13.486 90.511 37.49 24.003 24.005 37.489 56.562 37.489 90.51v42.666"
      ],
      "attrs": [
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        },
        {},
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        }
      ],
      "isMulticolor2": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "s": 0
          },
          {},
          {
            "s": 0
          }
        ]
      },
      "tags": [
        "shield-lock"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M491.241 131.164c10.218-14.158 31.301-14.158 41.515 0l171.658 237.855c12.221 16.931 0.123 40.581-20.756 40.581h-343.315c-20.88 0-32.977-23.65-20.759-40.581l171.657-237.855z",
        "M532.756 892.836c-10.214 14.157-31.297 14.157-41.515 0l-171.657-237.855c-12.219-16.932-0.121-40.581 20.759-40.581h343.315c20.879 0 32.978 23.649 20.756 40.581l-171.658 237.855z"
      ],
      "attrs": [
        {
          "fill": "rgb(176, 178, 181)"
        },
        {
          "fill": "rgb(84, 85, 88)"
        }
      ],
      "isMulticolor": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "f": 2
          },
          {
            "f": 1
          }
        ]
      },
      "tags": [
        "Sort-down"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M491.241 131.164c10.218-14.158 31.301-14.158 41.515 0l171.658 237.855c12.221 16.931 0.123 40.581-20.756 40.581h-343.315c-20.88 0-32.977-23.65-20.759-40.581l171.657-237.855z",
        "M532.756 892.836c-10.214 14.157-31.297 14.157-41.515 0l-171.657-237.855c-12.219-16.932-0.121-40.581 20.759-40.581h343.315c20.879 0 32.978 23.649 20.756 40.581l-171.658 237.855z"
      ],
      "attrs": [
        {
          "fill": "rgb(176, 178, 181)"
        },
        {
          "fill": "rgb(176, 178, 181)"
        }
      ],
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "f": 2
          },
          {
            "f": 2
          }
        ]
      },
      "tags": [
        "Sort-none"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M491.241 131.164c10.218-14.158 31.301-14.158 41.515 0l171.658 237.855c12.221 16.931 0.123 40.581-20.756 40.581h-343.315c-20.88 0-32.977-23.65-20.759-40.581l171.657-237.855z",
        "M532.756 892.836c-10.214 14.157-31.297 14.157-41.515 0l-171.657-237.855c-12.219-16.932-0.121-40.581 20.759-40.581h343.315c20.879 0 32.978 23.649 20.756 40.581l-171.658 237.855z"
      ],
      "attrs": [
        {
          "fill": "rgb(84, 85, 88)"
        },
        {
          "fill": "rgb(176, 178, 181)"
        }
      ],
      "isMulticolor": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      },
      "tags": [
        "Sort-up"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M469.334 878.326v-878.326h85.331v878.326l183.168-183.163 60.339 60.339-256 256c-16.666 16.666-43.679 16.666-60.342 0l-256-256 60.34-60.339 183.163 183.163z"
      ],
      "tags": [
        "icon-keyboard-down-arrow"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M481.83 21.030c16.663-16.662 43.676-16.662 60.342 0l256 256-60.339 60.34-183.168-183.163v878.328h-85.331v-878.328l-183.163 183.163-60.34-60.34 256-256z"
      ],
      "tags": [
        "icon-keyboard-up-arrow"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M512 512c0-0.001 0-0.003 0-0.004 0-12.428-5.314-23.615-13.794-31.413l-0.030-0.028-426.667-390.955c-7.567-6.96-17.707-11.226-28.843-11.226-23.506 0-42.572 19.008-42.666 42.492l-0 0.009v782.251c-0 0.001-0 0.003-0 0.004 0 23.564 19.103 42.667 42.667 42.667 11.136 0 21.275-4.266 28.873-11.253l-0.031 0.028 426.667-391.125c8.51-7.826 13.824-19.013 13.824-31.441 0-0.001-0-0.003-0-0.004l0 0zM85.333 806.101v-588.203l320.853 294.101z",
        "M1010.176 480.555l-469.333-430.251-57.685 62.933 435.029 398.763-435.2 398.763 57.685 62.933 469.333-430.251c8.513-7.826 13.829-19.015 13.829-31.445s-5.316-23.619-13.798-31.418l-0.031-0.028z",
        "M768 512c0-0.001 0-0.003 0-0.004 0-12.428-5.314-23.615-13.794-31.413l-0.030-0.028-469.333-430.251-57.685 62.933 435.029 398.763-435.2 398.763 57.685 62.933 469.333-430.251c8.575-7.802 13.949-18.992 13.995-31.437l0-0.008z"
      ],
      "tags": [
        "streamline-icon-navigation-arrows-right-2@20x20 (1)"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.29h170.67v85.334h-170.67v-85.334zM128 341.29h298.666v85.334h-298.666v-85.334zM128 469.29h213.334v85.334h-213.334v-85.334z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34s-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h426.666v-85.33h-426.666v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M810.665 853.289c23.567 0 42.67-19.103 42.67-42.665s-19.103-42.665-42.67-42.665c-23.562 0-42.665 19.103-42.665 42.665s19.103 42.665 42.665 42.665z",
        "M931.343 519.322c32.010 32.005 49.992 75.412 49.992 120.678 11.315 0 22.164 4.495 30.167 12.498 8.003 7.997 12.498 18.852 12.498 30.167v298.67c0 11.315-4.495 22.164-12.498 30.167s-18.852 12.498-30.167 12.498h-341.335c-11.315 0-22.17-4.495-30.172-12.498-7.997-8.003-12.493-18.852-12.493-30.167v-298.67c0-11.315 4.495-22.17 12.493-30.167 7.962-7.962 18.744-12.452 29.998-12.498h256.174c0-22.63-8.991-44.339-24.996-60.339-16-16.005-37.704-24.996-60.339-24.996-16.855 0-33.198 4.987-47.048 14.147l-73.871-49.249c0.077-0.082 0.159-0.164 0.241-0.241 32.005-32.008 75.418-49.989 120.678-49.989 45.266 0 88.673 17.981 120.678 49.989zM682.665 725.335v213.33h256v-213.33h-256z"
      ],
      "tags": [
        "credit-card-unlock"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M556.503 341.333h170.665v85.333h-170.665v-85.333zM129.834 341.333h298.666v85.333h-298.666v-85.333zM129.834 469.333h213.333v85.332h-213.333v-85.332z",
        "M727.168 597.335h-640.001v-298.669h682.665v298.669h85.335v-512.002c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.704-24.994-60.339-24.994h-682.665c-22.631 0-44.336 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h640.001v-85.33zM769.833 85.334v128h-682.665v-128h682.665zM1025.833 810.665h-128v-128h-85.33v128h-128v85.335h128v128h85.33v-128h128v-85.335z"
      ],
      "tags": [
        "credit-card-add"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M128 341.333h298.666v85.333h-298.666v-85.333zM128 469.333h213.334v85.332h-213.334v-85.332z",
        "M85.334 298.666h682.666v42.667h85.335v-256c0-22.632-8.991-44.337-24.996-60.34s-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h256v-85.33h-256v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M725.335 426.667c-59.069 0-116.818 17.517-165.929 50.335-49.118 32.818-87.399 79.465-110.004 134.040s-28.52 114.621-16.996 172.559c11.524 57.938 39.969 111.155 81.739 152.924 41.769 41.769 94.986 70.211 152.924 81.736 57.933 11.525 117.985 5.612 172.559-16.993s101.217-60.887 134.036-110.003c32.819-49.116 50.335-106.86 50.335-165.929-0.102-79.181-31.601-155.090-87.588-211.077-55.992-55.99-131.896-87.489-211.077-87.591zM725.335 938.665c-42.194 0-83.441-12.508-118.523-35.953-35.082-23.439-62.428-56.755-78.572-95.739-16.148-38.984-20.372-81.874-12.14-123.259 8.228-41.385 28.549-79.396 58.383-109.23s67.845-50.156 109.23-58.383c41.385-8.233 84.275-4.009 123.259 12.14 38.984 16.143 72.3 43.489 95.739 78.572 23.444 35.082 35.953 76.329 35.953 118.523-0.067 56.556-22.564 110.781-62.556 150.774s-94.218 62.49-150.774 62.556z",
        "M768 554.665h-85.335v213.335h170.67v-85.335h-85.335v-128z"
      ],
      "tags": [
        "credit-card-clock"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.29h170.67v85.334h-170.67v-85.334zM128 341.29h298.666v85.334h-298.666v-85.334zM128 469.29h213.334v85.334h-213.334v-85.334z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34s-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h426.666v-85.33h-426.666v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M810.665 853.289c23.567 0 42.67-19.103 42.67-42.665s-19.103-42.665-42.67-42.665c-23.562 0-42.665 19.103-42.665 42.665s19.103 42.665 42.665 42.665z",
        "M931.343 519.322c32.010 32.005 49.992 75.412 49.992 120.678 11.315 0 22.164 4.495 30.167 12.498 8.003 7.997 12.498 18.852 12.498 30.167v298.67c0 11.315-4.495 22.164-12.498 30.167s-18.852 12.498-30.167 12.498h-341.335c-11.315 0-22.17-4.495-30.172-12.498-7.997-8.003-12.493-18.852-12.493-30.167v-298.67c0-11.315 4.495-22.17 12.493-30.167 7.962-7.962 18.744-12.452 29.998-12.498h256.174c0-22.63-8.991-44.339-24.996-60.339-16-16.005-37.704-24.996-60.339-24.996-16.855 0-33.198 4.987-47.048 14.147l-73.871-49.249c0.077-0.082 0.159-0.164 0.241-0.241 32.005-32.008 75.418-49.989 120.678-49.989 45.266 0 88.673 17.981 120.678 49.989zM682.665 725.335v213.33h256v-213.33h-256z"
      ],
      "tags": [
        "credit-card-lock-1"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.29h170.67v85.334h-170.67v-85.334zM128 341.29h298.666v85.334h-298.666v-85.334zM128 469.29h213.334v85.334h-213.334v-85.334z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34s-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h426.666v-85.33h-426.666v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M981.335 640c0-45.266-17.981-88.673-49.987-120.678-32.010-32.008-75.418-49.989-120.684-49.989-45.261 0-88.673 17.981-120.678 49.989-32.005 32.005-49.987 75.412-49.987 120.678-11.315 0-22.17 4.495-30.172 12.498-7.997 7.997-12.493 18.852-12.493 30.167v298.67c0 11.315 4.495 22.164 12.493 30.167 8.003 8.003 18.857 12.498 30.172 12.498h341.335c11.315 0 22.164-4.495 30.167-12.498s12.498-18.852 12.498-30.167v-298.67c0-11.315-4.495-22.17-12.498-30.167-8.003-8.003-18.852-12.498-30.167-12.498zM810.665 554.665c22.636 0 44.339 8.991 60.339 24.996 16.005 16 24.996 37.709 24.996 60.339h-170.665c0-22.63 8.991-44.339 24.991-60.339 16.005-16.005 37.709-24.996 60.339-24.996v0zM938.665 938.665h-256v-213.33h256v213.33z",
        "M810.665 853.289c23.567 0 42.67-19.103 42.67-42.665s-19.103-42.665-42.67-42.665c-23.562 0-42.665 19.103-42.665 42.665s19.103 42.665 42.665 42.665z"
      ],
      "tags": [
        "credit-card-lock"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M556.503 341.333h170.665v85.333h-170.665v-85.333zM129.834 341.333h298.666v85.333h-298.666v-85.333zM129.834 469.333h213.333v85.332h-213.333v-85.332z",
        "M87.167 298.666h682.665v298.669h85.335v-512.002c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.704-24.994-60.339-24.994h-682.665c-22.631 0-44.336 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h554.665v-85.33h-554.665v-298.669zM769.833 85.334v128h-682.665v-128h682.665zM1013.335 755.497l-60.334-60.329-97.833 97.879-97.833-97.879-60.334 60.329 97.838 97.838-97.838 97.833 60.334 60.329 97.833-97.792 97.833 97.792 60.334-60.329-97.838-97.833 97.838-97.838z"
      ],
      "tags": [
        "credit-card-remove-cross"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.29h170.67v85.334h-170.67v-85.334zM128 341.29h298.666v85.334h-298.666v-85.334zM128 469.29h213.334v85.334h-213.334v-85.334z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34s-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h341.333v-85.33h-341.333v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M768 512c-50.632 0-100.127 15.012-142.223 43.146-42.102 28.129-74.916 68.111-94.29 114.888s-24.445 98.248-14.566 147.912c9.876 49.659 34.258 95.273 70.062 131.072 35.799 35.804 81.413 60.186 131.077 70.062 49.659 9.882 101.13 4.808 147.907-14.566s86.758-52.188 114.888-94.285c28.134-42.102 43.146-91.597 43.146-142.228-0.077-67.871-27.075-132.941-75.069-180.931-47.99-47.995-113.060-74.993-180.931-75.069zM768 597.335c30.367 0.169 60.129 8.525 86.144 24.192l-232.617 232.617c-15.693-26.004-24.054-55.772-24.192-86.144 0-45.266 17.981-88.673 49.987-120.678s75.412-49.987 120.678-49.987zM768 938.665c-30.362-0.154-60.124-8.494-86.144-24.146l232.617-232.663c15.672 26.015 24.033 55.777 24.192 86.144 0 45.266-17.981 88.673-49.987 120.678s-75.412 49.987-120.678 49.987z"
      ],
      "tags": [
        "credit-card-restrict"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.333h170.67v85.333h-170.67v-85.333zM128 341.333h298.666v85.333h-298.666v-85.333zM128 469.333h213.334v85.332h-213.334v-85.332z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34s-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h341.333v-85.33h-341.333v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M768 512c-67.876 0.067-132.951 27.059-180.946 75.054s-74.988 113.070-75.054 180.946h85.335c0-33.756 10.010-66.749 28.759-94.817 18.755-28.068 45.409-49.94 76.595-62.858s65.5-16.297 98.606-9.713c33.106 6.584 63.514 22.84 87.383 46.71s40.125 54.277 46.71 87.383c6.584 33.106 3.205 67.42-9.713 98.606s-34.79 57.841-62.858 76.595c-28.068 18.749-61.061 28.759-94.817 28.759-43.884 0.317-86.159-16.522-117.801-46.93l-2.734-3.328 77.87-77.742h-213.335v213.335l75.008-75.008c29.768 29.778 66.417 51.753 106.706 63.974 40.289 12.227 82.975 14.331 124.268 6.118 41.298-8.212 79.928-26.481 112.476-53.192s58.004-61.036 74.112-99.932c16.113-38.902 22.38-81.172 18.253-123.075-4.132-41.897-18.534-82.135-41.928-117.14-23.398-35-55.066-63.698-92.201-83.538s-78.592-30.217-120.694-30.208v0z"
      ],
      "tags": [
        "credit-card-return"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M682.665 512c-58.429 0.722-116.244 11.996-170.665 33.28v-118.614c0-95.786-175.83-128-256-128s-256 32.214-256 128v383.998c0 95.744 175.83 128 256 128 58.802-0.717 116.982-12.14 171.69-33.705 10.838 88.663 177.406 119.040 254.974 119.040 80.174 0 256-32.256 256-128v-256c0-95.785-175.826-128-256-128zM682.665 597.335c58.552-1.603 116.388 13.174 166.999 42.665-50.621 29.466-108.447 44.242-166.999 42.665-58.547 1.577-116.378-13.199-166.994-42.665 50.606-29.491 108.442-44.268 166.994-42.665v0zM853.335 763.735c-50.442 33.413-110.234 49.853-170.67 46.93-60.431 2.924-120.223-13.517-170.665-46.93v-29.015c54.42 21.284 112.236 32.558 170.665 33.28 58.429-0.722 116.25-11.996 170.67-33.28v29.015zM85.334 649.385c54.419 21.289 112.237 32.563 170.666 33.28 58.429-0.717 116.248-11.991 170.666-33.28v29.015c-50.442 33.413-110.232 49.853-170.666 46.935-60.434 2.918-120.224-13.522-170.666-46.935v-29.015zM85.334 521.385c54.419 21.289 112.237 32.563 170.666 33.28 58.429-0.717 116.248-11.991 170.666-33.28v29.015c-50.442 33.413-110.232 49.853-170.666 46.935-60.434 2.918-120.224-13.522-170.666-46.935v-29.015zM256 384c58.552-1.6 116.388 13.177 166.998 42.666-50.619 29.465-108.448 44.24-166.998 42.667-58.549 1.573-116.378-13.202-166.998-42.667 50.609-29.49 108.445-44.266 166.998-42.666v0zM85.334 806.953v-29.568c54.419 21.289 112.237 32.563 170.666 33.28 58.429-0.717 116.248-11.991 170.666-33.28v29.568c-50.668 32.865-110.335 49.080-170.666 46.382-60.333 2.703-120.003-13.512-170.666-46.382v0zM682.665 938.665c-60.329 2.708-120.003-13.507-170.665-46.377v-29.568c54.42 21.284 112.236 32.558 170.665 33.28 58.429-0.722 116.25-11.996 170.67-33.28v29.568c-50.668 32.86-110.336 49.075-170.67 46.377v0zM768 0v85.334h110.336l-183.168 183.168 60.329 60.33 183.168-183.168v110.336h85.335v-256h-256z"
      ],
      "tags": [
        "payment-coin"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M371.504-64.303l627.506 627.503-627.506 627.502-60.34-60.339 567.162-567.163-567.162-567.163 60.34-60.34z",
        "M72.837-64.303l627.503 627.503-627.503 627.502-60.34-60.339 567.164-567.163-567.164-567.163 60.34-60.34z"
      ],
      "tags": [
        "navigation-right-3"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M768 1024c141.384 0 256-114.616 256-256s-114.616-256-256-256c-141.384 0-256 114.616-256 256s114.616 256 256 256zM716.8 768v-128h102.4v128h76.8l-128 128-128-128h76.8z",
        "M757.76 184.32l-168.96-168.96c-10.24-10.24-20.48-15.36-35.84-15.36h-512c-20.48 0-40.96 20.48-40.96 40.96v768c0 25.6 20.48 40.96 40.96 40.96h384v-81.92h-337.92v-680.96h424.96v168.96h168.96v168.96h87.040v-209.92c0-15.36-5.12-25.6-10.24-30.72z",
        "M291.84 373.759l-107.52 107.52c-10.24 10.24-15.36 20.48-15.36 30.72s5.12 20.481 10.24 30.721l107.52 107.52 61.44-61.44-76.8-76.801 76.8-76.8-56.32-61.44z",
        "M481.414 372.991l-61.546 61.546 104.988 104.993 61.548-61.549-104.99-104.99z"
      ],
      "tags": [
        "file-code-download"
      ],
      "defaultCode": 59648,
      "grid": 0
    },
    {
      "paths": [
        "M426.666 853.335h-384c-25.6 0-42.667-17.070-42.667-42.67v-767.998c0-25.6 17.067-42.667 42.667-42.667h511.998c12.8 0 21.335 4.267 29.87 12.8l170.665 170.666c8.535 8.534 12.8 17.067 12.8 29.867v213.333h-85.335v-196.266l-145.065-145.066h-452.266v682.666h341.333v85.335z",
        "M512 42.666v213.333h213.335l-213.335-213.333zM170.667 341.332h85.334v128h-85.334v-128zM362.667 554.665h85.334v128h-85.334v-128zM512 341.332h85.335v128h-85.335v-128zM320.001 341.332h128v128h-128v-128zM170.667 554.665h128v128h-128v-128z",
        "M768 1024c141.384 0 256-114.616 256-256s-114.616-256-256-256c-141.384 0-256 114.616-256 256s114.616 256 256 256zM725.335 768v-128h85.33v128h85.335l-128 128-128-128h85.335z"
      ],
      "tags": [
        "file-download"
      ],
      "defaultCode": 59649,
      "grid": 0
    },
    {
      "paths": [
        "M489.094 6.67c13.976-8.894 31.836-8.894 45.813 0l469.335 298.667c16 10.184 23.363 29.712 18.058 47.925s-21.996 30.737-40.965 30.737h-938.668c-18.97 0-35.661-12.525-40.965-30.737s2.054-37.741 18.058-47.925l469.333-298.667zM189.187 298.666h645.629l-322.816-205.427-322.813 205.427zM128.001 853.335v-384.002h85.333v384.002h-85.333zM355.542 853.335v-384.002h85.334v384.002h-85.334zM583.127 853.335v-384.002h85.33v384.002h-85.33zM810.665 853.335v-384.002h85.335v384.002h-85.335zM1024 938.665v85.335h-1024v-85.335h1024z"
      ],
      "tags": [
        "bank"
      ],
      "defaultCode": 59650,
      "grid": 0
    },
    {
      "paths": [
        "M700.329 42.666h-316.329c-22.631 0-44.337 8.991-60.34 24.994s-24.993 37.708-24.993 60.34v597.331c0 22.636 8.99 44.339 24.993 60.344 16.003 16 37.708 24.991 60.34 24.991h426.665c22.636 0 44.339-8.991 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.344v-486.995l-195.671-195.669zM810.665 725.33h-426.665v-597.331h256.001v170.666h170.665v426.664z",
        "M213.334 213.331h-85.334v682.669c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h512.002v-85.33h-512.002v-682.669z"
      ],
      "tags": [
        "common-files"
      ],
      "defaultCode": 59651,
      "grid": 0
    },
    {
      "paths": [
        "M853.335 958.971c0 12.723-5.053 24.919-14.049 33.915-8.991 8.991-21.192 14.044-33.91 14.044h-46.935v-94.807h94.894v46.848zM0.001 958.971c0 12.723 5.053 24.919 14.046 33.915 8.994 8.991 21.192 14.044 33.911 14.044h46.933v-94.807h-94.89v46.848zM189.611 912.123h94.806v94.807h-94.806v-94.807zM379.265 912.123h94.806v94.807h-94.806v-94.807zM568.873 912.123h94.807v94.807h-94.807v-94.807z",
        "M213.334 51.198c0-23.564 19.103-42.667 42.666-42.667h716.799c23.562 0 42.665 19.103 42.665 42.667v716.802c0 23.562-19.103 42.665-42.665 42.665h-716.799c-23.564 0-42.666-19.103-42.666-42.665v-716.802zM298.668 93.864v631.465h631.468v-631.465h-631.468z",
        "M409.601 213.331h409.599v85.333h-409.599v-85.333zM409.601 366.931h409.599v85.333h-409.599v-85.333zM409.601 520.53h199.127v85.335h-199.127v-85.335z",
        "M0.001 532.859h94.805v94.807h-94.805v-94.807zM0.001 722.473h94.805v94.802h-94.805v-94.802zM0.001 343.207h94.805v94.806h-94.805v-94.806zM0.001 199.89v48.512h94.805v-94.806h-48.512c-12.278 0-24.053 4.877-32.734 13.559s-13.559 20.457-13.559 32.735z"
      ],
      "tags": [
        "doc-layer-copy"
      ],
      "defaultCode": 59652,
      "grid": 0
    },
    {
      "paths": [
        "M40.405-2.263h241.366v85.333h-138.359l314.193 314.192-60.34 60.34-314.193-314.192v138.359h-85.333v-241.365c0-23.564 19.103-42.667 42.667-42.667zM880.589 940.928l-312.658-312.658 60.339-60.339 312.658 312.658v-138.363h85.335v241.367c0 23.562-19.103 42.665-42.67 42.665h-241.362v-85.33h138.358z"
      ],
      "tags": [
        "expand-diagonal"
      ],
      "defaultCode": 59653,
      "grid": 0
    },
    {
      "paths": [
        "M768 1024c141.384 0 256-114.616 256-256s-114.616-256-256-256c-141.384 0-256 114.616-256 256s114.616 256 256 256z",
        "M716.8 808.96v-168.96h102.4v168.96h-102.4z",
        "M896 768l-128 128-128-128h256z",
        "M757.76 184.32l-168.96-168.96c-10.24-10.24-20.48-15.36-35.84-15.36h-512c-20.48 0-40.96 20.48-40.96 40.96v768c0 25.6 20.48 40.96 40.96 40.96h384v-81.92h-337.92v-680.96h424.96v168.96h168.96v168.96h87.040v-209.92c0-15.36-5.12-25.6-10.24-30.72z",
        "M291.84 373.759l-107.52 107.52c-10.24 10.24-15.36 20.48-15.36 30.72s5.12 20.481 10.24 30.721l107.52 107.52 61.44-61.44-76.8-76.801 76.8-76.8-56.32-61.44z",
        "M481.414 372.991l-61.546 61.546 104.988 104.993 61.548-61.549-104.99-104.99z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        },
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(0, 0, 0)"
        }
      ],
      "isMulticolor": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "f": 0
          },
          {
            "f": 4
          },
          {
            "f": 4
          },
          {
            "f": 0
          },
          {
            "f": 0
          },
          {
            "f": 0
          }
        ]
      },
      "tags": [
        "file-code-download"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M426.666 853.335h-384c-25.6 0-42.667-17.070-42.667-42.67v-767.998c0-25.6 17.067-42.667 42.667-42.667h511.998c12.8 0 21.335 4.267 29.87 12.8l170.665 170.666c8.535 8.534 12.8 17.067 12.8 29.867v213.333h-85.335v-196.266l-145.065-145.066h-452.266v682.666h341.333v85.335z",
        "M512 42.666v213.333h213.335l-213.335-213.333zM170.667 341.332h85.334v128h-85.334v-128zM362.667 554.665h85.334v128h-85.334v-128zM512 341.332h85.335v128h-85.335v-128zM320.001 341.332h128v128h-128v-128zM170.667 554.665h128v128h-128v-128z",
        "M768 1024c141.384 0 256-114.616 256-256s-114.616-256-256-256c-141.384 0-256 114.616-256 256s114.616 256 256 256z",
        "M725.335 810.665v-170.665h85.33v170.665h-85.33z",
        "M896 768l-128 128-128-128h256z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "isMulticolor": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "f": 0
          },
          {
            "f": 0
          },
          {
            "f": 0
          },
          {
            "f": 4
          },
          {
            "f": 4
          }
        ]
      },
      "tags": [
        "file-download"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M981.335 725.335h-53.335v-61.655c-0.102-37.309-14.966-73.068-41.349-99.451s-62.141-41.247-99.451-41.349h-243.2v-138.88h53.335c11.315 0 22.164-4.495 30.167-12.497s12.498-18.854 12.498-30.17v-170.667c0-11.316-4.495-22.168-12.498-30.17s-18.852-12.497-30.167-12.497h-170.669c-11.316 0-22.168 4.495-30.17 12.497s-12.497 18.854-12.497 30.17v170.667c0 11.316 4.495 22.168 12.497 30.17s18.854 12.497 30.17 12.497h53.334v138.665h-242.986c-37.348 0.102-73.135 15.002-99.524 41.431-26.389 26.424-41.231 62.234-41.276 99.584v61.655h-53.547c-11.316 0-22.168 4.495-30.17 12.493-8.002 8.003-12.497 18.857-12.497 30.172v170.665c0 11.315 4.495 22.17 12.497 30.172s18.854 12.498 30.17 12.498h170.667c11.316 0 22.168-4.495 30.17-12.498s12.497-18.857 12.497-30.172v-170.665c0-11.315-4.495-22.17-12.497-30.172-8.002-7.997-18.854-12.493-30.17-12.493h-53.334v-61.655c0.079-20.347 8.195-39.834 22.581-54.221 14.386-14.382 33.874-22.502 54.219-22.579h243.2v138.455h-53.334c-11.316 0-22.168 4.495-30.17 12.493-8.002 8.003-12.497 18.857-12.497 30.172v170.665c0 11.315 4.495 22.17 12.497 30.172s18.854 12.498 30.17 12.498h170.669c11.315 0 22.164-4.495 30.167-12.498s12.498-18.857 12.498-30.172v-170.665c0-11.315-4.495-22.17-12.498-30.172-8.003-7.997-18.852-12.493-30.167-12.493h-53.335v-138.67h243.2c20.347 0.082 39.834 8.197 54.221 22.584 14.382 14.382 22.502 33.874 22.579 54.216v61.87h-53.335c-11.315 0-22.164 4.495-30.167 12.493-8.003 8.003-12.498 18.857-12.498 30.172v170.665c0 11.315 4.495 22.17 12.498 30.172s18.852 12.498 30.167 12.498h170.67c11.315 0 22.164-4.495 30.167-12.498s12.498-18.857 12.498-30.172v-170.665c0-11.315-4.495-22.17-12.498-30.172-8.003-7.997-18.852-12.493-30.167-12.493zM469.334 213.334h85.331v85.333h-85.331v-85.333zM170.666 896h-85.333v-85.335h85.333v85.335zM554.665 896h-85.331v-85.335h85.331v85.335zM938.665 896h-85.33v-85.335h85.33v85.335z"
      ],
      "tags": [
        "hierarchy-square-4"
      ],
      "defaultCode": 59654,
      "grid": 0
    },
    {
      "paths": [
        "M1024 512c0-19.399-7.706-38.003-21.422-51.72s-32.323-21.423-51.722-21.423h-347.428c-4.849 0-9.498-1.927-12.928-5.356s-5.356-8.080-5.356-12.93v-347.429c0-19.399-7.706-38.003-21.422-51.72-13.722-13.717-32.323-21.423-51.722-21.423-19.399 0-38.003 7.706-51.72 21.423s-21.423 32.321-21.423 51.72v347.429c0 4.85-1.927 9.501-5.356 12.93s-8.080 5.356-12.93 5.356h-347.429c-19.399 0-38.003 7.706-51.72 21.423s-21.423 32.321-21.423 51.72c0 19.4 7.706 38.001 21.423 51.722 13.717 13.716 32.321 21.422 51.72 21.422h347.429c4.85 0 9.501 1.925 12.93 5.356s5.356 8.079 5.356 12.928v347.428c0 19.4 7.706 38.006 21.423 51.722s32.321 21.422 51.72 21.422c19.4 0 38.001-7.706 51.722-21.422 13.716-13.716 21.422-32.323 21.422-51.722v-347.428c0-4.849 1.925-9.498 5.356-12.928s8.079-5.356 12.928-5.356h347.428c19.4 0 38.006-7.706 51.722-21.422 13.716-13.722 21.422-32.323 21.422-51.722z"
      ],
      "tags": [
        "interface-add-1"
      ],
      "defaultCode": 59655,
      "grid": 0
    },
    {
      "paths": [
        "M853.335 958.976c0 12.718-5.053 24.919-14.049 33.91-8.991 8.996-21.192 14.049-33.91 14.049h-46.935v-94.807h94.894v46.848zM0 958.976c0 12.718 5.053 24.919 14.046 33.91 8.994 8.996 21.192 14.049 33.911 14.049h46.933v-94.807h-94.89v46.848zM189.61 912.128h94.806v94.807h-94.806v-94.807zM379.264 912.128h94.806v94.807h-94.806v-94.807zM568.873 912.128h94.807v94.807h-94.807v-94.807z",
        "M256 51.2h725.335v725.335h-725.335v-725.335z",
        "M0 532.864h94.806v94.807h-94.806v-94.807zM0 722.473h94.806v94.807h-94.806v-94.807zM0 343.21h94.806v94.806h-94.806v-94.806zM0 199.894v48.512h94.806v-94.806h-48.512c-12.278 0-24.053 4.877-32.734 13.559s-13.559 20.457-13.559 32.735z"
      ],
      "attrs": [
        {},
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        },
        {}
      ],
      "isMulticolor2": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {},
          {
            "s": 0
          },
          {}
        ]
      },
      "tags": [
        "layer-select-front"
      ],
      "defaultCode": 59656,
      "grid": 0
    },
    {
      "paths": [
        "M1002.665 826.711c0 12.718-5.053 24.919-14.044 33.91-8.996 8.996-21.192 14.049-33.91 14.049h-46.935v-94.807h94.889v46.848zM907.863 400.599h94.802v94.805h-94.802v-94.805zM907.863 590.208h94.802v94.807h-94.802v-94.807zM907.863 210.945h94.802v94.806h-94.802v-94.806zM1002.665 67.628v48.512h-94.802v-94.805h48.512c12.278 0 24.049 4.877 32.732 13.559s13.558 20.456 13.558 32.734zM149.333 826.711c0 12.718 5.052 24.919 14.046 33.91 8.994 8.996 21.192 14.049 33.911 14.049h46.934v-94.807h-94.89v46.848zM149.333 400.599h94.805v94.805h-94.805v-94.805zM149.333 590.208h94.805v94.807h-94.805v-94.807zM149.333 210.945h94.805v94.806h-94.805v-94.806zM338.943 21.334h94.806v94.805h-94.806v-94.805zM528.599 21.334h94.802v94.805h-94.802v-94.805zM718.208 21.334h94.807v94.805h-94.807v-94.805zM338.943 779.863h94.806v94.807h-94.806v-94.807zM528.599 779.863h94.802v94.807h-94.802v-94.807zM718.208 779.863h94.807v94.807h-94.807v-94.807zM149.333 67.628v48.512h94.805v-94.805h-48.512c-12.278 0-24.053 4.877-32.734 13.559s-13.559 20.456-13.559 32.734z",
        "M704 1002.665h-682.667v-682.665"
      ],
      "attrs": [
        {},
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        }
      ],
      "isMulticolor2": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {},
          {
            "s": 0
          }
        ]
      },
      "tags": [
        "layer-select"
      ],
      "defaultCode": 59657,
      "grid": 0
    },
    {
      "paths": [
        "M29.867 42.667c0-23.564 19.103-42.667 42.667-42.667h213.333c23.564 0 42.667 19.103 42.667 42.667v213.333c0 23.564-19.103 42.666-42.667 42.666h-213.333c-23.564 0-42.667-19.102-42.667-42.666v-213.333zM115.201 85.334v128h128v-128h-128zM1002.665 192h-588.798v-85.334h588.798v85.334zM29.867 405.334c0-23.564 19.103-42.667 42.667-42.667h213.333c23.564 0 42.667 19.103 42.667 42.667v213.331c0 23.567-19.103 42.67-42.667 42.67h-213.333c-23.564 0-42.667-19.103-42.667-42.67v-213.331zM115.201 448v128h128v-128h-128zM1002.665 554.665h-588.798v-85.331h588.798v85.331zM29.867 768c0-23.562 19.103-42.665 42.667-42.665h213.333c23.564 0 42.667 19.103 42.667 42.665v213.335c0 23.562-19.103 42.665-42.667 42.665h-213.333c-23.564 0-42.667-19.103-42.667-42.665v-213.335zM115.201 810.665v128h128v-128h-128zM1002.665 917.335h-588.798v-85.335h588.798v85.335z"
      ],
      "tags": [
        "list-bullet-point-square"
      ],
      "defaultCode": 59658,
      "grid": 0
    },
    {
      "paths": [
        "M170.667 469.335c-0.317-41.217 7.9-82.054 24.135-119.94s40.137-72.002 70.2-100.2c30.064-28.198 65.638-49.868 104.485-63.646s80.126-19.367 121.238-16.413c41.115 2.953 81.168 14.385 117.648 33.574 36.475 19.19 68.588 45.722 94.316 77.928 25.723 32.206 44.503 69.388 55.153 109.206 10.655 39.818 12.948 81.41 6.743 122.157h86.231c8.643-77.293-6.39-155.389-43.11-223.951-36.716-68.563-93.389-124.36-162.514-160.007s-147.446-49.463-224.596-39.62c-77.15 9.843-149.493 42.881-207.454 94.742s-98.808 120.1-117.135 195.685c-18.327 75.586-13.27 154.956 14.502 227.604s76.949 135.148 141.024 179.236c64.074 44.083 140.025 67.671 217.801 67.645 14.257-0.061 28.501-0.901 42.666-2.519v-86.226c-42.418 6.497-85.742 3.707-126.978-8.172-41.235-11.884-79.399-32.579-111.856-60.652s-58.429-62.863-76.127-101.955c-17.697-39.096-26.695-81.567-26.373-124.478z",
        "M512 256h-85.332v44.8c-25.924 5.264-48.966 19.972-64.655 41.27s-22.904 47.665-20.246 73.983c2.659 26.318 15.001 50.71 34.632 68.44s45.15 27.532 71.602 27.507h42.667c5.658 0 11.084 2.248 15.085 6.246 4.001 4.004 6.248 9.431 6.248 15.089s-2.247 11.085-6.248 15.084c-4.001 3.999-9.427 6.246-15.085 6.246h-149.334v85.335h85.334v42.665h85.332v-44.8c25.923-5.263 48.968-19.973 64.655-41.267 15.688-21.299 22.902-47.667 20.244-73.984-2.657-26.319-15.002-50.711-34.632-68.441s-45.148-27.533-71.601-27.507h-42.667c-5.658 0-11.084-2.248-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.247-11.084 6.248-15.085s9.427-6.248 15.085-6.248h149.335v-85.334h-85.335v-42.666z",
        "M754.903 674.729l97.833 97.833h-238.336v85.335h238.336l-97.833 97.833 60.37 60.334 200.832-200.832-200.832-200.832-60.37 60.329z"
      ],
      "tags": [
        "money-fund-move-found--business-products"
      ],
      "defaultCode": 59659,
      "grid": 0
    },
    {
      "paths": [
        "M170.667 42.667c0-23.564 19.103-42.667 42.667-42.667h768.001c23.562 0 42.665 19.103 42.665 42.667v767.998c0 23.567-19.103 42.67-42.665 42.67h-768.001c-23.564 0-42.667-19.103-42.667-42.67v-767.998zM256.001 85.334v682.666h682.664v-682.666h-682.664z",
        "M0 981.33v-810.664h85.334v767.999h768.002v85.335h-810.668c-23.564 0-42.667-19.103-42.667-42.67zM384 213.332h426.665v85.333h-426.665v-85.333zM384 383.999h426.665v85.334h-426.665v-85.334zM384 554.665h237.056v85.335h-237.056v-85.335z"
      ],
      "tags": [
        "paginate-filter-document"
      ],
      "defaultCode": 59660,
      "grid": 0
    },
    {
      "paths": [
        "M457.069 804.214l201.552-604.654-80.952-26.984-210.549 631.639h89.949zM705.357 328.627l194.611 194.611-194.611 194.606 60.339 60.344 224.783-224.783c8.003-8.003 12.498-18.852 12.498-30.167 0-11.317-4.495-22.17-12.498-30.171l-224.783-224.78-60.339 60.34zM245.809 268.287l-224.78 224.78c-8.002 8.002-12.497 18.854-12.497 30.171 0 11.315 4.495 22.164 12.497 30.167l224.78 224.783 60.34-60.344-194.61-194.606 194.61-194.611-60.34-60.34z"
      ],
      "tags": [
        "programming-code--programing-apps-websites"
      ],
      "defaultCode": 59661,
      "grid": 0
    },
    {
      "paths": [
        "M10.235 70.574l60.34-60.34 314.192 314.193v-138.359h85.334v241.365c0 23.564-19.103 42.666-42.666 42.666h-241.366v-85.333h138.359l-314.193-314.193zM598.103 555.433h241.362v85.335h-138.358l312.658 312.658-60.339 60.339-312.658-312.658v138.358h-85.335v-241.367c0-23.562 19.103-42.665 42.67-42.665z"
      ],
      "tags": [
        "shrink-diagonal"
      ],
      "defaultCode": 59662,
      "grid": 0
    },
    {
      "paths": [
        "M386.189 504.716c-31.643 26.489-70.597 49.954-117.389 49.954h-298.667v-85.336h298.667c17.208 0 36.92-8.54 62.611-30.048 22.147-18.542 43.972-42.488 68.967-69.913 4.227-4.638 8.545-9.375 12.97-14.203 56.487-61.623 132.618-141.836 239.452-141.836h256v85.333h-256c-63.836 0-115.702 47.787-176.548 114.164-3.993 4.356-8.035 8.798-12.123 13.29-24.658 27.098-50.971 56.015-77.94 78.594z",
        "M891.126 256.002l-140.498-140.497 60.339-60.34 170.67 170.667c16.66 16.662 16.66 43.677 0 60.34l-170.67 170.666-60.339-60.34 140.498-140.497zM268.799 554.67h-298.667v-85.335h298.667c46.792 0 85.747 23.46 117.389 49.95 26.97 22.579 53.283 51.497 77.941 78.597 4.087 4.49 8.13 8.934 12.122 13.286 60.847 66.381 112.713 114.166 176.549 114.166h256v85.335h-256c-106.834 0-182.965-80.215-239.453-141.839-4.425-4.823-8.743-9.564-12.97-14.203-24.995-27.423-46.82-51.369-68.967-69.908-25.691-21.509-45.403-30.049-62.61-30.049z",
        "M810.967 567.168l170.67 170.665c16.66 16.66 16.66 43.679 0 60.339l-170.67 170.665-60.339-60.339 140.498-140.498-140.498-140.493 60.339-60.339z"
      ],
      "tags": [
        "zigzag-split-arrow"
      ],
      "defaultCode": 59663,
      "grid": 0
    },
    {
      "paths": [
        "M102.4 204.8h563.2v102.4h-563.2v-102.4z",
        "M51.2 90.585c0-21.751 17.192-39.385 38.4-39.385h537.6c21.207 0 38.4 17.633 38.4 39.385v283.569h-76.8v-244.185h-460.8v354.462h179.2v78.769h-217.6c-21.208 0-38.4-17.633-38.4-39.383v-433.232z",
        "M409.6 497.068c0-20.030 16.238-36.268 36.268-36.268h507.752c20.029 0 36.265 16.238 36.265 36.268v217.607h-72.535v-181.34h-435.214v326.41h471.484v72.54h-507.752c-20.030 0-36.268-16.241-36.268-36.27v-398.947z",
        "M989.885 896.046c0 20.029-16.236 36.265-36.265 36.265h-507.752c-20.030 0-36.268-16.236-36.268-36.265v-217.61h72.536v181.34h435.214v-326.41h-471.482v-72.536h507.752c20.029 0 36.265 16.238 36.265 36.268v398.948z",
        "M445.981 605.901h507.752v108.805h-507.752v-108.805z",
        "M136.534 742.4v-128h-85.334v170.665c0 23.567 19.103 42.67 42.666 42.67h128v-85.335h-85.333z",
        "M221.6 913.101v-256l128 128-128 128z",
        "M904.556 221.865v128h85.33v-170.666c0-23.564-19.103-42.666-42.665-42.666h-128v85.333h85.335z",
        "M819.666 51.2v256l-128-128 128-128z"
      ],
      "tags": [
        "account-credit-card-replace"
      ],
      "defaultCode": 59664,
      "grid": 0
    },
    {
      "paths": [
        "M542.72 1018.88v-87.040c30.72 0 66.56-5.12 97.28-10.24l20.48 81.92c-40.96 10.24-76.8 15.36-117.76 15.36zM742.4 977.92l-35.84-76.8c56.32-25.6 102.4-56.32 143.36-102.4l61.44 56.32c-46.080 51.2-102.4 92.16-168.96 122.88zM967.68 783.36l-71.68-46.080c30.72-51.2 51.2-107.52 61.44-168.96l87.040 10.24c-15.36 76.8-35.84 143.36-76.8 204.8zM957.44 501.759c0-61.44-15.36-117.76-46.080-174.080l76.8-40.96c30.72 66.56 51.2 133.12 51.2 204.8l-81.92 10.24zM875.52 266.239c-35.84-46.080-81.92-87.040-133.12-117.76l40.96-76.8c61.44 35.84 117.76 81.92 158.72 138.24l-66.56 56.32zM680.96 122.879c-30.72-10.24-66.56-20.48-97.28-20.48l10.24-87.040c40.96 5.12 76.8 10.24 112.64 25.6l-25.6 81.92z",
        "M542.72 1018.88c-138.24 0-271.36-56.32-363.52-158.72-92.16-97.28-138.24-225.28-138.24-358.4 5.12-133.12 61.44-256 158.72-348.16l56.32 61.44c-76.8 71.68-122.88 179.2-128 286.72s35.84 215.040 112.64 296.96c76.8 81.92 189.44 128 302.080 128v92.16z",
        "M368.64 51.2v348.16l-348.16-348.16h348.16z"
      ],
      "tags": [
        "design-tool-rotate-clockwise"
      ],
      "defaultCode": 59665,
      "grid": 0
    },
    {
      "paths": [
        "M512 853.504h-469.504c-11.317-0.133-22.126-4.726-30.081-12.774-7.955-8.054-12.416-18.913-12.415-30.234v-768c0-11.271 4.477-22.080 12.447-30.049s18.779-12.447 30.049-12.447h512c11.279 0.026 22.113 4.432 30.208 12.288l171.008 171.008c7.854 8.096 12.262 18.927 12.288 30.208v128h-85.504v-110.592l-145.408-145.408h-451.584v682.496h426.496v85.504z",
        "M512 42.495v213.504h213.504l-213.504-213.504z",
        "M478.208 648.704l-60.416-60.416 76.288-76.288-76.288-76.287 60.416-60.416 106.496 106.496c4.055 3.916 7.286 8.609 9.487 13.798s3.338 10.771 3.338 16.409c0 5.637-1.137 11.218-3.338 16.41s-5.432 9.882-9.487 13.798l-106.496 106.496zM289.792 648.704l-106.496-106.496c-4.057-3.917-7.284-8.607-9.487-13.798s-3.339-10.772-3.339-16.41c0-5.638 1.136-11.218 3.339-16.409s5.43-9.883 9.487-13.798l106.496-106.496 60.416 60.416-76.288 76.287 76.288 76.288-60.416 60.416z",
        "M981.504 682.496h-341.504c-23.47 0-42.496 19.026-42.496 42.496v256.512c0 23.47 19.026 42.496 42.496 42.496h341.504c23.47 0 42.496-19.026 42.496-42.496v-256.512c0-23.47-19.026-42.496-42.496-42.496z",
        "M989.696 682.496h-102.4v-84.992c0-20.367-8.090-39.905-22.492-54.308s-33.94-22.492-54.308-22.492c-20.367 0-39.905 8.090-54.308 22.492s-22.492 33.94-22.492 54.308v84.992h-102.4v-84.992c0-47.529 18.877-93.108 52.485-126.714s79.186-52.487 126.715-52.487c47.529 0 93.107 18.88 126.715 52.487 33.603 33.607 52.485 79.185 52.485 126.714v84.992z"
      ],
      "tags": [
        "file-code-lock"
      ],
      "defaultCode": 59666,
      "grid": 0
    },
    {
      "paths": [
        "M512 554.665h-469.333v-426.665h938.668v341.334",
        "M256 426.666c47.129 0 85.334-38.205 85.334-85.333s-38.205-85.334-85.334-85.334c-47.128 0-85.333 38.205-85.333 85.334s38.205 85.333 85.333 85.333z",
        "M512 426.666c47.13 0 85.335-38.205 85.335-85.333s-38.205-85.334-85.335-85.334c-47.128 0-85.333 38.205-85.333 85.334s38.205 85.333 85.333 85.333z",
        "M768 426.666c47.13 0 85.335-38.205 85.335-85.333s-38.205-85.334-85.335-85.334c-47.13 0-85.335 38.205-85.335 85.334s38.205 85.333 85.335 85.333z",
        "M721.065 512l-106.665 106.665 106.665 106.67M849.065 512l106.67 106.665-106.67 106.67"
      ],
      "attrs": [
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        },
        {},
        {},
        {},
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        }
      ],
      "isMulticolor2": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "s": 0
          },
          {},
          {},
          {},
          {
            "s": 0
          }
        ]
      },
      "tags": [
        "security-password-check"
      ],
      "defaultCode": 59667,
      "grid": 0
    },
    {
      "paths": [
        "M896 127.999v597.331l-384 256-384-256v-597.331c120.651-54.904 251.451-83.971 384-85.333 132.552 1.363 263.347 30.43 384 85.333z",
        "M682.665 426.665h-341.331c-23.564 0-42.667 19.103-42.667 42.667v170.668c0 23.562 19.103 42.665 42.667 42.665h341.331c23.567 0 42.67-19.103 42.67-42.665v-170.668c0-23.564-19.103-42.667-42.67-42.667z",
        "M384 426.666v-42.666c0-33.948 13.486-66.505 37.49-90.51s56.562-37.49 90.51-37.49c33.946 0 66.504 13.486 90.511 37.49 24.003 24.005 37.489 56.562 37.489 90.51v42.666"
      ],
      "attrs": [
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        },
        {},
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        }
      ],
      "isMulticolor2": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "s": 0
          },
          {},
          {
            "s": 0
          }
        ]
      },
      "tags": [
        "shield-lock"
      ],
      "defaultCode": 59668,
      "grid": 0
    },
    {
      "paths": [
        "M822.784 511.999c-0.082-25.165-3.005-50.241-8.704-74.752l105.472-108.544-79.872-126.976-144.384 45.568c-30.572-25.003-65.208-44.573-102.4-57.856l-36.864-146.944h-149.504l-36.864 146.944c-37.193 13.283-71.829 32.853-102.4 57.856l-144.384-45.568-79.872 126.976 105.472 108.544c-11.268 49.198-11.268 100.306 0 149.505l-105.472 108.544 79.872 126.976 144.384-45.568c30.571 25.001 65.207 44.57 102.4 57.856l36.864 146.944h149.504l36.864-146.944c37.192-13.286 71.828-32.855 102.4-57.856l144.384 46.080 78.336-127.488-103.936-108.544c5.699-24.509 8.622-49.587 8.704-74.753v0z",
        "M481.28 682.496c94.162 0 170.496-76.334 170.496-170.496s-76.334-170.495-170.496-170.495c-94.162 0-170.496 76.334-170.496 170.495s76.334 170.496 170.496 170.496z"
      ],
      "width": 973,
      "attrs": [
        {
          "fill": "none",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.504
        },
        {
          "fill": "none",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.504
        }
      ],
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "s": 0
          },
          {
            "s": 0
          }
        ]
      },
      "tags": [
        "streamline-icon-settings-cog-1@20x20 (1)"
      ],
      "defaultCode": 59669,
      "grid": 0
    },
    {
      "paths": [
        "M341.334 682.665c-33.755 0-66.751-10.010-94.817-28.759-28.066-18.755-49.941-45.409-62.858-76.595s-16.297-65.5-9.712-98.607c6.585-33.106 22.84-63.516 46.708-87.384s54.278-40.122 87.385-46.708c33.106-6.585 67.421-3.206 98.607 9.712s57.84 34.792 76.593 62.858c18.753 28.066 28.763 61.063 28.763 94.817 0 45.261-17.981 88.674-49.987 120.679s-75.416 49.987-120.679 49.987zM341.334 426.666c-16.878 0-33.376 5.005-47.409 14.381s-24.971 22.704-31.429 38.297c-6.459 15.592-8.148 32.748-4.856 49.301s11.42 31.759 23.354 43.694c11.934 11.935 27.139 20.060 43.692 23.352s33.711 1.603 49.303-4.854c15.593-6.461 28.92-17.398 38.297-31.432 9.376-14.029 14.381-30.531 14.381-47.407 0-22.631-8.99-44.337-24.993-60.34s-37.708-24.993-60.34-24.993zM682.665 1024h-682.665v-42.665c0-150.743 140.374-256 341.334-256 200.962 0 341.331 105.257 341.331 256v42.665zM92.118 938.665h498.434c-25.6-77.138-120.877-128-249.218-128s-223.702 50.862-249.216 128zM725.335 529.664l-158.167-158.166 60.329-60.331 97.838 97.835 183.168-183.168 60.329 60.33-243.497 243.499z"
      ],
      "tags": [
        "user-geometric-action-check-approve"
      ],
      "defaultCode": 59670,
      "grid": 0
    },
    {
      "paths": [
        "M341.334 682.665c-33.755 0-66.751-10.010-94.817-28.759-28.066-18.755-49.941-45.409-62.858-76.595s-16.297-65.501-9.712-98.607c6.585-33.106 22.84-63.516 46.708-87.384s54.278-40.123 87.385-46.708c33.106-6.585 67.421-3.205 98.607 9.712s57.84 34.792 76.593 62.858c18.753 28.066 28.763 61.063 28.763 94.817 0 45.261-17.981 88.674-49.987 120.679s-75.416 49.987-120.679 49.987zM341.334 426.666c-16.878 0-33.376 5.005-47.409 14.382s-24.971 22.704-31.429 38.296c-6.459 15.593-8.148 32.749-4.856 49.302s11.42 31.759 23.354 43.694c11.934 11.935 27.139 20.060 43.692 23.352s33.711 1.603 49.303-4.854c15.593-6.461 28.92-17.398 38.297-31.432 9.376-14.029 14.381-30.531 14.381-47.407 0-22.632-8.99-44.337-24.993-60.34s-37.708-24.994-60.34-24.994zM682.665 1024h-682.665v-42.665c0-150.743 140.374-256 341.334-256 200.962 0 341.331 105.257 341.331 256v42.665zM92.118 938.665h498.434c-25.6-77.138-120.877-128-249.218-128s-223.702 50.862-249.216 128zM926.167 202.154l-60.334-60.33-97.833 97.834-97.833-97.834-60.334 60.33 97.838 97.835-97.838 97.834 60.334 60.33 97.833-97.834 97.833 97.834 60.334-60.33-97.838-97.834 97.838-97.835z"
      ],
      "tags": [
        "user-geometric-action-cross-remove"
      ],
      "defaultCode": 59671,
      "grid": 0
    },
    {
      "paths": [
        "M426.666 85.334c-188.513 0-341.333 152.82-341.333 341.333 0 188.512 152.82 341.334 341.333 341.334 188.512 0 341.334-152.822 341.334-341.334 0-188.513-152.822-341.333-341.334-341.333zM0 426.666c0-235.641 191.025-426.666 426.666-426.666s426.669 191.025 426.669 426.666c0 235.641-191.027 426.669-426.669 426.669s-426.666-191.027-426.666-426.669z",
        "M469.334 469.333v170.667h-85.334v-170.667h-170.666v-85.334h170.666v-170.666h85.334v170.666h170.666v85.334h-170.666zM951.163 1011.502l-283.136-283.136 60.339-60.339 283.136 283.136-60.339 60.339z"
      ],
      "tags": [
        "zoom-in"
      ],
      "defaultCode": 59672,
      "grid": 0
    },
    {
      "paths": [
        "M426.666 85.334c-188.513 0-341.333 152.82-341.333 341.333 0 188.512 152.82 341.334 341.333 341.334 188.512 0 341.334-152.822 341.334-341.334 0-188.513-152.822-341.333-341.334-341.333zM0 426.666c0-235.641 191.025-426.666 426.666-426.666s426.669 191.025 426.669 426.666c0 235.641-191.027 426.669-426.669 426.669s-426.666-191.027-426.666-426.669z",
        "M213.333 384h426.667v85.334h-426.667v-85.334zM951.163 1011.502l-283.136-283.136 60.339-60.339 283.136 283.136-60.339 60.339z"
      ],
      "tags": [
        "zoom-out"
      ],
      "defaultCode": 59673,
      "grid": 0
    },
    {
      "paths": [
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h597.333c23.562 0 42.665 19.103 42.665 42.667v256h-85.33v-213.333h-512.002v384h384v85.331h-426.667c-23.564 0-42.667-19.103-42.667-42.665v-469.333zM554.665 426.666c0-23.564 19.103-42.666 42.67-42.666h384c23.562 0 42.665 19.103 42.665 42.666v554.669c0 23.562-19.103 42.665-42.665 42.665h-384c-23.567 0-42.67-19.103-42.67-42.665v-554.669zM640 469.334v469.331h298.665v-469.331h-298.665zM256 768v-128h-85.334v170.665c0 23.567 19.103 42.67 42.667 42.67h128v-85.335h-85.334z",
        "M341.334 938.665v-256l128 128-128 128z",
        "M938.665 170.667h-85.33v-85.334h128c23.562 0 42.665 19.103 42.665 42.667v170.666h-85.335v-128z",
        "M853.335 0v256l-128-128 128-128zM42.666 170.666h597.334v128h-597.334v-128zM853.335 512h-128l-85.335-85.334h298.665l-85.33 85.334z"
      ],
      "tags": [
        "account-credit-card-mobile-smartphone-wiring--business-products"
      ],
      "defaultCode": 59674,
      "grid": 0
    },
    {
      "paths": [
        "M277.334 264.534h-51.2c-23.564 0-42.667 19.102-42.667 42.666v125.142c0 20.855 15.076 38.653 35.646 42.085l152.087 25.371v46.338h-102.4v-18.831h-85.334v61.496c0 23.562 19.103 42.665 42.667 42.665h51.2v51.2h85.333v-51.2h51.2c23.564 0 42.667-19.103 42.667-42.665v-125.142c0-20.855-15.076-38.653-35.646-42.085l-152.087-25.371v-46.336h102.4v19.926h85.334v-62.592c0-23.564-19.103-42.666-42.667-42.666h-51.2v-51.2h-85.333v51.2z",
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h554.668c23.562 0 42.665 19.103 42.665 42.667v938.668c0 23.562-19.103 42.665-42.665 42.665h-554.668c-23.564 0-42.667-19.103-42.667-42.665v-938.668zM85.334 85.334v853.331h469.331v-853.331h-469.331z",
        "M42.667 853.335h554.668v85.33h-554.668v-85.33z",
        "M919.199 371.36c-12.867-31.061-31.724-59.283-55.501-83.056l60.339-60.343c31.698 31.696 56.842 69.326 73.999 110.741s25.984 85.803 25.984 130.631c0 44.827-8.827 89.218-25.984 130.628-17.157 41.416-42.301 79.048-73.999 110.746l-60.339-60.344c23.777-23.772 42.634-51.994 55.501-83.057s19.492-64.352 19.492-97.973c0-33.621-6.625-66.912-19.492-97.973z",
        "M803.328 589.993c31.995-32.005 49.971-75.407 49.971-120.659 0-45.255-17.976-88.657-49.971-120.662l-120.663 120.662 120.663 120.659z"
      ],
      "tags": [
        "account-mobile-payment-wiring--business-products"
      ],
      "defaultCode": 59675,
      "grid": 0
    },
    {
      "paths": [
        "M395.94 32.321c4.747-18.995 21.814-32.321 41.393-32.321h149.331c19.579 0 36.644 13.323 41.395 32.316l31.324 125.272c27.044 11.198 52.721 25.453 76.524 42.484l122.936-39.207c18.647-5.947 38.948 1.556 49.249 18.2l78.592 127.018c10.301 16.651 7.946 38.177-5.709 52.208l-90.030 92.504c3.302 20.183 4.997 40.61 5.053 61.087l-42.665 0.118 42.665 0.118c-0.056 20.475-1.751 40.904-5.053 61.087l90.030 92.503c13.655 14.029 16.010 35.548 5.714 52.198l-78.592 127.104c-10.301 16.66-30.618 24.166-49.275 18.202l-122.941-39.281c-23.803 17.004-49.464 31.232-76.498 42.409l-31.324 125.338c-4.746 18.995-21.816 32.323-41.395 32.323h-149.331c-19.577 0-36.642-13.322-41.392-32.317l-31.327-125.271c-27.045-11.197-52.722-25.457-76.529-42.486l-122.94 39.168c-18.642 5.944-38.935-1.562-49.232-18.196l-78.592-126.976c-10.306-16.65-7.954-38.18 5.704-52.214l89.994-92.467c-6.69-40.55-6.69-81.929 0-122.482l-89.994-92.467c-13.656-14.031-16.009-35.557-5.707-52.208l78.592-127.018c10.298-16.644 30.6-24.146 49.247-18.2l122.952 39.212c23.803-17.007 49.472-31.239 76.506-42.417l31.326-125.339zM810.665 512c-0.067-22.039-2.57-44.002-7.465-65.491-3.21-14.101 0.937-28.869 11.023-39.233l82.365-84.626-43.54-70.368-112.364 35.834c-13.706 4.372-28.698 1.539-39.869-7.536-27.218-22.115-58.112-39.264-91.279-50.661-13.66-4.695-24.018-15.985-27.525-30l-28.657-114.586h-82.705l-28.658 114.665c-3.506 14.026-13.875 25.322-27.55 30.013-33.16 11.374-64.058 28.498-91.28 50.587-11.167 9.061-26.147 11.887-39.848 7.518l-112.36-35.834-43.54 70.368 82.362 84.626c10.116 10.394 14.259 25.214 10.999 39.347-9.922 43.020-9.922 87.736 0 130.754 3.259 14.131-0.884 28.954-10.999 39.347l-82.359 84.623 43.536 70.339 112.371-35.804c13.708-4.367 28.694-1.536 39.86 7.537 27.216 22.118 58.115 39.265 91.28 50.662 13.662 4.695 24.021 15.985 27.526 29.998l28.655 114.586h82.705l28.662-114.662c3.502-14.029 13.875-25.324 27.551-30.013 33.157-11.377 64.056-28.498 91.279-50.586 11.172-9.068 26.163-11.894 39.869-7.511l112.338 35.891 43.546-70.426-82.371-84.634c-10.086-10.363-14.234-25.134-11.023-39.235 4.895-21.489 7.398-43.453 7.465-65.49z",
        "M469.334 328.534h-93.867v203.957l187.733 31.273v46.372h-102.399v-19.164h-85.334v104.494h93.867v51.2h85.331v-51.2h93.87v-203.996l-187.735-31.274v-46.328h102.399v18.141h85.335v-103.475h-93.87v-51.2h-85.331v51.2z"
      ],
      "tags": [
        "account-setting-optimization"
      ],
      "defaultCode": 59676,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M597.335 213.334h-170.669l42.666 384.002h85.332l42.67-384.002zM458.666 672h106.669v106.665h-106.669v-106.665z"
      ],
      "tags": [
        "alert-circle--interface-essential"
      ],
      "defaultCode": 59677,
      "grid": 0
    },
    {
      "paths": [
        "M481.83 12.507c16.663-16.662 43.677-16.662 60.342 0l469.32 469.323c16.666 16.662 16.666 43.676 0 60.342l-469.32 469.32c-16.666 16.666-43.68 16.666-60.342 0l-469.323-469.32c-16.662-16.666-16.662-43.68 0-60.342l469.323-469.323zM512 103.017l-408.983 408.983 408.983 408.986 408.98-408.986-408.98-408.983z",
        "M469.334 256h85.331v298.665h-85.331v-298.665zM469.334 640h85.331v85.335h-85.331v-85.335z"
      ],
      "tags": [
        "alert-daimond--interface-essential"
      ],
      "defaultCode": 59678,
      "grid": 0
    },
    {
      "paths": [
        "M512 0c16.159 0 30.935 9.131 38.164 23.586l469.33 938.667c6.615 13.225 5.908 28.933-1.869 41.513-7.772 12.58-21.504 20.234-36.291 20.234h-938.668c-14.787 0-28.52-7.654-36.294-20.234s-8.481-28.288-1.868-41.513l469.334-938.667c7.227-14.455 22.001-23.586 38.162-23.586zM111.703 938.665h800.594l-400.297-800.593-400.297 800.593z",
        "M469.333 384h85.332v298.665h-85.332v-298.665zM469.333 768h85.332v85.335h-85.332v-85.335z"
      ],
      "tags": [
        "alert-triangle--interface-essential"
      ],
      "defaultCode": 59679,
      "grid": 0
    },
    {
      "paths": [
        "M881.239 725.335c26.609-46.136 44.298-96.87 52.137-149.55l84.393 12.8c-9.441 63.212-30.705 124.073-62.674 179.415l-73.856-42.665zM725.335 881.193c46.167-26.665 86.948-61.727 120.233-103.378l66.688 53.289c-39.956 49.946-88.878 91.991-144.256 123.991l-42.665-73.902zM512 938.665c53.325-0.251 106.138-10.378 155.776-29.865l31.191 79.401c-59.561 23.429-122.962 35.569-186.967 35.799v-85.335zM298.88 881.193c46.128 26.634 96.862 44.339 149.546 52.183l-12.8 84.393c-63.285-9.405-124.227-30.669-179.626-62.674l42.88-73.902zM142.762 725.335c26.729 46.075 61.801 86.774 103.424 120.018l-53.248 66.688c-49.936-39.89-91.999-88.735-124.032-144.041l73.856-42.665zM85.334 512c0.229 53.315 10.356 106.117 29.866 155.735l-79.445 31.232c-23.394-59.571-35.518-122.967-35.755-186.967h85.334zM142.762 298.88c-26.61 46.135-44.297 96.868-52.138 149.546l-84.395-12.8c9.419-63.282 30.683-124.221 62.677-179.626l73.856 42.88zM298.88 142.806c-46.17 26.668-86.948 61.73-120.234 103.381l-66.688-53.29c39.89-49.923 88.739-91.971 144.042-123.99l42.88 73.899zM512 85.334c-53.324 0.253-106.14 10.379-155.776 29.866l-31.19-79.488c59.567-23.399 122.968-35.509 186.966-35.712v85.334zM725.335 142.806c-46.193-26.66-97.004-44.364-149.76-52.182l12.8-84.395c63.283 9.406 124.227 30.67 179.625 62.677l-42.665 73.899zM881.239 298.88c-26.711-46.154-61.783-86.928-103.424-120.234l53.248-66.688c49.935 39.889 91.996 88.737 124.032 144.042l-73.856 42.88zM938.665 512c-0.225-53.313-10.353-106.119-29.865-155.734l79.447-31.232c23.393 59.57 35.517 122.967 35.753 186.966h-85.335z",
        "M469.333 314.454h-59.734c-23.564 0-42.666 19.102-42.666 42.666v136.534c0 20.855 15.079 38.658 35.652 42.088l169.15 28.191v57.723h-119.469v-32.855h-85.333v75.52c0 23.562 19.102 42.665 42.666 42.665h59.734v59.735h85.332v-59.735h59.735c23.562 0 42.665-19.103 42.665-42.665v-136.535c0-20.855-15.078-38.655-35.651-42.084l-169.148-28.191v-57.723h119.469v25.6h85.33v-68.266c0-23.564-19.103-42.666-42.665-42.666h-59.735v-59.734h-85.332v59.734z"
      ],
      "tags": [
        "analytic-currency--business-products"
      ],
      "defaultCode": 59680,
      "grid": 0
    },
    {
      "paths": [
        "M881.239 725.335c26.609-46.136 44.298-96.87 52.137-149.55l84.393 12.8c-9.441 63.212-30.705 124.073-62.674 179.415l-73.856-42.665zM725.335 881.193c46.167-26.665 86.948-61.727 120.233-103.378l66.688 53.289c-39.956 49.946-88.878 91.991-144.256 123.991l-42.665-73.902zM512 938.665c53.325-0.251 106.138-10.378 155.776-29.865l31.191 79.401c-59.561 23.429-122.962 35.569-186.967 35.799v-85.335zM298.88 881.193c46.128 26.634 96.862 44.339 149.546 52.183l-12.8 84.393c-63.285-9.405-124.227-30.669-179.626-62.674l42.88-73.902zM142.762 725.335c26.729 46.075 61.801 86.774 103.424 120.018l-53.248 66.688c-49.936-39.89-91.999-88.735-124.032-144.041l73.856-42.665zM85.334 512c0.229 53.315 10.356 106.117 29.866 155.735l-79.445 31.232c-23.394-59.571-35.518-122.967-35.755-186.967h85.334zM142.762 298.88c-26.61 46.135-44.297 96.868-52.138 149.546l-84.395-12.8c9.419-63.282 30.683-124.221 62.677-179.626l73.856 42.88zM298.88 142.806c-46.17 26.668-86.948 61.73-120.234 103.381l-66.688-53.29c39.89-49.923 88.739-91.971 144.042-123.99l42.88 73.899zM512 85.334c-53.324 0.253-106.14 10.379-155.776 29.866l-31.19-79.488c59.567-23.399 122.968-35.509 186.966-35.712v85.334zM725.335 142.806c-46.193-26.66-97.004-44.364-149.76-52.182l12.8-84.395c63.283 9.406 124.227 30.67 179.625 62.677l-42.665 73.899zM881.239 298.88c-26.711-46.154-61.783-86.928-103.424-120.234l53.248-66.688c49.935 39.889 91.996 88.737 124.032 144.042l-73.856 42.88zM938.665 512c-0.225-53.313-10.353-106.119-29.865-155.734l79.447-31.232c23.393 59.57 35.517 122.967 35.753 186.966h-85.335z",
        "M268.497 695.163l426.666-426.666 60.339 60.34-426.665 426.665-60.34-60.339z",
        "M298.667 384c0-47.129 38.205-85.334 85.334-85.334s85.334 38.205 85.334 85.334c0 47.128-38.205 85.334-85.334 85.334s-85.334-38.205-85.334-85.334z",
        "M554.665 640c0-47.13 38.205-85.335 85.335-85.335s85.335 38.205 85.335 85.335c0 47.13-38.205 85.335-85.335 85.335s-85.335-38.205-85.335-85.335z"
      ],
      "tags": [
        "analytic-percentage--business-products"
      ],
      "defaultCode": 59681,
      "grid": 0
    },
    {
      "paths": [
        "M85.333 42.667c0-23.564 19.103-42.667 42.667-42.667h768c23.562 0 42.665 19.103 42.665 42.667v938.668c0 23.562-19.103 42.665-42.665 42.665h-768c-23.564 0-42.667-19.103-42.667-42.665v-938.668zM170.666 85.334v224h682.669v-224h-682.669zM853.335 394.666h-682.669v543.998h682.669v-543.998z",
        "M341.333 351.999l37.931 128h265.472l37.929-128h-341.332zM341.333 42.666l37.931 128h265.472l37.929-128h-341.332z",
        "M896 704h-768v-85.335h768v85.335z",
        "M341.333 661.335l37.931 128h265.472l37.929-128h-341.332z"
      ],
      "tags": [
        "archive-locker--content"
      ],
      "defaultCode": 59682,
      "grid": 0
    },
    {
      "paths": [
        "M981.868 0.003c0.010 0 0.015 0-0.532 42.663 42.66-0.55 42.66-0.543 42.66-0.536l0.005 0.076v0.178l0.005 0.611 0.015 2.212c0.005 1.902 0.005 4.643-0.020 8.124-0.046 6.958-0.195 16.889-0.584 28.983-0.778 24.124-2.534 57.166-6.472 92.552-3.922 35.181-10.122 73.821-20.116 108.725-9.626 33.596-24.361 69.636-48.886 94.169-0.005 0.005 0.005-0.005 0 0l-176.010 176.182c-17.638 17.592-29.763 39.956-34.877 64.343s-3 49.736 6.077 72.934c21.222 54.103 26.194 113.219 14.31 170.107-11.884 56.899-40.11 109.092-81.224 150.185-16.666 16.655-43.674 16.65-60.334-0.010l-603.384-603.387c-8.005-8.003-12.502-18.86-12.5-30.18s4.502-22.175 12.509-30.176c41.112-41.078 93.316-69.268 150.213-81.117 56.887-11.846 115.994-6.84 170.079 14.404 23.196 9.074 48.536 11.184 72.913 6.070 24.386-5.116 46.748-17.238 64.344-34.878l176.167-176.167c24.53-24.533 60.58-39.271 94.182-48.896 34.903-9.998 73.544-16.199 108.723-20.117 35.384-3.941 68.429-5.696 92.554-6.473 12.093-0.39 22.026-0.536 28.984-0.584 3.476-0.024 6.221-0.024 8.12-0.017l2.826 0.018 0.251 0.003zM663.67 722.324c-15.135-38.671-18.657-80.916-10.127-121.559 8.52-40.627 28.713-77.885 58.097-107.21 0.010-0.010-0.010 0.010 0 0l175.939-176.105c8.786-8.79 18.673-27.535 27.213-57.357 8.172-28.52 13.701-61.949 17.341-94.672 3.287-29.489 4.941-57.479 5.765-79.321-21.842 0.824-49.828 2.481-79.319 5.765-32.722 3.645-66.15 9.172-94.669 17.342-29.824 8.543-48.553 18.413-57.344 27.203l-176.092 176.090c-0.005 0.007 0.010-0.007 0 0-29.322 29.39-66.605 49.606-107.238 58.131-40.642 8.526-82.89 5.005-121.56-10.131l-0.051-0.020c-38.637-15.18-80.864-18.759-121.505-10.296-26.534 5.526-51.64 16.027-74.044 30.818l536.951 536.948c14.817-22.405 25.344-47.519 30.889-74.066 8.489-40.643 4.92-82.908-10.245-121.559zM981.335 42.667l42.66-0.536c-0.297-23.134-18.99-41.83-42.127-42.128l-0.532 42.663z",
        "M276.524 968.535c-61.056 61.097-276.523 55.465-276.523 55.465s-5.76-215.337 55.467-276.393c29.576-27.93 68.873-43.223 109.545-42.65 40.673 0.579 79.518 16.988 108.29 45.742s45.201 67.589 45.803 108.262c0.602 40.673-14.673 79.98-42.582 109.573v0z",
        "M306.386 415.909l163.712-163.712 60.339 60.34-163.711 163.712-60.34-60.34zM547.753 657.275l163.712-163.713 60.339 60.34-163.712 163.712-60.339-60.339z",
        "M753.623 339.5c38.175 0 69.12-30.946 69.12-69.12s-30.945-69.12-69.12-69.12c-38.175 0-69.12 30.946-69.12 69.12s30.945 69.12 69.12 69.12z"
      ],
      "tags": [
        "astronomy-rocket-1--school-science"
      ],
      "defaultCode": 59683,
      "grid": 0
    },
    {
      "paths": [
        "M938.665 1024l-128-85.33-128 85.33v-324.265h256v324.265z",
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h767.998c23.567 0 42.67 19.103 42.67 42.667v213.333h-85.335v-170.666h-682.666v512.002h426.666v85.33h-469.333c-23.564 0-42.667-19.103-42.667-42.665v-597.333z",
        "M810.665 426.668c-70.692 0-128 57.308-128 128.003 0 70.692 57.308 128 128 128s128-57.308 128-128c0-70.695-57.308-128.003-128-128.003zM597.335 554.67c0-117.823 95.508-213.336 213.33-213.336s213.335 95.513 213.335 213.336c0 117.816-95.514 213.33-213.335 213.33s-213.33-95.514-213.33-213.33z",
        "M682.665 255.999h-511.998v-85.334h511.998v85.334zM426.667 426.665h-170.666v-85.333h170.666v85.333z"
      ],
      "tags": [
        "award-badge-certification--rewards-rating"
      ],
      "defaultCode": 59684,
      "grid": 0
    },
    {
      "paths": [
        "M170.665 42.667c0-23.564 19.103-42.667 42.667-42.667h597.332c23.562 0 42.665 19.103 42.665 42.667v938.668c0 16.66-9.697 31.8-24.837 38.764-15.135 6.958-32.942 4.475-45.594-6.369l-270.9-232.202-270.9 232.202c-12.651 10.844-30.457 13.327-45.596 6.369-15.138-6.963-24.838-22.103-24.838-38.764v-938.668zM255.999 85.334v803.232l228.233-195.625c15.978-13.696 39.555-13.696 55.534 0l228.234 195.625v-803.232h-512.001z",
        "M652.498 268.497l60.339 60.34-213.334 213.336c-16.662 16.66-43.677 16.66-60.34 0l-106.666-106.669 60.34-60.34 76.497 76.497 183.164-183.163z"
      ],
      "tags": [
        "award-banner-check--rewards-rating"
      ],
      "defaultCode": 59685,
      "grid": 0
    },
    {
      "paths": [
        "M746.665 791.808c64.118 0 116.096-51.978 116.096-116.096s-51.978-116.096-116.096-116.096c-64.118 0-116.096 51.978-116.096 116.096s51.978 116.096 116.096 116.096z",
        "M1024 1024c-12.8-104.105-132.009-185.728-277.335-185.728-145.321 0-264.532 81.623-277.332 185.728h554.667z",
        "M393.092 6.671c13.977-8.895 31.84-8.895 45.816 0l371.542 236.458c16.005 10.185 23.363 29.713 18.058 47.925s-21.996 30.737-40.965 30.737h-58.583v190.208h-85.335v-190.208h-94.848v378.665h27.223v85.335h-565.334v-85.335h92.502v-378.665h-58.71c-18.969 0-35.661-12.524-40.965-30.737s2.053-37.74 18.057-47.925l371.541-236.458zM188.501 321.792v378.665h94.806v-378.665h-94.806zM368.64 321.792v378.665h94.805v-378.665h-94.805zM190.966 236.458h450.068l-225.034-143.217-225.034 143.217z"
      ],
      "tags": [
        "bank-account--business-products"
      ],
      "defaultCode": 59686,
      "grid": 0
    },
    {
      "paths": [
        "M487.67 7.617c14.63-10.156 34.033-10.156 48.66 0l352 244.352c15.324 10.637 21.96 29.996 16.389 47.797-5.576 17.802-22.067 29.919-40.719 29.919h-53.335v267.65h85.335v85.33h-341.335v128h341.335c23.562 0 42.665 19.103 42.665 42.67v170.665h-85.33v-128h-682.668v128h-85.334v-170.665c0-23.567 19.103-42.67 42.667-42.67h341.333v-128h-341.333v-85.33h85.333v-267.65h-53.333c-18.654 0-35.145-12.118-40.718-29.919s1.064-37.16 16.388-47.797l352-244.352zM298.667 329.686v267.65h85.333v-267.65h-85.333zM469.334 329.686v267.65h85.331v-267.65h-85.331zM640 329.686v267.65h85.335v-267.65h-85.335zM296.285 244.352h431.431l-215.716-149.746-215.715 149.746z"
      ],
      "tags": [
        "bank-branch-client"
      ],
      "defaultCode": 59687,
      "grid": 0
    },
    {
      "paths": [
        "M240.471 112.471c72.014-72.014 169.686-112.471 271.529-112.471 101.842 0 199.517 40.457 271.529 112.471s112.471 169.686 112.471 271.529v341.335h128v85.33h-1024.001c-23.564 0-42.667-19.103-42.667-42.665s19.103-42.665 42.667-42.665h128v-341.335c0-101.843 40.457-199.515 112.471-271.529zM213.333 725.335h597.332v-341.335c0-79.212-31.468-155.178-87.475-211.189-56.013-56.011-131.978-87.477-211.19-87.477s-155.178 31.466-211.189 87.477c-56.011 56.011-87.477 131.978-87.477 211.189v341.335z",
        "M640 896c0 33.946-13.486 66.504-37.489 90.511-24.008 24.003-56.566 37.489-90.511 37.489-33.948 0-66.505-13.486-90.51-37.489-24.005-24.008-37.49-56.566-37.49-90.511h256z"
      ],
      "tags": [
        "bell-notification--interface-essential"
      ],
      "defaultCode": 59688,
      "grid": 0
    },
    {
      "paths": [
        "M184.099 262.305c58.675-58.675 138.256-91.639 221.236-91.639s162.561 32.964 221.236 91.639c58.675 58.675 91.638 138.256 91.638 221.236v261.332h92.462v85.335h-810.669c-23.564 0-42.667-19.103-42.667-42.665 0-23.567 19.103-42.67 42.667-42.67h92.458v-261.332c0-82.979 32.964-162.561 91.639-221.236zM177.793 744.873h455.085v-261.332c0-60.347-23.977-118.224-66.647-160.896-42.675-42.672-100.549-66.646-160.897-66.646s-118.224 23.973-160.896 66.646c-42.673 42.672-66.646 100.549-66.646 160.896v261.332z",
        "M506.666 922.665c0 26.88-10.676 52.654-29.68 71.654-19.004 19.005-44.778 29.681-71.653 29.681s-52.65-10.675-71.654-29.681c-19.003-19-29.68-44.774-29.68-71.654h202.666z",
        "M878.326 85.334h-152.991v-85.334h256c17.254 0 32.814 10.395 39.419 26.339s2.954 34.295-9.252 46.498l-161.828 161.83h174.326v85.334h-277.33c-17.26 0-32.819-10.395-39.419-26.339-6.605-15.944-2.954-34.295 9.247-46.498l161.828-161.83z"
      ],
      "tags": [
        "bell-notification-snooze-1--interface-essential"
      ],
      "defaultCode": 59689,
      "grid": 0
    },
    {
      "paths": [
        "M320 341.334h149.333v-85.334h-85.333v-42.666h-85.334v44.8c-25.923 5.264-48.966 19.972-64.655 41.27s-22.904 47.665-20.246 73.983c2.658 26.318 15.001 50.71 34.632 68.44s45.149 27.533 71.602 27.507h42.666c5.658 0 11.084 2.247 15.085 6.248s6.248 9.427 6.248 15.085c0 5.658-2.248 11.084-6.248 15.085s-9.427 6.248-15.085 6.248h-149.334v85.335h85.334v42.665h85.334v-44.841c25.877-5.309 48.864-20.029 64.509-41.313 15.646-21.289 22.837-47.619 20.182-73.901s-14.968-50.644-34.555-68.369c-19.587-17.724-45.053-27.551-71.47-27.576h-42.666c-5.658 0-11.084-2.248-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.248-11.084 6.248-15.085s9.427-6.248 15.085-6.248v0zM868.736 691.671c29.056-21.248 50.652-51.139 61.696-85.402 11.049-34.258 10.977-71.132-0.2-105.352-11.177-34.218-32.886-64.026-62.024-85.162s-64.21-32.518-100.209-32.518c-35.999 0-71.071 11.382-100.209 32.518s-50.847 50.945-62.024 85.162c-11.177 34.22-11.249 71.094-0.2 105.352 11.044 34.263 32.64 64.154 61.696 85.402-44.57 12.554-83.835 39.291-111.852 76.16s-43.254 81.864-43.412 128.169v128h512v-128c-0.159-46.305-15.396-91.3-43.412-128.169s-67.282-63.606-111.852-76.16v0zM768 469.334c16.876 0 33.377 5.004 47.406 14.381 14.034 9.377 24.975 22.704 31.432 38.295 6.456 15.596 8.146 32.753 4.854 49.306s-11.418 31.759-23.352 43.689c-11.935 11.935-27.141 20.065-43.694 23.357s-33.71 1.603-49.3-4.859c-15.596-6.456-28.918-17.393-38.298-31.427-9.375-14.034-14.382-30.531-14.382-47.411 0-22.63 8.991-44.335 24.996-60.338 16-16.003 37.709-24.993 60.339-24.993v0zM938.665 938.665h-341.33v-42.665c0-33.946 13.486-66.504 37.489-90.511 24.003-24.003 56.561-37.489 90.511-37.489h85.33c33.951 0 66.509 13.486 90.511 37.489 24.003 24.008 37.489 56.566 37.489 90.511v42.665z",
        "M445.654 689.833l-104.32 69.632-104.32-69.55c-6.247-4.163-13.481-6.6-20.973-7.071s-14.974 1.039-21.694 4.383l-109.013 54.4v-629.929l108.928 54.442c6.716 3.351 14.197 4.871 21.688 4.406s14.727-2.897 20.978-7.051l104.406-69.632 104.32 69.589c6.25 4.155 13.487 6.587 20.978 7.052s14.972-1.056 21.688-4.406l109.015-54.4v252.672c24.847-22.352 53.842-39.617 85.33-50.816v-270.891c0.005-7.274-1.853-14.427-5.391-20.782s-8.643-11.698-14.828-15.525c-6.19-3.826-13.251-6.007-20.516-6.336s-14.495 1.205-21.002 4.456l-148.522 74.283-107.392-71.595c-7.012-4.678-15.251-7.174-23.68-7.174s-16.669 2.496-23.68 7.174l-107.392 71.595-148.523-74.283c-6.506-3.251-13.736-4.785-21.002-4.456s-14.328 2.51-20.514 6.336c-6.186 3.826-11.291 9.17-14.83 15.525s-5.396 13.508-5.392 20.782v768.002c0 11.315 4.495 22.164 12.497 30.167s18.854 12.498 30.17 12.498c6.624 0.005 13.156-1.546 19.072-4.521l148.523-74.24 107.392 71.593c7.011 4.68 15.251 7.173 23.68 7.173s16.668-2.493 23.68-7.173l80.341-53.591c13.427-35.886 33.634-68.854 59.52-97.106l-16.469-8.238c-6.723-3.374-14.219-4.91-21.726-4.449-7.508 0.456-14.762 2.888-21.026 7.055v0z"
      ],
      "tags": [
        "billing-account--business-products"
      ],
      "defaultCode": 59690,
      "grid": 0
    },
    {
      "paths": [
        "M320 341.334h149.333v-85.334h-85.333v-42.666h-85.334v44.8c-25.923 5.264-48.966 19.972-64.655 41.27s-22.904 47.665-20.246 73.983c2.658 26.318 15.001 50.71 34.632 68.44s45.149 27.533 71.602 27.507h42.666c5.658 0 11.084 2.247 15.085 6.248s6.248 9.427 6.248 15.085c0 5.658-2.248 11.084-6.248 15.085s-9.427 6.248-15.085 6.248h-149.334v85.335h85.334v42.665h85.334v-44.841c25.877-5.309 48.864-20.029 64.509-41.313 15.646-21.289 22.837-47.619 20.182-73.901s-14.968-50.644-34.555-68.369c-19.587-17.724-45.053-27.551-71.47-27.576h-42.666c-5.658 0-11.084-2.248-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.248-11.084 6.248-15.085s9.427-6.248 15.085-6.248v0z",
        "M682.665 639.995v-597.332c0.005-7.274-1.853-14.427-5.391-20.782s-8.643-11.698-14.828-15.525c-6.19-3.826-13.251-6.007-20.516-6.336s-14.495 1.205-21.002 4.456l-148.522 74.283-107.392-71.595c-7.011-4.678-15.251-7.174-23.68-7.174s-16.669 2.496-23.68 7.174l-107.392 71.595-148.523-74.283c-6.506-3.251-13.736-4.785-21.002-4.456s-14.328 2.51-20.514 6.336c-6.186 3.826-11.291 9.17-14.83 15.525s-5.396 13.508-5.392 20.782v768.002c0 11.315 4.495 22.164 12.497 30.167s18.854 12.498 30.17 12.498c6.624 0.005 13.156-1.546 19.072-4.521l148.523-74.24 107.392 71.593c7.011 4.68 15.251 7.173 23.68 7.173s16.669-2.493 23.68-7.173l107.349-71.593 82.302 41.129v-95.401l-66.259-33.152c-6.72-3.348-14.203-4.859-21.694-4.388s-14.726 2.913-20.973 7.076l-104.405 69.632-104.32-69.55c-6.247-4.163-13.481-6.6-20.973-7.071s-14.974 1.039-21.694 4.383l-109.013 54.4v-629.929l108.928 54.442c6.716 3.351 14.197 4.871 21.688 4.406s14.727-2.897 20.978-7.051l104.406-69.632 104.32 69.589c6.25 4.155 13.487 6.587 20.978 7.052s14.972-1.056 21.688-4.406l109.015-54.4v528.297h85.33zM951.168 695.163l-183.168 183.168-97.833-97.833-60.334 60.329 158.167 158.167 243.497-243.497-60.329-60.334z"
      ],
      "tags": [
        "billing-check--business-products"
      ],
      "defaultCode": 59691,
      "grid": 0
    },
    {
      "paths": [
        "M384.938 640v-44.8c25.924-5.263 48.966-19.973 64.655-41.272 15.689-21.294 22.904-47.663 20.246-73.981s-15.001-50.71-34.632-68.44c-19.631-17.73-45.15-27.533-71.602-27.507h-42.667c-5.658 0-11.084-2.248-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.248-11.084 6.248-15.085s9.427-6.248 15.085-6.248h149.334v-85.334h-85.334v-42.666h-85.334v44.8c-25.923 5.264-48.966 19.972-64.654 41.27s-22.904 47.665-20.246 73.983c2.658 26.318 15.001 50.71 34.632 68.44s45.149 27.533 71.602 27.507h42.667c5.658 0 11.084 2.247 15.085 6.248s6.248 9.427 6.248 15.085c0 5.658-2.248 11.084-6.248 15.085s-9.427 6.248-15.085 6.248h-149.334v85.335h85.333v42.665h85.334z",
        "M213.334 682.665c-6.619-0.010-13.148 1.526-19.072 4.48l-108.928 54.482v-629.887l108.928 54.4c6.716 3.351 14.197 4.871 21.688 4.406s14.727-2.897 20.978-7.051l104.406-69.632 104.32 69.546c6.25 4.155 13.487 6.587 20.978 7.052s14.972-1.056 21.688-4.406l109.015-54.315v144.256h85.33v-213.333c0.005-7.274-1.853-14.427-5.391-20.782s-8.643-11.698-14.828-15.525c-6.19-3.826-13.251-6.007-20.516-6.336s-14.495 1.205-21.002 4.456l-148.522 74.283-107.392-71.595c-7.012-4.678-15.251-7.174-23.68-7.174s-16.669 2.496-23.68 7.174l-107.392 71.595-148.523-74.283c-6.506-3.251-13.736-4.785-21.002-4.456s-14.328 2.51-20.514 6.336c-6.186 3.826-11.291 9.17-14.83 15.525s-5.396 13.508-5.392 20.782v768.002c0 11.315 4.495 22.164 12.497 30.167s18.854 12.498 30.17 12.498c6.624 0.005 13.156-1.546 19.072-4.521l148.523-74.24 46.677 31.104v-102.4l-19.925-13.271c-6.993-4.736-15.235-7.291-23.68-7.337v0zM640.937 639.995h85.335v128h-85.335v-128z",
        "M683.607 896c23.562 0 42.665-19.103 42.665-42.665 0-23.567-19.103-42.67-42.665-42.67-23.567 0-42.67 19.103-42.67 42.67 0 23.562 19.103 42.665 42.67 42.665z",
        "M1018.88 961.111l-298.665-554.669c-3.999-6.346-9.539-11.575-16.102-15.2-6.569-3.624-13.947-5.525-21.448-5.525-7.496 0-14.874 1.901-21.443 5.525-6.564 3.624-12.104 8.854-16.102 15.2l-298.666 554.669c-3.498 6.497-5.251 13.793-5.087 21.171s2.238 14.587 6.022 20.92c3.783 6.339 9.145 11.587 15.562 15.232s13.67 5.56 21.050 5.565h597.335c7.378-0.005 14.633-1.92 21.048-5.565s11.781-8.893 15.565-15.232c3.779-6.333 5.857-13.542 6.021-20.92s-1.592-14.674-5.089-21.171v0zM455.424 938.665l227.241-421.97 227.246 421.97h-454.487z"
      ],
      "tags": [
        "billing-warning--business-products"
      ],
      "defaultCode": 59692,
      "grid": 0
    },
    {
      "paths": [
        "M128 170.667h-128v-85.334h1024v85.334h-128v725.333c0 33.946-13.486 66.504-37.489 90.511-24.008 24.003-56.566 37.489-90.511 37.489h-512c-33.948 0-66.505-13.486-90.51-37.489-24.005-24.008-37.49-56.566-37.49-90.511v-725.333zM213.334 170.667v725.333c0 11.315 4.495 22.17 12.496 30.172 8.002 7.997 18.854 12.493 30.17 12.493h512c11.315 0 22.17-4.495 30.172-12.493 7.997-8.003 12.493-18.857 12.493-30.172v-725.333h-597.331zM341.334 810.665v-511.998h85.333v511.998h-85.333zM597.335 810.665v-511.998h85.33v511.998h-85.33z",
        "M649.344 0h-274.688c-9.512 0-18.75 3.179-26.249 9.031s-12.827 14.042-15.138 23.268l-34.602 138.368h426.669l-34.606-138.368c-2.309-9.226-7.639-17.416-15.135-23.268-7.501-5.852-16.737-9.030-26.25-9.031v0z"
      ],
      "tags": [
        "bin-1--interface-essential"
      ],
      "defaultCode": 59693,
      "grid": 0
    },
    {
      "paths": [
        "M870.349 1.441c16.481-2.335 33.265-1.401 49.382 2.75 16.118 4.149 31.258 11.431 44.559 21.43 0.005 0.004-0.005-0.004 0 0l8.919 6.699c13.307 9.999 24.52 22.526 32.988 36.858 8.463 14.331 14.024 30.191 16.358 46.671s1.403 33.261-2.749 49.38c-4.147 16.111-11.428 31.248-21.427 44.546-0.005 0.007 0.005-0.007 0 0l-295.89 393.939-68.229-51.246 295.89-393.942c3.267-4.344 5.663-9.311 7.020-14.576s1.659-10.745 0.896-16.127c-0.763-5.383-2.575-10.562-5.34-15.243-2.765-4.679-6.426-8.767-10.767-12.033 0-0.001 0 0.002 0 0l-8.919-6.698c-4.347-3.27-9.313-5.663-14.582-7.020s-10.757-1.662-16.143-0.899c-5.386 0.763-10.568 2.58-15.252 5.347s-8.781 6.429-12.052 10.778l-298.67 397.189-68.2-51.285 298.662-397.18c0-0.002 0 0.002 0 0 10.004-13.305 22.533-24.514 36.864-32.979 14.336-8.466 30.198-14.025 46.684-16.36z",
        "M644.905 664.361c-72.53 96.814-237.097 64-290.558 23.936 92.075-82.217 56.832-115.922 97.024-169.385 19.288-25.665 47.981-42.616 79.768-47.124 15.739-2.233 31.764-1.343 47.16 2.617 15.391 3.96 29.86 10.914 42.568 20.465 12.703 9.551 23.409 21.509 31.493 35.199 8.084 13.686 13.394 28.831 15.631 44.57 2.232 15.739 1.341 31.759-2.621 47.155-3.958 15.396-10.911 29.86-20.465 42.568v0z",
        "M567.665 515.727c-9.969-2.56-20.342-3.139-30.536-1.69-20.582 2.918-39.161 13.896-51.65 30.51l-0.004 0.005c-9.809 13.051-11.805 20.977-15.591 36.019-1.647 6.538-3.634 14.428-6.749 24.668-6.598 21.688-16.788 44.114-36.865 69.535 19.417 5.632 42.588 9.754 67.037 10.23 49.844 0.973 92.744-13.24 117.453-46.223l34.15 25.585-34.109-25.631c6.18-8.233 10.685-17.597 13.251-27.566s3.139-20.347 1.695-30.536c-1.449-10.194-4.884-19.999-10.122-28.861-5.233-8.863-12.165-16.604-20.393-22.789s-17.597-10.691-27.566-13.256zM417.267 493.277c26.086-34.707 64.891-57.631 107.881-63.729 21.284-3.019 42.957-1.817 63.78 3.54 20.818 5.356 40.381 14.761 57.569 27.678s31.662 29.092 42.598 47.603c10.936 18.511 18.12 38.996 21.135 60.28 3.021 21.289 1.818 42.962-3.538 63.78-5.356 20.813-14.756 40.371-27.663 57.554zM679.030 689.981c-47.821 63.8-123.459 81.587-187.387 80.338-63.235-1.229-127.167-21.11-162.883-47.872l-41.706-31.258 38.875-34.714c40.88-36.5 50.371-58.988 55.566-76.068 0.995-3.272 1.966-7.224 3.069-11.725 4.629-18.872 11.615-47.355 32.698-75.401z",
        "M37.49 506.828c24.004-24.005 56.562-37.49 90.51-37.49h170.666v85.332h-170.666c-11.316 0-22.168 4.495-30.17 12.498s-12.496 18.852-12.496 30.167v298.67c0 11.315 4.495 22.17 12.496 30.167 8.002 8.003 18.854 12.498 30.17 12.498h554.665c11.315 0 22.17-4.495 30.172-12.498 8.003-7.997 12.498-18.852 12.498-30.167v-128h85.33v128c0 33.946-13.486 66.504-37.489 90.506-24.003 24.008-56.561 37.494-90.511 37.494h-554.665c-33.948 0-66.505-13.486-90.51-37.494-24.005-24.003-37.49-56.561-37.49-90.506v-298.67c0-33.946 13.486-66.504 37.49-90.507z"
      ],
      "tags": [
        "blob-brush--design"
      ],
      "defaultCode": 59694,
      "grid": 0
    },
    {
      "paths": [
        "M-0.007 511.999c0-130.667 49.959-256.39 139.644-351.418l62.059 58.57c-74.737 79.191-116.369 183.96-116.369 292.849 0 108.888 41.632 213.658 116.369 292.849l-62.059 58.568c-89.685-95.027-139.644-220.749-139.644-351.417zM938.675 511.999c0-108.889-41.636-213.658-116.372-292.849l62.060-58.57c89.687 95.029 139.643 220.751 139.643 351.418 0 130.668-49.956 256.39-139.643 351.417l-62.060-58.568c74.737-79.191 116.372-183.962 116.372-292.849zM191.954 512.041c0-83.76 32.842-164.182 91.474-223.999l60.94 59.734c-42.997 43.866-67.081 102.842-67.081 164.265 0 61.425 24.084 120.402 67.081 164.27l-60.94 59.73c-58.633-59.817-91.474-140.237-91.474-224zM746.711 512.041c0-61.424-24.084-120.399-67.082-164.265l60.943-59.734c58.629 59.817 91.474 140.239 91.474 223.999 0 83.763-32.845 164.183-91.474 224l-60.943-59.73c42.998-43.868 67.082-102.845 67.082-164.27z",
        "M511.999 597.33c47.13 0 85.336-38.2 85.336-85.331 0-47.128-38.205-85.334-85.336-85.334-47.128 0-85.333 38.205-85.333 85.334 0 47.131 38.205 85.331 85.333 85.331z",
        "M512 469.334c-23.564 0-42.666 19.102-42.666 42.666 0 23.562 19.102 42.665 42.666 42.665 23.562 0 42.665-19.103 42.665-42.665 0-23.564-19.103-42.666-42.665-42.666zM384 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z"
      ],
      "tags": [
        "boardcasting-wifi-signal--interface-essential"
      ],
      "defaultCode": 59695,
      "grid": 0
    },
    {
      "paths": [
        "M0 64.001c0-23.564 19.103-42.667 42.667-42.667h128c120.013 0 236.789 38.925 332.8 110.933l8.534 6.4 8.535-6.4c96.010-72.008 212.787-110.933 332.8-110.933h128c23.562 0 42.665 19.103 42.665 42.667v767.999c0 23.567-19.103 42.67-42.665 42.67h-128c-101.55 0-200.361 32.937-281.6 93.865l-34.135 25.6c-15.171 11.377-36.029 11.377-51.2 0l-34.134-25.6c-81.24-60.928-180.050-93.865-281.6-93.865h-128c-23.564 0-42.667-19.103-42.667-42.67v-767.999zM85.334 106.668v682.668h85.333c120.013 0 236.789 38.922 332.8 110.935l8.534 6.4 8.535-6.4c96.010-72.013 212.787-110.935 332.8-110.935h85.33v-682.668h-85.33c-101.55 0-200.361 32.937-281.6 93.867l-34.135 25.6c-15.171 11.378-36.029 11.378-51.2 0l-34.134-25.6c-81.24-60.93-180.050-93.867-281.6-93.867h-85.333z",
        "M512 960v-768c-145.442-75.864-305.514-119.52-469.334-128v768c146.432-42.368 304 10.025 469.334 128z",
        "M512 351.101c-8.924 6.967-17.655 14.224-26.179 21.764l26.179 29.594v-51.358zM597.335 296.25v98.687c75.766-49.306 164.623-75.961 256-75.96v-85.334c-89.784-0.001-177.516 21.775-256 62.606zM512 522.281c-8.924 6.968-17.655 14.223-26.179 21.765l26.179 29.594v-51.359zM597.335 566.118v-98.69c78.484-40.832 166.216-62.608 256-62.606v85.333c-91.377-0.001-180.234 26.652-256 75.963zM512 693.458c-8.924 6.968-17.655 14.223-26.179 21.765l26.179 29.594v-51.359zM597.335 737.295v-98.688c78.484-40.832 166.216-62.607 256-62.607v85.335c-91.377 0-180.234 26.655-256 75.96z"
      ],
      "tags": [
        "book-open-1"
      ],
      "defaultCode": 59696,
      "grid": 0
    },
    {
      "paths": [
        "M384 691.794v-93.952c-67.058-27.94-139.501-42.665-213.335-42.66l0.002 85.33c74.721 0 147.761 17.823 213.333 51.282zM512 672.635v51.359l26.179-29.594c-8.525-7.542-17.254-14.797-26.179-21.765zM512 510.149v-51.357c8.924 6.967 17.654 14.223 26.179 21.764l-26.179 29.594zM384 477.951v-93.953c-67.058-27.939-139.501-42.665-213.335-42.664l0.002 85.333c74.721-0.001 147.761 17.824 213.333 51.283z",
        "M0 170.666c0-23.564 19.103-42.666 42.667-42.666h128c120.013 0 236.789 38.925 332.8 110.934l8.534 6.4 8.535-6.4c96.010-72.008 212.787-110.934 332.8-110.934h128c23.562 0 42.665 19.103 42.665 42.666v639.998c0 23.567-19.103 42.67-42.665 42.67h-128c-101.55 0-200.361 32.937-281.6 93.865l-34.135 25.6c-15.171 11.377-36.029 11.377-51.2 0l-34.134-25.6c-81.24-60.928-180.050-93.865-281.6-93.865h-128c-23.564 0-42.667-19.103-42.667-42.67v-639.998zM85.334 213.334v554.666h85.333c120.013 0 236.789 38.927 332.8 110.935l8.534 6.4 8.535-6.4c96.010-72.008 212.787-110.935 332.8-110.935h85.33v-554.666h-85.33c-101.55 0-200.361 32.936-281.6 93.866l-34.135 25.6c-15.171 11.378-36.029 11.378-51.2 0l-34.134-25.6c-81.24-60.93-180.050-93.866-281.6-93.866h-85.333z",
        "M853.335 490.668l-106.67-64-106.665 106.668v-405.334l213.335-42.666v405.333z",
        "M469.334 938.67v-640.002h85.331v640.002h-85.331z"
      ],
      "tags": [
        "book-open-bookmark"
      ],
      "defaultCode": 59697,
      "grid": 0
    },
    {
      "paths": [
        "M0 85.332c0-23.564 19.103-42.667 42.667-42.667h128c120.013 0 236.789 38.925 332.8 110.933l8.534 6.4 8.535-6.4c96.010-72.008 212.787-110.933 332.8-110.933h128c23.562 0 42.665 19.103 42.665 42.667v725.332c0 23.562-19.103 42.665-42.665 42.665h-128c-101.55 0-200.361 32.937-281.6 93.87l-34.135 25.6c-15.171 11.377-36.029 11.377-51.2 0l-34.134-25.6c-81.24-60.933-180.050-93.87-281.6-93.87h-128c-23.564 0-42.667-19.103-42.667-42.665v-725.332zM85.334 127.999v640.001h85.333c106.127 0 209.723 30.438 298.667 87.276v-620.61l-17.067-12.8c-81.24-60.93-180.050-93.866-281.6-93.866h-85.333zM554.665 234.665v620.61c88.945-56.837 192.543-87.276 298.67-87.276h85.33v-640.001h-85.33c-101.55 0-200.361 32.937-281.6 93.866l-17.070 12.8z"
      ],
      "tags": [
        "book-open"
      ],
      "defaultCode": 59698,
      "grid": 0
    },
    {
      "paths": [
        "M256 85.334c-11.316 0-22.169 4.495-30.17 12.496s-12.496 18.854-12.496 30.17v776.351l276.054-172.534c13.835-8.648 31.389-8.648 45.228 0l276.050 172.534v-776.351c0-11.316-4.495-22.168-12.493-30.17-8.003-8.002-18.857-12.496-30.172-12.496h-512zM165.49 37.49c24.005-24.005 56.562-37.49 90.51-37.49h512c33.946 0 66.504 13.486 90.511 37.49 24.003 24.004 37.489 56.562 37.489 90.51v853.335c0 15.508-8.417 29.798-21.985 37.315-13.563 7.521-30.141 7.086-43.295-1.137l-318.72-199.199-318.72 199.199c-13.153 8.223-29.731 8.658-43.297 1.137-13.566-7.516-21.983-21.806-21.983-37.315v-853.335c0-33.948 13.486-66.505 37.49-90.51z"
      ],
      "tags": [
        "bookmark-1--interface-essential"
      ],
      "defaultCode": 59699,
      "grid": 0
    },
    {
      "paths": [
        "M85.333 469.334c0-23.564 19.103-42.667 42.667-42.667h768c23.562 0 42.665 19.103 42.665 42.667v554.666h-85.33v-512h-682.669v512h-85.334v-554.666z",
        "M469.334 603.863h-94.379v204.636l188.758 31.447v47.007h-103.424v-16.553h-85.334v101.888h94.379v51.712h85.331v-51.712h94.382v-204.636l-188.759-31.447v-47.012h103.424v20.224h85.335v-105.554h-94.382v-51.712h-85.331v51.712z",
        "M512 232.192c64.118 0 116.096-51.978 116.096-116.096s-51.978-116.096-116.096-116.096c-64.118 0-116.096 51.978-116.096 116.096s51.978 116.096 116.096 116.096z",
        "M789.335 464.342c-12.8-104.107-132.014-185.728-277.336-185.728-145.322 0-264.533 81.621-277.333 185.728h554.669z"
      ],
      "tags": [
        "business-anouncement-podium--business-products"
      ],
      "defaultCode": 59700,
      "grid": 0
    },
    {
      "paths": [
        "M930.601 921.001l-77.266-122.624v-329.043c0-11.316-4.495-22.169-12.498-30.17s-18.857-12.497-30.172-12.497h-597.331c-11.316 0-22.169 4.495-30.17 12.497s-12.497 18.854-12.497 30.17v329.043l-77.269 122.624c-1.796 2.903-3.229 6.011-4.267 9.262-3.587 10.696-4.578 22.093-2.891 33.249s6.004 21.75 12.595 30.904c6.59 9.16 15.264 16.62 25.306 21.76 10.042 5.146 21.164 7.828 32.446 7.823h710.829c11.305 0.026 22.451-2.647 32.517-7.793s18.76-12.616 25.364-21.791c6.6-9.175 10.921-19.794 12.6-30.976 1.679-11.177 0.671-22.595-2.944-33.306-1.075-3.21-2.534-6.277-4.352-9.134v0zM256 512h512v256h-512v-256zM183.126 938.665l53.76-85.33h550.402l53.76 85.33h-657.922zM448 0h-448v320h448v-320zM374.314 64l-150.314 100.224-150.314-100.224h300.629zM64 256v-121.558l160 106.667 160-106.667v121.558h-320zM576 0v320h448v-320h-448zM950.313 64l-150.313 100.224-150.313-100.224h300.626zM640 256v-121.558l160 106.667 160-106.667v121.558h-320zM128 522.665h-53.334v-159.998h-64v223.998h117.333v-64zM949.335 522.665h-53.335v64h117.335v-223.998h-64v159.998z"
      ],
      "tags": [
        "business-email-promotion--business-products"
      ],
      "defaultCode": 59701,
      "grid": 0
    },
    {
      "paths": [
        "M341.359 1.968l-271.53 30.165c-19.834 2.203-35.491 17.861-37.695 37.695l-30.165 271.53c-1.761 15.853 5.467 31.365 18.739 40.212l339.656 226.429-26.366 184.602c-1.899 13.297 2.573 26.711 12.071 36.209l181.036 180.992c11.597 11.592 28.815 15.514 44.293 10.086 15.473-5.432 26.465-19.251 28.278-35.553l28.513-256.65 99.497-99.497 256.65-28.513c16.302-1.812 30.121-12.805 35.553-28.278 5.427-15.478 1.505-32.696-10.086-44.293l-180.992-181.036c-9.498-9.498-22.912-13.97-36.209-12.071l-184.602 26.366-226.429-339.656c-8.848-13.272-24.359-20.5-40.212-18.739zM439.067 660.485l103.095 68.71-17.495 157.501-103.177-103.153 17.577-123.059zM581.996 653.194l-492.349-328.222 23.529-211.796 211.796-23.529 328.222 492.349-71.199 71.199zM729.196 542.162l-68.726-103.093 123.075-17.579 103.153 103.177-157.501 17.495z",
        "M919.296 738.135c50.007 50.002 60.334 241.362 60.334 241.362s-191.36-10.322-241.367-60.329c-24.008-24.008-37.494-56.566-37.494-90.516s13.486-66.509 37.494-90.516c24.008-24.008 56.566-37.494 90.516-37.494s66.509 13.486 90.516 37.494v0z",
        "M255.574 340.908c47.128 0 85.334-38.205 85.334-85.334s-38.205-85.334-85.334-85.334c-47.129 0-85.334 38.205-85.334 85.334s38.205 85.334 85.334 85.334z"
      ],
      "tags": [
        "business-startup--business-products"
      ],
      "defaultCode": 59702,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 213.335v256c12.022 0 23.485 5.071 31.575 13.966l426.665 469.332c11.361 12.498 14.28 30.52 7.45 45.962-6.835 15.447-22.134 25.405-39.020 25.405h-938.668c-16.888 0-32.187-9.958-39.019-25.405-6.832-15.442-3.912-33.464 7.449-45.962l426.667-469.332c8.087-8.895 19.55-13.966 31.571-13.966v-256h85.331zM488.208 554.67l-349.091 384h745.767l-349.092-384h-47.585z",
        "M469.334 0l341.331 170.666-341.331 170.667v-341.334zM682.665 668.457l-170.665 99.543-170.666-99.543 142.208-156.457h56.915l142.208 156.457z"
      ],
      "tags": [
        "business-target-goal-mountain--business-products"
      ],
      "defaultCode": 59703,
      "grid": 0
    },
    {
      "paths": [
        "M284.703 51.2c23.564 0 42.666 19.103 42.666 42.666v135.42h403.393v-135.42c0-23.564 19.103-42.666 42.67-42.666 23.562 0 42.665 19.103 42.665 42.666v135.42h96.968c23.567 0 42.67 19.103 42.67 42.666v641.112c0 23.567-19.103 42.67-42.67 42.67h-767.998c-23.564 0-42.666-19.103-42.666-42.67v-641.112c0-23.564 19.103-42.666 42.666-42.666h96.97v-135.42c0-23.564 19.103-42.666 42.667-42.666zM187.734 314.62v92.753h682.666v-92.753h-682.666zM870.4 492.707h-682.666v377.693h682.666v-377.693z"
      ],
      "tags": [
        "calendar-2--interface-essential"
      ],
      "defaultCode": 59704,
      "grid": 0
    },
    {
      "paths": [
        "M303.171 87.586c7.227-14.455 22.001-23.586 38.162-23.586h341.331c16.164 0 30.935 9.131 38.164 23.586l73.539 147.081h186.967c23.562 0 42.665 19.103 42.665 42.667v640.002c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-640.002c0-23.564 19.103-42.667 42.667-42.667h186.964l73.541-147.081zM367.703 149.334l-73.541 147.081c-7.227 14.455-22.002 23.586-38.162 23.586h-170.666v554.665h853.331v-554.665h-170.665c-16.159 0-30.935-9.131-38.164-23.586l-73.539-147.081h-288.594z",
        "M512 405.334c-82.473 0-149.332 66.858-149.332 149.331 0 82.478 66.859 149.335 149.332 149.335s149.335-66.857 149.335-149.335c0-82.473-66.862-149.331-149.335-149.331zM277.335 554.665c0-129.601 105.063-234.665 234.665-234.665s234.67 105.064 234.67 234.665c0 129.603-105.068 234.67-234.67 234.67s-234.665-105.068-234.665-234.67z"
      ],
      "tags": [
        "camera--images-videos"
      ],
      "defaultCode": 59705,
      "grid": 0
    },
    {
      "paths": [
        "M303.171 87.586c7.227-14.455 22.001-23.586 38.162-23.586h341.331c16.164 0 30.935 9.131 38.164 23.586l73.539 147.081h186.967c23.562 0 42.665 19.103 42.665 42.667v640.002c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-640.002c0-23.564 19.103-42.667 42.667-42.667h186.964l73.541-147.081zM367.703 149.334l-73.541 147.081c-7.227 14.455-22.002 23.586-38.162 23.586h-170.666v554.665h853.331v-554.665h-170.665c-16.159 0-30.935-9.131-38.164-23.586l-73.539-147.081h-288.594z",
        "M558.781 456.83c-18.908-7.428-39.311-10.249-59.526-8.229s-39.658 8.823-56.723 19.845c-17.065 11.023-31.262 25.949-41.415 43.545l-73.91-42.65c16.923-29.327 40.583-54.204 69.025-72.575s60.848-29.709 94.539-33.076c33.691-3.366 67.698 1.335 99.212 13.715 31.519 12.38 59.633 32.084 82.022 57.482l-64.010 56.432c-13.435-15.239-30.3-27.061-49.213-34.489zM416.002 660.675c12.012 13.619 26.784 24.53 43.336 32s34.504 11.336 52.663 11.336c18.161 0 36.111-3.866 52.664-11.336s31.324-18.381 43.336-32l64 56.443c-20.019 22.702-44.641 40.878-72.223 53.335-27.587 12.452-57.508 18.893-87.777 18.893-30.265 0-60.186-6.441-87.772-18.893-27.586-12.457-52.207-30.633-72.226-53.335l64-56.443z",
        "M725.33 533.335v-170.669l-170.665 170.669h170.665zM298.665 618.665v170.67l170.667-170.67h-170.667z"
      ],
      "tags": [
        "camera-refresh-flip--images-videos"
      ],
      "defaultCode": 59706,
      "grid": 0
    },
    {
      "paths": [
        "M170.666 153.036v508.765l341.334 265.482 341.336-265.482v-508.765c-0.138-0.069-0.276-0.138-0.415-0.207-14.305-7.151-36.439-17.028-66.412-27.018-59.889-19.962-151.337-40.477-274.509-40.477-123.171 0-214.622 20.515-274.508 40.477-29.973 9.991-52.109 19.867-66.411 27.018-0.139 0.070-0.277 0.139-0.415 0.207zM896 128l23.665-35.501c11.873 7.913 19 21.235 19 35.501v554.665c0 13.169-6.077 25.595-16.471 33.679l-384 298.67c-15.406 11.981-36.982 11.981-52.389 0l-384-298.67c-10.393-8.084-16.472-20.511-16.472-33.679v-554.665c0-14.266 7.13-27.588 18.999-35.501l23.667 35.501c-23.667-35.501-23.651-35.512-23.634-35.523l0.037-0.024 0.082-0.054 0.2-0.132 0.543-0.353c0.425-0.275 0.979-0.628 1.659-1.053 1.361-0.851 3.233-1.992 5.615-3.382 4.764-2.779 11.57-6.551 20.418-10.974 17.698-8.849 43.562-20.306 77.589-31.648 68.114-22.705 168.663-44.856 301.492-44.856s233.38 22.152 301.492 44.856c34.028 11.342 59.894 22.8 77.588 31.648 8.847 4.424 15.657 8.196 20.419 10.974 2.381 1.39 4.255 2.531 5.617 3.382 0.681 0.425 1.234 0.778 1.659 1.053l0.543 0.353 0.2 0.132 0.082 0.054 0.036 0.024c0.015 0.011 0.031 0.022-23.634 35.523z",
        "M755.502 328.837l-298.665 298.665c-8.002 8.003-18.854 12.498-30.17 12.498s-22.169-4.495-30.17-12.498l-128-127.999 60.34-60.34 97.83 97.832 268.496-268.499 60.339 60.34z"
      ],
      "tags": [
        "check-shield--interface-essential"
      ],
      "defaultCode": 59707,
      "grid": 0
    },
    {
      "paths": [
        "M0 320.129c0-23.564 19.103-42.667 42.667-42.667h511.998v85.334h-469.331v511.998h853.331v-298.665h85.335v341.335c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-597.335z",
        "M782.935 90.858c8.658-21.915 33.444-32.66 55.357-24l158.72 62.72c21.914 8.66 32.66 33.444 24.003 55.359l-183.895 465.452c-2.883 7.306-7.731 13.67-14.003 18.396l-130.647 98.432c-11.868 8.945-27.53 11.064-41.349 5.606s-23.803-17.71-26.358-32.348l-28.119-161.152c-1.347-7.741-0.538-15.703 2.355-23.014l183.936-465.45zM846.612 161.9l-31.37 79.386 79.375 31.345 31.355-79.37-79.36-31.361zM863.263 351.994l-79.38-31.347-101.11 255.85 14.065 80.589 65.336-49.224 101.089-255.868zM298.667 576c23.564 0 42.666 19.103 42.666 42.665 0 22.636 8.99 44.339 24.993 60.344 16.003 16 37.708 24.991 60.34 24.991h127.998v85.335h-127.998c-45.264 0-88.674-17.981-120.68-49.987-2.528-2.529-4.969-5.13-7.32-7.798-2.352 2.668-4.792 5.268-7.321 7.798-32.006 32.005-75.416 49.987-120.679 49.987v-85.335c22.631 0 44.337-8.991 60.34-24.991 16.003-16.005 24.993-37.709 24.993-60.344 0-23.562 19.103-42.665 42.667-42.665z"
      ],
      "tags": [
        "check-write--business-products-1"
      ],
      "defaultCode": 59708,
      "grid": 0
    },
    {
      "paths": [
        "M0 320.129c0-23.564 19.103-42.667 42.667-42.667h511.998v85.334h-469.331v511.998h853.331v-298.665h85.335v341.335c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-597.335z",
        "M782.935 90.858c8.658-21.915 33.444-32.66 55.357-24l158.72 62.72c21.914 8.66 32.66 33.444 24.003 55.359l-183.895 465.452c-2.883 7.306-7.731 13.67-14.003 18.396l-130.647 98.432c-11.868 8.945-27.53 11.064-41.349 5.606s-23.803-17.71-26.358-32.348l-28.119-161.152c-1.347-7.741-0.532-15.703 2.355-23.014l183.936-465.45zM846.612 161.9l-31.37 79.386 79.375 31.345 31.36-79.37-79.365-31.361zM863.263 351.994l-79.38-31.347-101.105 255.85 14.060 80.589 65.336-49.224 101.089-255.868zM298.667 576c23.564 0 42.667 19.103 42.667 42.665 0 22.636 8.99 44.339 24.993 60.344 16.003 16 37.708 24.991 60.34 24.991h127.998v85.335h-127.998c-45.263 0-88.673-17.981-120.679-49.987-2.528-2.529-4.969-5.13-7.32-7.798-2.352 2.668-4.792 5.268-7.321 7.798-32.007 32.005-75.416 49.987-120.68 49.987v-85.335c22.632 0 44.337-8.991 60.34-24.991 16.004-16.005 24.994-37.709 24.994-60.344 0-23.562 19.103-42.665 42.666-42.665z"
      ],
      "tags": [
        "check-write--business-products"
      ],
      "defaultCode": 59709,
      "grid": 0
    },
    {
      "paths": [
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h682.668c23.562 0 42.665 19.103 42.665 42.667v341.333h-85.335v-298.666h-597.331v853.331h256v85.335h-298.667c-23.564 0-42.667-19.103-42.667-42.665v-938.668zM860.677 425.77c11.315 0.001 22.17 4.498 30.172 12.503l120.658 120.703c16.66 16.666 16.655 43.674-0.005 60.334l-353.874 353.879c-5.56 5.555-12.539 9.467-20.178 11.31l-159.018 38.313c-14.446 3.482-29.662-0.804-40.168-11.315-10.506-10.506-14.788-25.723-11.303-40.166l38.357-159.022c1.842-7.634 5.754-14.612 11.308-20.163l353.875-353.879c8.003-8.003 18.857-12.498 30.177-12.497zM545.454 843.991l-19.18 79.519 79.508-19.154 194.545-194.55-60.355-60.329-194.519 194.514zM800.312 589.138l60.355 60.329 60.334-60.329-60.334-60.355-60.355 60.355z",
        "M542.167 243.504l-170.664 170.667c-8.002 8.002-18.854 12.497-30.17 12.497s-22.169-4.495-30.17-12.497l-85.333-85.334 60.34-60.34 55.163 55.163 140.497-140.497 60.337 60.34zM542.167 542.172l-170.664 170.665c-16.662 16.66-43.677 16.66-60.34 0l-85.333-85.335 60.34-60.339 55.163 55.163 140.497-140.495 60.337 60.341z"
      ],
      "tags": [
        "checklist-pen--interface-essential"
      ],
      "defaultCode": 59710,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M469.333 512v-260.736h85.332v218.070h165.934v85.331h-208.6c-23.564 0-42.666-19.103-42.666-42.665z"
      ],
      "tags": [
        "clock--interface-essential"
      ],
      "defaultCode": 59711,
      "grid": 0
    },
    {
      "paths": [
        "M512-0c-43.218 0.233-86.231 5.968-128 17.067v87.936c100.255-32.097 208.804-26.276 305.050 16.358 96.251 42.635 173.496 119.117 217.088 214.934 43.597 95.817 50.499 204.301 19.405 304.873-31.099 100.572-98.028 186.225-188.099 240.717-90.066 54.492-197.002 74.025-300.515 54.892-103.515-19.128-196.406-75.592-261.047-158.674s-96.537-187.003-89.633-292.045c6.903-105.041 52.125-203.893 127.085-277.801v133.078h85.333v-256h-256v85.334h88.704c-78.008 87.321-123.683 198.77-129.392 315.722s28.896 232.321 98.029 326.821c69.133 94.505 168.608 162.417 281.798 192.389s233.24 20.188 340.079-27.72c106.844-47.903 194.007-131.031 246.927-235.479 52.915-104.453 68.378-223.903 43.807-338.385-24.571-114.484-87.69-217.065-178.811-290.602s-204.718-113.57-321.807-113.413v0z",
        "M469.333 213.333v298.666c0.019 11.326 4.512 22.18 12.501 30.209l170.669 170.665 60.329-60.37-158.167-158.168v-281.002h-85.332z"
      ],
      "tags": [
        "clock-cycle-twenty-four-hour--business-products"
      ],
      "defaultCode": 59712,
      "grid": 0
    },
    {
      "paths": [
        "M597.335 448.001c29.532 0 58.404-8.758 82.964-25.167 24.556-16.409 43.699-39.732 54.999-67.019 11.305-27.287 14.259-57.313 8.499-86.281s-19.983-55.577-40.868-76.461c-20.884-20.885-47.493-35.107-76.462-40.869s-58.993-2.805-86.282 8.498c-27.284 11.303-50.61 30.443-67.018 55.001s-25.167 53.43-25.167 82.965c0 39.606 15.733 77.589 43.739 105.594 28.008 28.006 65.988 43.739 105.596 43.739v0zM597.335 234.667c12.657 0 25.032 3.753 35.553 10.786 10.527 7.032 18.729 17.028 23.572 28.723s6.113 24.563 3.64 36.977c-2.468 12.415-8.561 23.819-17.51 32.769-8.955 8.951-20.357 15.046-32.773 17.516-12.411 2.469-25.283 1.202-36.977-3.642s-21.688-13.047-28.723-23.572c-7.030-10.525-10.783-22.898-10.783-35.556 0-16.974 6.743-33.252 18.744-45.255s28.278-18.745 45.256-18.745v0z",
        "M981.335 0h-768.002c-11.316 0-22.169 4.495-30.17 12.497s-12.496 18.854-12.496 30.17v472.748c14.122-2.156 28.381-3.297 42.666-3.415 14.29 0.118 28.553 1.3 42.666 3.543 1.238-1.239 0-156.503 0-156.503l93.099 93.226c30.547-13.451 63.149-21.645 96.426-24.234l-189.526-189.696v-153.002h409.001l273.664 273.706v152.96h-260.521c25.093 24.658 45.645 53.545 60.713 85.335h242.478c11.315 0 22.164-4.495 30.167-12.498s12.498-18.857 12.498-30.172v-511.998c0-11.316-4.495-22.168-12.498-30.17s-18.852-12.497-30.167-12.497v0zM938.665 238.336l-153.001-153.002h153.001v153.002z",
        "M469.334 512c-36.052 0.082-71.494 9.313-103.001 26.839-31.507 17.521-58.050 42.757-77.138 73.344-24.134-9.656-49.867-14.694-75.861-14.848-37.183-0.246-73.786 9.231-106.178 27.489-32.391 18.263-59.447 44.672-78.485 76.616-19.038 31.939-29.396 68.306-30.048 105.482s8.425 73.882 26.332 106.47c17.906 32.589 44.020 59.935 75.751 79.319s67.979 30.141 105.148 31.196c37.17 1.060 73.97-7.619 106.753-25.165 32.783-17.551 60.409-43.361 80.14-74.88 24.385 9.656 50.359 14.679 76.586 14.802 56.578 0 110.839-22.477 150.847-62.484s62.484-94.269 62.484-150.845c0-56.581-22.477-110.843-62.484-150.851s-94.269-62.484-150.847-62.484zM213.334 938.665c-33.948 0-66.505-13.486-90.51-37.489s-37.49-56.561-37.49-90.511c0-33.946 13.486-66.504 37.49-90.506 24.005-24.008 56.562-37.494 90.51-37.494 15.782 0.031 31.416 3.041 46.080 8.878-6.304 33.853-3.924 68.756 6.917 101.448 10.842 32.686 29.791 62.095 55.077 85.473-11.426 18.381-27.341 33.551-46.248 44.083s-40.184 16.082-61.826 16.118v0zM469.334 853.335c-25.316 0-50.063-7.511-71.113-21.576s-37.455-34.053-47.143-57.441c-9.688-23.388-12.223-49.126-7.284-73.958 4.939-24.827 17.129-47.636 35.031-65.536s40.709-30.090 65.538-35.031c24.83-4.941 50.566-2.406 73.956 7.286 23.388 9.687 43.377 26.092 57.441 47.14 14.065 21.053 21.576 45.798 21.576 71.117 0 33.946-13.486 66.504-37.494 90.506-24.003 24.008-56.56 37.494-90.508 37.494v0z"
      ],
      "tags": [
        "coin-bank-note--business-products-1"
      ],
      "defaultCode": 59713,
      "grid": 0
    },
    {
      "paths": [
        "M597.335 448c29.532 0 58.404-8.758 82.964-25.167 24.556-16.409 43.699-39.732 54.999-67.019 11.305-27.287 14.259-57.313 8.499-86.281s-19.983-55.577-40.868-76.461c-20.884-20.885-47.493-35.107-76.462-40.869s-58.993-2.805-86.282 8.498c-27.284 11.303-50.61 30.444-67.018 55.001s-25.167 53.43-25.167 82.965c0 39.606 15.733 77.59 43.739 105.595 28.008 28.005 65.988 43.739 105.596 43.739v0zM597.335 234.666c12.657 0 25.032 3.753 35.553 10.786 10.527 7.032 18.729 17.028 23.572 28.722s6.113 24.563 3.64 36.977c-2.468 12.415-8.561 23.819-17.51 32.77-8.955 8.95-20.357 15.046-32.773 17.515-12.411 2.47-25.283 1.202-36.977-3.642s-21.688-13.047-28.723-23.572c-7.030-10.525-10.783-22.898-10.783-35.556 0-16.974 6.743-33.252 18.744-45.255s28.278-18.745 45.256-18.745v0z",
        "M981.335 0h-768.001c-11.316 0-22.169 4.495-30.17 12.497s-12.497 18.854-12.497 30.17v472.748c14.123-2.156 28.382-3.297 42.667-3.415 14.29 0.118 28.552 1.3 42.666 3.543 1.238-1.239 0-156.503 0-156.503l93.098 93.226c30.548-13.451 63.149-21.645 96.427-24.234l-189.526-189.696v-153.002h409l273.664 273.706v152.96h-260.521c25.093 24.658 45.645 53.545 60.713 85.335h242.478c11.315 0 22.17-4.495 30.167-12.498 8.003-8.003 12.498-18.857 12.498-30.172v-511.998c0-11.316-4.495-22.168-12.498-30.17-7.997-8.002-18.852-12.497-30.167-12.497v0zM938.665 238.336l-153.001-153.002h153.001v153.002z",
        "M469.334 512c-36.052 0.082-71.494 9.313-103.001 26.839-31.507 17.521-58.050 42.757-77.138 73.344-24.135-9.656-49.868-14.694-75.861-14.848-37.184-0.246-73.786 9.231-106.178 27.489-32.392 18.263-59.447 44.672-78.485 76.616-19.038 31.939-29.396 68.306-30.048 105.482s8.425 73.882 26.332 106.47c17.906 32.589 44.020 59.935 75.751 79.319s67.979 30.141 105.148 31.196c37.169 1.060 73.97-7.619 106.753-25.165 32.783-17.551 60.409-43.361 80.14-74.88 24.386 9.656 50.359 14.679 76.587 14.802 56.577 0 110.844-22.477 150.852-62.484s62.479-94.269 62.479-150.845c0-56.581-22.472-110.843-62.479-150.851s-94.275-62.484-150.852-62.484zM213.334 938.665c-33.948 0-66.505-13.486-90.51-37.489s-37.49-56.561-37.49-90.511c0-33.946 13.486-66.504 37.49-90.506 24.005-24.008 56.562-37.494 90.51-37.494 15.781 0.031 31.416 3.041 46.080 8.878-6.304 33.853-3.924 68.756 6.917 101.448 10.842 32.686 29.79 62.095 55.077 85.473-11.426 18.381-27.342 33.551-46.248 44.083s-40.184 16.082-61.826 16.118v0zM469.334 853.335c-25.316 0-50.064-7.511-71.113-21.576s-37.455-34.053-47.143-57.441c-9.688-23.388-12.223-49.126-7.284-73.958 4.939-24.827 17.13-47.636 35.031-65.536s40.709-30.090 65.538-35.031c24.829-4.941 50.566-2.406 73.956 7.286 23.388 9.687 43.377 26.092 57.446 47.14 14.065 21.053 21.571 45.798 21.571 71.117 0 33.946-13.486 66.504-37.494 90.506-24.003 24.008-56.56 37.494-90.507 37.494v0z"
      ],
      "tags": [
        "coin-bank-note--business-products"
      ],
      "defaultCode": 59714,
      "grid": 0
    },
    {
      "paths": [
        "M689.592 93.466c-52.127-11.87-106.394-10.492-157.85 4.008s-98.459 41.661-136.716 79.001l-59.603-61.067c48.459-47.298 107.996-81.701 173.172-100.068s133.918-20.113 199.941-5.078c66.028 15.035 127.232 46.372 178.028 91.149 50.801 44.776 89.569 101.566 112.773 165.182 23.199 63.616 30.095 132.031 20.055 198.998-10.045 66.967-36.705 130.352-77.548 184.363l-68.065-51.471c32.246-42.639 53.294-92.679 61.22-145.547 7.931-52.868 2.488-106.88-15.831-157.103s-48.927-95.057-89.032-130.407c-40.1-35.35-88.422-60.090-140.544-71.96z",
        "M405.334 298.666c-176.731 0-320 143.269-320 319.999 0 176.732 143.269 320 320 320 176.729 0 320.002-143.268 320.002-320 0-176.73-143.273-319.999-320.002-319.999zM0 618.665c0-223.858 181.474-405.332 405.334-405.332 223.858 0 405.331 181.474 405.331 405.332 0 223.862-181.473 405.335-405.331 405.335-223.86 0-405.334-181.473-405.334-405.335z",
        "M362.666 435.2h-51.2c-23.564 0-42.666 19.103-42.666 42.666v125.142c0 20.854 15.076 38.656 35.646 42.086l152.088 25.37v46.336h-102.4v-19.927h-85.334v62.592c0 23.567 19.103 42.67 42.666 42.67h51.2v51.2h85.334v-51.2h51.2c23.562 0 42.665-19.103 42.665-42.67v-125.138c0-20.859-15.073-38.656-35.644-42.086l-152.087-25.37v-46.336h102.4v19.922h85.331v-62.59c0-23.564-19.103-42.666-42.665-42.666h-51.2v-51.2h-85.334v51.2z"
      ],
      "tags": [
        "coins-dollar--business-products"
      ],
      "defaultCode": 59715,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 426.667h-85.332v127.998h-128v85.335h128v128h85.332v-128h128v-85.335h-128v-127.998z",
        "M700.329 42.667h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v767.999c0 22.63 8.99 44.339 24.994 60.339 16.003 16.005 37.708 24.996 60.34 24.996h597.331c22.636 0 44.339-8.991 60.339-24.996 16.005-16 24.996-37.709 24.996-60.339v-657.663l-195.671-195.669zM213.334 896v-767.999h426.666v170.666h170.665v597.333h-597.331z"
      ],
      "tags": [
        "common-file-add---files-&-folders"
      ],
      "defaultCode": 59717,
      "grid": 0
    },
    {
      "paths": [
        "M469.334 622.336l-97.835-97.833-60.33 60.329 158.166 158.167 243.498-243.5-60.329-60.331-183.17 183.167z",
        "M700.329 42.667h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v767.999c0 22.63 8.99 44.339 24.994 60.339 16.003 16.005 37.708 24.996 60.34 24.996h597.331c22.636 0 44.339-8.991 60.339-24.996 16.005-16 24.996-37.709 24.996-60.339v-657.663l-195.671-195.669zM213.334 896v-767.999h426.666v170.666h170.665v597.333h-597.331z"
      ],
      "tags": [
        "common-file-check---files-&-folders"
      ],
      "defaultCode": 59718,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 597.335v-213.335h-85.331v213.335h-128l170.666 170.665 170.665-170.665h-128z",
        "M700.329 42.667h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v767.999c0 22.63 8.99 44.339 24.994 60.339 16.003 16.005 37.708 24.996 60.34 24.996h597.331c22.636 0 44.339-8.991 60.339-24.996 16.005-16 24.996-37.709 24.996-60.339v-657.663l-195.671-195.669zM213.334 896v-767.999h426.666v170.666h170.665v597.333h-597.331z"
      ],
      "tags": [
        "common-file-download---files-&-folders"
      ],
      "defaultCode": 59719,
      "grid": 0
    },
    {
      "paths": [
        "M828.334 128h-529.667c-22.631 0-44.337 8.99-60.34 24.994s-24.993 37.708-24.993 60.34v426.666c0 22.63 8.99 44.339 24.993 60.339 16.003 16.005 37.708 24.996 60.34 24.996h597.332c22.63 0 44.339-8.991 60.339-24.996 16.005-16 24.996-37.709 24.996-60.339v-358.998l-153.001-153.002zM896 640h-597.332v-426.666h469.332v128h128v298.666z",
        "M128.001 256h-85.333v554.665c0 22.636 8.991 44.339 24.994 60.339 16.003 16.005 37.708 24.996 60.34 24.996h639.999v-85.335h-639.999v-554.665z",
        "M489.388 361.388l-107.947 107.946 107.947 107.987 45.228-45.266-62.721-62.721 62.721-62.677-45.228-45.27zM617.385 406.657l62.72 62.677-62.72 62.721 45.23 45.266 107.945-107.987-107.945-107.946-45.23 45.27z"
      ],
      "tags": [
        "common-file-horizontal-codes---files-&-folders"
      ],
      "defaultCode": 59720,
      "grid": 0
    },
    {
      "paths": [
        "M127.999 256h-85.333v554.665c0 22.636 8.99 44.339 24.993 60.339 16.003 16.005 37.708 24.996 60.34 24.996h640.001v-85.335h-640.001v-554.665z",
        "M512.215 505.857l-48.898-78.422-79.318 127.23h384l-143.063-229.544-112.722 180.736z",
        "M828.329 128h-529.663c-22.631 0-44.337 8.99-60.34 24.994s-24.993 37.708-24.993 60.34v426.666c0 22.63 8.99 44.339 24.993 60.339 16.003 16.005 37.708 24.996 60.34 24.996h597.334c22.63 0 44.334-8.991 60.339-24.996 16.005-16 24.996-37.709 24.996-60.339v-358.998l-153.006-153.002zM298.666 640v-426.666h469.334v128h128v298.666h-597.334z"
      ],
      "tags": [
        "common-file-horizontal-images---files-&-folders"
      ],
      "defaultCode": 59721,
      "grid": 0
    },
    {
      "paths": [
        "M640 512c0-33.948-13.486-66.505-37.489-90.51-24.008-24.005-56.566-37.49-90.512-37.49-33.948 0-66.505 13.486-90.51 37.49s-37.49 56.562-37.49 90.51v42.665h-42.666v256h341.332v-256h-42.665v-42.665zM469.333 512c0-11.316 4.495-22.169 12.496-30.17s18.854-12.496 30.17-12.496c11.316 0 22.17 4.495 30.168 12.496 8.003 8.002 12.498 18.854 12.498 30.17v42.665h-85.332v-42.665zM597.335 725.335h-170.669v-85.335h170.669v85.335z",
        "M700.329 42.666h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v768.001c0 22.63 8.99 44.334 24.994 60.339s37.708 24.991 60.34 24.991h597.331c22.636 0 44.339-8.986 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-657.665l-195.671-195.669zM213.334 896v-768.001h426.666v170.666h170.665v597.335h-597.331z"
      ],
      "tags": [
        "common-file-lock---files-&-folders"
      ],
      "defaultCode": 59722,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 384h-85.331v44.842c-25.877 5.308-48.864 20.030-64.509 41.314s-22.837 47.619-20.182 73.9c2.655 26.281 14.968 50.642 34.555 68.367s45.053 27.551 71.469 27.576h42.669c5.658 0 11.085 2.248 15.084 6.246 3.999 4.004 6.246 9.431 6.246 15.089s-2.248 11.085-6.246 15.084c-3.999 3.999-9.426 6.246-15.084 6.246h-149.335v85.335h85.334v42.665h85.331v-44.841c25.876-5.309 48.865-20.029 64.512-41.313s22.835-47.616 20.183-73.897c-2.657-26.286-14.971-50.647-34.555-68.372-19.589-17.725-45.056-27.551-71.47-27.576h-42.669c-5.658 0-11.084-2.248-15.085-6.246s-6.248-9.426-6.248-15.084c0-5.658 2.247-11.085 6.248-15.089 4.001-3.999 9.427-6.246 15.085-6.246h149.334v-85.334h-85.335v-42.666z",
        "M700.329 42.666h-486.995c-22.632 0-44.337 8.99-60.34 24.993s-24.994 37.708-24.994 60.34v768.001c0 22.63 8.99 44.334 24.994 60.339s37.708 24.996 60.34 24.996h597.331c22.636 0 44.339-8.991 60.339-24.996 16.005-16.005 24.996-37.709 24.996-60.339v-657.665l-195.671-195.669zM213.334 896v-768.001h426.666v170.667h170.665v597.334h-597.331z"
      ],
      "tags": [
        "common-file-money-fund---files-&-folders-1"
      ],
      "defaultCode": 59723,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 384h-85.331v44.842c-25.877 5.308-48.864 20.030-64.509 41.314s-22.837 47.619-20.182 73.9c2.655 26.281 14.968 50.642 34.555 68.367s45.053 27.551 71.469 27.576h42.669c5.658 0 11.085 2.248 15.084 6.246 3.999 4.004 6.246 9.431 6.246 15.089s-2.248 11.085-6.246 15.084c-3.999 3.999-9.426 6.246-15.084 6.246h-149.335v85.335h85.334v42.665h85.331v-44.841c25.876-5.309 48.865-20.029 64.512-41.313s22.835-47.616 20.183-73.897c-2.657-26.286-14.971-50.647-34.555-68.372-19.589-17.725-45.056-27.551-71.47-27.576h-42.669c-5.658 0-11.084-2.248-15.085-6.246s-6.248-9.426-6.248-15.084c0-5.658 2.247-11.085 6.248-15.089 4.001-3.999 9.427-6.246 15.085-6.246h149.334v-85.334h-85.335v-42.666z",
        "M700.329 42.666h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v768.001c0 22.63 8.99 44.334 24.994 60.339s37.708 24.991 60.34 24.991h597.331c22.636 0 44.339-8.986 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-657.665l-195.671-195.669zM213.334 896v-768.001h426.666v170.666h170.665v597.335h-597.331z"
      ],
      "tags": [
        "common-file-money-fund---files-&-folders"
      ],
      "defaultCode": 59724,
      "grid": 0
    },
    {
      "paths": [
        "M512 725.33c-27.147-0.077-53.556-8.852-75.349-25.042l75.349-60.288h-213.333v170.665l70.272-56.192c27.716 25.559 61.739 43.279 98.571 51.333 36.832 8.059 75.143 6.159 111.004-5.494 35.855-11.658 67.958-32.655 93.015-60.831 25.052-28.17 42.153-62.51 49.536-99.482h-88.96c-8.75 24.888-24.996 46.454-46.505 61.732-21.504 15.283-47.217 23.526-73.6 23.598zM655.104 440.233c-27.709-25.571-61.737-43.3-98.57-51.365s-75.153-6.173-111.016 5.479c-35.862 11.653-67.973 32.647-93.033 60.823s-42.163 62.517-49.551 99.494h88.96c6.511-18.831 17.368-35.86 31.692-49.708 14.324-13.849 31.71-24.126 50.748-29.999s39.192-7.175 58.827-3.801c19.64 3.374 38.2 11.329 54.19 23.219l-75.351 60.287h213.335v-170.666l-70.231 56.234z",
        "M700.329 42.666h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v768.001c0 22.63 8.99 44.334 24.994 60.339s37.708 24.991 60.34 24.991h597.331c22.636 0 44.339-8.986 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-657.665l-195.671-195.669zM213.334 896v-768.001h426.666v170.666h170.665v597.335h-597.331z"
      ],
      "tags": [
        "common-file-refresh---files-&-folders"
      ],
      "defaultCode": 59725,
      "grid": 0
    },
    {
      "paths": [
        "M512 384l-170.666 170.665h128v213.335h85.331v-213.335h128l-170.665-170.665z",
        "M700.329 42.666h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v768.001c0 22.63 8.99 44.334 24.994 60.339s37.708 24.991 60.34 24.991h597.331c22.636 0 44.339-8.986 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-657.665l-195.671-195.669zM213.334 896v-768.001h426.666v170.666h170.665v597.335h-597.331z"
      ],
      "tags": [
        "common-file-upload---files-&-folders"
      ],
      "defaultCode": 59727,
      "grid": 0
    },
    {
      "paths": [
        "M469.334 384h85.331v256h-85.331v-256z",
        "M700.329 42.666h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v768.001c0 22.63 8.99 44.334 24.994 60.339s37.708 24.991 60.34 24.991h597.331c22.636 0 44.339-8.986 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-657.665l-195.671-195.669zM213.334 896v-768.001h426.666v170.666h170.665v597.335h-597.331z",
        "M512 682.665c-8.438 0-16.688 2.504-23.704 7.194-7.016 4.685-12.485 11.351-15.714 19.144-3.23 7.798-4.074 16.379-2.428 24.653 1.647 8.279 5.71 15.882 11.677 21.847s13.57 10.030 21.846 11.679c8.276 1.644 16.854 0.799 24.651-2.432 7.798-3.226 14.459-8.694 19.149-15.713 4.69-7.014 7.188-15.263 7.188-23.706 0-11.315-4.495-22.164-12.493-30.167-8.003-8.003-18.857-12.498-30.172-12.498z"
      ],
      "tags": [
        "common-file-warning---files-&-folders"
      ],
      "defaultCode": 59728,
      "grid": 0
    },
    {
      "paths": [
        "M700.329 42.666h-316.329c-22.631 0-44.337 8.991-60.34 24.994s-24.993 37.708-24.993 60.34v597.331c0 22.636 8.99 44.339 24.993 60.344 16.003 16 37.708 24.991 60.34 24.991h426.665c22.636 0 44.339-8.991 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.344v-486.995l-195.671-195.669zM810.665 725.33h-426.665v-597.331h256v170.666h170.665v426.664z",
        "M213.334 213.331h-85.334v682.669c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h512.002v-85.33h-512.002v-682.669z"
      ],
      "tags": [
        "common-files---files-&-folders"
      ],
      "defaultCode": 59729,
      "grid": 0
    },
    {
      "paths": [
        "M176 853.335c58.91 0 106.666-47.759 106.666-106.67s-47.756-106.665-106.666-106.665c-58.91 0-106.666 47.754-106.666 106.665s47.756 106.67 106.666 106.67z",
        "M352 1024c-8.15-71.767-83.754-128-176-128s-167.851 56.233-176 128h352z",
        "M848 853.335c58.911 0 106.665-47.759 106.665-106.67s-47.754-106.665-106.665-106.665c-58.911 0-106.665 47.754-106.665 106.665s47.754 106.67 106.665 106.67z",
        "M1024 1024c-8.151-71.767-83.753-128-176-128s-167.849 56.233-176 128h352z",
        "M170.666 42.667c0-23.564 19.103-42.667 42.667-42.667h597.331c23.567 0 42.67 19.103 42.67 42.667v511.998c0 23.567-19.103 42.67-42.67 42.67h-238.326l-158.17 158.167c-12.202 12.206-30.554 15.852-46.497 9.252-15.944-6.605-26.339-22.164-26.339-39.419v-128h-128c-23.564 0-42.667-19.103-42.667-42.67v-511.998zM256 85.334v426.666h128c23.564 0 42.666 19.103 42.666 42.665v67.661l97.831-97.828c8.003-8.003 18.852-12.498 30.167-12.498h213.335v-426.666h-512zM298.666 213.334c0-23.564 19.103-42.667 42.667-42.667h256.002c23.562 0 42.665 19.103 42.665 42.667s-19.103 42.666-42.665 42.666h-256.002c-23.564 0-42.667-19.103-42.667-42.666zM682.665 426.666h-341.331v-85.333h341.331v85.333z"
      ],
      "tags": [
        "conversation-chat-bubble--messages-chat"
      ],
      "defaultCode": 59730,
      "grid": 0
    },
    {
      "paths": [
        "M855.168 597.335v-512.002c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.704-24.994-60.339-24.994h-682.665c-22.631 0-44.336 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h682.665c22.636 0 44.339-8.991 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339zM769.833 85.334v128h-682.665v-128h682.665zM87.167 597.335v-298.669h682.665v298.669h-682.665z",
        "M556.503 341.334h170.665v85.333h-170.665v-85.333zM129.834 341.334h298.666v85.333h-298.666v-85.333zM129.834 469.334h213.333v85.331h-213.333v-85.331zM953.001 695.168l-183.168 183.168-97.833-97.833-60.329 60.329 158.162 158.208 243.502-243.543-60.334-60.329z"
      ],
      "tags": [
        "credit-card-check-approved--business-products"
      ],
      "defaultCode": 59731,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.334h170.67v85.334h-170.67v-85.334zM128 341.334h298.666v85.334h-298.666v-85.334zM128 469.334h213.334v85.331h-213.334v-85.331z",
        "M85.334 298.666h682.666v213.334h85.335v-426.666c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h512.002v-85.33h-512.002v-298.669zM768 85.334v128h-682.666v-128h682.666zM951.168 737.792l-97.833 97.833v-238.336h-85.335v238.336l-97.833-97.833-60.334 60.375 200.832 200.832 200.832-200.832-60.329-60.375z"
      ],
      "tags": [
        "credit-card-download--business-products"
      ],
      "defaultCode": 59732,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.334h170.67v85.334h-170.67v-85.334zM128 341.334h298.666v85.334h-298.666v-85.334zM128 469.334h213.334v85.331h-213.334v-85.331z",
        "M85.334 298.666h682.666v85.334h85.335v-298.666c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h384v-85.33h-384v-298.669zM768 85.334v128h-682.666v-128h682.666zM1011.497 609.833l-128-127.998c-7.997-7.998-18.852-12.492-30.162-12.492-11.315 0-22.164 4.494-30.167 12.492l-298.665 298.669c-5.463 5.458-9.344 12.303-11.223 19.794l-42.666 170.67c-1.576 6.287-1.697 12.856-0.354 19.2 1.343 6.349 4.115 12.303 8.105 17.413 3.99 5.115 9.093 9.252 14.922 12.099 5.829 2.842 12.229 4.321 18.714 4.321 3.492-0.010 6.973-0.425 10.368-1.239l170.665-42.665c7.501-1.889 14.341-5.786 19.799-11.264l298.665-298.665c8.003-8.003 12.493-18.852 12.493-30.167s-4.49-22.164-12.493-30.167v0zM660.864 900.265l-90.24 22.528 22.569-90.24 132.27-132.265 67.538 67.712-132.137 132.265zM853.335 707.671l-67.671-67.671 67.671-67.671 67.666 67.671-67.666 67.671z"
      ],
      "tags": [
        "credit-card-edit--business-products"
      ],
      "defaultCode": 59733,
      "grid": 0
    },
    {
      "paths": [
        "M128 341.334h298.666v85.334h-298.666v-85.334zM128 469.334h213.334v85.331h-213.334v-85.331z",
        "M85.334 298.666h682.666v42.667h85.335v-256c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h256v-85.33h-256v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M725.335 426.666c-59.069 0-116.818 17.517-165.929 50.334-49.118 32.818-87.399 79.461-110.004 134.035s-28.52 114.627-16.996 172.564c11.524 57.933 39.969 111.15 81.739 152.924 41.769 41.769 94.986 70.211 152.924 81.736 57.933 11.525 117.985 5.612 172.559-16.993 54.574-22.61 101.217-60.887 134.036-110.003s50.335-106.86 50.335-165.929c-0.092-79.186-31.585-155.1-87.578-211.092-55.992-55.99-131.907-87.486-211.087-87.576zM725.335 938.665c-42.194 0-83.441-12.508-118.523-35.953-35.082-23.439-62.428-56.76-78.572-95.739-16.148-38.984-20.372-81.879-12.14-123.259 8.228-41.385 28.549-79.396 58.383-109.23s67.845-50.156 109.23-58.383c41.385-8.234 84.275-4.009 123.259 12.14 38.984 16.143 72.3 43.489 95.739 78.572 23.444 35.082 35.953 76.329 35.953 118.523-0.067 56.556-22.564 110.781-62.556 150.774s-94.218 62.49-150.774 62.556z",
        "M682.665 725.335h85.335v170.665h-85.335v-170.665z",
        "M725.335 682.665c23.562 0 42.665-19.103 42.665-42.665s-19.103-42.665-42.665-42.665c-23.567 0-42.67 19.103-42.67 42.665s19.103 42.665 42.67 42.665z"
      ],
      "tags": [
        "credit-card-information--business-products"
      ],
      "defaultCode": 59734,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.29h170.67v85.334h-170.67v-85.334zM128 341.29h298.666v85.334h-298.666v-85.334zM128 469.29h213.334v85.334h-213.334v-85.334z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h426.666v-85.33h-426.666v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M981.335 640c0-45.261-17.981-88.673-49.987-120.678-32.010-32.007-75.418-49.988-120.684-49.988-45.261 0-88.673 17.981-120.678 49.988-32.005 32.005-49.987 75.418-49.987 120.678-11.315 0-22.17 4.495-30.172 12.498-7.997 8.003-12.493 18.852-12.493 30.167v298.67c0 11.315 4.495 22.164 12.493 30.167 8.003 8.003 18.857 12.498 30.172 12.498h341.335c11.315 0 22.164-4.495 30.167-12.498s12.498-18.852 12.498-30.167v-298.67c0-11.315-4.495-22.164-12.498-30.167s-18.852-12.498-30.167-12.498zM810.665 554.665c22.636 0 44.339 8.991 60.339 24.996 16.005 16.005 24.996 37.709 24.996 60.339h-170.665c0-22.63 8.991-44.334 24.991-60.339 16.005-16.005 37.709-24.996 60.339-24.996v0zM938.665 938.665h-256v-213.33h256v213.33z",
        "M810.665 853.289c23.567 0 42.67-19.103 42.67-42.665s-19.103-42.665-42.67-42.665c-23.562 0-42.665 19.103-42.665 42.665s19.103 42.665 42.665 42.665z"
      ],
      "tags": [
        "credit-card-lock--business-products"
      ],
      "defaultCode": 59735,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.334h170.67v85.334h-170.67v-85.334zM128 341.334h298.666v85.334h-298.666v-85.334zM128 469.334h213.334v85.331h-213.334v-85.331z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h512.002v-85.33h-512.002v-298.669zM768 85.334v128h-682.666v-128h682.666zM896 725.335h-85.335c-11.315 0-22.164-4.495-30.167-12.498s-12.498-18.857-12.498-30.172c0-11.315 4.495-22.164 12.498-30.167s18.852-12.498 30.167-12.498h170.67v-85.335h-85.335v-42.665h-85.335v42.665c-33.946 0-66.504 13.486-90.506 37.494-24.008 24.003-37.494 56.561-37.494 90.506 0 33.951 13.486 66.509 37.494 90.511 24.003 24.003 56.561 37.489 90.506 37.489h85.335c11.315 0 22.17 4.495 30.172 12.498 7.997 8.003 12.493 18.857 12.493 30.172s-4.495 22.164-12.493 30.167c-8.003 8.003-18.857 12.498-30.172 12.498h-170.665v85.335h85.33v42.665h85.335v-42.665c33.946 0 66.504-13.486 90.511-37.494 24.003-24.003 37.489-56.561 37.489-90.506 0-33.951-13.486-66.509-37.489-90.511-24.008-24.003-56.566-37.489-90.511-37.489z"
      ],
      "tags": [
        "credit-card-money-fund--business-products-1"
      ],
      "defaultCode": 59736,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.334h170.67v85.334h-170.67v-85.334zM128 341.334h298.666v85.334h-298.666v-85.334zM128 469.334h213.334v85.331h-213.334v-85.331z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h512.002v-85.33h-512.002v-298.669zM768 85.334v128h-682.666v-128h682.666zM896 725.335h-85.335c-11.315 0-22.164-4.495-30.167-12.498s-12.498-18.857-12.498-30.172c0-11.315 4.495-22.164 12.498-30.167s18.852-12.498 30.167-12.498h170.67v-85.335h-85.335v-42.665h-85.335v42.665c-33.946 0-66.504 13.486-90.506 37.494-24.008 24.003-37.494 56.561-37.494 90.506 0 33.951 13.486 66.509 37.494 90.511 24.003 24.003 56.561 37.489 90.506 37.489h85.335c11.315 0 22.17 4.495 30.172 12.498 7.997 8.003 12.493 18.857 12.493 30.172s-4.495 22.164-12.493 30.167c-8.003 8.003-18.857 12.498-30.172 12.498h-170.665v85.335h85.33v42.665h85.335v-42.665c33.946 0 66.504-13.486 90.511-37.494 24.003-24.003 37.489-56.561 37.489-90.506 0-33.951-13.486-66.509-37.489-90.511-24.008-24.003-56.566-37.489-90.511-37.489z"
      ],
      "tags": [
        "credit-card-money-fund--business-products-2"
      ],
      "defaultCode": 59737,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.334h170.67v85.333h-170.67v-85.333zM128 341.334h298.666v85.333h-298.666v-85.333zM128 469.334h213.334v85.331h-213.334v-85.331z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h512.002v-85.33h-512.002v-298.669zM768 85.334v128h-682.666v-128h682.666zM896 725.335h-85.335c-11.315 0-22.164-4.495-30.167-12.498s-12.498-18.857-12.498-30.172c0-11.315 4.495-22.164 12.498-30.167s18.852-12.498 30.167-12.498h170.67v-85.335h-85.335v-42.665h-85.335v42.665c-33.946 0-66.504 13.486-90.506 37.494-24.008 24.003-37.494 56.561-37.494 90.506 0 33.951 13.486 66.509 37.494 90.511 24.003 24.003 56.561 37.489 90.506 37.489h85.335c11.315 0 22.17 4.495 30.172 12.498 7.997 8.003 12.493 18.857 12.493 30.172s-4.495 22.164-12.493 30.167c-8.003 8.003-18.857 12.498-30.172 12.498h-170.665v85.335h85.33v42.665h85.335v-42.665c33.946 0 66.504-13.486 90.511-37.494 24.003-24.003 37.489-56.561 37.489-90.506 0-33.951-13.486-66.509-37.489-90.511-24.008-24.003-56.566-37.489-90.511-37.489z"
      ],
      "tags": [
        "credit-card-money-fund--business-products"
      ],
      "defaultCode": 59738,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.29h170.67v85.334h-170.67v-85.334zM128 341.29h298.666v85.334h-298.666v-85.334zM128 469.29h213.334v85.334h-213.334v-85.334z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h341.333v-85.33h-341.333v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M998.999 938.665l-138.542-138.537c29.276-44.227 41.078-97.751 33.126-150.19-7.956-52.434-35.103-100.050-76.17-133.606-41.073-33.56-93.148-50.667-146.115-48.007-52.972 2.66-103.071 24.899-140.57 62.404-37.505 37.499-59.744 87.598-62.404 140.57-2.66 52.966 14.447 105.042 48.007 146.115 33.556 41.068 81.172 68.214 133.606 76.17 52.439 7.951 105.964-3.85 150.19-33.126l138.537 138.542 60.334-60.334zM554.665 682.665c0-25.313 7.511-50.063 21.576-71.112s34.053-37.453 57.441-47.145c23.388-9.687 49.126-12.221 73.958-7.281 24.827 4.936 47.636 17.126 65.536 35.031 17.9 17.9 30.090 40.709 35.031 65.536 4.941 24.832 2.406 50.565-7.286 73.953-9.687 23.393-26.092 43.382-47.14 57.446-21.053 14.065-45.798 21.571-71.117 21.571-33.946 0-66.504-13.486-90.506-37.489-24.008-24.003-37.494-56.561-37.494-90.511z"
      ],
      "tags": [
        "credit-card-search--business-products"
      ],
      "defaultCode": 59739,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 341.29h170.67v85.334h-170.67v-85.334zM128 341.29h298.666v85.334h-298.666v-85.334zM128 469.29h213.334v85.334h-213.334v-85.334z",
        "M85.334 298.666h682.666v128h85.335v-341.333c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994h-682.666c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v512.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h341.333v-85.33h-341.333v-298.669zM768 85.334v128h-682.666v-128h682.666z",
        "M1024 810.665v-85.33h-46.935c-5.489-26.721-16.113-52.122-31.273-74.798l33.449-33.408-60.288-60.37-33.49 33.449c-22.687-15.145-48.082-25.764-74.798-31.273v-46.935h-85.33v46.935c-26.711 5.478-52.106 16.072-74.798 31.186l-33.449-33.408-60.288 60.375 33.408 33.408c-15.155 22.697-25.774 48.108-31.273 74.839h-46.935v85.33h46.935c5.494 26.737 16.097 52.163 31.232 74.88l-33.408 33.454 60.37 60.329 33.408-33.495c22.676 15.15 48.077 25.759 74.798 31.232v46.935h85.33v-46.935c26.711-5.504 52.106-16.108 74.798-31.232l33.449 33.454 60.288-60.416-33.449-33.408c15.165-22.682 25.8-48.077 31.314-74.798h46.935zM768 853.335c-16.876 0-33.377-5.007-47.411-14.382-14.029-9.38-24.97-22.707-31.427-38.298s-8.151-32.748-4.854-49.306c3.292-16.553 11.418-31.754 23.352-43.689s27.136-20.060 43.689-23.352c16.558-3.297 33.715-1.603 49.306 4.854s28.918 17.398 38.298 31.427c9.375 14.034 14.382 30.536 14.382 47.411 0 22.63-8.991 44.339-24.996 60.339-16 16.005-37.709 24.996-60.339 24.996z"
      ],
      "tags": [
        "credit-card-setting"
      ],
      "defaultCode": 59740,
      "grid": 0
    },
    {
      "paths": [
        "M153.653 514.145c56.011-56.012 131.978-87.479 211.189-87.479h104.491v85.333h-104.491c-56.58 0-110.841 22.477-150.85 62.485-7.18 7.178-13.796 14.817-19.818 22.851h170.668v85.33h-209.024c-2.845 13.942-4.309 28.227-4.309 42.67 0 14.438 1.464 28.723 4.309 42.665h209.024v85.335h-170.668c6.022 8.028 12.638 15.667 19.818 22.845 40.008 40.008 94.27 62.484 150.85 62.484h104.491v85.335h-104.491c-79.211 0-155.178-31.468-211.189-87.475-24.402-24.407-44.146-52.598-58.658-83.19h-94.995v-85.335h69.238c-2.028-14.049-3.062-28.303-3.062-42.665s1.034-28.621 3.062-42.67h-69.238v-85.33h94.995c14.512-30.597 34.256-58.788 58.658-83.19z",
        "M725.335 65.408h-128v234.032l256 31.318v73.168h-170.67v-19.926h-85.33v105.258h128v65.406h85.33v-65.406h128v-234.032l-256-31.318v-73.168h170.67v19.925h85.33v-105.258h-128v-65.408h-85.33v65.408zM256 170.666c-45.263 0-88.673 17.981-120.679 49.987s-49.987 75.416-49.987 120.68h-85.334c0-67.896 26.971-133.010 74.981-181.020s113.124-74.98 181.019-74.98v85.333z",
        "M256 0v256l170.666-128-170.666-128z",
        "M925.676 747.976c8.576-20.705 12.989-42.895 12.989-65.311h85.335c0 33.618-6.62 66.908-19.487 97.966-12.867 31.063-31.724 59.284-55.496 83.057s-51.994 42.629-83.052 55.491c-31.058 12.867-64.348 19.487-97.966 19.487v-85.33c22.41 0 44.605-4.419 65.311-12.995s39.521-21.146 55.368-36.992c15.852-15.852 28.421-34.662 36.997-55.373z",
        "M768 1024v-256l-170.665 128 170.665 128z"
      ],
      "tags": [
        "currency-exchange--business-products"
      ],
      "defaultCode": 59741,
      "grid": 0
    },
    {
      "paths": [
        "M789.335 213.334h149.33v-85.334h-85.33v-42.666h-85.335v44.8c-25.923 5.264-48.968 19.972-64.655 41.27s-22.902 47.665-20.244 73.983c2.657 26.318 15.002 50.71 34.632 68.44s45.148 27.533 71.603 27.507h42.665c5.658 0 11.085 2.247 15.084 6.248 4.004 4.001 6.252 9.427 6.252 15.085s-2.248 11.084-6.252 15.085c-3.999 4.001-9.426 6.248-15.084 6.248h-149.335v85.333h85.335v42.667h85.335v-44.8c25.923-5.264 48.963-19.973 64.655-41.27 15.688-21.298 22.902-47.665 20.244-73.983s-15.002-50.71-34.632-68.44c-19.63-17.73-45.153-27.533-71.603-27.507h-42.665c-5.658 0-11.085-2.248-15.089-6.248-3.999-4.001-6.246-9.427-6.246-15.085s2.248-11.084 6.246-15.085c4.004-4.001 9.431-6.248 15.089-6.248zM512 213.334c0-25.316-7.507-50.064-21.572-71.113s-34.056-37.455-57.444-47.143c-23.389-9.688-49.125-12.223-73.955-7.284s-47.637 17.13-65.539 35.031c-17.901 17.901-30.092 40.709-35.031 65.538s-2.404 50.566 7.284 73.955c9.688 23.389 26.094 43.38 47.144 57.445s45.797 21.572 71.113 21.572c33.948 0 66.505-13.486 90.51-37.491s37.49-56.562 37.49-90.509zM384 256c-8.439 0-16.688-2.503-23.704-7.191s-12.486-11.352-15.715-19.148c-3.229-7.796-4.074-16.375-2.428-24.652s5.71-15.879 11.677-21.846c5.967-5.967 13.569-10.031 21.846-11.677s16.855-0.801 24.651 2.428c7.797 3.229 14.46 8.698 19.148 15.714s7.191 15.266 7.191 23.705c0 11.316-4.495 22.168-12.496 30.17s-18.854 12.497-30.17 12.497z",
        "M597.335 554.665c0-56.578-22.477-110.84-62.484-150.848-40.009-40.008-94.271-62.484-150.851-62.484s-110.841 22.476-150.849 62.484c-40.008 40.008-62.484 94.27-62.484 150.848h-85.334v85.335h42.667v298.665h85.333v-298.665h597.331v298.665h85.335v-298.665h42.665v-85.335h-341.33zM256.001 554.665c0-33.946 13.486-66.504 37.49-90.508s56.562-37.49 90.509-37.49c33.948 0 66.505 13.486 90.51 37.49s37.49 56.563 37.49 90.508h-255.999z"
      ],
      "tags": [
        "currency-exchange-booth----business-products"
      ],
      "defaultCode": 59742,
      "grid": 0
    },
    {
      "paths": [
        "M469.334 128h-170.667c-23.564 0-42.666 19.103-42.666 42.666v307.2c0 20.962 15.227 38.818 35.926 42.131l390.739 62.52v228.147h-341.331v-119.465h-85.334v162.135c0 23.562 19.103 42.665 42.666 42.665h170.667v128h85.331v-128h170.67c23.562 0 42.665-19.103 42.665-42.665v-307.2c0-20.961-15.227-38.821-35.927-42.132l-390.739-62.519v-228.15h341.331v128h85.335v-170.667c0-23.564-19.103-42.666-42.665-42.666h-170.67v-128h-85.331v128z"
      ],
      "tags": [
        "currency-usd-dollar--business-products"
      ],
      "defaultCode": 59743,
      "grid": 0
    },
    {
      "paths": [
        "M1024 853.335h-1024v-85.335h1024v85.335z",
        "M512 810.665l-170.666 213.335h341.331l-170.665-213.335z",
        "M896 42.666v85.333h85.335c23.562 0 42.665 19.103 42.665 42.667v85.333h-85.335v-42.666h-170.665v91.856l220.349 36.725c20.572 3.429 35.651 21.229 35.651 42.086v170.665c0 23.567-19.103 42.67-42.665 42.67h-85.335v85.33h-85.335v-85.33h-85.33c-23.567 0-42.67-19.103-42.67-42.67v-93.865h85.335v51.2h170.665v-91.856l-220.344-36.724c-20.577-3.429-35.656-21.229-35.656-42.086v-170.666c0-23.564 19.103-42.667 42.67-42.667h85.33v-85.333h85.335z",
        "M213.334 42.666v85.333h85.333c23.564 0 42.667 19.103 42.667 42.667v85.333h-85.334v-42.666h-170.666v91.856l220.347 36.725c20.574 3.429 35.653 21.229 35.653 42.086v170.665c0 23.567-19.103 42.67-42.667 42.67h-85.333v85.33h-85.334v-85.33h-85.333c-23.564 0-42.667-19.103-42.667-42.67v-93.865h85.334v51.2h170.666v-91.856l-220.348-36.724c-20.573-3.429-35.652-21.229-35.652-42.086v-170.666c0-23.564 19.103-42.667 42.667-42.667h85.333v-85.333h85.334z"
      ],
      "tags": [
        "cypto-currency-exchange-rate--business-products"
      ],
      "defaultCode": 59744,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M522.47 640.041l76.503-267.763 82.053 23.443-72.084 252.292c100.618 17.316 195.164 62.249 272.635 130.673l-56.489 63.959c-86.313-76.232-197.683-117.996-312.837-117.315l-0.503 0.005v-0.005c-115.154-0.681-226.524 41.083-312.837 117.315l-56.489-63.959c101.974-90.061 233.534-139.428 369.578-138.685 3.492-0.020 6.984-0.005 10.47 0.041z",
        "M512 255.999c23.562 0 42.665-19.103 42.665-42.666s-19.103-42.667-42.665-42.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.666 42.667 42.666z",
        "M298.666 341.334c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.666-42.667-42.666c-23.564 0-42.666 19.103-42.666 42.666s19.103 42.667 42.666 42.667z",
        "M725.335 341.334c23.562 0 42.665-19.103 42.665-42.667s-19.103-42.666-42.665-42.666c-23.567 0-42.67 19.103-42.67 42.666s19.103 42.667 42.67 42.667z",
        "M213.334 511.999c23.564 0 42.666-19.103 42.666-42.666s-19.102-42.667-42.666-42.667c-23.564 0-42.666 19.103-42.666 42.667s19.102 42.666 42.666 42.666z",
        "M810.665 511.999c23.567 0 42.67-19.103 42.67-42.666s-19.103-42.667-42.67-42.667c-23.562 0-42.665 19.103-42.665 42.667s19.103 42.666 42.665 42.666z"
      ],
      "tags": [
        "dashboard-speed-guage--transportation"
      ],
      "defaultCode": 59745,
      "grid": 0
    },
    {
      "paths": [
        "M700.329 42.666h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v768.001c0 22.63 8.99 44.334 24.994 60.339s37.708 24.991 60.34 24.991h597.331c22.636 0 44.339-8.986 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-657.665l-195.671-195.669zM213.334 896v-768.001h426.666v170.666h170.665v597.335h-597.331z",
        "M469.334 426.665h-170.667c-11.316 0-22.168 4.495-30.17 12.497s-12.497 18.854-12.497 30.17v298.668h85.334v-85.335h85.333v85.335h85.334v-298.668c0-11.316-4.495-22.169-12.497-30.17s-18.854-12.497-30.17-12.497zM426.666 597.33h-85.333v-85.331h85.333v85.331zM597.335 511.999h42.665v170.666h-42.665v85.335h170.665v-85.335h-42.665v-170.666h42.665v-85.334h-170.665v85.334z"
      ],
      "tags": [
        "design-file-ai--design"
      ],
      "defaultCode": 59746,
      "grid": 0
    },
    {
      "paths": [
        "M700.329 42.666h-486.995c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v768.001c0 22.63 8.99 44.334 24.994 60.339s37.708 24.991 60.34 24.991h597.331c22.636 0 44.339-8.986 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-657.665l-195.671-195.669zM213.334 896v-768.001h426.666v170.666h170.665v597.335h-597.331z",
        "M426.667 810.665h255.998l-128-213.335-127.998 213.335z",
        "M661.335 597.33c35.343 0 64-28.652 64-64 0-35.345-28.657-63.998-64-63.998-35.348 0-64 28.654-64 63.998 0 35.348 28.652 64 64 64z",
        "M298.667 256h213.333v85.334h-213.333v-85.334zM298.667 384h255.998v85.334h-255.998v-85.334zM298.667 512h170.667v85.335h-170.667v-85.335z"
      ],
      "tags": [
        "design-file-text-image--design"
      ],
      "defaultCode": 59747,
      "grid": 0
    },
    {
      "paths": [
        "M396.502 652.503l-76.502 76.498-76.502-76.498-60.33 60.329 76.502 76.503-76.502 76.498 60.33 60.334 76.502-76.503 76.502 76.503 60.33-60.334-76.502-76.498 76.502-76.503-60.33-60.329zM640 793.001l-55.168-55.168-60.329 60.334 85.33 85.33c8.003 8.003 18.852 12.493 30.167 12.493s22.164-4.49 30.167-12.493l170.665-170.665-60.329-60.329-140.503 140.498zM170.667 128h170.667v85.334h-170.667v-85.334zM426.667 128h170.668v85.334h-170.668v-85.334zM682.665 128h170.67v85.334h-170.67v-85.334zM170.667 298.666h170.667v85.334h-170.667v-85.334zM426.667 298.666h170.668v85.334h-170.668v-85.334zM682.665 298.666h170.67v85.334h-170.67v-85.334zM170.667 469.334h170.667v85.331h-170.667v-85.331zM426.667 469.334h170.668v85.331h-170.668v-85.331zM682.665 469.334h170.67v85.331h-170.67v-85.331z"
      ],
      "tags": [
        "dialpad--business-products"
      ],
      "defaultCode": 59748,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M150.011 813.65l663.68-663.681 60.339 60.34-663.679 663.681-60.34-60.339z"
      ],
      "tags": [
        "disable-delete--interface-essential"
      ],
      "defaultCode": 59749,
      "grid": 0
    },
    {
      "paths": [
        "M85.914 120.987l-85.333 511.999c-2.062 12.37 1.424 25.027 9.531 34.596s20.014 15.089 32.556 15.089h384v213.33c0 23.567 19.103 42.67 42.667 42.67h128.002c17.065 0 32.492-10.173 39.214-25.861l116.92-272.809h14.531c0 23.567 19.103 42.67 42.665 42.67h170.67c23.562 0 42.665-19.103 42.665-42.67v-469.332c0-23.564-19.103-42.666-42.665-42.666h-170.67c-18.918 0-34.964 12.318-40.556 29.372l-246.39-70.397c-3.809-1.089-7.757-1.641-11.72-1.641h-384c-20.857 0-38.658 15.079-42.086 35.652zM853.335 597.335v-384.001h85.33v384.001h-85.33zM768 245.518v309.152h-42.665c-17.070 0-32.497 10.168-39.219 25.856l-116.915 272.809h-57.201v-213.335c0-23.562-19.103-42.665-42.666-42.665h-376.301l71.111-426.668h341.88l261.976 74.85z"
      ],
      "tags": [
        "dislike--rewards-rating"
      ],
      "defaultCode": 59750,
      "grid": 0
    },
    {
      "paths": [
        "M448 896h-362.666v-810.666h515.667l124.334 124.33v281.002h85.33v-316.33l-174.336-174.336h-636.329v981.335h448v-85.335z",
        "M277.334 429.27l-86.613-86.656 45.226-45.226 41.386 41.344 105.387-105.344 45.226 45.226-150.614 150.656zM277.334 685.271l-86.613-86.656 45.226-45.225 41.386 41.339 105.387-105.341 45.226 45.228-150.614 150.656zM490.667 309.334h127.998v64h-127.998v-64zM490.667 565.335h127.998v64h-127.998v-64zM618.368 1016.535c-7.148 1.792-14.643 1.7-21.745-0.266-7.107-1.966-13.578-5.74-18.79-10.952s-8.986-11.689-10.952-18.79c-1.966-7.107-2.058-14.597-0.266-21.75l19.666-78.761c3.753-15.002 11.51-28.703 22.446-39.639l260.649-260.603c16.973-16.978 39.997-26.511 64-26.511s47.027 9.533 64 26.511c16.973 16.973 26.511 39.992 26.511 64 0 24.003-9.539 47.022-26.511 64l-260.649 260.603c-10.936 10.936-24.637 18.693-39.639 22.446l-78.72 19.712z"
      ],
      "tags": [
        "document-list-edit--work-office"
      ],
      "defaultCode": 59751,
      "grid": 0
    },
    {
      "paths": [
        "M448 896h-362.666v-810.666h515.667l124.334 124.33v281.002h85.33v-316.33l-174.336-174.336h-636.329v981.335h448v-85.335z",
        "M277.334 429.27l-86.613-86.656 45.226-45.226 41.386 41.344 105.387-105.344 45.226 45.226-150.614 150.656zM277.334 685.271l-86.613-86.656 45.226-45.225 41.386 41.339 105.387-105.341 45.226 45.228-150.614 150.656zM490.667 309.334h127.998v64h-127.998v-64zM490.667 565.335h127.998v64h-127.998v-64zM984.791 525.696c-55.634 5.652-110.116 19.543-161.664 41.216l-46.254 120.279c-0.819 2.166-2.324 4.004-4.28 5.243-1.961 1.234-4.27 1.797-6.579 1.608-2.309-0.195-4.49-1.137-6.221-2.678-1.725-1.546-2.903-3.61-3.354-5.883l-15.104-75.602c-66.458 39.071-118.815 98.212-149.55 168.914-8.141 19.63-11.75 40.847-10.552 62.065 1.193 21.217 7.168 41.887 17.464 60.477l-70.912 70.866 45.271 45.271 70.953-70.953c19.589 11.796 42.035 17.997 64.896 17.92 19.768-0.225 39.352-3.83 57.902-10.665 107.264-38.4 232.402-189.015 253.010-393.006l4.183-38.999-39.209 3.927z"
      ],
      "tags": [
        "document-list-quill--work-office"
      ],
      "defaultCode": 59752,
      "grid": 0
    },
    {
      "paths": [
        "M42.666 42.667c0-23.564 19.102-42.667 42.667-42.667h853.332c23.567 0 42.67 19.103 42.67 42.667v938.668c0 23.562-19.103 42.665-42.67 42.665h-853.332c-23.564 0-42.667-19.103-42.667-42.665v-938.668zM127.999 85.334v853.331h768.001v-853.331h-768.001zM213.333 298.666c0-23.564 19.103-42.666 42.666-42.666h512.001c23.562 0 42.665 19.103 42.665 42.666s-19.103 42.667-42.665 42.667h-512.001c-23.564 0-42.666-19.103-42.666-42.667zM213.333 512c0-23.564 19.103-42.666 42.666-42.666h512.001c23.562 0 42.665 19.102 42.665 42.666 0 23.562-19.103 42.665-42.665 42.665h-512.001c-23.564 0-42.666-19.103-42.666-42.665zM640 768h-384.001v-85.335h384.001v85.335z"
      ],
      "tags": [
        "document-paragraph-text--interface-essential"
      ],
      "defaultCode": 59753,
      "grid": 0
    },
    {
      "paths": [
        "M853.335 85.335h-682.668c-22.632 0-44.337 8.99-60.34 24.993s-24.994 37.708-24.994 60.34v682.668c0 22.63 8.991 44.334 24.994 60.339s37.708 24.996 60.34 24.996h682.668c22.63 0 44.334-8.991 60.339-24.996 16-16.005 24.991-37.709 24.991-60.339v-682.668c0-22.631-8.991-44.337-24.991-60.34-16.005-16.003-37.709-24.993-60.339-24.993zM853.335 853.335h-682.668v-682.668h682.668v682.668z",
        "M512 298.669h256v85.334h-256v-85.334zM512 469.336h256v85.335h-256v-85.335zM512 640h170.665v85.335h-170.665v-85.335zM256 298.669h170.666v170.667h-170.666v-170.667zM256 554.67h170.666v170.665h-170.666v-170.665z"
      ],
      "tags": [
        "document-paragraph-text-image-1--interface-essential"
      ],
      "defaultCode": 59754,
      "grid": 0
    },
    {
      "paths": [
        "M849.664 0h-593.664v341.334h85.334v-256h473.002l124.329 124.33v643.671h-341.33v85.33h426.665v-764.329l-174.336-174.336z",
        "M640 234.665h170.665v85.334h-170.665v-85.334zM512 405.332h298.665v85.333h-298.665v-85.333zM512 576h298.665v85.33h-298.665v-85.33zM394.666 736h-85.333v-74.67c29.591-12.329 53.995-34.529 69.062-62.822s19.865-60.938 13.578-92.37c-6.287-31.434-23.27-59.719-48.061-80.042s-55.857-31.43-87.913-31.43c-32.056 0-63.122 11.107-87.913 31.43s-41.774 48.608-48.061 80.042c-6.287 31.432-1.488 64.077 13.578 92.37s39.472 50.493 69.062 62.822v74.67h-85.333c-31.112 0.020-60.943 12.39-82.942 34.391s-34.368 51.83-34.391 82.939v32h512v-32c-0.023-31.109-12.392-60.938-34.391-82.939s-51.83-34.371-82.942-34.391v0zM21.333 981.33c0 11.32 4.495 22.17 12.497 30.172s18.854 12.498 30.17 12.498h384c11.316 0 22.169-4.495 30.17-12.498s12.496-18.852 12.496-30.172v-42.665h-469.333v42.665z"
      ],
      "tags": [
        "document-stamp-approvement--work-office"
      ],
      "defaultCode": 59755,
      "grid": 0
    },
    {
      "paths": [
        "M938.665 256v-170.666c0-22.632-8.991-44.337-24.991-60.34-16.005-16.003-37.709-24.994-60.339-24.994h-768.002c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v597.331c0 22.636 8.99 44.339 24.994 60.339 16.003 16.005 37.708 24.996 60.34 24.996h278.869v-85.335h-278.869v-426.665h853.331zM853.335 85.334v85.333h-341.335v-85.333h341.335zM426.666 170.666h-128v-85.333h128v85.333zM213.334 85.334v85.333h-128v-85.333h128zM769.536 693.335h-74.071c-5.658 0-11.085-2.248-15.084-6.252-3.999-3.999-6.246-9.426-6.246-15.084s2.248-11.085 6.246-15.084c3.999-4.004 9.426-6.252 15.084-6.252h128v-64h-64.594v-32h-64v32.087c-22.636 0.102-44.298 9.19-60.227 25.267-15.933 16.072-24.827 37.816-24.724 60.452 0.102 22.63 9.19 44.293 25.267 60.227 16.072 15.928 37.816 24.822 60.452 24.719h73.897c5.658 0 11.085 2.248 15.084 6.252 4.004 3.999 6.252 9.426 6.252 15.084s-2.248 11.085-6.252 15.084c-3.999 4.004-9.426 6.252-15.084 6.252h-139.392v64h64.727v31.913h64v-32h10.665c22.63 0 44.339-8.991 60.339-24.996 16.005-16 24.996-37.704 24.996-60.339 0-22.63-8.991-44.334-24.996-60.339-16-16-37.709-24.991-60.339-24.991z",
        "M867.287 472.321l46.93-89.984c3.389-6.515 5.033-13.794 4.782-21.131s-2.391-14.486-6.216-20.754c-3.82-6.268-9.196-11.444-15.606-15.026s-13.635-5.451-20.977-5.425h-298.665c-7.332-0.005-14.541 1.88-20.931 5.472s-11.745 8.77-15.555 15.034c-3.809 6.265-5.939 13.405-6.185 20.731s1.403 14.594 4.782 21.099l46.935 89.984c-47.749 34.293-86.892 79.196-114.351 131.174s-42.487 109.619-43.901 168.387c0 153.175 117.246 252.119 298.668 252.119 181.417 0 298.665-98.944 298.665-252.119-1.428-58.778-16.476-116.424-43.955-168.407-27.484-51.978-66.652-96.874-114.422-131.153v0zM726.871 938.665c-50.048 0-213.335-12.032-213.335-166.784 1.085-50.104 15.309-99.041 41.247-141.926 25.938-42.88 62.679-78.198 106.552-102.426 5.181-2.447 9.82-5.914 13.635-10.199 3.814-4.28 6.728-9.286 8.566-14.718 1.833-5.432 2.555-11.179 2.12-16.897-0.43-5.718-2.017-11.289-4.654-16.381l-33.193-64h158.167l-33.239 64c-2.652 5.106-4.244 10.696-4.68 16.433-0.44 5.737 0.292 11.504 2.14 16.952s4.782 10.469 8.622 14.754c3.835 4.285 8.504 7.752 13.716 10.184 43.853 24.238 80.573 59.561 106.491 102.441 25.912 42.885 40.115 91.822 41.175 141.911 0 154.624-163.282 166.656-213.33 166.656v0z"
      ],
      "tags": [
        "earning-per-page--business-products"
      ],
      "defaultCode": 59756,
      "grid": 0
    },
    {
      "paths": [
        "M256 128c19.578 0 36.644 13.325 41.393 32.318l129.274 517.093 129.273-517.093c4.751-18.994 21.816-32.318 41.395-32.318s36.644 13.325 41.39 32.318l129.275 517.093 43.94-175.76c4.751-18.994 21.816-32.318 41.395-32.318h170.665v85.331h-137.354l-77.251 309.018c-4.751 18.995-21.816 32.317-41.395 32.317s-36.644-13.322-41.395-32.317l-129.27-517.096-129.275 517.096c-4.749 18.995-21.815 32.317-41.393 32.317s-36.644-13.322-41.393-32.317l-129.274-517.097-43.94 175.762c-4.749 18.995-21.815 32.317-41.393 32.317h-170.666v-85.331h137.354l77.254-309.015c4.748-18.994 21.814-32.318 41.393-32.318z"
      ],
      "tags": [
        "electronics-resistor--computers-devices-electronics"
      ],
      "defaultCode": 59757,
      "grid": 0
    },
    {
      "paths": [
        "M0 170.666c0-23.564 19.103-42.666 42.667-42.666h938.668c23.562 0 42.665 19.103 42.665 42.666v682.669c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-682.669zM85.334 213.334v597.331h853.331v-597.331h-853.331z",
        "M489.094 590.664l-469.333-298.668 45.813-71.992 446.427 284.089 446.428-284.089 45.814 71.992-469.335 298.668c-13.978 8.893-31.837 8.893-45.813 0z"
      ],
      "tags": [
        "email-envelope-1--emails"
      ],
      "defaultCode": 59758,
      "grid": 0
    },
    {
      "paths": [
        "M256 127.999c0-23.564 19.103-42.666 42.666-42.666h682.669c23.562 0 42.665 19.102 42.665 42.666v512.001c0 23.562-19.103 42.665-42.665 42.665h-682.669c-23.564 0-42.666-19.103-42.666-42.665v-512.001zM341.334 170.666v426.669h597.331v-426.669h-597.331z",
        "M616.591 451.671l-341.334-224 46.819-71.343 317.924 208.638 317.926-208.638 46.817 71.343-341.335 224c-14.213 9.327-32.604 9.327-46.817 0zM0 383.999c0-23.564 19.103-42.666 42.667-42.666h128v85.333h-85.333v426.669h597.331v-85.335h85.335v128c0 23.562-19.103 42.665-42.665 42.665h-682.668c-23.564 0-42.667-19.103-42.667-42.665v-512.001z"
      ],
      "tags": [
        "email-envelopes--emails"
      ],
      "defaultCode": 59759,
      "grid": 0
    },
    {
      "paths": [
        "M128 42.667c0-23.564 19.103-42.667 42.666-42.667h682.669c23.562 0 42.665 19.103 42.665 42.667v341.333h-85.335v-298.666h-597.331v298.666h-85.334v-341.333zM24.569 430.695c14.992-7.022 32.694-4.738 45.412 5.861l244.133 203.444h395.774l244.132-203.444c12.718-10.598 30.418-12.883 45.409-5.861 14.996 7.022 24.571 22.083 24.571 38.639v512.002c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-512.002c0-16.556 9.577-31.617 24.569-38.639zM85.334 560.43v378.235h853.331v-378.235l-186.015 155.013c-7.67 6.39-17.336 9.892-27.315 9.892h-426.669c-9.981 0-19.646-3.502-27.314-9.892l-186.019-155.013z",
        "M565.335 213.333l-93.313 149.333-53.334-85.333-120.022 192h426.668l-160-256z"
      ],
      "tags": [
        "email-image--emails"
      ],
      "defaultCode": 59760,
      "grid": 0
    },
    {
      "paths": [
        "M384.001 554.665c47.128 0 85.334-38.205 85.334-85.331 0-47.129-38.205-85.334-85.334-85.334s-85.334 38.205-85.334 85.334c0 47.126 38.205 85.331 85.334 85.331z",
        "M597.335 512c47.124 0 85.33-38.204 85.33-85.332s-38.205-85.333-85.33-85.333c-47.13 0-85.335 38.205-85.335 85.333s38.205 85.332 85.335 85.332z",
        "M663.921 135.336c11.725 7.938 18.744 21.173 18.744 35.331v256h-85.33v-192.98l-128.002 51.2v184.446h-85.334v-213.334c0-17.446 10.622-33.135 26.821-39.615l213.333-85.333c13.148-5.258 28.042-3.653 39.767 4.284zM0 682.665c0-23.562 19.103-42.665 42.667-42.665h213.333c14.266 0 27.588 7.132 35.501 19l72.667 109h295.662l72.668-109c7.916-11.868 21.238-19 35.502-19h213.335c23.562 0 42.665 19.103 42.665 42.665v298.67c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-298.67zM85.334 725.335v213.33h853.331v-213.33h-147.83l-72.668 109c-7.91 11.868-21.233 19-35.502 19h-341.331c-14.266 0-27.588-7.132-35.501-19l-72.667-109h-147.832z",
        "M128 42.667c0-23.564 19.103-42.667 42.666-42.667h682.669c23.562 0 42.665 19.103 42.665 42.667v511.998h-85.335v-469.331h-597.331v469.331h-85.334v-511.998z"
      ],
      "tags": [
        "email-inbox-audio-music--emails"
      ],
      "defaultCode": 59761,
      "grid": 0
    },
    {
      "paths": [
        "M128 42.667c0-23.564 19.103-42.667 42.666-42.667h682.669c23.562 0 42.665 19.103 42.665 42.667v511.998h-85.335v-469.331h-597.331v469.331h-85.334v-511.998zM0 682.665c0-23.562 19.103-42.665 42.667-42.665h213.333c14.266 0 27.588 7.132 35.501 19l72.667 109h295.662l72.668-109c7.916-11.868 21.238-19 35.502-19h213.335c23.562 0 42.665 19.103 42.665 42.665v298.67c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-298.67zM85.334 725.335v213.33h853.331v-213.33h-147.83l-72.668 109c-7.91 11.868-21.233 19-35.502 19h-341.331c-14.266 0-27.588-7.132-35.501-19l-72.667-109h-147.832z",
        "M512 170.665l-213.333 170.667h426.668l-213.335-170.667zM384.001 341.332h255.999v170.666h-255.999v-170.666z",
        "M469.333 384h85.332v128h-85.332v-128z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "isMulticolor": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "f": 0
          },
          {
            "f": 0
          },
          {
            "f": 4
          }
        ]
      },
      "tags": [
        "email-inbox-home--emails"
      ],
      "defaultCode": 59762,
      "grid": 0
    },
    {
      "paths": [
        "M128 42.667c0-23.564 19.103-42.667 42.666-42.667h682.669c23.562 0 42.665 19.103 42.665 42.667v511.998h-85.335v-469.331h-597.331v469.331h-85.334v-511.998zM0 682.665c0-23.562 19.103-42.665 42.667-42.665h213.333c14.266 0 27.588 7.132 35.501 19l72.667 109h295.662l72.668-109c7.916-11.868 21.238-19 35.502-19h213.335c23.562 0 42.665 19.103 42.665 42.665v298.67c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-298.67zM85.334 725.335v213.33h853.331v-213.33h-147.83l-72.668 109c-7.91 11.868-21.233 19-35.502 19h-341.331c-14.266 0-27.588-7.132-35.501-19l-72.667-109h-147.832z",
        "M565.335 256l-93.313 136.15-53.334-77.782-120.022 175.062h426.668l-160-233.43z"
      ],
      "tags": [
        "email-inbox-image--emails"
      ],
      "defaultCode": 59765,
      "grid": 0
    },
    {
      "paths": [
        "M128 42.667c0-23.564 19.103-42.667 42.666-42.667h682.669c23.562 0 42.665 19.103 42.665 42.667v511.998h-85.335v-469.331h-597.331v469.331h-85.334v-511.998zM0 682.665c0-23.562 19.103-42.665 42.667-42.665h213.333c14.266 0 27.588 7.132 35.501 19l72.667 109h295.662l72.668-109c7.916-11.868 21.238-19 35.502-19h213.335c23.562 0 42.665 19.103 42.665 42.665v298.67c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-298.67zM85.334 725.335v213.33h853.331v-213.33h-147.83l-72.668 109c-7.91 11.868-21.233 19-35.502 19h-341.331c-14.266 0-27.588-7.132-35.501-19l-72.667-109h-147.832z"
      ],
      "tags": [
        "email-inbox-money-fund--emails"
      ],
      "defaultCode": 59766,
      "grid": 0
    },
    {
      "paths": [
        "M128 42.667c0-23.564 19.103-42.667 42.666-42.667h682.669c23.562 0 42.665 19.103 42.665 42.667v511.998h-85.335v-469.331h-597.331v469.331h-85.334v-511.998zM682.665 298.666h-341.331v-85.333h341.331v85.333zM682.665 469.334h-341.331v-85.334h341.331v85.334zM0 682.665c0-23.562 19.103-42.665 42.667-42.665h213.333c14.266 0 27.588 7.132 35.501 19l72.667 109h295.662l72.668-109c7.916-11.868 21.238-19 35.502-19h213.335c23.562 0 42.665 19.103 42.665 42.665v298.67c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-298.67zM85.334 725.335v213.33h853.331v-213.33h-147.83l-72.668 109c-7.91 11.868-21.233 19-35.502 19h-341.331c-14.266 0-27.588-7.132-35.501-19l-72.667-109h-147.832z"
      ],
      "tags": [
        "email-inbox-read--emails"
      ],
      "defaultCode": 59767,
      "grid": 0
    },
    {
      "paths": [
        "M469.334 430.328v-408.993h85.331v408.993l140.498-140.497 60.339 60.34-213.33 213.331c-16.666 16.666-43.68 16.666-60.342 0l-213.333-213.331 60.34-60.34 140.497 140.497zM0 661.335c0-23.567 19.103-42.665 42.667-42.665h213.333c14.266 0 27.588 7.127 35.501 18.995l72.667 109.005h295.662l72.668-109.005c7.916-11.868 21.238-18.995 35.502-18.995h213.335c23.562 0 42.665 19.098 42.665 42.665v341.335c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-341.335zM85.334 704v256h853.331v-256h-147.83l-72.668 109c-7.91 11.873-21.233 19-35.502 19h-341.331c-14.266 0-27.588-7.127-35.501-19l-72.667-109h-147.832z"
      ],
      "tags": [
        "email-inbox-recieve--emails"
      ],
      "defaultCode": 59768,
      "grid": 0
    },
    {
      "paths": [
        "M481.83 12.497c16.663-16.662 43.677-16.662 60.342 0l213.33 213.333-60.339 60.34-140.498-140.497v408.992h-85.331v-408.992l-140.497 140.497-60.34-60.34 213.333-213.333zM0 640c0-23.562 19.103-42.665 42.667-42.665h213.333c14.266 0 27.588 7.127 35.501 19l72.667 109h295.662l72.668-109c7.916-11.873 21.238-19 35.502-19h213.335c23.562 0 42.665 19.103 42.665 42.665v341.335c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-341.335zM85.334 682.665v256h853.331v-256h-147.83l-72.668 109c-7.91 11.873-21.233 19-35.502 19h-341.331c-14.266 0-27.588-7.127-35.501-19l-72.667-109h-147.832z"
      ],
      "tags": [
        "email-inbox-send--emails"
      ],
      "defaultCode": 59769,
      "grid": 0
    },
    {
      "paths": [
        "M128 42.667c0-23.564 19.103-42.667 42.666-42.667h682.669c23.562 0 42.665 19.103 42.665 42.667v341.333h-85.335v-298.666h-597.331v298.666h-85.334v-341.333zM682.665 298.666h-341.331v-85.333h341.331v85.333zM682.665 469.334h-341.331v-85.334h341.331v85.334zM24.569 430.695c14.992-7.022 32.694-4.738 45.412 5.861l244.133 203.444h395.774l244.132-203.444c12.718-10.598 30.418-12.883 45.409-5.861 14.996 7.022 24.571 22.083 24.571 38.639v512.002c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-512.002c0-16.556 9.577-31.617 24.569-38.639zM85.334 560.43v378.235h853.331v-378.235l-186.015 155.013c-7.67 6.39-17.336 9.892-27.315 9.892h-426.669c-9.981 0-19.646-3.502-27.314-9.892l-186.019-155.013z"
      ],
      "tags": [
        "email-read--emails"
      ],
      "defaultCode": 59770,
      "grid": 0
    },
    {
      "paths": [
        "M85.333 490.666c0-23.564 19.102-42.666 42.666-42.666h768.001c23.562 0 42.665 19.103 42.665 42.666v511.998c0 23.567-19.103 42.67-42.665 42.67h-768.001c-23.564 0-42.666-19.103-42.666-42.67v-511.998zM170.666 533.335v426.665h682.669v-426.665h-682.669z",
        "M469.334 216.993l-97.83-97.83-60.34 60.34 170.667 170.667c8.002 8.002 18.854 12.496 30.17 12.496s22.17-4.495 30.172-12.496l170.665-170.667-60.339-60.34-97.833 97.83v-195.66h-85.331v195.66zM490.502 815.519l-384-224 42.997-73.708 362.502 211.461 362.501-211.461 42.998 73.708-384 224c-13.286 7.752-29.712 7.752-42.997 0z"
      ],
      "tags": [
        "email-recieve--emails"
      ],
      "defaultCode": 59771,
      "grid": 0
    },
    {
      "paths": [
        "M488.449 1024c-3.738 0.502-7.526 0.502-11.264 0h-4.096l-343.040-131.072c-8.096-3.098-15.068-8.566-20.001-15.693s-7.599-15.575-7.647-24.243v-340.992c-0.049-6.947 1.605-13.799 4.818-19.958s7.888-11.436 13.614-15.37l128-84.992 50.176 70.144-58.88 39.424 248.32 91.648 248.319-93.184-58.368-39.424 47.104-70.656 128 84.992c5.729 3.934 10.399 9.211 13.614 15.37s4.869 13.011 4.818 19.958v340.992c0.097 8.699-2.509 17.219-7.46 24.371-4.956 7.158-12.006 12.595-20.188 15.565l-340.991 128-14.848 5.12zM530.944 669.184v250.368l256-95.744v-250.368l-256 95.744zM189.953 822.784l256 95.744v-249.344l-256-95.744v249.344zM488.449 468.992c-5.6 0.070-11.158-0.981-16.346-3.091s-9.902-5.237-13.862-9.197l-170.496-171.008 60.416-59.904 97.792 97.792v-323.584h84.991v323.584l97.792-97.792 60.416 59.904-170.496 171.008c-3.958 3.96-8.673 7.087-13.861 9.197s-10.746 3.161-16.346 3.091z"
      ],
      "tags": [
        "email-recieve-box--emails"
      ],
      "defaultCode": 59772,
      "grid": 0
    },
    {
      "paths": [
        "M413.366 9.588c99.791-19.596 203.159-9.030 296.927 30.352 93.763 39.382 173.676 105.796 229.545 190.773s85.171 184.668 84.163 286.361l-85.33-0.845c0.84-84.746-23.578-167.822-70.134-238.637-46.561-70.814-113.152-126.159-191.288-158.978s-164.28-41.624-247.439-25.293c-83.161 16.33-159.575 57.057-219.498 116.986l-66.401 66.358-60.32-60.359 66.378-66.335c0.004-0.004-0.004 0.004 0 0 71.907-71.909 163.61-120.788 263.398-140.383z",
        "M346.070 279.68h-265.515v-265.472l265.515 265.472z",
        "M84.172 793.262c-55.869-84.966-85.171-184.648-84.17-286.332l85.329 0.839c-0.834 84.738 23.585 167.805 70.142 238.609s113.144 126.147 191.273 158.961c78.129 32.819 164.26 41.626 247.415 25.303 83.154-16.323 159.565-57.037 219.489-116.951l66.396-66.355 60.324 60.36-66.386 66.34c-71.91 71.9-163.604 120.755-263.388 140.344-99.784 19.584-203.142 9.016-296.897-30.367-93.754-39.378-173.659-105.784-229.528-190.751z",
        "M943.447 1009.792v-265.472h-265.518l265.518 265.472z",
        "M315.863 347.65h461.825v15.858l-230.917 144.336-230.907-144.309v-15.884zM315.863 439.005v238.545h461.825v-238.568l-213.955 133.731c-10.373 6.487-23.542 6.487-33.92 0.005l-213.95-133.713z"
      ],
      "tags": [
        "email-refresh-sync--emails"
      ],
      "defaultCode": 59773,
      "grid": 0
    },
    {
      "paths": [
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h853.333c23.562 0 42.665 19.103 42.665 42.667v426.667h-85.33v-384h-768.002v597.331h341.333v85.335h-384c-23.564 0-42.667-19.103-42.667-42.665v-682.668z",
        "M445.923 438.36l-426.667-280.022 46.821-71.341 403.256 264.657 403.258-264.657 46.817 71.341-426.664 280.022c-14.213 9.328-32.608 9.328-46.821 0zM896 768h-298.665v-85.335h298.665c33.946 0 66.504 13.486 90.511 37.494 24.003 24.003 37.489 56.561 37.489 90.506v170.67h-85.335v-170.67c0-11.315-4.495-22.164-12.493-30.167-8.003-8.003-18.857-12.498-30.172-12.498z",
        "M567.163 695.163l170.665-170.665 60.344 60.339-140.498 140.498 140.498 140.493-60.344 60.344-170.665-170.67c-16.66-16.66-16.66-43.679 0-60.339z"
      ],
      "tags": [
        "email-reply-1--emails"
      ],
      "defaultCode": 59774,
      "grid": 0
    },
    {
      "paths": [
        "M597.335 810.665h-512.002v-291.241l228.224 195.625c7.728 6.615 17.564 10.245 27.733 10.245s20.005-3.63 27.734-10.245l170.665-146.258-55.465-64.812-142.89 122.494-183.467-157.139h226.134v-85.334h-341.333c-11.316 0-22.168 4.495-30.17 12.497s-12.497 18.854-12.497 30.17v426.668c0 11.315 4.495 22.17 12.497 30.167 8.002 8.003 18.854 12.498 30.17 12.498h597.333c11.315 0 22.17-4.495 30.172-12.498 7.997-7.997 12.493-18.852 12.493-30.167v-256h-85.33v213.33zM1013.417 569.216l-161.618-184.703c28.503-36.79 44.042-81.972 44.201-128.512 0-42.193-12.513-83.439-35.953-118.521s-56.76-62.426-95.744-78.573c-38.979-16.146-81.874-20.371-123.254-12.14-41.385 8.232-79.396 28.55-109.23 58.385-29.837 29.835-50.156 67.848-58.387 109.231s-4.007 84.277 12.14 123.258c16.146 38.982 43.492 72.3 78.575 95.741s76.324 35.953 118.518 35.953c36.869-0.23 73.032-10.132 104.878-28.715l161.705 184.83 64.169-56.233zM554.665 256.001c0-25.316 7.511-50.063 21.576-71.113s34.053-37.456 57.441-47.144c23.388-9.688 49.126-12.222 73.958-7.284 24.827 4.939 47.636 17.129 65.536 35.031s30.090 40.709 35.031 65.539c4.941 24.829 2.406 50.566-7.286 73.955-9.687 23.389-26.092 43.38-47.14 57.445-21.053 14.065-45.798 21.572-71.117 21.572-33.946 0-66.504-13.486-90.506-37.49-24.008-24.005-37.494-56.562-37.494-90.51v0z"
      ],
      "tags": [
        "email-search-1--emails"
      ],
      "defaultCode": 59775,
      "grid": 0
    },
    {
      "paths": [
        "M137.385 554.665h177.503l17.066-85.331h-177.504l-17.065 85.331zM255.564 384.001h93.457l17.066-85.334h-93.457l-17.066 85.334zM297.821 640h-262.844l-17.067 85.335h262.843l17.067-85.335z",
        "M427.493 290.299c3.989-19.943 21.5-34.299 41.838-34.299h511.998c12.785 0 24.893 5.731 32.998 15.617s11.346 22.883 8.842 35.418l-85.335 426.667c-3.988 19.942-21.499 34.299-41.836 34.299h-512.002c-12.783 0-24.892-5.729-32.996-15.616s-11.349-22.886-8.842-35.42l85.333-426.665zM504.31 341.334l-68.266 341.331h424.977l68.265-341.331h-424.975z",
        "M1002.501 378.378l-298.665 170.665c-15.201 8.684-34.156 7.209-47.826-3.727l-213.332-170.666 53.307-66.634 190.688 152.551 273.49-156.279 42.337 74.090z"
      ],
      "tags": [
        "email-send-1--emails"
      ],
      "defaultCode": 59776,
      "grid": 0
    },
    {
      "paths": [
        "M927.36 184.406c-5.059-5.504-11.469-9.584-18.601-11.83-7.127-2.246-14.72-2.58-22.016-0.97l-768.003 170.667c-8.218 1.828-15.711 6.048-21.536 12.126s-9.722 13.744-11.2 22.032c-1.478 8.288-0.471 16.828 2.894 24.545s8.938 14.266 16.017 18.822l236.416 151.937v281.6c-0.003 8.038 2.266 15.918 6.544 22.723s10.394 12.268 17.64 15.749c7.246 3.482 15.329 4.849 23.317 3.937s15.556-4.060 21.832-9.088l187.263-149.847 104.32 67.072c5.545 3.594 11.843 5.847 18.406 6.589 6.559 0.742 13.204-0.051 19.41-2.314 6.2-2.258 11.796-5.934 16.343-10.721 4.541-4.792 7.91-10.573 9.841-16.891l170.67-554.666c2.176-7.144 2.437-14.735 0.758-22.012-1.674-7.278-5.233-13.988-10.317-19.46v0zM682.281 304.556l-294.015 196.010-151.082-97.109 445.097-98.902zM426.666 764.544v-137.815l95.533 61.399-95.533 76.416zM701.097 701.696l-234.665-150.784 353.577-235.604-118.912 386.388z"
      ],
      "tags": [
        "email-send-2--emails"
      ],
      "defaultCode": 59777,
      "grid": 0
    },
    {
      "paths": [
        "M85.334 469.334c0-23.564 19.103-42.667 42.667-42.667h767.999c23.562 0 42.665 19.103 42.665 42.667v512.001c0 23.562-19.103 42.665-42.665 42.665h-767.999c-23.564 0-42.667-19.103-42.667-42.665v-512.001zM170.667 512v426.665h682.668v-426.665h-682.668z",
        "M512 0c11.315 0 22.17 4.495 30.172 12.497l170.665 170.667-60.339 60.34-97.833-97.83v195.66h-85.331v-195.66l-97.83 97.83-60.34-60.34 170.667-170.667c8.002-8.002 18.854-12.497 30.17-12.497zM490.502 794.189l-384-224 42.997-73.71 362.502 211.459 362.501-211.459 42.998 73.71-384 224c-13.286 7.747-29.712 7.747-42.997 0z"
      ],
      "tags": [
        "email-send-3--emails"
      ],
      "defaultCode": 59778,
      "grid": 0
    },
    {
      "paths": [
        "M0 554.665c0-23.562 19.103-42.665 42.667-42.665h597.333c23.562 0 42.665 19.103 42.665 42.665v426.67c0 23.562-19.103 42.665-42.665 42.665h-597.333c-23.564 0-42.667-19.103-42.667-42.665v-426.67zM85.334 597.335v341.33h512.002v-341.33h-512.002z",
        "M1011.502 12.496c11.428 11.427 15.416 28.331 10.307 43.662l-170.665 511.997c-5.806 17.423-22.113 29.179-40.479 29.179s-34.668-11.756-40.474-29.179l-78.587-235.759-235.764-78.587c-17.423-5.808-29.174-22.112-29.174-40.477s11.751-34.67 29.174-40.477l511.998-170.667c15.334-5.111 32.236-1.12 43.663 10.307zM604.257 213.333l134.569 44.856c12.739 4.247 22.738 14.244 26.982 26.984l44.856 134.568 103.204-309.614-309.612 103.205zM318.72 830.848l-298.667-186.665 45.226-72.366 276.054 172.534 276.052-172.534 45.23 72.366-298.669 186.665c-13.836 8.648-31.391 8.648-45.226 0z"
      ],
      "tags": [
        "email-send-envelope--emails"
      ],
      "defaultCode": 59779,
      "grid": 0
    },
    {
      "paths": [
        "M132.632 972.8c-14.66 0.036-29.058-3.804-41.674-11.105-12.616-7.306-22.983-17.807-30.006-30.397-6.107-11.32-9.298-23.926-9.298-36.731 0-12.8 3.192-25.405 9.298-36.726l175.543-345.841-176.518-345.839c-6.107-11.322-9.298-23.929-9.298-36.73s3.191-25.409 9.298-36.73c10.406-18.537 27.881-32.299 48.615-38.286s43.047-3.713 62.075 6.325l780.19 416.437c3.743 2.644 7.178 5.684 10.24 9.063 3.031 3.868 5.34 8.228 6.825 12.879 0.701 3.946 0.701 7.98 0 11.926v0c0.701 3.944 0.701 7.979 0 11.927-1.485 4.649-3.794 9.011-6.825 12.877-3.062 3.379-6.497 6.42-10.24 9.068v0l-780.19 418.345c-11.686 6.185-24.748 9.462-38.034 9.539v0zM307.199 551.593l-174.567 342.021 640.243-342.021h-465.675zM307.199 472.408h465.675l-640.243-342.023 174.567 342.023z"
      ],
      "tags": [
        "email-send"
      ],
      "defaultCode": 59780,
      "grid": 0
    },
    {
      "paths": [
        "M0 554.665c0-23.562 19.103-42.665 42.667-42.665h597.333c23.562 0 42.665 19.103 42.665 42.665v426.67c0 23.562-19.103 42.665-42.665 42.665h-597.333c-23.564 0-42.667-19.103-42.667-42.665v-426.67zM85.334 597.335v341.33h512.002v-341.33h-512.002z",
        "M318.72 830.848l-298.667-186.665 45.226-72.366 276.054 172.534 276.052-172.534 45.23 72.366-298.669 186.665c-13.836 8.648-31.391 8.648-45.226 0z",
        "M896 533.335c58.911 0 106.67-47.758 106.67-106.669s-47.759-106.666-106.67-106.666c-58.911 0-106.665 47.756-106.665 106.666s47.754 106.669 106.665 106.669z",
        "M896 234.666c58.911 0 106.67-47.756 106.67-106.666s-47.759-106.667-106.67-106.667c-58.911 0-106.665 47.756-106.665 106.667s47.754 106.666 106.665 106.666z",
        "M597.335 383.999c58.911 0 106.665-47.756 106.665-106.666s-47.754-106.667-106.665-106.667c-58.911 0-106.668 47.756-106.668 106.667s47.757 106.666 106.668 106.666z",
        "M578.253 239.171l298.665-149.334 38.164 76.324-222.341 111.171 222.341 111.171-38.164 76.324-298.665-149.333c-14.454-7.227-23.588-22.002-23.588-38.162s9.134-30.935 23.588-38.162z"
      ],
      "tags": [
        "email-share--emails"
      ],
      "defaultCode": 59781,
      "grid": 0
    },
    {
      "paths": [
        "M768 511.999c-40.771 0.026-80.082-15.194-110.208-42.667h67.543v-85.333h-213.335v213.336h85.335v-67.927c28.298 26.696 62.454 46.392 99.732 57.518s76.646 13.373 114.949 6.554c38.303-6.815 74.476-22.508 105.626-45.814s56.412-53.581 73.759-88.402l-76.329-38.144c-13.573 27.379-34.545 50.406-60.544 66.469-25.994 16.063-55.972 24.519-86.528 24.411zM938.665 85.332v67.926c-28.298-26.695-62.454-46.394-99.732-57.521s-76.646-13.37-114.949-6.553c-38.303 6.818-74.476 22.508-105.626 45.814s-56.412 53.582-73.759 88.403l76.329 38.144c11.32-22.695 27.74-42.458 47.98-57.739s43.745-25.665 68.675-30.337c24.924-4.671 50.596-3.503 74.993 3.414 24.402 6.916 46.863 19.392 65.633 36.449h-67.543v85.334h213.335v-213.334h-85.335zM597.335 938.665h-512.002v-291.241l228.224 195.625c7.728 6.61 17.564 10.245 27.733 10.245s20.005-3.635 27.734-10.245l170.665-146.258-55.465-64.814-142.89 122.496-183.467-157.138h226.134v-85.336h-341.333c-11.316 0-22.168 4.496-30.17 12.498-8.002 7.997-12.497 18.852-12.497 30.167v426.67c0 11.315 4.495 22.164 12.497 30.167s18.854 12.498 30.17 12.498h597.333c11.315 0 22.17-4.495 30.172-12.498 7.997-8.003 12.493-18.852 12.493-30.167v-256h-85.33v213.33z"
      ],
      "tags": [
        "email-sync-refresh--emails"
      ],
      "defaultCode": 59782,
      "grid": 0
    },
    {
      "paths": [
        "M386.262 426.666c-47.129 0-85.334 38.205-85.334 85.334 0 47.13 38.205 85.336 85.334 85.336s85.334-38.205 85.334-85.336c0-47.128-38.205-85.334-85.334-85.334zM215.596 511.999c0-94.257 76.41-170.666 170.666-170.666s170.666 76.41 170.666 170.666c0 94.255-76.409 170.665-170.666 170.665s-170.666-76.411-170.666-170.665z",
        "M940.928 343.467c-0.108-28.508-7.352-56.534-21.079-81.521s-33.49-46.137-57.492-61.521c-23.997-15.384-51.471-24.51-79.908-26.546-28.431-2.036-56.924 3.083-82.872 14.89s-48.522 29.926-65.669 52.702c-17.142 22.776-28.308 49.484-32.476 77.686s-1.208 56.998 8.617 83.76c9.82 26.762 26.194 50.637 47.616 69.445 11.587 10.35 20.854 23.033 27.192 37.218s9.605 29.55 9.585 45.084h151.68c-0.010-15.534 3.261-30.894 9.6-45.079 6.333-14.184 15.601-26.868 27.182-37.223 18.263-16.137 32.881-35.977 42.89-58.201 10.004-22.224 15.16-46.323 15.135-70.695v0z",
        "M770.263-42.667c23.562 0 42.665 19.103 42.665 42.667v85.334c0 23.564-19.103 42.666-42.665 42.666-23.567 0-42.67-19.103-42.67-42.666v-85.334c0-23.564 19.103-42.667 42.67-42.667zM513.828 63.568c16.666-16.663 43.679-16.662 60.344 0l60.329 60.33c16.66 16.663 16.66 43.678 0 60.34s-43.679 16.663-60.339 0l-60.334-60.33c-16.66-16.663-16.66-43.678 0-60.34zM1026.734 63.568c16.666 16.662 16.666 43.677 0 60.34l-60.329 60.33c-16.66 16.663-43.679 16.663-60.339 0-16.666-16.662-16.666-43.677 0-60.34l60.329-60.33c16.66-16.662 43.679-16.663 60.339 0zM661.975 682.665c0-23.562 19.103-42.665 42.665-42.665h131.287c23.562 0 42.665 19.103 42.665 42.665 0 23.567-19.103 42.67-42.665 42.67h-131.287c-23.562 0-42.665-19.103-42.665-42.67zM161.553 789.427c67.473-41.892 145.311-64.087 224.73-64.087s157.257 22.195 224.728 64.087c67.476 41.887 121.897 101.801 157.128 172.979 6.543 13.225 5.791 28.892-1.992 41.431s-21.494 20.163-36.25 20.163h-687.23c-14.757 0-28.466-7.624-36.249-20.163s-8.536-28.206-1.99-41.431c35.23-71.178 89.652-131.092 157.125-172.979zM386.282 810.67c-63.513 0-125.761 17.756-179.721 51.251-33.126 20.567-62.318 46.566-86.44 76.744h532.32c-24.12-30.177-53.315-56.177-86.436-76.744-53.96-33.495-116.21-51.251-179.723-51.251z"
      ],
      "tags": [
        "employment-employee-idea--work-office"
      ],
      "defaultCode": 59783,
      "grid": 0
    },
    {
      "paths": [
        "M423.656 192.634c32.431-14.755 68.041-21.153 103.581-18.609 35.538 2.544 69.873 13.949 99.871 33.174s54.702 45.656 71.864 76.882c17.157 31.226 26.22 66.253 26.363 101.882v0.14c0.020 30.419-6.426 60.495-18.913 88.233-12.472 27.7-30.679 52.435-53.422 72.572-0.031 0.031-0.061 0.056-0.092 0.082l-28.268-31.959 28.421 31.821c-0.020 0.020-0.041 0.036-0.061 0.056-7.071 6.333-12.728 14.080-16.599 22.748-3.881 8.689-5.883 18.104-5.873 27.622 0.015 11.325-4.475 22.19-12.477 30.203-8.003 8.018-18.862 12.518-30.188 12.518h-151.724c-11.331 0-22.196-4.506-30.2-12.529-8.004-8.018-12.489-18.893-12.467-30.223 0.018-9.508-1.978-18.918-5.858-27.602-3.863-8.643-9.504-16.374-16.556-22.687 0.048 0.041 0.095 0.082 0.142 0.123l28.16-32.051-28.4 31.841c0.033 0.026 0.066 0.056 0.098 0.087-26.697-23.496-47.098-53.297-59.344-86.688-12.269-33.451-15.963-69.442-10.747-104.688s19.176-68.624 40.608-97.088c21.431-28.464 49.65-51.106 82.081-65.861zM521.144 259.141c-21.325-1.526-42.692 2.312-62.15 11.165s-36.389 22.439-49.248 39.517c-12.859 17.078-21.235 37.105-24.365 58.252s-0.913 42.742 6.448 62.813c7.361 20.070 19.632 37.978 35.692 52.087l0.241 0.211-0.001 0.001c16.094 14.354 28.964 31.955 37.762 51.647 2.883 6.451 5.307 13.076 7.263 19.83h78.444c1.956-6.748 4.383-13.373 7.265-19.825 8.791-19.676 21.647-37.275 37.724-51.633l0.159-0.141v0.001c13.722-12.137 24.709-27.054 32.23-43.761 7.511-16.685 11.397-34.774 11.392-53.070-0.097-21.354-5.535-42.346-15.816-61.062-10.296-18.736-25.119-34.595-43.121-46.13-17.997-11.534-38.6-18.377-59.919-19.904zM577.623 810.665h-131.244v-85.33h131.244v85.33z",
        "M175.999 853.335c58.91 0 106.666-47.759 106.666-106.67s-47.756-106.665-106.666-106.665c-58.91 0-106.666 47.754-106.666 106.665s47.756 106.67 106.666 106.67z",
        "M352 1024c-8.15-71.767-83.754-128-176-128s-167.851 56.233-176 128h352z",
        "M848 853.335c58.911 0 106.665-47.759 106.665-106.67s-47.754-106.665-106.665-106.665c-58.911 0-106.665 47.754-106.665 106.665s47.754 106.67 106.665 106.67z",
        "M1024 1024c-8.151-71.767-83.753-128-176-128s-167.849 56.233-176 128h352z",
        "M512-42.667c23.562 0 42.665 19.103 42.665 42.667v85.334c0 23.564-19.103 42.666-42.665 42.666-23.564 0-42.666-19.103-42.666-42.666v-85.334c0-23.564 19.102-42.667 42.666-42.667zM210.299 82.299c16.663-16.663 43.678-16.663 60.34 0l60.331 60.33c16.662 16.663 16.662 43.678 0 60.34s-43.678 16.662-60.34 0l-60.33-60.331c-16.663-16.663-16.663-43.677 0-60.34zM813.701 82.299c16.66 16.663 16.66 43.677 0 60.34l-60.329 60.331c-16.666 16.662-43.679 16.662-60.344 0-16.66-16.663-16.66-43.678 0-60.34l60.334-60.33c16.66-16.663 43.679-16.663 60.339 0zM213.334 426.666h-85.334v-85.333h85.334v85.333zM768 383.999c0-23.564 19.103-42.666 42.665-42.666h85.335c23.562 0 42.665 19.102 42.665 42.666s-19.103 42.666-42.665 42.666h-85.335c-23.562 0-42.665-19.102-42.665-42.666z"
      ],
      "tags": [
        "employment-employee-idea-brainstorm--work-office"
      ],
      "defaultCode": 59784,
      "grid": 0
    },
    {
      "paths": [
        "M294.656 383.999h-294.656v-298.666l294.656 298.666z",
        "M682.634 121.246c-89.626-39.159-189.981-46.338-284.265-20.334s-176.774 83.611-233.654 163.175l-69.418-49.627c68.256-95.477 167.243-164.606 280.385-195.81s233.569-22.59 341.119 24.4c107.551 46.991 195.686 129.505 249.661 233.725 53.97 104.221 70.497 223.82 46.812 338.772-23.685 114.949-86.144 218.276-176.916 292.669-90.778 74.399-204.355 115.348-321.72 115.999-117.365 0.65-231.389-39.045-322.98-112.435-91.591-73.385-155.188-176.015-180.142-290.698l83.382-18.145c20.795 95.57 73.793 181.094 150.119 242.253s171.346 94.234 269.151 93.691c97.802-0.538 192.451-34.662 268.099-96.66 75.643-61.998 127.693-148.101 147.43-243.896 19.738-95.791 5.965-195.457-39.009-282.307-44.979-86.85-118.426-155.612-208.051-194.77z",
        "M511.999 341.334c-47.128 0-85.334 38.205-85.334 85.333s38.205 85.334 85.334 85.334c47.13 0 85.336-38.205 85.336-85.334s-38.205-85.333-85.336-85.333zM341.333 426.666c0-94.257 76.41-170.666 170.666-170.666 94.255 0 170.665 76.41 170.665 170.666 0 94.258-76.411 170.669-170.665 170.669-94.257 0-170.666-76.411-170.666-170.669z",
        "M125.929 798.152c70.442-97.833 221.135-158.152 386.071-158.152s315.628 60.319 386.068 158.152l-69.248 49.864c-48.512-67.374-167.388-122.68-316.82-122.68s-268.308 55.306-316.821 122.68l-69.25-49.864z"
      ],
      "tags": [
        "employment-employee-previous--work-office"
      ],
      "defaultCode": 59785,
      "grid": 0
    },
    {
      "paths": [
        "M426.667 810.665c212.079 0 383.998-171.919 383.998-383.998 0-212.077-171.919-384-383.998-384-212.077 0-384 171.923-384 384 0 212.079 171.923 383.998 384 383.998z",
        "M698.199 698.199l283.136 283.136",
        "M426.667 469.335c70.693 0 127.998-57.308 127.998-128s-57.305-128-127.998-128c-70.692 0-128 57.308-128 128s57.308 128 128 128z",
        "M716.8 678.4c-86.38-55.537-187.479-83.784-290.134-81.065-102.527-2.647-203.48 25.6-289.75 81.065"
      ],
      "attrs": [
        {
          "fill": "none",
          "strokeLinejoin": "miter",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "10",
          "strokeWidth": 85.333504
        },
        {
          "fill": "none",
          "strokeLinejoin": "miter",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "10",
          "strokeWidth": 85.333504
        },
        {
          "fill": "none",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        },
        {
          "fill": "none",
          "strokeLinejoin": "round",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "4",
          "strokeWidth": 85.333504
        }
      ],
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "s": 0
          },
          {
            "s": 0
          },
          {
            "s": 0
          },
          {
            "s": 0
          }
        ]
      },
      "tags": [
        "employment-recuit-search--work-office"
      ],
      "defaultCode": 59786,
      "grid": 0
    },
    {
      "paths": [
        "M554.665 0h426.67c23.562 0 42.665 19.103 42.665 42.667v426.667h-85.335v-323.66l-792.992 792.992h280.993v85.335h-384c-23.564 0-42.667-19.103-42.667-42.665v-384h85.334v280.991l792.992-792.992h-323.661v-85.334z"
      ],
      "tags": [
        "expand-diagonal-1--interface-essential"
      ],
      "defaultCode": 59787,
      "grid": 0
    },
    {
      "paths": [
        "M0.001 42.667c0-23.564 19.103-42.667 42.667-42.667h384v85.334h-280.994l792.991 792.992v-323.661h85.335v426.67c0 23.562-19.103 42.665-42.665 42.665h-426.67v-85.335h323.661l-792.992-792.992v280.993h-85.333v-384z"
      ],
      "tags": [
        "expand-diagonal-2--interface-essential"
      ],
      "defaultCode": 59788,
      "grid": 0
    },
    {
      "paths": [
        "M40.406-2.261h241.365v85.333h-138.359l314.193 314.193-60.34 60.34-314.192-314.193v138.359h-85.333v-241.365c0-23.564 19.103-42.667 42.667-42.667zM880.589 940.928l-312.658-312.658 60.339-60.339 312.658 312.658v-138.358h85.335v241.362c0 23.567-19.103 42.67-42.67 42.67h-241.362v-85.335h138.358z"
      ],
      "tags": [
        "expand-diagonal-4--interface-essential"
      ],
      "defaultCode": 59789,
      "grid": 0
    },
    {
      "paths": [
        "M481.831 12.497c16.662-16.662 43.676-16.662 60.341 0l298.665 298.667-60.339 60.34-268.498-268.497-268.496 268.497-60.34-60.34 298.667-298.667zM481.831 1011.502l-298.667-298.665 60.34-60.339 268.496 268.498 268.498-268.498 60.339 60.339-298.665 298.665c-16.666 16.666-43.679 16.666-60.341 0z"
      ],
      "tags": [
        "expand-vertical-7--interface-essential"
      ],
      "defaultCode": 59790,
      "grid": 0
    },
    {
      "paths": [
        "M85.334 85.334h170.666v-85.334h-213.333c-11.316 0-22.168 4.495-30.17 12.497s-12.497 18.854-12.497 30.17v213.333h85.334v-170.666zM981.335 0h-213.335v85.334h170.665v170.666h85.335v-213.333c0-11.316-4.495-22.168-12.498-30.17s-18.852-12.497-30.167-12.497v0zM85.334 768h-85.334v213.335c0 11.315 4.495 22.164 12.497 30.167s18.854 12.498 30.17 12.498h213.333v-85.335h-170.666v-170.665zM938.665 938.665h-170.665v85.335h213.335c11.315 0 22.164-4.495 30.167-12.498s12.498-18.852 12.498-30.167v-213.335h-85.335v170.665zM842.88 699.136c-98.463-65.705-214.031-101.1-332.404-101.796-118.371-0.696-234.35 33.331-333.58 97.869l46.592 71.47c85.231-55.398 184.828-84.603 286.478-84.004 101.648 0.599 200.894 30.976 285.467 87.373l47.447-70.912z",
        "M720.215 383.999c0-42.193-12.513-83.439-35.953-118.521-23.444-35.083-56.76-62.426-95.744-78.573-38.979-16.146-81.875-20.371-123.257-12.14s-79.395 28.549-109.23 58.384c-29.835 29.835-50.153 67.848-58.385 109.231s-4.007 84.277 12.14 123.258c16.146 38.981 43.49 72.3 78.573 95.739 35.082 23.444 76.328 35.953 118.522 35.953 56.56-0.067 110.781-22.564 150.773-62.556 39.992-39.993 62.49-94.216 62.561-150.775v0zM506.881 511.999c-25.316 0-50.064-7.507-71.113-21.572s-37.455-34.056-47.143-57.445c-9.688-23.389-12.223-49.125-7.284-73.955s17.13-47.637 35.031-65.539c17.901-17.901 40.709-30.092 65.538-35.031s50.566-2.404 73.954 7.284c23.388 9.688 43.382 26.094 57.446 47.144s21.571 45.797 21.571 71.113c0 33.948-13.486 66.505-37.489 90.51-24.008 24.005-56.566 37.49-90.511 37.49z"
      ],
      "tags": [
        "face-id-user--interface-essential"
      ],
      "defaultCode": 59791,
      "grid": 0
    },
    {
      "paths": [
        "M447.999 383.999h-42.666c-5.658 0-11.084-2.247-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.248-11.084 6.248-15.085s9.427-6.248 15.085-6.248h149.332v-85.334h-85.332v-85.333h-85.334v87.51c-25.877 5.308-48.864 20.029-64.509 41.314s-22.837 47.617-20.182 73.898c2.655 26.282 14.968 50.644 34.555 68.369s45.054 27.551 71.47 27.576h42.666c5.658 0 11.084 2.248 15.085 6.248s6.248 9.427 6.248 15.085c0 5.658-2.248 11.084-6.248 15.085s-9.427 6.248-15.085 6.248h-149.333v85.336h85.333v85.33h85.334v-87.506c25.877-5.309 48.862-20.029 64.509-41.318 15.647-21.284 22.835-47.614 20.183-73.896-2.657-26.282-14.971-50.644-34.555-68.368-19.588-17.724-45.054-27.551-71.471-27.576v0zM1024 682.665h-170.665v-255.998l-298.67 341.334h170.67v256l298.665-341.335z",
        "M85.333 426.666c-0.004-83.92 30.908-164.901 86.832-227.473s132.938-102.35 216.332-111.734c83.395-9.384 167.326 12.282 235.754 60.86s116.567 120.664 135.214 202.486l83.246-18.944c-17.848-78.31-57.436-149.992-114.212-206.803s-128.435-96.442-206.735-114.335c-78.299-17.894-160.059-13.323-235.876 13.186s-142.612 73.879-192.703 136.664c-50.091 62.785-81.443 138.433-90.45 218.244s4.695 160.545 39.533 232.916c34.837 72.366 89.394 133.432 157.396 176.174s146.686 65.418 227.004 65.428v-85.335c-90.496-0.102-177.256-36.096-241.247-100.086s-99.985-150.753-100.087-241.248v0z"
      ],
      "tags": [
        "fast-payment--business-products-1"
      ],
      "defaultCode": 59792,
      "grid": 0
    },
    {
      "paths": [
        "M448.001 383.999h-42.666c-5.658 0-11.084-2.247-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.248-11.084 6.248-15.085s9.427-6.248 15.085-6.248h149.331v-85.334h-85.331v-85.333h-85.334v87.51c-25.877 5.308-48.864 20.029-64.509 41.314s-22.837 47.617-20.182 73.898c2.655 26.282 14.968 50.644 34.555 68.369s45.053 27.551 71.47 27.576h42.666c5.658 0 11.084 2.248 15.085 6.248s6.248 9.427 6.248 15.085c0 5.658-2.248 11.084-6.248 15.085s-9.427 6.248-15.085 6.248h-149.334v85.336h85.334v85.33h85.334v-87.506c25.877-5.309 48.861-20.029 64.508-41.318 15.647-21.284 22.84-47.614 20.183-73.896s-14.966-50.644-34.555-68.368c-19.587-17.724-45.053-27.551-71.47-27.576v0zM1024 682.665h-170.665v-255.998l-298.67 341.334h170.67v256l298.665-341.335z",
        "M85.334 426.666c-0.004-83.92 30.908-164.901 86.832-227.473s132.938-102.35 216.332-111.734c83.395-9.384 167.325 12.282 235.754 60.86 68.434 48.578 116.567 120.664 135.214 202.486l83.246-18.944c-17.848-78.31-57.436-149.992-114.212-206.803s-128.435-96.442-206.735-114.335c-78.299-17.894-160.059-13.323-235.876 13.186s-142.612 73.879-192.703 136.664c-50.091 62.785-81.443 138.433-90.45 218.244s4.695 160.545 39.533 232.916c34.837 72.366 89.394 133.432 157.396 176.174s146.686 65.418 227.004 65.428v-85.335c-90.496-0.102-177.256-36.096-241.247-100.086s-99.984-150.753-100.086-241.248v0z"
      ],
      "tags": [
        "fast-payment--business-products"
      ],
      "defaultCode": 59793,
      "grid": 0
    },
    {
      "paths": [
        "M128.001 0c-23.564 0-42.666 19.103-42.666 42.667v341.333h85.333v-298.666h469.333v255.999h256v42.668h85.335v-85.334c0-11.316-4.495-22.168-12.498-30.17l-256-256c-8.003-8.002-18.852-12.497-30.172-12.497h-554.664zM892.559 469.334h109.281l-136.535 170.666 136.535 170.665h-109.281l-81.894-102.364v102.364h-85.33v-341.332l85.33 0.001v102.366l81.894-102.366zM896 896v42.665h-725.333v-42.665h-85.333v85.335c0 23.562 19.102 42.665 42.666 42.665h810.664c23.567 0 42.67-19.103 42.67-42.665v-85.335h-85.335zM426.667 469.334c-23.564 0-42.666 19.102-42.666 42.666v298.665h85.334v-128h128.001c23.562 0 42.665-19.103 42.665-42.665v-128c0-23.564-19.103-42.666-42.665-42.666h-170.668zM469.334 554.665v42.67h85.331v-42.67h-85.331zM42.667 511.999c0-23.564 19.103-42.666 42.667-42.666h170.666c23.564 0 42.666 19.102 42.666 42.666v298.666h-85.333v-128h-85.334v128h-85.333v-298.666zM128.001 597.33h85.334v-42.665h-85.334v42.665z"
      ],
      "tags": [
        "file-apk--programing-apps-websites"
      ],
      "defaultCode": 59794,
      "grid": 0
    },
    {
      "paths": [
        "M85.333 42.667c0-23.564 19.102-42.667 42.666-42.667h554.665c11.315 0 22.17 4.495 30.172 12.497l256 256c8.003 8.002 12.498 18.854 12.498 30.17v682.669c0 23.562-19.103 42.665-42.67 42.665h-810.665c-23.564 0-42.666-19.103-42.666-42.665v-938.668zM170.666 85.334v853.331h725.334v-622.325l-231.009-231.006h-494.325z",
        "M640 42.666v298.667h298.665l-298.665-298.667z",
        "M311.162 609.833l128-128.002 60.34 60.341-97.83 97.828 97.83 97.833-60.34 60.339-128-128c-16.663-16.666-16.663-43.679 0-60.339zM664.991 640l-97.828-97.828 60.339-60.341 128 128.002c16.66 16.66 16.66 43.674 0 60.339l-128 128-60.339-60.339 97.828-97.833z"
      ],
      "tags": [
        "file-code--programing-apps-websites"
      ],
      "defaultCode": 59795,
      "grid": 0
    },
    {
      "paths": [
        "M931.456 119.809c-5.407-10.394-13.558-19.104-23.572-25.183s-21.504-9.293-33.219-9.292h-682.665c-11.616-0.005-23.015 3.153-32.974 9.133s-18.102 14.559-23.557 24.815c-5.454 10.256-8.015 21.804-7.407 33.404s4.362 22.817 10.86 32.446l245.078 382.037v328.832c-0.006 6.979 1.701 13.85 4.968 20.014s7.998 11.438 13.776 15.35c5.778 3.912 12.427 6.349 19.365 7.091 6.938 0.748 13.953-0.22 20.429-2.816l213.334-85.335c7.916-3.174 14.7-8.643 19.476-15.708s7.327-15.401 7.316-23.931v-243.497l244.439-381.141c6.707-9.586 10.66-20.827 11.428-32.501s-1.679-23.336-7.076-33.717v0zM604.073 531.625c-4.403 6.876-6.743 14.874-6.738 23.040v227.118l-128.002 51.2v-278.318c0.004-8.166-2.336-16.164-6.742-23.040l-231.552-360.958h604.585l-231.552 360.958z"
      ],
      "tags": [
        "filter-3--interface-essential"
      ],
      "defaultCode": 59796,
      "grid": 0
    },
    {
      "paths": [
        "M580.163 2.123c17.526 5.746 29.373 22.101 29.373 40.543v298.667h286.464c16.087 0 30.802 9.047 38.067 23.398s5.842 31.568-3.681 44.531l-438.872 597.335c-10.919 14.858-30.152 21.023-47.677 15.278s-29.374-22.098-29.374-40.54v-298.67h-286.464c-16.085 0-30.803-9.047-38.068-23.398s-5.84-31.565 3.684-44.529l438.87-597.334c10.921-14.862 30.152-21.026 47.677-15.281zM212.292 597.335h244.838c23.564 0 42.666 19.103 42.666 42.665v211.2l311.912-424.534h-244.838c-23.567 0-42.67-19.103-42.67-42.666v-211.199l-311.909 424.535z"
      ],
      "tags": [
        "flash-enable-allow-1--interface-essential"
      ],
      "defaultCode": 59797,
      "grid": 0
    },
    {
      "paths": [
        "M457.13 981.33v-341.33h-329.13l438.871-597.334v341.333h329.129l-438.87 597.331z"
      ],
      "tags": [
        "flash-enable-allow-2--interface-essential"
      ],
      "defaultCode": 59798,
      "grid": 0
    },
    {
      "paths": [
        "M85.334 42.667c0-23.564 19.103-42.667 42.667-42.667h511.999c11.315 0 22.17 4.495 30.172 12.497l256 256c7.997 8.002 12.493 18.854 12.493 30.17v682.669c0 23.562-19.103 42.665-42.665 42.665h-767.999c-23.564 0-42.667-19.103-42.667-42.665v-938.668zM170.667 85.334v853.331h682.668v-622.325l-231.009-231.006h-451.659z",
        "M554.665 341.334h-85.331v-85.334h128.002c23.562 0 42.665 19.103 42.665 42.666v426.669c0 23.562-19.103 42.665-42.665 42.665h-128.002v-85.335h85.331v-341.331z",
        "M256 234.665h128v128h-128v-128zM256 447.999h128v128.001h-128v-128.001zM256 661.33h128v128h-128v-128z",
        "M725.335 554.67h-128v-85.336h128v85.336z"
      ],
      "tags": [
        "flowchart"
      ],
      "defaultCode": 59799,
      "grid": 0
    },
    {
      "paths": [
        "M546.135 426.666h-68.269v35.882c-20.692 4.256-39.071 16.035-51.579 33.060-12.508 17.026-18.256 38.085-16.133 59.102s11.969 40.504 27.629 54.682c15.661 14.177 36.024 22.042 57.149 22.072h34.131c4.526 0 8.868 1.797 12.068 5.002 3.2 3.2 5.002 7.542 5.002 12.068s-1.802 8.868-5.002 12.068c-3.2 3.2-7.542 4.997-12.068 4.997h-119.465v68.265h68.266v34.135h68.269v-35.84c20.736-4.214 39.173-15.98 51.722-33.014 12.549-17.039 18.324-38.134 16.195-59.187-2.125-21.059-12.001-40.571-27.704-54.753s-36.122-22.026-57.283-22.006h-34.131c-4.527 0-8.867-1.797-12.068-4.997s-4.999-7.542-4.999-12.068c0-4.526 1.798-8.868 4.999-12.068 3.201-3.205 7.542-5.002 12.068-5.002h119.466v-68.265h-68.265v-34.134z",
        "M853.335 298.666h-352.002l-70.4-93.866c-7.965-10.581-18.275-19.171-30.12-25.093s-24.903-9.017-38.147-9.040h-192c-22.631 0-44.337 8.99-60.34 24.993s-24.993 37.708-24.993 60.34v554.665c0 22.636 8.99 44.339 24.993 60.339 16.003 16.005 37.708 24.996 60.34 24.996h682.669c22.63 0 44.334-8.991 60.339-24.996 16-16 24.991-37.704 24.991-60.339v-426.665c0-22.632-8.991-44.337-24.991-60.34-16.005-16.003-37.709-24.993-60.339-24.993v0zM170.666 810.665v-554.665h192l70.4 93.867c7.965 10.581 18.275 19.17 30.12 25.093s24.903 9.017 38.147 9.040h352.002v426.665h-682.669z"
      ],
      "tags": [
        "folder-money-fund---files-&-folders"
      ],
      "defaultCode": 59800,
      "grid": 0
    },
    {
      "paths": [
        "M512 149.333c59.54-0.115 118.185 14.546 170.665 42.667v-93.867c-54.323-22.492-112.553-34.041-171.349-33.986-58.797 0.055-117.005 11.713-171.288 34.306s-103.572 55.677-145.046 97.355c-41.473 41.678-74.312 91.132-96.636 145.525h-77.013l128 170.667 128-170.667h-84.267c30.786-57.89 76.718-106.33 132.891-140.146s120.477-51.739 186.043-51.854v0zM469.334 469.333h85.331v85.332h-85.331v-85.332zM597.335 316.672v109.994h109.993c-21.514-49.202-60.795-88.48-109.993-109.994v0z",
        "M426.666 426.667v-109.994c-49.202 21.514-88.48 60.792-109.994 109.994h109.994zM597.335 554.665h123.73c5.75-28.15 5.75-57.177 0-85.331h-123.73v85.331zM554.665 302.934c-28.155-5.747-57.178-5.747-85.331 0v123.734h85.331v-123.734zM426.666 469.334h-123.733c-5.747 28.154-5.747 57.182 0 85.331h123.733v-85.331zM597.335 707.287c49.162-21.55 88.428-60.795 109.993-109.952h-109.993v109.952zM469.334 721.065c28.154 5.75 57.177 5.75 85.331 0v-123.73h-85.331v123.73zM426.666 707.287v-109.952h-109.994c21.565 49.157 60.829 88.402 109.994 109.952v0z",
        "M874.665 512l-128 170.665h84.27c-22.246 42.045-52.582 79.283-89.267 109.568-36.68 30.28-78.986 53.012-124.488 66.893-45.496 13.875-93.292 18.627-140.631 13.967-47.34-4.654-93.292-18.621-135.216-41.093v93.865c54.337 22.528 112.585 34.099 171.404 34.063 58.824-0.036 117.053-11.689 171.361-34.284s103.619-55.69 145.111-97.388c41.487-41.692 74.332-91.172 96.655-145.592h76.8l-128-170.665zM874.665 128h149.335v-85.333h-85.335v-42.667h-85.33v44.8c-25.923 5.264-48.968 19.972-64.655 41.27s-22.907 47.665-20.244 73.983c2.657 26.318 14.996 50.71 34.632 68.44 19.63 17.73 45.148 27.533 71.598 27.507h42.67c5.658 0 11.085 2.248 15.084 6.248s6.246 9.427 6.246 15.085c0 5.658-2.248 11.084-6.246 15.085s-9.426 6.248-15.084 6.248h-149.335v85.334h85.335v42.666h85.33v-44.842c25.876-5.308 48.865-20.030 64.512-41.314s22.835-47.617 20.183-73.899c-2.657-26.282-14.971-50.644-34.555-68.368-19.589-17.725-45.056-27.551-71.47-27.576h-42.67c-5.658 0-11.085-2.248-15.084-6.248s-6.246-9.427-6.246-15.085c0-5.658 2.248-11.084 6.246-15.085s9.426-6.248 15.084-6.248v0zM170.666 597.335h-85.333v44.8c-25.924 5.263-48.966 19.973-64.655 41.267-15.689 21.299-22.904 47.667-20.246 73.984s15.001 50.708 34.632 68.439c19.631 17.731 45.15 27.535 71.602 27.51h42.667c5.658 0 11.084 2.248 15.085 6.246s6.248 9.426 6.248 15.084c0 5.658-2.248 11.085-6.248 15.089-4.001 3.999-9.427 6.246-15.085 6.246h-149.333v85.335h85.333v42.665h85.333v-44.841c25.877-5.309 48.864-20.029 64.509-41.313 15.646-21.289 22.837-47.621 20.182-73.902s-14.968-50.642-34.555-68.367c-19.587-17.725-45.053-27.551-71.469-27.576h-42.667c-5.658 0-11.084-2.248-15.085-6.246-4.001-4.004-6.248-9.431-6.248-15.089s2.248-11.085 6.248-15.084c4.001-3.999 9.427-6.246 15.085-6.246h149.334v-85.335h-85.334v-42.665z"
      ],
      "tags": [
        "global-exchange-rate-transaction-2--business-products"
      ],
      "defaultCode": 59801,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M341.334 341.335v-256h85.334v238.327l72.837 72.837c12.337 12.337 15.922 30.941 9.047 46.977l-128 298.669c-4.994 11.648-14.909 20.475-27.059 24.090-12.151 3.61-25.278 1.633-35.825-5.396l-128-85.335c-11.87-7.916-18.999-21.238-18.999-35.502v-52.019l-138.348-34.586 20.696-82.787 170.666 42.666c18.994 4.746 32.319 21.816 32.319 41.395v62.495l66.322 44.216 96.415-224.97-64.907-64.907c-8.002-8.002-12.497-18.854-12.497-30.17zM726.61 586.988c4.746-18.995 21.811-32.317 41.39-32.317h213.335v85.33h-180.019l-34.591 138.348c-3.538 14.152-14.060 25.518-27.899 30.131l-87.521 29.174 29.174 87.521-80.957 26.988-42.665-128c-7.45-22.354 4.628-46.52 26.982-53.97l105.784-35.261 36.987-147.942z"
      ],
      "tags": [
        "globe-1--maps-navigation"
      ],
      "defaultCode": 59802,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M431.418 194.712c-28.782 79.15-47.418 191.323-47.418 317.288 0 125.967 18.637 238.136 47.418 317.286 14.455 39.752 30.659 68.92 46.504 87.347 15.965 18.57 27.627 22.031 34.077 22.031 6.452 0 18.115-3.461 34.079-22.031 15.846-18.427 32.046-47.596 46.505-87.347 28.78-79.15 47.416-191.319 47.416-317.286 0-125.965-18.637-238.138-47.416-317.288-14.459-39.75-30.659-68.916-46.505-87.348-15.964-18.569-27.628-22.031-34.079-22.031-6.45 0-18.113 3.462-34.077 22.031-15.846 18.431-32.050 47.598-46.504 87.348zM413.215 51.734c24.871-28.93 58.106-51.734 98.784-51.734 40.679 0 73.913 22.804 98.786 51.734 24.991 29.068 45.563 68.634 61.993 113.816 32.988 90.715 52.557 213.21 52.557 346.45 0 133.238-19.569 255.734-52.557 346.45-16.43 45.184-37.002 84.746-61.993 113.818-24.873 28.928-58.107 51.732-98.786 51.732-40.678 0-73.913-22.804-98.784-51.732-24.991-29.071-45.563-68.634-61.993-113.818-32.987-90.716-52.556-213.212-52.556-346.45 0-133.24 19.569-255.735 52.556-346.45 16.43-45.182 37.002-84.748 61.993-113.816z",
        "M42.666 341.332c0-23.564 19.102-42.667 42.667-42.667h853.332c23.567 0 42.67 19.103 42.67 42.667s-19.103 42.666-42.67 42.666h-853.332c-23.564 0-42.667-19.103-42.667-42.666zM938.665 725.33h-853.332v-85.33h853.332v85.33z"
      ],
      "tags": [
        "globe-wireframe--maps-navigation"
      ],
      "defaultCode": 59803,
      "grid": 0
    },
    {
      "paths": [
        "M512 106.664c-70.692 0-128 57.308-128 128s57.308 128 128 128c70.692 0 128-57.308 128-128s-57.308-128-128-128zM298.666 234.664c0-117.82 95.513-213.333 213.334-213.333s213.335 95.513 213.335 213.333c0 117.821-95.514 213.334-213.335 213.334s-213.334-95.513-213.334-213.334z",
        "M213.334 661.335c-70.693 0-128 57.308-128 128s57.307 128 128 128c70.692 0 128-57.308 128-128s-57.308-128-128-128zM0 789.335c0-117.821 95.513-213.335 213.334-213.335s213.333 95.514 213.333 213.335c0 117.821-95.513 213.33-213.333 213.33s-213.334-95.508-213.334-213.33z",
        "M810.665 661.335c-70.692 0-128 57.308-128 128s57.308 128 128 128c70.692 0 128-57.308 128-128s-57.308-128-128-128zM597.335 789.335c0-117.821 95.508-213.335 213.33-213.335s213.335 95.514 213.335 213.335c0 117.821-95.514 213.33-213.335 213.33s-213.33-95.508-213.33-213.33z",
        "M640 831.995h-256v-85.33h256v85.33z",
        "M405.952 368.743c20.206 12.124 26.758 38.332 14.634 58.538l-128 213.333c-12.124 20.209-38.332 26.757-58.538 14.633s-26.758-38.328-14.634-58.537l128-213.333c12.124-20.206 38.332-26.758 58.538-14.634zM618.051 368.743c20.204-12.124 46.413-5.572 58.537 14.634l128 213.333c12.124 20.209 5.571 46.413-14.638 58.537-20.204 12.124-46.413 5.576-58.537-14.633l-128-213.333c-12.124-20.206-5.571-46.415 14.638-58.538z"
      ],
      "tags": [
        "hierarchy-circle-triangle"
      ],
      "defaultCode": 59804,
      "grid": 0
    },
    {
      "paths": [
        "M901.632 640h-85.335v-42.665c0-33.951-13.486-66.504-37.489-90.51-24.003-24.005-56.561-37.49-90.511-37.49h-128v-85.334h85.335c11.315 0 22.17-4.495 30.172-12.497 7.997-8.002 12.493-18.854 12.493-30.17v-213.334c0-11.316-4.495-22.169-12.493-30.17-8.003-8.002-18.857-12.496-30.172-12.496h-255.999c-11.316 0-22.169 4.495-30.17 12.496s-12.497 18.854-12.497 30.17v213.334c0 11.316 4.495 22.168 12.497 30.17s18.854 12.497 30.17 12.497h85.333v85.334h-128c-33.948 0-66.505 13.486-90.509 37.49-24.005 24.007-37.491 56.56-37.491 90.51v42.665h-85.333c-11.316 0-22.169 4.495-30.17 12.498s-12.497 18.852-12.497 30.172v213.33c0 11.315 4.495 22.17 12.497 30.172s18.854 12.498 30.17 12.498h256c11.316 0 22.168-4.495 30.17-12.498s12.497-18.857 12.497-30.172v-213.33c0-11.32-4.495-22.17-12.497-30.172s-18.854-12.498-30.17-12.498h-85.334v-42.665c0-11.315 4.495-22.17 12.497-30.172 8.002-7.997 18.854-12.493 30.17-12.493h341.331c11.32 0 22.17 4.495 30.172 12.493 8.003 8.003 12.498 18.857 12.498 30.172v42.665h-85.335c-11.315 0-22.17 4.495-30.167 12.498-8.003 8.003-12.498 18.852-12.498 30.172v213.33c0 11.315 4.495 22.17 12.498 30.172 7.997 8.003 18.852 12.498 30.167 12.498h256c11.315 0 22.17-4.495 30.172-12.498 7.997-8.003 12.493-18.857 12.493-30.172v-213.33c0-11.32-4.495-22.17-12.493-30.172-8.003-8.003-18.857-12.498-30.172-12.498zM432.299 298.668v-128h170.668v128h-170.668zM346.966 853.335h-170.666v-128h170.666v128zM858.967 853.335h-170.67v-128h170.67v128z"
      ],
      "tags": [
        "hierarchy-square"
      ],
      "defaultCode": 59805,
      "grid": 0
    },
    {
      "paths": [
        "M213.334 896v-469.334h-85.334v511.998c0 23.567 19.103 42.67 42.666 42.67h682.669c23.562 0 42.665-19.103 42.665-42.67v-511.998h-85.335v469.334h-597.331z",
        "M481.831 55.163c16.662-16.663 43.675-16.663 60.341 0l469.33 469.335c12.206 12.201 15.857 30.551 9.252 46.495s-22.164 26.342-39.419 26.342h-128v-85.335h24.991l-366.326-366.327-366.326 366.327h24.994v85.335h-128c-17.257 0-32.815-10.399-39.419-26.342s-2.954-34.294 9.249-46.495l469.333-469.335z",
        "M512 597.335c33.946 0 66.504 13.481 90.511 37.489 24.003 24.003 37.489 56.561 37.489 90.511v213.33h-256v-213.33c0-33.951 13.486-66.509 37.49-90.511 24.005-24.008 56.562-37.489 90.51-37.489v0z"
      ],
      "tags": [
        "home-button"
      ],
      "defaultCode": 59806,
      "grid": 0
    },
    {
      "paths": [
        "M585.175 85.329c-16.133 0-31.606 6.406-43.013 17.809l-439.024 439.024c-11.403 11.407-17.809 26.88-17.809 43.013 0 16.128 6.402 31.59 17.8 43.003 0.003 0-0.003-0.005 0 0l36.592 36.547-60.304 60.375-36.608-36.567c-27.397-27.407-42.813-64.604-42.813-103.357 0-38.758 15.39-75.926 42.787-103.337l439.048-439.048c27.411-27.397 64.586-42.795 103.345-42.795 38.753 0 75.924 15.39 103.332 42.787l36.593 36.634-60.375 60.304-36.541-36.583c0-0.003 0.005 0.003 0 0-11.407-11.398-26.88-17.809-43.008-17.809zM555.003 408.657l365.87-365.867 60.339 60.34-365.87 365.867-60.339-60.34zM944.584 298.901l36.608 36.565c27.397 27.411 42.813 64.606 42.813 103.361s-15.391 75.922-42.788 103.335l-439.045 439.050c-27.412 27.397-64.59 42.793-103.345 42.793s-75.924-15.391-103.335-42.788l-36.591-36.634 60.375-60.303 36.54 36.582c0.005 0.005-0.005-0.005 0 0 11.408 11.392 26.887 17.807 43.011 17.807 16.127 0 31.595-6.4 43.003-17.797zM481.83 920.873l439.032-439.035c0.005-0.003 0 0.003 0 0 11.397-11.408 17.807-26.884 17.807-43.011 0-16.124-6.4-31.588-17.792-42.997-0.005-0.005 0.005 0.005 0 0l-36.598-36.554 60.303-60.375zM42.79 920.873l365.867-365.87 60.34 60.339-365.867 365.87-60.34-60.339z"
      ],
      "tags": [
        "hyperlink-1--interface-essential"
      ],
      "defaultCode": 59807,
      "grid": 0
    },
    {
      "paths": [
        "M529.495 636.16c-10.455 4.26-18.792 12.488-23.191 22.886-4.399 10.394-4.498 22.113-0.276 32.579 3.268 7.772 4.16 16.333 2.566 24.612s-5.605 15.898-11.526 21.898l-120.746 120.745c-7.925 7.936-17.336 14.228-27.696 18.524-10.359 4.291-21.464 6.502-32.678 6.502s-22.318-2.212-32.677-6.502c-10.359-4.296-19.771-10.588-27.696-18.524l-90.454-90.88c-7.934-7.926-14.228-17.336-18.523-27.694-4.294-10.363-6.504-21.463-6.504-32.681 0-11.213 2.21-22.318 6.504-32.676s10.589-19.768 18.523-27.694l120.746-120.32c6-5.924 13.619-9.933 21.896-11.525 8.277-1.597 16.841-0.707 24.611 2.565 10.467 4.296 22.214 4.265 32.656-0.097s18.724-12.691 23.024-23.158c4.3-10.467 4.265-22.214-0.095-32.656s-12.691-18.724-23.158-23.024c-23.391-9.695-49.133-12.235-73.967-7.299s-47.648 17.128-65.553 35.033l-120.746 120.747c-31.917 31.995-49.841 75.341-49.841 120.535 0 45.189 17.924 88.535 49.841 120.53l90.88 90.88c31.994 31.918 75.341 49.843 120.533 49.843s88.539-17.925 120.534-49.843l120.749-120.745c17.905-17.905 30.095-40.719 35.031-65.551 4.936-24.837 2.396-50.575-7.301-73.969-4.342-10.378-12.605-18.616-22.989-22.932-10.388-4.316-22.062-4.352-32.476-0.108v0z",
        "M331.095 692.905c7.994 7.946 18.808 12.411 30.080 12.411s22.086-4.465 30.080-12.411l334.081-331.945c6.989-8.162 10.644-18.661 10.23-29.4s-4.869-20.924-12.467-28.523c-7.598-7.599-17.787-12.050-28.524-12.465s-21.238 3.238-29.399 10.228l-334.081 331.945c-7.947 7.997-12.407 18.811-12.407 30.080 0 11.274 4.46 22.088 12.407 30.080z",
        "M919.47 194.986l-90.88-90.453c-31.995-31.917-75.346-49.841-120.535-49.841-45.194 0-88.54 17.924-120.535 49.841l-120.745 120.746c-24.011 23.982-37.516 56.517-37.546 90.454 0.011 16.842 3.346 33.516 9.814 49.066 4.3 10.467 12.582 18.798 23.024 23.158s22.189 4.395 32.656 0.095c10.467-4.3 18.799-12.582 23.156-23.024 4.362-10.442 4.398-22.189 0.097-32.656-2.243-5.262-3.405-10.921-3.415-16.64 0.046-11.193 4.49-21.92 12.375-29.867l120.745-120.746c7.926-7.934 17.336-14.228 27.699-18.523 10.358-4.294 21.463-6.504 32.676-6.504s22.318 2.21 32.676 6.504c10.363 4.295 19.773 10.589 27.699 18.523l90.45 90.88c7.936 7.925 14.228 17.336 18.524 27.696s6.502 21.464 6.502 32.678c0 11.214-2.207 22.318-6.502 32.677s-10.588 19.77-18.524 27.696l-120.745 119.894c-5.955 5.992-13.548 10.082-21.827 11.753s-16.87 0.847-24.678-2.367c-10.419-4.246-22.088-4.208-32.476 0.107s-18.652 12.558-22.994 22.931c-2.166 5.181-3.292 10.742-3.308 16.358s1.080 11.182 3.22 16.374c2.14 5.192 5.289 9.912 9.257 13.885 3.968 3.978 8.684 7.127 13.87 9.277 23.393 9.697 49.132 12.237 73.969 7.301 24.837-4.941 47.647-17.132 65.551-35.036l120.75-120.745c15.867-15.85 28.452-34.673 37.043-55.392 8.586-20.719 13.010-42.927 13.010-65.355s-4.424-44.637-13.010-65.355c-8.591-20.719-21.176-39.541-37.043-55.392v0z"
      ],
      "tags": [
        "hyperlink-2--interface-essential"
      ],
      "defaultCode": 59808,
      "grid": 0
    },
    {
      "paths": [
        "M586.665 191.999h-586.665v-85.333h586.665v85.333z",
        "M714.67 85.334c-35.348 0-64 28.654-64 64s28.652 64 64 64c35.343 0 64-28.654 64-64s-28.657-64-64-64zM565.335 149.334c0-82.474 66.857-149.334 149.335-149.334 82.473 0 149.33 66.859 149.33 149.334s-66.857 149.333-149.33 149.333c-82.478 0-149.335-66.858-149.335-149.333z",
        "M800 149.333c0-23.564 19.103-42.666 42.665-42.666h181.335c23.562 0 42.665 19.102 42.665 42.666s-19.103 42.666-42.665 42.666h-181.335c-23.562 0-42.665-19.102-42.665-42.666zM586.665 917.335h-586.665v-85.335h586.665v85.335z",
        "M714.67 810.665c-35.348 0-64 28.657-64 64 0 35.348 28.652 64 64 64 35.343 0 64-28.652 64-64 0-35.343-28.657-64-64-64zM565.335 874.665c0-82.473 66.857-149.33 149.335-149.33 82.473 0 149.33 66.857 149.33 149.33 0 82.478-66.857 149.335-149.33 149.335-82.478 0-149.335-66.857-149.335-149.335z",
        "M490.665 469.334h533.335v85.331h-533.335v-85.331zM800 874.665c0-23.562 19.103-42.665 42.665-42.665h181.335c23.562 0 42.665 19.103 42.665 42.665 0 23.567-19.103 42.67-42.665 42.67h-181.335c-23.562 0-42.665-19.103-42.665-42.67z",
        "M362.668 447.999c-35.346 0-64 28.654-64 64 0 35.349 28.654 64.001 64 64.001s64-28.652 64-64.001c0-35.346-28.654-64-64-64zM213.335 511.999c0-82.474 66.858-149.333 149.333-149.333s149.332 66.858 149.332 149.333c0 82.473-66.858 149.336-149.332 149.336s-149.333-66.862-149.333-149.336z",
        "M0 469.334h234.666v85.331h-234.666v-85.331z"
      ],
      "tags": [
        "icon-settings-slider-horizontal"
      ],
      "defaultCode": 59809,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M554.665 298.666h-85.331v-85.334h85.331v85.334z",
        "M469.334 469.334h-85.334v-85.334h170.665v298.665h85.335v85.335h-256v-85.335h85.334v-213.331z"
      ],
      "tags": [
        "information-circle--interface-essential"
      ],
      "defaultCode": 59811,
      "grid": 0
    },
    {
      "paths": [
        "M1002.788 248.686c-6.799-6.855-14.889-12.297-23.803-16.010s-18.473-5.625-28.129-5.625c-9.656 0-19.215 1.912-28.129 5.625-8.909 3.714-16.998 9.155-23.803 16.010l-373.76 373.758c-1.705 1.772-3.748 3.18-6.011 4.142s-4.695 1.454-7.153 1.454c-2.458 0-4.891-0.492-7.153-1.454s-4.307-2.371-6.013-4.142l-373.76-373.758c-6.799-6.855-14.889-12.297-23.802-16.010s-18.473-5.625-28.129-5.625c-9.655 0-19.216 1.912-28.129 5.625s-17.003 9.155-23.802 16.010c-13.623 13.704-21.269 32.243-21.269 51.566s7.646 37.861 21.269 51.566l413.257 413.259c20.571 20.541 48.457 32.082 77.531 32.082 29.076 0 56.96-11.54 77.532-32.082l413.256-413.259c13.624-13.704 21.268-32.243 21.268-51.566s-7.644-37.862-21.268-51.566v0z"
      ],
      "tags": [
        "interface-arrows-button-down--interface-essential"
      ],
      "defaultCode": 59812,
      "grid": 0
    },
    {
      "paths": [
        "M401.555 525.164c-1.769-1.705-3.177-3.748-4.139-6.011s-1.457-4.695-1.457-7.153c0-2.458 0.496-4.891 1.457-7.153s2.37-4.307 4.139-6.013l373.762-373.76c6.856-6.8 12.293-14.889 16.010-23.802 3.712-8.913 5.622-18.473 5.622-28.129s-1.91-19.216-5.622-28.129c-3.717-8.913-9.155-17.003-16.010-23.802-13.706-13.623-32.246-21.269-51.569-21.269s-37.862 7.646-51.564 21.269l-413.258 413.257c-20.369 20.665-31.788 48.516-31.788 77.532 0 29.015 11.419 56.868 31.788 77.532l413.258 413.256c13.701 13.624 32.241 21.268 51.564 21.268s37.862-7.644 51.569-21.268c6.856-6.799 12.293-14.889 16.010-23.803 3.712-8.914 5.622-18.473 5.622-28.129s-1.91-19.215-5.622-28.129c-3.717-8.914-9.155-17.004-16.010-23.803l-373.762-373.76z"
      ],
      "tags": [
        "interface-arrows-button-left--interface-essential"
      ],
      "defaultCode": 59813,
      "grid": 0
    },
    {
      "paths": [
        "M248.686 1002.788c-6.856-6.799-12.297-14.889-16.010-23.803s-5.625-18.473-5.625-28.129c0-9.656 1.912-19.215 5.625-28.129s9.155-17.004 16.010-23.803l373.758-373.76c1.772-1.705 3.18-3.748 4.142-6.011s1.454-4.695 1.454-7.153c0-2.458-0.492-4.891-1.454-7.153s-2.371-4.307-4.142-6.013l-373.758-373.76c-6.856-6.8-12.297-14.889-16.010-23.802s-5.625-18.473-5.625-28.129c0-9.656 1.912-19.216 5.625-28.129s9.155-17.003 16.010-23.802c13.704-13.623 32.242-21.269 51.566-21.269s37.861 7.646 51.566 21.269l413.26 413.257c20.367 20.665 31.785 48.516 31.785 77.532 0 29.015-11.418 56.868-31.785 77.532l-413.26 413.256c-13.704 13.624-32.242 21.268-51.566 21.268s-37.861-7.644-51.566-21.268v0z"
      ],
      "tags": [
        "interface-arrows-button-right--interface-essential"
      ],
      "defaultCode": 59814,
      "grid": 0
    },
    {
      "paths": [
        "M898.924 775.316l-373.76-373.762c-1.705-1.77-3.748-3.177-6.011-4.139s-4.695-1.457-7.153-1.457c-2.458 0-4.891 0.496-7.153 1.457s-4.307 2.369-6.013 4.139l-373.76 373.762c-6.799 6.856-14.889 12.293-23.802 16.010-8.913 3.712-18.473 5.622-28.129 5.622s-19.216-1.91-28.129-5.622c-8.913-3.717-17.003-9.155-23.802-16.010-13.623-13.706-21.269-32.246-21.269-51.569s7.646-37.862 21.269-51.564l413.257-413.259c20.665-20.369 48.515-31.788 77.531-31.788 29.015 0 56.868 11.419 77.532 31.788l413.256 413.259c13.624 13.701 21.268 32.241 21.268 51.564s-7.644 37.862-21.268 51.569c-6.799 6.856-14.889 12.293-23.803 16.010-8.914 3.712-18.473 5.622-28.129 5.622s-19.215-1.91-28.129-5.622c-8.909-3.717-16.998-9.155-23.803-16.010v0z"
      ],
      "tags": [
        "interface-arrows-button-up--interface-essential"
      ],
      "defaultCode": 59815,
      "grid": 0
    },
    {
      "paths": [
        "M637.076 525.896c-3.497-3.784-5.437-8.745-5.437-13.896s1.94-10.114 5.437-13.897l365.711-365.714c7.434-7.225 13.338-15.867 17.372-25.416s6.113-19.808 6.113-30.173c0-10.365-2.079-20.625-6.113-30.173s-9.938-18.19-17.372-25.416c-7.224-7.432-15.867-13.339-25.416-17.373s-19.809-6.112-30.172-6.112c-10.363 0-20.623 2.078-30.172 6.112s-18.191 9.941-25.416 17.373l-365.716 365.714c-3.784 3.495-8.745 5.437-13.896 5.437s-10.113-1.942-13.897-5.437l-365.714-365.714c-14.799-14.050-34.541-21.699-54.942-21.288s-39.819 8.848-54.041 23.482c-7.432 7.225-13.339 15.868-17.373 25.416s-6.112 19.808-6.112 30.173c0 10.365 2.078 20.625 6.112 30.173s9.941 18.19 17.373 25.416l365.715 365.714c3.495 3.784 5.436 8.746 5.436 13.899 0 5.151-1.941 10.112-5.436 13.896l-365.715 365.711c-7.432 7.229-13.339 15.872-17.373 25.416-4.034 9.549-6.112 19.809-6.112 30.177 0 10.363 2.078 20.623 6.112 30.172s9.941 18.186 17.373 25.416c7.225 7.429 15.868 13.338 25.416 17.372s19.808 6.113 30.173 6.113c10.365 0 20.625-2.079 30.173-6.113s18.19-9.943 25.416-17.372l365.714-365.716c3.784-3.497 8.746-5.437 13.899-5.437 5.151 0 10.112 1.94 13.896 5.437l365.711 365.716c14.746 14.74 34.739 23.025 55.593 23.025 20.849 0 40.842-8.284 55.588-23.025 14.74-14.746 23.025-34.739 23.025-55.588 0-20.854-8.284-40.847-23.025-55.593l-367.908-367.908z"
      ],
      "tags": [
        "interface-delete-1--interface-essential"
      ],
      "defaultCode": 59816,
      "grid": 0
    },
    {
      "paths": [
        "M292.572 914.284c-21.968-0.384-43.568-5.714-63.195-15.59s-36.777-24.044-50.177-41.457l-160.914-182.129c-6.443-7.224-11.388-15.657-14.547-24.806s-4.471-18.836-3.859-28.498c0.612-9.661 3.136-19.108 7.426-27.786s10.259-16.42 17.563-22.774c14.65-12.698 33.741-19.057 53.080-17.684s37.341 10.363 50.052 25.001l150.674 170.424c1.468 2.109 3.443 3.82 5.743 4.972 2.3 1.147 4.853 1.705 7.422 1.608 2.491 0.061 4.964-0.43 7.241-1.444 2.277-1.009 4.3-2.514 5.925-4.403l593.19-617.328c13.722-12.343 31.611-19.041 50.068-18.748s36.122 7.553 49.449 20.325c13.327 12.772 21.33 30.112 22.41 48.54 1.075 18.428-4.854 36.582-16.604 50.82l-599.771 631.222c-13.677 16.026-30.751 28.8-49.981 37.407-19.23 8.602-40.135 12.815-61.196 12.329v0z"
      ],
      "tags": [
        "interface-validation-check--interface-essential"
      ],
      "defaultCode": 59817,
      "grid": 0
    },
    {
      "paths": [
        "M981.335 533.335c-9.185 0.067-18.094 3.133-25.375 8.73-7.281 5.601-12.529 13.43-14.945 22.287l-217.6-111.658c-7.327-3.762-15.58-5.324-23.772-4.498s-15.969 4.002-22.395 9.149l-64.983 52.010-70.185-70.186c-7.091-7.085-16.451-11.447-26.44-12.321-9.985-0.873-19.959 1.797-28.174 7.543l-158.933 111.274c-7.939-7.89-18.674-12.324-29.867-12.329h-42.666v384h42.666c6.652-0.092 13.188-1.756 19.070-4.864s10.942-7.567 14.765-13.015l215.763 119.209c7.757 4.265 16.64 6.016 25.431 5.007s17.055-4.726 23.639-10.639l35.328-31.698h135.337c6.62 0.005 13.148-1.531 19.072-4.48l159.017-79.534c3.702 6.047 8.878 11.054 15.043 14.551 6.164 3.502 13.112 5.381 20.204 5.463h42.665v-384h-42.665zM562.903 929.28l-221.57-122.455v-165.929l165.802-116.096 38.144 38.185-81.066 65.024c-4.999 3.999-9.034 9.068-11.807 14.838s-4.213 12.088-4.213 18.488c0 6.4 1.44 12.718 4.213 18.483 2.773 5.77 6.809 10.839 11.807 14.838l106.666 85.335c6.804 5.443 15.114 8.668 23.813 9.252 8.694 0.579 17.357-1.521 24.827-6.011l73.257-43.945 32.43 44.16-162.304 145.833zM757.929 896h-30.464l83.2-74.967c7.859-7.071 12.815-16.809 13.901-27.325 1.091-10.516-1.766-21.059-8.013-29.588l-78.208-106.67c-6.287-8.586-15.565-14.51-25.999-16.609s-21.279-0.225-30.403 5.263l-81.070 48.722-41.938-33.49 150.098-120.064 229.632 117.801v146.56l-180.736 90.368z",
        "M85.334 170.666c0-22.631 8.99-44.337 24.993-60.34s37.708-24.993 60.34-24.993h449.581c-14.623 26.095-22.497 55.425-22.912 85.333v170.667h85.33v-85.334h213.335c11.315 0 22.17-4.495 30.172-12.497 7.997-8.002 12.493-18.854 12.493-30.17v-42.667c0-45.263-17.981-88.673-49.987-120.679s-75.412-49.987-120.678-49.987h-597.334c-45.263 0-88.673 17.981-120.679 49.987s-49.987 75.416-49.987 120.679v725.334c0 11.315 4.495 22.17 12.497 30.172 8.002 7.997 18.854 12.493 30.17 12.493h149.333v-85.33h-106.666v-682.669zM853.335 170.666h-170.67c0-22.631 8.991-44.337 24.996-60.34 16-16.003 37.709-24.993 60.339-24.993s44.339 8.99 60.339 24.993c16.005 16.003 24.996 37.708 24.996 60.34v0z",
        "M234.667 192h256v85.334h-256v-85.334zM170.667 362.666h128v85.334h-128v-85.334z"
      ],
      "tags": [
        "investment-agreement-document--business-products"
      ],
      "defaultCode": 59818,
      "grid": 0
    },
    {
      "paths": [
        "M772.265 703.744v86.656c97.408 18.601 155.735 44.841 165.847 62.935-17.065 30.802-173.225 85.33-426.071 85.33-257.833 0-415.017-56.745-426.921-83.538 6.784-17.326 60.928-43.182 153.814-62.254v-86.825c-129.152 23.808-238.934 68.649-238.934 147.287 0 134.697 321.834 170.665 512 170.665 190.167 0 512-35.968 512-170.665 0-81.070-117.161-126.382-251.735-149.591z",
        "M516.265 888.791l30.167-30.167c11.776-11.817 289.833-292.649 289.833-538.624 0-84.869-33.71-166.263-93.722-226.274s-141.409-93.726-226.278-93.726c-84.867 0-166.26 33.714-226.272 93.726s-93.726 141.405-93.726 226.274c0 245.975 277.974 526.807 289.835 538.624l30.163 30.167zM516.265 85.334c62.218 0.068 121.866 24.813 165.862 68.807 43.991 43.994 68.741 103.643 68.808 165.859 0 167.168-165.248 368.681-234.67 445.952-69.544-77.225-234.664-278.486-234.664-445.952 0.068-62.217 24.813-121.866 68.807-165.859s103.643-68.74 165.857-68.807v0z",
        "M548.224 554.665v-53.332h7.127c24.044 0 47.104-9.552 64.108-26.556s26.557-40.065 26.557-64.111c0-24.046-9.554-47.108-26.557-64.111s-40.064-26.556-64.108-26.556h-78.21c-7.072 0-13.855-2.809-18.856-7.811s-7.811-11.784-7.811-18.856c0-7.073 2.809-13.855 7.811-18.856s11.784-7.811 18.856-7.811h156.418v-64h-85.335v-53.333h-63.999v53.333h-7.083c-24.046 0-47.108 9.552-64.111 26.556s-26.556 40.065-26.556 64.111c0 24.046 9.552 47.108 26.556 64.111s40.065 26.556 64.111 26.556h78.21c7.071 0 13.855 2.809 18.857 7.811 4.997 5.001 7.808 11.784 7.808 18.856s-2.811 13.855-7.808 18.856c-5.002 5.001-11.786 7.811-18.857 7.811h-156.46v64h85.334v53.332h63.999z"
      ],
      "tags": [
        "investment-location-area-circle--business-products"
      ],
      "defaultCode": 59819,
      "grid": 0
    },
    {
      "paths": [
        "M21.030 481.83l256-256 60.34 60.34-183.163 183.164h827.128v85.331h-827.128l183.163 183.163-60.34 60.344-256-256c-16.662-16.666-16.662-43.68 0-60.342z"
      ],
      "tags": [
        "keyboard-left-arrow--interface-essential"
      ],
      "defaultCode": 59820,
      "grid": 0
    },
    {
      "paths": [
        "M1011.502 542.172l-256 256-60.339-60.344 183.163-183.163h-827.126v-85.331h827.126l-183.163-183.163 60.339-60.34 256 255.999c16.666 16.663 16.666 43.677 0 60.342z"
      ],
      "tags": [
        "keyboard-right-arrow--interface-essential"
      ],
      "defaultCode": 59821,
      "grid": 0
    },
    {
      "paths": [
        "M605.568 12.491c16.666-16.657 43.674-16.655 60.334 0.005l241.367 241.365c8.003 8.003 12.498 18.856 12.498 30.174-0.005 11.317-4.5 22.171-12.503 30.172l-120.704 120.662c-16.666 16.657-43.674 16.655-60.334-0.006l-241.367-241.365c-8.003-8.003-12.498-18.856-12.497-30.174s4.498-22.171 12.502-30.172l120.703-120.661zM575.375 163.333l181.023 181.026 60.355-60.332-181.023-181.026-60.355 60.332zM334.082 301.654c11.317 0.001 22.17 4.496 30.171 12.499l241.367 241.408c7.997 8.003 12.493 18.857 12.493 30.172s-4.5 22.17-12.503 30.172l-120.703 120.658c-16.661 16.655-43.668 16.655-60.329 0l-241.408-241.321c-8.004-8.001-12.501-18.854-12.502-30.171s4.494-22.171 12.497-30.174l120.746-120.747c8.002-8.002 18.855-12.497 30.172-12.496zM273.678 465.061l181.063 181.001 60.362-60.344-181.026-181.055-60.399 60.399z",
        "M545.193 150.869c11.315-0.001 22.17 4.494 30.172 12.496l181.033 181.035c8.003 8.002 12.498 18.855 12.498 30.172s-4.495 22.17-12.498 30.171l-60.334 60.315 331.868 331.864-60.344 60.339-331.868-331.868-60.36 60.339c-16.66 16.66-43.674 16.66-60.334 0l-180.993-180.993c-16.661-16.661-16.663-43.674-0.004-60.336l180.991-181.035c8.003-8.003 18.857-12.499 30.172-12.5zM545.198 253.879l-120.659 120.688 120.659 120.659 120.689-120.659-120.689-120.688z",
        "M469.334 1024h-469.334l85.334-170.665h298.666l85.334 170.665z"
      ],
      "tags": [
        "law-hammer--business-products"
      ],
      "defaultCode": 59822,
      "grid": 0
    },
    {
      "paths": [
        "M474.511 88.511c10.354-4.235 21.957-4.235 32.31 0l469.332 192c16.036 6.56 26.511 22.165 26.511 39.49s-10.476 32.93-26.511 39.49l-469.332 191.999c-10.354 4.234-21.957 4.234-32.31 0l-469.333-191.999c-16.035-6.56-26.512-22.165-26.512-39.49s10.476-32.93 26.512-39.49l469.333-192zM134.019 320.001l356.647 145.901 356.647-145.901-356.647-145.901-356.647 145.901z",
        "M474.511 744.643l-589.482-241.15 32.31-78.98 573.327 234.544 550.798-225.328 32.312 78.978-566.955 231.936c-10.354 4.239-21.957 4.239-32.31 0z",
        "M1093.233 695.572l-586.41 239.913c-10.354 4.239-21.957 4.239-32.31 0.005l-573.654-234.67 32.309-78.981 557.498 228.060 570.255-233.308 32.312 78.981z"
      ],
      "tags": [
        "layers--design"
      ],
      "defaultCode": 59823,
      "grid": 0
    },
    {
      "paths": [
        "M-21.333 42.667c0-23.564 19.102-42.667 42.667-42.667h384c23.564 0 42.666 19.103 42.666 42.667v384c0 23.564-19.103 42.667-42.666 42.667h-384c-23.564 0-42.667-19.103-42.667-42.667v-384zM64.001 85.334v298.666h298.666v-298.666h-298.666zM490.667 170.666c0-23.564 19.103-42.666 42.668-42.666h469.33c23.567 0 42.67 19.103 42.67 42.666s-19.103 42.667-42.67 42.667h-469.33c-23.565 0-42.668-19.103-42.668-42.667zM490.667 341.334c0-23.564 19.103-42.667 42.668-42.667h469.33c23.567 0 42.67 19.103 42.67 42.667s-19.103 42.666-42.67 42.666h-469.33c-23.565 0-42.668-19.103-42.668-42.666zM-21.333 597.335c0-23.567 19.102-42.67 42.667-42.67h384c23.564 0 42.666 19.103 42.666 42.67v384c0 23.562-19.103 42.665-42.666 42.665h-384c-23.564 0-42.667-19.103-42.667-42.665v-384zM64.001 640v298.665h298.666v-298.665h-298.666zM490.667 725.335c0-23.567 19.103-42.67 42.668-42.67h469.33c23.567 0 42.67 19.103 42.67 42.67 0 23.562-19.103 42.665-42.67 42.665h-469.33c-23.565 0-42.668-19.103-42.668-42.665zM1002.665 938.665h-469.33v-85.33h469.33v85.33z"
      ],
      "tags": [
        "layout-thumbnail"
      ],
      "defaultCode": 59824,
      "grid": 0
    },
    {
      "paths": [
        "M387.45 111.194c6.724-15.688 22.149-25.859 39.217-25.859h127.998c23.567 0 42.67 19.102 42.67 42.666v213.334h384c12.539 0 24.448 5.518 32.553 15.088 8.11 9.57 11.592 22.222 9.533 34.593l-85.335 511.999c-3.43 20.572-21.228 35.656-42.086 35.656h-384c-3.964 0-7.909-0.553-11.721-1.644l-246.391-70.4c-5.587 17.055-21.633 29.373-40.554 29.373h-170.667c-23.564 0-42.667-19.103-42.667-42.665v-469.334c0-23.564 19.103-42.666 42.667-42.666h170.667c23.564 0 42.666 19.102 42.666 42.666h14.533l116.917-272.807zM256 469.335v309.151l261.975 74.849h341.883l71.112-426.668h-376.305c-23.562 0-42.665-19.102-42.665-42.666v-213.334h-57.199l-116.917 272.807c-6.724 15.688-22.149 25.86-39.217 25.86h-42.666zM170.666 810.67v-384.003h-85.333v384.003h85.333z"
      ],
      "tags": [
        "like--rewards-rating"
      ],
      "defaultCode": 59825,
      "grid": 0
    },
    {
      "paths": [
        "M-21.333 42.667c0-23.564 19.102-42.667 42.667-42.667h213.333c23.564 0 42.667 19.103 42.667 42.667v213.333c0 23.564-19.103 42.666-42.667 42.666h-213.333c-23.564 0-42.667-19.102-42.667-42.666v-213.333zM64.001 85.334v128h128v-128h-128zM320.001 149.334c0-23.564 19.103-42.667 42.666-42.667h639.998c23.567 0 42.67 19.103 42.67 42.667s-19.103 42.666-42.67 42.666h-639.998c-23.564 0-42.666-19.103-42.666-42.666zM-21.333 405.334c0-23.564 19.102-42.667 42.667-42.667h213.333c23.564 0 42.667 19.103 42.667 42.667v213.331c0 23.567-19.103 42.67-42.667 42.67h-213.333c-23.564 0-42.667-19.103-42.667-42.67v-213.331zM64.001 448v128h128v-128h-128zM320.001 512c0-23.564 19.103-42.666 42.666-42.666h639.998c23.567 0 42.67 19.102 42.67 42.666 0 23.562-19.103 42.665-42.67 42.665h-639.998c-23.564 0-42.666-19.103-42.666-42.665zM-21.333 768c0-23.562 19.102-42.665 42.667-42.665h213.333c23.564 0 42.667 19.103 42.667 42.665v213.335c0 23.562-19.103 42.665-42.667 42.665h-213.333c-23.564 0-42.667-19.103-42.667-42.665v-213.335zM64.001 810.665v128h128v-128h-128zM1002.665 917.335h-639.998v-85.335h639.998v85.335z"
      ],
      "tags": [
        "list-bullet-point-square"
      ],
      "defaultCode": 59826,
      "grid": 0
    },
    {
      "paths": [
        "M661.335 448h-298.669c-23.564 0-42.666 19.103-42.666 42.666v213.334c0 23.562 19.103 42.665 42.666 42.665h298.669c23.562 0 42.665-19.103 42.665-42.665v-213.334c0-23.564-19.103-42.666-42.665-42.666z",
        "M512 309.335c-19.803 0-38.795 7.866-52.797 21.869s-21.87 32.995-21.87 52.797v64h-64v-64c0-36.776 14.61-72.047 40.615-98.052s61.275-40.614 98.052-40.614c36.777 0 72.049 14.609 98.053 40.614s40.612 61.276 40.612 98.052v64h-64v-64c0-19.803-7.864-38.795-21.868-52.797s-32.993-21.869-52.797-21.869z",
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z"
      ],
      "tags": [
        "lock-square-circle--interface-essential"
      ],
      "defaultCode": 59827,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-56.58 0-110.842 22.476-150.85 62.483s-62.484 94.27-62.484 150.85v128h554.669c23.562 0 42.665 19.103 42.665 42.667v512.002c0 23.562-19.103 42.665-42.665 42.665h-682.669c-23.564 0-42.666-19.103-42.666-42.665v-512.002c0-23.564 19.103-42.667 42.666-42.667h42.667v-128c0-79.211 31.466-155.178 87.477-211.189s131.978-87.477 211.189-87.477c79.212 0 155.177 31.467 211.19 87.477s87.475 131.978 87.475 211.189l3.062 128h-88.392v-128c0-56.58-22.477-110.841-62.484-150.85s-94.269-62.483-150.851-62.483zM213.334 512v426.665h597.331v-426.665h-597.331z",
        "M512 810.665c47.13 0 85.335-38.205 85.335-85.33 0-47.13-38.205-85.335-85.335-85.335-47.128 0-85.334 38.205-85.334 85.335 0 47.124 38.205 85.33 85.334 85.33z"
      ],
      "tags": [
        "lock-square-lock-1--interface-essential"
      ],
      "defaultCode": 59828,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-56.58 0-110.842 22.476-150.85 62.483s-62.484 94.27-62.484 150.85v128h554.669c23.562 0 42.665 19.103 42.665 42.667v512.002c0 23.562-19.103 42.665-42.665 42.665h-682.669c-23.564 0-42.666-19.103-42.666-42.665v-512.002c0-23.564 19.103-42.667 42.666-42.667h42.667v-128c0-79.211 31.466-155.178 87.477-211.189s131.978-87.477 211.189-87.477c79.212 0 155.177 31.467 211.19 87.477s87.475 131.978 87.475 211.189h-85.33c0-56.58-22.477-110.841-62.484-150.85s-94.269-62.483-150.851-62.483zM213.334 512v426.665h597.331v-426.665h-597.331z",
        "M512 810.665c47.13 0 85.335-38.205 85.335-85.33 0-47.13-38.205-85.335-85.335-85.335-47.128 0-85.334 38.205-85.334 85.335 0 47.124 38.205 85.33 85.334 85.33z"
      ],
      "tags": [
        "lock-square-unlock-1--interface-essential"
      ],
      "defaultCode": 59829,
      "grid": 0
    },
    {
      "paths": [
        "M426.666 85.334c-188.513 0-341.333 152.82-341.333 341.333 0 188.512 152.82 341.334 341.333 341.334 188.512 0 341.334-152.822 341.334-341.334 0-188.513-152.822-341.333-341.334-341.333zM0 426.666c0-235.641 191.025-426.666 426.666-426.666s426.669 191.025 426.669 426.666c0 235.641-191.027 426.669-426.669 426.669s-426.666-191.027-426.666-426.669z",
        "M951.163 1011.502l-283.136-283.136 60.339-60.339 283.136 283.136-60.339 60.339z"
      ],
      "tags": [
        "magnifier--interface-essential"
      ],
      "defaultCode": 59830,
      "grid": 0
    },
    {
      "paths": [
        "M-2432-405.333h15061.35v2261.333h-15061.35v-2261.333z",
        "M511.999 554.665c42.194 0 83.441-12.508 118.523-35.953 35.082-23.44 62.423-56.758 78.572-95.74s20.372-81.875 12.14-123.258c-8.233-41.382-28.549-79.395-58.383-109.23s-67.85-50.153-109.23-58.385c-41.385-8.231-84.278-4.006-123.26 12.14s-72.3 43.49-95.741 78.573c-23.441 35.083-35.953 76.328-35.953 118.522 0.068 56.559 22.565 110.781 62.559 150.774s94.216 62.491 150.774 62.557v0zM511.999 213.334c25.314 0 50.064 7.507 71.112 21.572s37.458 34.056 47.145 57.445c9.687 23.389 12.221 49.125 7.286 73.955-4.941 24.83-17.132 47.637-35.031 65.539-17.905 17.901-40.709 30.092-65.541 35.031-24.827 4.939-50.565 2.404-73.954-7.284s-43.38-26.094-57.445-47.144c-14.065-21.049-21.572-45.797-21.572-71.113 0-33.948 13.486-66.505 37.491-90.51s56.562-37.49 90.509-37.49v0zM554.665 597.335h-85.332c-79.183 0.087-155.098 31.585-211.089 87.578-55.991 55.987-87.487 131.901-87.577 211.087v42.665h682.669v-42.665c-0.092-79.186-31.59-155.1-87.578-211.087-55.992-55.992-131.907-87.491-211.092-87.578v0zM424.789 687.872l44.544 80.128-28.458 85.335h-180.608c8.421-40.566 28.458-77.804 57.67-107.182s66.337-49.628 106.852-58.281v0zM581.719 853.335l-31.319-85.335 41.6-82.007c42.071 7.537 80.916 27.51 111.529 57.339 30.607 29.824 51.579 68.142 60.206 110.003h-182.016z"
      ],
      "attrs": [
        {
          "fill": "none",
          "stroke": "rgb(0, 0, 0)",
          "strokeLinejoin": "miter",
          "strokeLinecap": "butt",
          "strokeMiterlimit": "10",
          "strokeWidth": 42.6666496
        },
        {}
      ],
      "isMulticolor2": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "s": 0
          },
          {}
        ]
      },
      "tags": [
        "man-business---users"
      ],
      "defaultCode": 59831,
      "grid": 0
    },
    {
      "paths": [
        "M490.666 597.335c42.192 0 83.439-12.513 118.521-35.953 35.082-23.444 62.428-56.761 78.572-95.742 16.148-38.982 20.372-81.876 12.14-123.258-8.228-41.383-28.549-79.395-58.383-109.231s-67.845-50.153-109.23-58.384c-41.382-8.232-84.276-4.007-123.258 12.14s-72.3 43.49-95.741 78.573c-23.441 35.082-35.953 76.328-35.953 118.521 0.068 56.559 22.565 110.781 62.559 150.773s94.216 62.495 150.774 62.561v0zM490.666 256.001c25.317 0 50.062 7.507 71.115 21.572 21.048 14.065 37.453 34.056 47.14 57.444 9.692 23.389 12.227 49.126 7.286 73.955s-17.132 47.637-35.031 65.538c-17.9 17.901-40.709 30.092-65.536 35.031-24.831 4.937-50.568 2.404-73.957-7.284s-43.38-26.094-57.445-47.143c-14.065-21.050-21.572-45.797-21.572-71.113 0-33.948 13.486-66.505 37.491-90.509s56.562-37.491 90.509-37.491v0zM490.666 682.665c-200.96 0-341.333 105.262-341.333 256v85.335h682.666v-85.335c0-150.738-140.375-256-341.334-256zM476.288 768.425l-56.79 170.24h-184.832c0-97.193 98.688-165.888 241.622-170.24zM561.623 938.665l-56.791-170.24c142.976 4.27 241.705 73.006 241.705 170.24h-184.914z"
      ],
      "tags": [
        "man-business-man---users"
      ],
      "defaultCode": 59832,
      "grid": 0
    },
    {
      "paths": [
        "M335.645 186.311c0-23.564 19.102-42.667 42.666-42.667h594.489c23.562 0 42.665 19.103 42.665 42.667v243.199c0 18.042-11.197 33.468-27.018 39.708v176.471c0 23.562-19.103 42.665-42.67 42.665h-405.33v-85.33h362.665v-130.846h-380.447v-85.334h407.47v-157.866h-509.157v92.444h-85.333v-135.111z",
        "M648.535 483.555h54.042v-54.045h-54.042v54.045z",
        "M605.865 483.555c0 23.564 19.103 42.668 42.67 42.668h54.042c23.567 0 42.67-19.104 42.67-42.668v-54.045c0-23.564-19.103-42.666-42.67-42.666h-54.042c-23.567 0-42.67 19.102-42.67 42.666v54.045z",
        "M648.535 429.511h54.042v-54.045h-54.042v54.045z",
        "M605.865 429.51c0 23.564 19.103 42.666 42.67 42.666h54.042c23.567 0 42.67-19.103 42.67-42.666v-54.045c0-23.564-19.103-42.666-42.67-42.666h-54.042c-23.567 0-42.67 19.102-42.67 42.666v54.045z",
        "M524.8 51.199c0-23.564 19.103-42.667 42.665-42.667h216.182c23.562 0 42.665 19.103 42.665 42.667v135.111h-85.335v-92.445h-130.842v92.445h-85.335v-135.111z",
        "M324.266 699.735c32.067 0 63.414-9.508 90.077-27.325s47.443-43.136 59.715-72.765c12.272-29.624 15.482-62.223 9.226-93.674s-21.698-60.34-44.372-83.015c-22.674-22.675-51.564-38.116-83.015-44.372s-64.050-3.045-93.677 9.226c-29.626 12.272-54.948 33.053-72.763 59.716s-27.324 58.009-27.324 90.076c0 43.003 17.082 84.239 47.487 114.647 30.406 30.403 71.645 47.488 114.646 47.488zM324.266 456.534c16.034 0 31.707 4.754 45.039 13.662s23.721 21.569 29.857 36.382c6.136 14.812 7.741 31.114 4.613 46.838s-10.849 30.172-22.186 41.508c-11.337 11.336-25.782 19.057-41.507 22.185s-32.026 1.526-46.838-4.613c-14.813-6.134-27.474-16.527-36.382-29.855-8.908-13.332-13.662-29.005-13.662-45.041 0-21.499 8.541-42.119 23.744-57.322s35.823-23.744 57.322-23.744zM324.266 740.265c-190.912 0-324.266 99.999-324.266 243.2v40.535h648.535v-40.535c0-143.201-133.356-243.2-324.269-243.2zM87.512 942.935c24.32-73.288 114.831-121.6 236.755-121.6s212.514 48.312 236.758 121.6h-473.512z"
      ],
      "tags": [
        "man-business-suitcase---users"
      ],
      "defaultCode": 59833,
      "grid": 0
    },
    {
      "paths": [
        "M511.456 89.598c-77.992-0.995-153.192 29-209.089 83.401-55.819 54.326-87.831 128.556-89.034 206.43 0.095 35.327 17.386 87.924 48.906 151.607 30.816 62.264 72.327 129.516 114.469 192.010 42.039 62.346 84.16 119.158 115.813 160.43 7.060 9.206 13.592 17.628 19.478 25.155 5.883-7.526 12.416-15.949 19.476-25.155 31.657-41.272 73.774-98.084 115.814-160.43 42.143-62.495 83.656-129.746 114.468-192.010 31.524-63.684 48.814-116.28 48.906-151.608-1.203-77.874-33.213-152.103-89.032-206.429-55.895-54.401-131.098-84.397-209.091-83.401h-1.087zM853.335 379.138h42.665c0 56.403-25.364 124.301-57.759 189.751-33.188 67.052-77.010 137.815-120.197 201.866-43.295 64.205-86.508 122.481-118.856 164.654-16.189 21.105-29.696 38.231-39.178 50.109-4.741 5.944-8.479 10.573-11.049 13.737l-3.732 4.577-0.21 0.256-0.056 0.072-0.015 0.020c-0.010 0.005-0.010 0.010-32.947-27.11-32.935 27.121-32.94 27.116-32.945 27.11l-0.017-0.020-0.058-0.072-0.209-0.256-0.78-0.952-2.953-3.625c-2.568-3.164-6.307-7.793-11.049-13.737-9.483-11.878-22.988-29.005-39.178-50.109-32.347-42.173-75.559-100.449-118.853-164.654-43.191-64.051-87.013-134.815-120.198-201.866-32.393-65.449-57.76-133.347-57.76-189.751v-0.612h0.005c1.443-100.597 42.748-196.509 114.846-266.678 71.968-70.042 168.745-108.719 269.149-107.582 100.403-1.138 197.181 37.539 269.148 107.582 72.1 70.169 113.403 166.082 114.847 266.678l-42.66 0.612zM512 977.070l-32.935 27.121c8.105 9.841 20.186 15.544 32.935 15.544s24.832-5.704 32.937-15.544l-32.937-27.121z",
        "M512 217.6l-213.334 170.666h85.334v170.669h85.334v-128.002h85.331v128.002h85.335v-170.669h85.335l-213.335-170.666z"
      ],
      "tags": [
        "map-pin-home--maps-navigation-1"
      ],
      "defaultCode": 59834,
      "grid": 0
    },
    {
      "paths": [
        "M511.456 89.595c-77.992-0.995-153.192 29-209.089 83.401-55.819 54.326-87.831 128.556-89.034 206.429 0.095 35.328 17.386 87.924 48.906 151.611 30.816 62.264 72.327 129.51 114.469 192.010 42.039 62.346 84.16 119.153 115.813 160.425 7.060 9.206 13.592 17.628 19.478 25.155 5.883-7.526 12.416-15.949 19.476-25.155 31.657-41.272 73.774-98.079 115.814-160.425 42.143-62.5 83.656-129.746 114.468-192.010 31.524-63.687 48.814-116.283 48.906-151.611-1.203-77.874-33.213-152.103-89.032-206.429-55.895-54.401-131.098-84.397-209.091-83.401h-1.087zM853.335 379.134h42.665c0 56.403-25.364 124.301-57.759 189.754-33.188 67.046-77.010 137.815-120.197 201.866-43.295 64.205-86.508 122.476-118.856 164.649-16.189 21.11-29.696 38.236-39.178 50.115-4.741 5.939-8.479 10.573-11.049 13.737l-3.732 4.577-0.21 0.251-0.056 0.072-0.015 0.020c-0.010 0.010-0.010 0.015-32.947-27.11-32.935 27.126-32.94 27.121-32.945 27.11l-0.017-0.020-0.058-0.072-0.209-0.251-0.78-0.952-2.953-3.625c-2.568-3.164-6.307-7.798-11.049-13.737-9.483-11.878-22.988-29.005-39.178-50.115-32.347-42.173-75.559-100.444-118.853-164.649-43.191-64.051-87.013-134.82-120.198-201.866-32.393-65.453-57.76-133.35-57.76-189.754v-0.612h0.005c1.443-100.597 42.748-196.509 114.846-266.678 71.968-70.043 168.745-108.72 269.149-107.582 100.403-1.138 197.181 37.539 269.148 107.582 72.1 70.169 113.403 166.082 114.847 266.678l-42.66 0.612zM512 977.065l-32.935 27.126c8.105 9.841 20.186 15.539 32.935 15.539s24.832-5.699 32.937-15.539l-32.937-27.126z",
        "M512 217.6l-213.333 170.666h85.334v170.669h85.334v-128.002h85.331v128.002h85.335v-170.669h85.335l-213.335-170.666z"
      ],
      "tags": [
        "map-pin-home--maps-navigation"
      ],
      "defaultCode": 59835,
      "grid": 0
    },
    {
      "paths": [
        "M511.456 89.595c-77.992-0.995-153.192 29-209.089 83.401-55.819 54.326-87.831 128.556-89.034 206.429 0.095 35.328 17.386 87.924 48.906 151.611 30.816 62.264 72.327 129.51 114.469 192.010 42.039 62.346 84.16 119.153 115.813 160.425 7.060 9.206 13.592 17.628 19.478 25.155 5.883-7.526 12.416-15.949 19.476-25.155 31.657-41.272 73.774-98.079 115.814-160.425 42.143-62.5 83.656-129.746 114.468-192.010 31.524-63.687 48.814-116.283 48.906-151.611-1.203-77.874-33.213-152.103-89.032-206.429-55.895-54.401-131.098-84.397-209.091-83.401h-1.087zM853.335 379.134h42.665c0 56.403-25.364 124.301-57.759 189.754-33.188 67.046-77.010 137.815-120.197 201.866-43.295 64.205-86.508 122.476-118.856 164.649-16.189 21.11-29.696 38.236-39.178 50.115-4.741 5.939-8.479 10.573-11.049 13.737l-3.732 4.577-0.21 0.251-0.056 0.072-0.015 0.020c-0.010 0.010-0.010 0.015-32.947-27.11-32.935 27.126-32.94 27.121-32.945 27.11l-0.017-0.020-0.058-0.072-0.209-0.251-0.78-0.952-2.953-3.625c-2.568-3.164-6.307-7.798-11.049-13.737-9.483-11.878-22.988-29.005-39.178-50.115-32.347-42.173-75.559-100.444-118.853-164.649-43.191-64.051-87.013-134.82-120.198-201.866-32.393-65.453-57.76-133.35-57.76-189.754v-0.612h0.005c1.443-100.597 42.748-196.509 114.846-266.678 71.968-70.043 168.745-108.72 269.149-107.582 100.403-1.138 197.181 37.539 269.148 107.582 72.1 70.169 113.403 166.082 114.847 266.678l-42.66 0.612zM512 977.065l-32.935 27.126c8.105 9.841 20.186 15.539 32.935 15.539s24.832-5.699 32.937-15.539l-32.937-27.126zM469.334 601.6v-256.002h85.331v256.002h-85.331z",
        "M511.999 302.934c23.563 0 42.665-19.103 42.665-42.667s-19.103-42.666-42.665-42.666c-23.564 0-42.666 19.103-42.666 42.666s19.102 42.667 42.666 42.667z"
      ],
      "tags": [
        "map-pin-information--maps-navigation"
      ],
      "defaultCode": 59836,
      "grid": 0
    },
    {
      "paths": [
        "M189.921 746.342c-49.864 26.742-61.922 51.072-61.922 64.323 0 8.054 3.903 20.040 20.179 35.43 16.366 15.478 42.336 31.38 77.966 45.635 71.024 28.411 172.070 46.935 285.855 46.935 113.787 0 214.831-18.524 285.855-46.935 35.63-14.254 61.599-30.157 77.967-45.635 16.276-15.391 20.178-27.377 20.178-35.43 0-11.976-9.631-33.341-50.76-57.999-39.204-23.506-97.715-43.812-169.917-56.428l14.684-84.060c78.5 13.711 147.988 36.649 199.112 67.297 49.198 29.496 92.216 73.196 92.216 131.19 0 39.076-19.978 71.987-46.879 97.428-26.819 25.359-63.329 46.234-104.909 62.863-83.4 33.362-195.686 53.043-317.548 53.043-121.863 0-234.15-19.681-317.548-53.043-41.581-16.63-78.092-37.504-104.907-62.863-26.905-25.441-46.879-58.353-46.879-97.428 0-63.16 50.727-109.384 106.921-139.525 59.068-31.677 139.231-54.369 229.091-65.664l10.643 84.664c-83.239 10.465-152.409 30.996-199.4 56.202z",
        "M469.333 42.667c0-23.564 19.102-42.667 42.666-42.667h426.665c23.567 0 42.67 19.103 42.67 42.667v341.333c0 23.564-19.103 42.666-42.67 42.666h-384v383.998h-85.332v-767.998zM554.665 85.334v256h341.335v-256h-341.335z"
      ],
      "tags": [
        "maps-flag--maps-navigation"
      ],
      "defaultCode": 59837,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-45.263 0-88.673 17.981-120.679 49.987s-49.987 75.416-49.987 120.679c0 20.283 10.174 57.397 30.228 107.054 19.278 47.734 45.255 101.37 71.629 152.111 24.718 47.555 49.479 91.986 68.809 125.763 19.328-33.777 44.093-78.208 68.808-125.763 26.373-50.74 52.352-104.377 71.629-152.111 20.055-49.656 30.228-86.771 30.228-107.054 0-45.263-17.981-88.673-49.987-120.679s-75.412-49.987-120.678-49.987zM512 725.335c-36.475 22.134-36.478 22.129-36.481 22.124l-0.659-1.091-1.84-3.057c-1.601-2.668-3.932-6.564-6.892-11.561-5.917-9.984-14.347-24.34-24.454-41.923-20.194-35.133-47.172-83.308-74.2-135.306-26.959-51.868-54.315-108.202-75.037-159.513-19.946-49.388-36.438-100.39-36.438-139.009 0-67.895 26.971-133.010 74.981-181.019s113.124-74.981 181.019-74.981c67.896 0 133.012 26.971 181.018 74.981 48.010 48.009 74.982 113.124 74.982 181.019 0 38.619-16.492 89.622-36.439 139.009-20.721 51.311-48.077 107.644-75.039 159.513-27.023 51.999-54.001 100.173-74.199 135.306-10.107 17.582-18.534 31.939-24.453 41.923-2.959 4.997-5.289 8.893-6.892 11.561l-1.838 3.057-0.65 1.075c0 0.005-0.015 0.026-36.49-22.108zM512 725.335l36.49 22.108c-7.736 12.744-21.581 20.557-36.49 20.557-14.91 0-28.745-7.793-36.481-20.541l36.481-22.124z",
        "M512 341.336c47.13 0 85.335-38.205 85.335-85.334s-38.205-85.334-85.335-85.334c-47.128 0-85.333 38.205-85.333 85.334s38.205 85.334 85.333 85.334z",
        "M86.35 588.078c4.338-19.517 21.653-33.408 41.651-33.408h128v85.33h-93.774l-66.37 298.67h832.287l-66.371-298.67h-93.773v-85.33h128c19.999 0 37.315 13.891 41.651 33.408l85.335 384c2.806 12.636-0.271 25.861-8.371 35.953-8.1 10.097-20.342 15.969-33.28 15.969h-938.668c-12.942 0-25.184-5.873-33.282-15.969-8.098-10.092-11.176-23.316-8.369-35.953l85.333-384z"
      ],
      "tags": [
        "maps-location-pin--maps-navigation"
      ],
      "defaultCode": 59838,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-30.419 0-60.54 5.991-88.644 17.632s-53.639 28.703-75.148 50.212c-21.51 21.51-38.572 47.045-50.213 75.149s-17.632 58.225-17.632 88.644c0 27.602 13.314 69.964 38.632 122.523 24.575 51.016 57.747 106.247 91.524 157.713 33.679 51.318 67.435 98.099 92.813 132.096 3.015 4.040 5.909 7.895 8.668 11.556 2.76-3.661 5.652-7.516 8.668-11.556 25.38-33.997 59.136-80.778 92.815-132.096 33.777-51.466 66.944-106.698 91.52-157.713 25.318-52.559 38.636-94.921 38.636-122.523 0-30.419-5.99-60.54-17.633-88.644s-28.703-53.639-50.212-75.149c-21.509-21.509-47.048-38.572-75.151-50.212s-58.225-17.632-88.643-17.632zM512 810.665c-33.292 26.685-33.296 26.68-33.301 26.675l-0.236-0.297-0.635-0.794-2.391-3.016c-2.076-2.627-5.092-6.467-8.916-11.392-7.647-9.841-18.53-24.018-31.572-41.492-26.055-34.903-60.874-83.149-95.772-136.32-34.799-53.023-70.203-111.749-97.060-167.502-26.114-54.209-47.088-111.426-47.088-159.557 0-41.625 8.199-82.843 24.128-121.299s39.277-73.399 68.711-102.833c29.433-29.433 64.376-52.781 102.833-68.71s79.674-24.128 121.299-24.128c41.626 0 82.842 8.199 121.298 24.128s73.4 39.277 102.835 68.71c29.435 29.434 52.782 64.376 68.71 102.833s24.125 79.674 24.125 121.299c0 48.132-20.972 105.348-47.084 159.557-26.86 55.753-62.264 114.479-97.060 167.502-34.898 53.171-69.719 101.417-95.775 136.32-13.041 17.475-23.926 31.652-31.57 41.492-3.825 4.925-6.84 8.765-8.919 11.392l-2.391 3.016-0.635 0.794-0.22 0.276c-0.005 0.010-0.026 0.031-33.316-26.655zM512 810.665l33.316 26.655c-8.095 10.107-20.367 16.015-33.316 16.015-12.947 0-25.203-5.893-33.301-15.995l33.301-26.675zM722.304 938.665v85.335h-426.666v-85.335h426.666z",
        "M512 426.667c60.585 0 109.696-49.113 109.696-109.696s-49.111-109.696-109.696-109.696c-60.583 0-109.695 49.113-109.695 109.696s49.113 109.696 109.695 109.696z"
      ],
      "tags": [
        "maps-location-pin-3--maps-navigation"
      ],
      "defaultCode": 59839,
      "grid": 0
    },
    {
      "paths": [
        "M512 497.75c-25.316 0-50.063-7.507-71.113-21.572s-37.456-34.056-47.144-57.445c-9.688-23.389-12.223-49.125-7.284-73.955s17.129-47.637 35.031-65.538c17.902-17.901 40.709-30.092 65.539-35.031s50.566-2.404 73.954 7.284c23.388 9.688 43.382 26.094 57.446 47.143s21.571 45.797 21.571 71.113c0 33.948-13.486 66.505-37.489 90.509-24.008 24.005-56.566 37.491-90.511 37.491zM512 327.082c-8.439 0-16.688 2.503-23.704 7.191s-12.486 11.352-15.715 19.148c-3.229 7.796-4.074 16.375-2.428 24.652s5.71 15.879 11.677 21.846c5.967 5.967 13.57 10.031 21.846 11.677s16.854 0.801 24.651-2.428c7.798-3.23 14.459-8.698 19.149-15.715s7.188-15.266 7.188-23.704c0-11.316-4.495-22.169-12.493-30.17-8.003-8.002-18.857-12.497-30.172-12.497z",
        "M512 952.873c-100.649-134.272-298.665-415.273-298.665-583.123 0-79.212 31.466-155.178 87.477-211.189s131.978-87.477 211.188-87.477c79.212 0 155.177 31.466 211.19 87.477s87.48 131.978 87.48 211.189c0 167.85-198.016 448.938-298.67 583.123zM512 156.416c-56.558 0.068-110.78 22.566-150.774 62.559s-62.491 94.216-62.559 150.775c0 110.592 132.566 323.539 213.332 439.082 80.727-115.584 213.335-328.533 213.335-439.082-0.067-56.559-22.564-110.781-62.561-150.775-39.992-39.993-94.213-62.491-150.774-62.559v0z"
      ],
      "tags": [
        "maps-pin--maps-navigation"
      ],
      "defaultCode": 59840,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-57.383 0-112.416 22.795-152.992 63.371s-63.371 95.609-63.371 152.992c0 25.515 12.362 65.122 36.248 114.719 23.143 48.055 54.406 100.126 86.273 148.689 31.77 48.415 63.617 92.554 87.562 124.641 2.161 2.893 4.257 5.688 6.281 8.376 2.022-2.688 4.122-5.484 6.282-8.376 23.941-32.087 55.793-76.227 87.562-124.641 31.867-48.563 63.13-100.635 86.272-148.689 23.885-49.597 36.244-89.204 36.244-114.719 0-57.383-22.794-112.416-63.37-152.992s-95.606-63.371-152.991-63.371zM512 768c-33.293 26.685-33.297 26.68-33.302 26.67l-0.225-0.276-0.602-0.758-2.263-2.857c-1.964-2.483-4.817-6.118-8.432-10.767-7.229-9.308-17.516-22.712-29.842-39.229-24.623-32.988-57.533-78.592-90.521-128.86-32.89-50.125-66.385-105.688-91.81-158.481-24.682-51.251-44.699-105.708-44.699-151.745 0-80.015 31.785-156.752 88.365-213.331s133.317-88.365 213.331-88.365c80.015 0 156.754 31.786 213.33 88.365 56.581 56.579 88.366 133.317 88.366 213.331 0 46.037-20.019 100.494-44.698 151.745-25.426 52.793-58.921 108.356-91.812 158.481-32.988 50.268-65.9 95.872-90.522 128.86-12.324 16.517-22.61 29.921-29.839 39.229-3.615 4.649-6.472 8.284-8.433 10.767l-2.263 2.857-0.604 0.758-0.21 0.261c-0.005 0.005-0.020 0.031-33.316-26.655zM512 768l33.316 26.655c-8.095 10.102-20.367 16.010-33.316 16.010s-25.205-5.888-33.302-15.995l33.302-26.67z",
        "M512 405.331c57.236 0 103.639-46.4 103.639-103.638s-46.403-103.637-103.639-103.637c-57.238 0-103.638 46.4-103.638 103.637s46.4 103.638 103.638 103.638z",
        "M148.816 774.636c-16.804 15.672-20.816 27.884-20.816 36.035 0 8.049 3.903 20.035 20.179 35.43 16.366 15.473 42.336 31.38 77.966 45.629 71.024 28.411 172.070 46.94 285.855 46.94 113.787 0 214.831-18.529 285.855-46.94 35.63-14.249 61.599-30.157 77.967-45.629 16.276-15.396 20.178-27.382 20.178-35.43 0-8.151-4.014-20.362-20.818-36.035-16.865-15.729-43.581-31.821-80.097-46.147l31.16-79.437c42.46 16.65 79.749 37.637 107.136 63.176 27.453 25.6 47.954 58.844 47.954 98.442 0 39.076-19.978 71.982-46.879 97.428-26.819 25.359-63.329 46.228-104.909 62.863-83.4 33.362-195.686 53.043-317.548 53.043-121.863 0-234.15-19.681-317.548-53.043-41.581-16.635-78.092-37.504-104.907-62.863-26.905-25.446-46.879-58.353-46.879-97.428 0-39.598 20.5-72.842 47.952-98.442 27.387-25.539 64.674-46.525 107.135-63.176l31.158 79.437c-36.514 14.326-63.227 30.418-80.096 46.147z"
      ],
      "tags": [
        "maps-your-location-pin--maps-navigation"
      ],
      "defaultCode": 59841,
      "grid": 0
    },
    {
      "paths": [
        "M597.335 0h384c23.562 0 42.665 19.103 42.665 42.667v384h-85.335v-280.993l-609.828 609.829-60.34-60.339 609.829-609.829h-280.991v-85.334zM0 256c0-23.564 19.103-42.666 42.667-42.666h384v85.333h-341.333v639.998h640.002v-341.33h85.33v384c0 23.562-19.103 42.665-42.665 42.665h-725.333c-23.564 0-42.667-19.103-42.667-42.665v-725.335z"
      ],
      "tags": [
        "maximize-square-2--interface-essential"
      ],
      "defaultCode": 59842,
      "grid": 0
    },
    {
      "paths": [
        "M768 938.665h-682.666v-639.998h384v-85.334h-384c-22.632 0-44.337 8.991-60.34 24.994s-24.994 37.708-24.994 60.34v639.998c0 22.636 8.99 44.339 24.994 60.339 16.003 16.005 37.708 24.996 60.34 24.996h682.666c22.63 0 44.339-8.991 60.339-24.996 16.005-16 24.996-37.704 24.996-60.339v-384h-85.335v384z",
        "M640 85.333v85.334h153.001l-311.166 311.168 60.333 60.333 311.168-311.17v153.003h85.33v-298.667h-298.665z"
      ],
      "tags": [
        "maximize-square-4--interface-essential"
      ],
      "defaultCode": 59843,
      "grid": 0
    },
    {
      "paths": [
        "M951.163 1011.502l-283.136-283.136 60.339-60.339 283.136 283.136-60.339 60.339z",
        "M746.020 69.822c18.596 0.554 34.693 13.097 39.772 30.995l61 214.874h177.208v85.333h-209.449c-19.077 0-35.835-12.663-41.047-31.015l-32.978-116.161-95.15 272.231c-5.647 16.154-20.403 27.372-37.478 28.498-17.080 1.121-33.172-8.069-40.888-23.347l-103.761-205.53-30.495 53.72c-7.58 13.353-21.751 21.603-37.105 21.603h-139.648v-85.333h114.806l57.539-101.362c7.764-13.677 22.423-21.974 38.146-21.591s29.96 9.385 37.048 23.425l94.406 186.994 106.527-304.766c6.139-17.564 22.948-29.125 41.549-28.57z",
        "M583.199 123.255c-63.263-32.62-135.136-44.649-205.57-34.404s-135.903 42.252-187.249 91.543c-51.345 49.291-85.998 113.399-99.11 183.355s-4.027 142.263 25.983 206.803c30.010 64.538 79.446 118.083 141.388 153.139 61.943 35.052 133.296 49.869 204.074 42.373 70.777-7.496 137.444-36.936 190.667-84.188 53.228-47.258 90.348-109.967 106.168-179.362l83.2 18.973c-19.779 86.738-66.181 165.13-132.71 224.2s-149.862 95.862-238.335 105.236c-88.474 9.37-177.665-9.149-255.093-52.972-77.429-43.817-139.223-110.746-176.736-191.421-37.513-80.671-48.869-171.056-32.479-258.502s59.706-167.581 123.887-229.194c64.182-61.614 146.018-101.622 234.061-114.428s177.886 2.23 256.959 43.005l-39.107 75.844z"
      ],
      "tags": [
        "medical-doctor-diagnostic--health-beauty"
      ],
      "defaultCode": 59844,
      "grid": 0
    },
    {
      "paths": [
        "M897.664 6.727c12.252 7.842 19.671 21.389 19.671 35.94v853.333c0 14.551-7.419 28.099-19.671 35.937-12.257 7.844-27.668 8.899-40.878 2.801l-554.665-256c-15.111-6.973-24.787-22.098-24.787-38.738v-341.333c0-16.643 9.676-31.766 24.787-38.74l554.665-256c13.21-6.097 28.621-5.042 40.878 2.8zM362.666 325.966v286.734l469.334 216.617v-719.966l-469.334 216.615z",
        "M917.335 278.913v380.84c26.839-23.931 48.312-53.268 63.017-86.088 14.705-32.814 22.308-68.371 22.308-104.331s-7.603-71.515-22.308-104.332c-14.705-32.817-36.178-62.154-63.017-86.089v0z",
        "M41.151 318.484c40.008-40.008 94.27-62.484 150.849-62.484h128c23.564 0 42.666 19.103 42.666 42.666v682.669c0 23.562-19.102 42.665-42.666 42.665s-42.666-19.103-42.666-42.665v-298.67h-85.334c-56.58 0-110.842-22.477-150.849-62.484s-62.484-94.269-62.484-150.847c0-56.58 22.476-110.842 62.484-150.85zM277.334 597.335v-256.002h-85.334c-33.948 0-66.505 13.486-90.51 37.49s-37.49 56.562-37.49 90.51c0 33.948 13.486 66.505 37.49 90.508 24.005 24.008 56.562 37.494 90.51 37.494h85.334z"
      ],
      "tags": [
        "megaphone-1--interface-essential"
      ],
      "defaultCode": 59845,
      "grid": 0
    },
    {
      "paths": [
        "M981.335 0c23.562 0 42.665 19.103 42.665 42.667v938.668c0 23.562-19.103 42.665-42.665 42.665-23.567 0-42.67-19.103-42.67-42.665v-95.57l-299.131-83.092c-3.2 46.049-22.917 89.574-55.767 122.424-36.009 36.009-84.846 56.238-135.767 56.238s-99.758-20.229-135.764-56.238c-36.007-36.004-56.236-84.844-56.236-135.762v-93.199l-54.086-15.027c-18.467-5.13-31.247-21.944-31.247-41.108v-256c0-19.166 12.781-35.98 31.247-41.11l736.751-204.654v-95.57c0-23.564 19.103-42.667 42.67-42.667zM341.334 719.836v69.499c0 28.288 11.238 55.419 31.242 75.423s47.135 31.242 75.425 31.242c28.29 0 55.421-11.238 75.423-31.242 20.004-20.004 31.242-47.135 31.242-75.423v-10.24l-213.331-59.259zM938.665 797.199v-570.399l-682.665 189.629v191.14l682.665 189.629zM42.667 298.666c23.564 0 42.667 19.103 42.667 42.667v341.331c0 23.567-19.103 42.67-42.667 42.67s-42.667-19.103-42.667-42.67v-341.331c0-23.564 19.103-42.667 42.667-42.667z"
      ],
      "tags": [
        "megaphone-2--interface-essential"
      ],
      "defaultCode": 59846,
      "grid": 0
    },
    {
      "paths": [
        "M426.666 42.667c0-23.564 19.103-42.667 42.667-42.667h512.002c23.562 0 42.665 19.103 42.665 42.667v341.333c0 23.564-19.103 42.666-42.665 42.666h-152.996l-158.167 158.171c-12.206 12.201-30.556 15.852-46.5 9.247s-26.337-22.159-26.337-39.419v-127.998h-128.002c-23.564 0-42.667-19.102-42.667-42.666v-341.333zM512 85.334v256h128c23.562 0 42.665 19.102 42.665 42.666v67.66l97.833-97.83c8.003-8.002 18.852-12.496 30.167-12.496h128v-256h-426.665zM325.199 428.206c-11.124 2.142-21.766 6.489-31.274 12.842-14.033 9.376-24.971 22.704-31.429 38.296s-8.148 32.748-4.856 49.306c3.293 16.553 11.42 31.754 23.354 43.689s27.139 20.060 43.692 23.352c16.553 3.297 33.711 1.603 49.303-4.854s28.92-17.398 38.297-31.427c6.354-9.513 10.7-20.152 12.842-31.278l-99.928-99.928zM246.516 370.096c28.066-18.754 61.063-28.763 94.817-28.763 11.316 0 22.168 4.495 30.17 12.496l128 128c8.002 8.002 12.497 18.854 12.497 30.17 0 33.756-10.010 66.749-28.763 94.817s-45.407 49.94-76.593 62.858c-31.185 12.918-65.501 16.297-98.607 9.713s-63.516-22.84-87.385-46.71c-23.868-23.869-40.122-54.277-46.708-87.383s-3.205-67.421 9.712-98.607c12.917-31.185 34.792-57.84 62.858-76.593zM135.133 795.054c59.911-42.793 131.081-67.031 204.658-69.693 1.029-0.036 2.058-0.036 3.086 0 73.576 2.662 144.747 26.9 204.657 69.693 59.914 42.793 105.917 102.257 132.301 170.993 5.033 13.117 3.287 27.873-4.669 39.455-7.962 11.581-21.11 18.499-35.164 18.499h-597.333c-14.052 0-27.203-6.917-35.162-18.499s-9.706-26.337-4.671-39.455c26.381-68.736 72.389-128.2 132.3-170.993zM341.334 810.701c-56.306 2.335-110.726 21.023-156.602 53.791-28.431 20.306-52.811 45.476-72.114 74.173h457.433c-19.302-28.698-43.684-53.868-72.116-74.173-45.876-32.768-100.295-51.456-156.601-53.791z",
        "M640 256.001c23.562 0 42.665-19.103 42.665-42.666s-19.103-42.667-42.665-42.667c-23.562 0-42.665 19.103-42.665 42.667s19.103 42.666 42.665 42.666z",
        "M810.665 256.001c23.567 0 42.67-19.103 42.67-42.666s-19.103-42.667-42.67-42.667c-23.562 0-42.665 19.103-42.665 42.667s19.103 42.666 42.665 42.666z"
      ],
      "tags": [
        "messages-people-man-bubble-square--messages-chat"
      ],
      "defaultCode": 59847,
      "grid": 0
    },
    {
      "paths": [
        "M789.335 725.335h149.33v-85.335h-85.33v-42.665h-85.335v44.8c-25.923 5.263-48.968 19.973-64.655 41.267-15.688 21.299-22.902 47.667-20.244 73.984s15.002 50.708 34.632 68.439c19.63 17.731 45.148 27.535 71.603 27.51h42.665c5.658 0 11.085 2.248 15.084 6.246 4.004 3.999 6.252 9.426 6.252 15.084s-2.248 11.085-6.252 15.089c-3.999 3.999-9.426 6.246-15.084 6.246h-149.335v85.335h85.335v42.665h85.335v-44.8c25.923-5.263 48.963-19.973 64.655-41.272 15.688-21.294 22.902-47.662 20.244-73.979-2.657-26.322-15.002-50.714-34.632-68.444s-45.148-27.53-71.603-27.505h-42.665c-5.658 0-11.085-2.248-15.089-6.246-3.999-4.004-6.246-9.431-6.246-15.089s2.248-11.085 6.246-15.084c4.004-3.999 9.431-6.246 15.089-6.246zM512 0h-341.333c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v682.666c0 22.63 8.991 44.339 24.994 60.339 16.003 16.005 37.708 24.996 60.34 24.996h341.333c22.63 0 44.339-8.991 60.339-24.996 16.005-16 24.996-37.709 24.996-60.339v-682.666c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994v0zM512 85.334v85.333h-341.333v-85.333h341.333zM512 256v341.335h-341.333v-341.335h341.333zM170.667 768v-85.335h341.333v85.335h-341.333z"
      ],
      "tags": [
        "mobile-payment_1--business-products"
      ],
      "defaultCode": 59848,
      "grid": 0
    },
    {
      "paths": [
        "M576.768 341.334v32.085c-22.63 0.102-44.298 9.19-60.227 25.265-15.932 16.075-24.824 37.82-24.722 60.452s9.19 44.296 25.265 60.227c16.077 15.933 37.821 24.827 60.452 24.724h73.897c5.658 0 11.085 2.248 15.089 6.246 3.999 3.999 6.246 9.426 6.246 15.084s-2.248 11.085-6.246 15.089c-4.004 3.999-9.431 6.246-15.089 6.246h-139.433v64h64.768v31.913h64v-32h10.665c22.636 0 44.339-8.991 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339 0-22.636-8.991-44.339-24.996-60.341-16-16.003-37.704-24.994-60.339-24.994h-73.897c-5.658 0-11.085-2.248-15.084-6.248-4.004-4.001-6.252-9.427-6.252-15.085s2.248-11.084 6.252-15.085c3.999-4.001 9.426-6.248 15.084-6.248h128v-64h-64.768v-32h-64z",
        "M490.667 213.334v85.333h341.333l106.665 106.667v213.331l-106.665 106.67h-341.333v85.33h533.333v-597.331h-533.333zM362.667 213.334h64v85.333h-64v-85.333zM234.667 213.334h64v85.333h-64v-85.333zM362.667 725.335h64v85.33h-64v-85.33zM234.667 725.335h64v85.33h-64v-85.33z",
        "M85.334 853.335v-682.669h533.331v-85.333c0-22.632-8.991-44.337-24.991-60.34-16.005-16.003-37.709-24.994-60.339-24.994h-448.002c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v853.331c0 22.636 8.99 44.339 24.994 60.339 16.003 16.005 37.708 24.996 60.34 24.996h448.002c22.63 0 44.334-8.991 60.339-24.996 16-16 24.991-37.704 24.991-60.339v-85.33h-533.331z"
      ],
      "tags": [
        "mobile-payment--business-products"
      ],
      "defaultCode": 59849,
      "grid": 0
    },
    {
      "paths": [
        "M277.76 42.667c0-23.564 19.103-42.667 42.666-42.667h383.998c23.567 0 42.67 19.103 42.67 42.667v384c0 23.564-19.103 42.667-42.67 42.667h-383.998c-23.564 0-42.666-19.103-42.666-42.667v-384zM363.094 85.334v298.666h298.666v-298.666h-298.666zM0 597.335c0-23.567 19.103-42.67 42.667-42.67h384c23.564 0 42.667 19.103 42.667 42.67v384c0 23.562-19.103 42.665-42.667 42.665h-384c-23.564 0-42.667-19.103-42.667-42.665v-384zM85.334 640v298.665h298.666v-298.665h-298.666zM554.665 597.335c0-23.567 19.103-42.67 42.67-42.67h384c23.562 0 42.665 19.103 42.665 42.67v384c0 23.562-19.103 42.665-42.665 42.665h-384c-23.567 0-42.67-19.103-42.67-42.665v-384zM640 640v298.665h298.665v-298.665h-298.665z"
      ],
      "tags": [
        "module-three--interface-essential"
      ],
      "defaultCode": 59850,
      "grid": 0
    },
    {
      "paths": [
        "M524.503 268.501l60.329 60.331 158.167-158.166-158.167-158.165-60.329 60.331 55.168 55.168h-409.005v85.333h409.005l-55.168 55.168zM243.498 755.497l-60.33-60.329-158.165 158.167 158.165 158.162 60.33-60.329-55.168-55.168h281.003v-85.335h-281.003l55.168-55.168zM768 512c-50.632 0-100.127 15.012-142.228 43.141-42.097 28.134-74.911 68.111-94.285 114.893-19.374 46.776-24.445 98.248-14.566 147.907 9.876 49.664 34.258 95.278 70.062 131.077 35.799 35.804 81.413 60.186 131.072 70.062 49.664 9.882 101.135 4.808 147.912-14.566s86.758-52.188 114.888-94.29c28.134-42.097 43.146-91.592 43.146-142.223-0.077-67.871-27.075-132.941-75.069-180.931-47.99-47.995-113.060-74.993-180.931-75.069zM768 938.665c-33.756 0-66.749-10.010-94.817-28.759-28.068-18.755-49.94-45.409-62.858-76.595s-16.297-65.5-9.713-98.606c6.584-33.106 22.84-63.519 46.71-87.383 23.869-23.869 54.277-40.125 87.383-46.71s67.42-3.205 98.606 9.713c31.186 12.918 57.841 34.79 76.595 62.858 18.749 28.068 28.759 61.061 28.759 94.817 0 45.266-17.981 88.673-49.987 120.678s-75.412 49.987-120.678 49.987z",
        "M810.665 640h-85.33v170.665h128v-85.33h-42.67v-85.335zM405.334 469.333h-42.667c-5.658 0-11.084-2.248-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.248-11.084 6.248-15.085s9.427-6.248 15.085-6.248h149.334v-85.334h-85.334v-42.666h-85.333v44.8c-25.924 5.264-48.966 19.972-64.655 41.27s-22.904 47.665-20.246 73.983c2.659 26.318 15.001 50.71 34.632 68.441s45.15 27.53 71.602 27.505h42.667c5.658 0 11.084 2.248 15.085 6.252 4.001 3.999 6.248 9.426 6.248 15.084s-2.247 11.085-6.248 15.084c-4.001 4.004-9.427 6.252-15.085 6.252h-149.334v85.33h85.334v42.67h85.333v-44.846c25.877-5.309 48.864-20.029 64.509-41.313s22.836-47.616 20.182-73.897c-2.655-26.281-14.968-50.647-34.555-68.369-19.587-17.725-45.053-27.551-71.469-27.576v0z"
      ],
      "tags": [
        "money-exchange-schedule-1--business-products"
      ],
      "defaultCode": 59851,
      "grid": 0
    },
    {
      "paths": [
        "M294.956 298.667h-252.587v-256l252.587 256z",
        "M677.596 118.767c-84.685-35.612-178.608-42.938-267.794-20.888s-168.872 72.298-227.208 143.272l-65.923-54.184c70.003-85.168 165.627-145.466 272.65-171.926s219.728-17.669 321.355 25.066c101.627 42.735 186.742 117.13 242.693 212.123s79.744 205.508 67.845 315.108c-11.899 109.604-58.854 212.434-133.888 293.207s-174.136 135.168-282.568 155.095c-108.427 19.927-220.393 4.326-319.243-44.483-98.851-48.814-179.306-128.23-229.4-226.437l76.015-38.774c41.745 81.838 108.791 148.019 191.166 188.698 82.376 40.673 175.681 53.678 266.040 37.069 90.358-16.609 172.938-61.937 235.469-129.244 62.525-67.313 101.658-153.006 111.575-244.342 9.917-91.334-9.912-183.429-56.54-262.589-46.623-79.161-117.555-141.157-202.245-176.77z",
        "M469.634 302.934h-68.267c-23.564 0-42.666 19.103-42.666 42.666v147.926c0 20.86 15.082 38.663 35.658 42.088l186.209 31.012v69.11h-136.534v-31.34h-85.334v74.004c0 23.562 19.103 42.665 42.666 42.665h68.267v68.27h85.334v-68.27h68.265c23.567 0 42.67-19.103 42.67-42.665v-147.927c0-20.857-15.084-38.659-35.661-42.085l-186.208-31.011v-69.11h136.534v31.274h85.335v-73.942c0-23.564-19.103-42.666-42.67-42.666h-68.265v-68.266h-85.334v68.266z"
      ],
      "tags": [
        "money-fund-cycle--business-products"
      ],
      "defaultCode": 59852,
      "grid": 0
    },
    {
      "paths": [
        "M170.667 469.334c-0.317-41.217 7.9-82.054 24.135-119.94s40.137-72.002 70.2-100.2c30.064-28.198 65.638-49.868 104.485-63.647s80.126-19.366 121.238-16.413c41.115 2.953 81.168 14.385 117.648 33.574 36.475 19.189 68.588 45.722 94.316 77.928 25.723 32.206 44.503 69.387 55.153 109.205 10.655 39.818 12.948 81.41 6.743 122.158h86.231c8.643-77.294-6.39-155.39-43.11-223.952-36.716-68.563-93.389-124.36-162.514-160.007s-147.446-49.463-224.596-39.62c-77.15 9.843-149.493 42.881-207.454 94.742s-98.808 120.1-117.135 195.685c-18.327 75.586-13.27 154.953 14.502 227.6 27.772 72.653 76.949 135.153 141.024 179.241 64.074 44.083 140.025 67.671 217.801 67.645 14.257-0.061 28.501-0.906 42.666-2.519v-86.231c-42.418 6.502-85.742 3.712-126.978-8.172-41.235-11.878-79.399-32.573-111.856-60.646-32.456-28.078-58.429-62.863-76.127-101.955-17.697-39.096-26.695-81.567-26.373-124.479v0zM968.832 712.873l-60.329-60.37-97.838 97.833-97.833-97.833-60.329 60.37 97.833 97.792-97.833 97.838 60.329 60.37 97.833-97.874 97.838 97.874 60.329-60.37-97.833-97.838 97.833-97.792z",
        "M512 256h-85.332v44.8c-25.924 5.264-48.966 19.972-64.655 41.27s-22.904 47.665-20.246 73.983c2.659 26.318 15.001 50.71 34.632 68.44s45.15 27.532 71.602 27.507h42.667c5.658 0 11.084 2.248 15.085 6.246 4.001 4.004 6.248 9.431 6.248 15.089s-2.247 11.085-6.248 15.084c-4.001 3.999-9.427 6.246-15.085 6.246h-149.334v85.335h85.334v42.665h85.332v-44.8c25.923-5.263 48.968-19.973 64.655-41.267 15.688-21.299 22.902-47.667 20.244-73.984-2.657-26.319-15.002-50.711-34.632-68.441s-45.148-27.533-71.601-27.507h-42.667c-5.658 0-11.084-2.248-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.247-11.084 6.248-15.085s9.427-6.248 15.085-6.248h149.335v-85.334h-85.335v-42.666z"
      ],
      "tags": [
        "money-fund-remove-not-found--business-products"
      ],
      "defaultCode": 59853,
      "grid": 0
    },
    {
      "paths": [
        "M0 170.666c0-23.564 19.103-42.666 42.667-42.666h767.998c23.567 0 42.67 19.103 42.67 42.666v511.998c0 23.567-19.103 42.67-42.67 42.67h-767.998c-23.564 0-42.667-19.103-42.667-42.67v-511.998zM85.334 213.334v426.666h682.666v-426.666h-682.666z",
        "M426.666 362.667c-35.346 0-64 28.654-64 64s28.654 64 64 64c35.346 0 64-28.654 64-64s-28.654-64-64-64zM277.333 426.667c0-82.474 66.858-149.334 149.333-149.334s149.334 66.859 149.334 149.334c0 82.474-66.86 149.333-149.334 149.333s-149.333-66.858-149.333-149.333z",
        "M938.665 810.665v-639.998h85.335v682.669c0 23.562-19.103 42.665-42.665 42.665h-853.335v-85.335h810.665z"
      ],
      "tags": [
        "money-note-1--business-products"
      ],
      "defaultCode": 59854,
      "grid": 0
    },
    {
      "paths": [
        "M981.335 213.334h-938.668c-11.316 0-22.168 4.495-30.17 12.497s-12.497 18.854-12.497 30.17v511.999c0 11.315 4.495 22.17 12.497 30.172 8.002 7.997 18.854 12.493 30.17 12.493h938.668c11.315 0 22.164-4.495 30.167-12.493 8.003-8.003 12.498-18.857 12.498-30.172v-511.999c0-11.316-4.495-22.169-12.498-30.17s-18.852-12.497-30.167-12.497zM768 725.335h-512l-170.666-170.67v-85.331l170.666-170.666h512l170.665 170.666v85.331l-170.665 170.67z",
        "M512 384c-25.316 0-50.063 7.507-71.113 21.572s-37.456 34.056-47.144 57.444c-9.688 23.389-12.223 49.127-7.284 73.954 4.939 24.832 17.129 47.636 35.031 65.541 17.902 17.9 40.709 30.090 65.539 35.031 24.829 4.936 50.566 2.401 73.954-7.286s43.382-26.097 57.446-47.145c14.065-21.048 21.571-45.793 21.571-71.112 0-33.948-13.486-66.505-37.489-90.51-24.008-24.005-56.566-37.49-90.511-37.49zM512 554.665c-8.439 0-16.688-2.499-23.704-7.188s-12.486-11.351-15.715-19.149c-3.229-7.798-4.074-16.375-2.428-24.652s5.71-15.879 11.677-21.846c5.967-5.967 13.57-10.031 21.846-11.677s16.854-0.801 24.651 2.428c7.798 3.229 14.459 8.698 19.149 15.714s7.188 15.266 7.188 23.705c0 11.315-4.495 22.17-12.493 30.172-8.003 7.997-18.857 12.493-30.172 12.493z"
      ],
      "tags": [
        "money-note-2--business-products"
      ],
      "defaultCode": 59855,
      "grid": 0
    },
    {
      "paths": [
        "M896 213.334h-896v-85.334h896v85.334z",
        "M853.335 0v341.334l170.665-170.667-170.665-170.666z",
        "M128 810.665h896v85.335h-896v-85.335z",
        "M170.666 682.665v341.335l-170.666-170.665 170.666-170.67z",
        "M460.799 328.533h-51.2c-23.564 0-42.666 19.103-42.666 42.667v125.141c0 20.856 15.075 38.653 35.646 42.083l152.086 25.375v46.336h-102.399v-21.335h-85.333v64c0 23.562 19.102 42.665 42.666 42.665h51.2v51.2h85.336v-51.2h51.2c23.562 0 42.665-19.103 42.665-42.665v-125.143c0-20.853-15.078-38.652-35.645-42.083l-152.089-25.371v-46.336h102.399v19.926h85.335v-62.592c0-23.564-19.103-42.667-42.665-42.667h-51.2v-51.2h-85.336v51.2z"
      ],
      "tags": [
        "money-transfer--business-products"
      ],
      "defaultCode": 59856,
      "grid": 0
    },
    {
      "paths": [
        "M709.033 253.014c51.758 35.714 92.616 85.064 118.042 142.579s34.427 120.949 26.004 183.264l84.608 11.438c9.293-69.627 1.336-140.467-23.168-206.295-32.236-86.445-91.761-160.032-169.559-209.622l37.719-82.602-179.886 67.114 67.072 179.883 39.168-85.76zM401.067 854.656c-69.311-24.356-128.893-70.461-169.86-131.441-40.967-60.984-61.125-133.576-57.468-206.95l-85.334-4.265c-4.436 90.435 20.011 179.937 69.806 255.555 49.796 75.622 122.356 133.443 207.186 165.094l-36.352 79.703 179.883-67.113-67.115-179.886-40.746 89.303zM282.923 245.334h64c8.487 0 16.626 3.372 22.627 9.373s9.373 14.14 9.373 22.627c0 8.487-3.372 16.626-9.373 22.627s-14.14 9.373-22.627 9.373h-141.696v64h77.696v53.333h64v-53.333c25.461 0 49.879-10.115 67.882-28.118s28.118-42.421 28.118-67.882c0-25.461-10.114-49.879-28.118-67.882s-42.422-28.118-67.882-28.118h-64c-8.487 0-16.626-3.372-22.627-9.373s-9.373-14.14-9.373-22.627c0-8.487 3.372-16.626 9.373-22.627s14.14-9.373 22.627-9.373h141.696v-64h-77.696v-53.334h-64v53.334c-25.461 0-49.879 10.114-67.882 28.118s-28.118 42.422-28.118 67.882c0 25.461 10.114 49.879 28.118 67.882s42.421 28.118 67.882 28.118v0zM906.455 737.833l-183.168 183.168-55.168-55.168-60.334 60.334 85.335 85.33c8.003 8.003 18.852 12.493 30.167 12.493 11.31 0 22.164-4.49 30.162-12.493l213.335-213.33-60.329-60.334z"
      ],
      "tags": [
        "money-transfer-correction--business-products"
      ],
      "defaultCode": 59857,
      "grid": 0
    },
    {
      "paths": [
        "M170.665 0h682.664v85.334h-682.664v-85.334zM511.999 170.666c11.316 0 22.171 4.495 30.168 12.497l213.335 213.334-60.339 60.34-140.498-140.497v664.995h-85.333v-664.995l-140.496 140.497-60.34-60.34 213.333-213.334c8.002-8.002 18.854-12.497 30.17-12.497z"
      ],
      "tags": [
        "move-snap-top--interface-essential"
      ],
      "defaultCode": 59858,
      "grid": 0
    },
    {
      "paths": [
        "M511.999 0c11.316 0 22.171 4.495 30.168 12.497l213.335 213.333-60.339 60.34-140.498-140.497v664.992h-85.333v-664.992l-140.496 140.497-60.34-60.34 213.333-213.333c8.002-8.002 18.854-12.497 30.17-12.497zM170.665 1024v-85.335h682.664v85.335h-682.664z"
      ],
      "tags": [
        "move-up-1--interface-essential"
      ],
      "defaultCode": 59859,
      "grid": 0
    },
    {
      "paths": [
        "M512 0c11.315 0 22.17 4.495 30.172 12.497l213.33 213.333-60.339 60.34-140.493-140.497v536.992h-85.336v-536.992l-140.497 140.497-60.34-60.34 213.334-213.333c8.002-8.002 18.854-12.497 30.169-12.497zM85.335 810.665c0-23.562 19.102-42.665 42.666-42.665h767.999c23.567 0 42.67 19.103 42.67 42.665v170.67c0 23.562-19.103 42.665-42.67 42.665h-767.999c-23.564 0-42.666-19.103-42.666-42.665v-170.67zM170.668 853.335v85.33h682.668v-85.33h-682.668z"
      ],
      "tags": [
        "move-up-2--interface-essential"
      ],
      "defaultCode": 59860,
      "grid": 0
    },
    {
      "paths": [
        "M511.999 1024c-11.316 0-22.168-4.495-30.17-12.498l-213.334-213.33 60.34-60.344 140.497 140.498v-536.992h85.332v536.992l140.498-140.498 60.339 60.344-213.335 213.33c-7.997 8.003-18.852 12.498-30.168 12.498zM938.665 213.334c0 23.564-19.103 42.666-42.665 42.666h-768.001c-23.564 0-42.666-19.103-42.666-42.666v-170.667c0-23.564 19.102-42.667 42.666-42.667l768.001-0c23.562-0 42.665 19.103 42.665 42.667v170.667zM853.33 170.666v-85.333h-682.664v85.333h682.664z"
      ],
      "tags": [
        "move-up-4--interface-essential"
      ],
      "defaultCode": 59861,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M384 725.335v-426.666h85.334v426.666h-85.334zM554.665 725.335v-426.666h85.335v426.666h-85.335z"
      ],
      "tags": [
        "music-player-button-pause--music-audio"
      ],
      "defaultCode": 59862,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z",
        "M363.317 261.348c13.566-7.519 30.144-7.084 43.297 1.137l341.331 213.333c12.477 7.797 20.055 21.471 20.055 36.182 0 14.71-7.578 28.385-20.055 36.183l-341.331 213.33c-13.153 8.223-29.731 8.658-43.297 1.137-13.566-7.516-21.983-21.806-21.983-37.315v-426.669c0-15.51 8.417-29.799 21.983-37.318zM426.666 375.648v272.703l218.162-136.351-218.162-136.352z"
      ],
      "tags": [
        "music-player-button-play--music-audio"
      ],
      "defaultCode": 59863,
      "grid": 0
    },
    {
      "paths": [
        "M138.666 650.665c76.583 0 138.667-62.080 138.667-138.665 0-76.583-62.084-138.666-138.667-138.666s-138.666 62.083-138.666 138.666c0 76.585 62.083 138.665 138.666 138.665z",
        "M511.999 650.665c76.585 0 138.665-62.080 138.665-138.665 0-76.583-62.080-138.666-138.665-138.666-76.583 0-138.666 62.083-138.666 138.666 0 76.585 62.083 138.665 138.666 138.665z",
        "M885.335 650.665c76.58 0 138.665-62.080 138.665-138.665 0-76.583-62.085-138.666-138.665-138.666-76.585 0-138.67 62.083-138.67 138.666 0 76.585 62.085 138.665 138.67 138.665z"
      ],
      "tags": [
        "navigation-menu-horizontal--interface-essential"
      ],
      "defaultCode": 59864,
      "grid": 0
    },
    {
      "paths": [
        "M511.999 277.334c76.585 0 138.665-62.084 138.665-138.667s-62.080-138.666-138.665-138.666c-76.583 0-138.666 62.083-138.666 138.666s62.083 138.667 138.666 138.667z",
        "M511.999 650.665c76.585 0 138.665-62.080 138.665-138.665 0-76.583-62.080-138.666-138.665-138.666-76.583 0-138.666 62.083-138.666 138.666 0 76.585 62.083 138.665 138.666 138.665z",
        "M511.999 1024c76.585 0 138.665-62.085 138.665-138.665 0-76.585-62.080-138.67-138.665-138.67-76.583 0-138.666 62.085-138.666 138.67 0 76.58 62.083 138.665 138.666 138.665z"
      ],
      "tags": [
        "navigation-menu-vertical--interface-essential"
      ],
      "defaultCode": 59865,
      "grid": 0
    },
    {
      "paths": [
        "M418.271 2.007c22.455 7.145 34.866 31.14 27.721 53.595l-50.187 157.73h422.453l58.419-183.604c7.142-22.455 31.14-34.866 53.591-27.721 22.456 7.145 34.867 31.14 27.725 53.595l-298.67 938.666c-7.142 22.456-31.14 34.867-53.591 27.725-22.456-7.148-34.867-31.145-27.725-53.596l50.191-157.732h-422.454l-58.419 183.603c-7.145 22.456-31.14 34.867-53.595 27.725-22.455-7.148-34.866-31.145-27.721-53.596l298.666-938.668c7.145-22.455 31.14-34.866 53.595-27.721zM232.896 725.33h422.454l54.303-170.665h-422.453l-54.303 170.665zM314.351 469.332h422.453l54.303-170.667h-422.453l-54.303 170.667z"
      ],
      "tags": [
        "object-ladder--furnitures-tools"
      ],
      "defaultCode": 59866,
      "grid": 0
    },
    {
      "paths": [
        "M0 85.334c0-23.564 19.103-42.667 42.667-42.667h938.668c23.562 0 42.665 19.103 42.665 42.667v853.331c0 23.567-19.103 42.67-42.665 42.67h-938.668c-23.564 0-42.667-19.103-42.667-42.67v-853.331zM85.334 128.001v767.999h853.331v-767.999h-853.331z",
        "M213.334 256.001c23.564 0 42.666-19.103 42.666-42.666s-19.102-42.667-42.666-42.667c-23.564 0-42.666 19.103-42.666 42.667s19.102 42.666 42.666 42.666z",
        "M384 256.001c23.564 0 42.666-19.103 42.666-42.666s-19.103-42.667-42.666-42.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.666 42.667 42.666z",
        "M0 341.334c0-23.564 19.103-42.667 42.667-42.667h938.668c23.562 0 42.665 19.103 42.665 42.667s-19.103 42.666-42.665 42.666h-938.668c-23.564 0-42.667-19.103-42.667-42.666zM554.665 554.665c0-23.562 19.103-42.665 42.67-42.665h256c23.562 0 42.665 19.103 42.665 42.665 0 23.567-19.103 42.67-42.665 42.67h-256c-23.567 0-42.67-19.103-42.67-42.67zM853.335 725.335c0 23.562-19.103 42.665-42.67 42.665h-170.665c-23.562 0-42.665-19.103-42.665-42.665v0c0-23.567 19.103-42.67 42.665-42.67h170.665c23.567 0 42.67 19.103 42.67 42.67v0z",
        "M341.334 640c47.128 0 85.333-38.205 85.333-85.33 0-47.131-38.205-85.336-85.333-85.336s-85.334 38.205-85.334 85.336c0 47.124 38.205 85.33 85.334 85.33z",
        "M170.667 810.665c0-45.261 17.981-88.673 49.987-120.678s75.416-49.987 120.679-49.987c45.263 0 88.673 17.981 120.679 49.987s49.987 75.418 49.987 120.678h-341.333z"
      ],
      "tags": [
        "page-profile-account-detail--programing-apps-websites"
      ],
      "defaultCode": 59867,
      "grid": 0
    },
    {
      "paths": [
        "M300.81 87.477c56.011-56.011 131.978-87.477 211.189-87.477s155.177 31.467 211.19 87.477c56.008 56.011 87.475 131.978 87.475 211.189v511.998h-85.33v-511.998c0-56.58-22.477-110.841-62.484-150.85s-94.269-62.483-150.851-62.483c-56.58 0-110.842 22.476-150.85 62.483s-62.484 94.27-62.484 150.85v511.998c0 33.951 13.486 66.509 37.491 90.511s56.562 37.489 90.509 37.489c33.948 0 66.505-13.486 90.51-37.489 24.003-24.003 37.489-56.561 37.489-90.511v-511.998c0-11.316-4.495-22.168-12.498-30.17-7.997-8.002-18.852-12.497-30.168-12.497s-22.169 4.495-30.17 12.497c-8.002 8.002-12.496 18.854-12.496 30.17v511.998h-85.334v-511.998c0-33.948 13.486-66.505 37.49-90.509s56.562-37.491 90.51-37.491c33.946 0 66.504 13.486 90.512 37.491 24.003 24.005 37.489 56.562 37.489 90.509v511.998c0 56.581-22.477 110.843-62.484 150.851s-94.27 62.484-150.85 62.484c-56.58 0-110.841-22.477-150.85-62.484s-62.483-94.269-62.483-150.851v-511.998c0-79.211 31.466-155.178 87.477-211.189z"
      ],
      "tags": [
        "paperclip-1--interface-essential"
      ],
      "defaultCode": 59868,
      "grid": 0
    },
    {
      "paths": [
        "M742.564 12.497l-655.571 655.571c-5.342 5.345-9.17 12.006-11.092 19.313l-74.496 283.095c-3.862 14.674 0.362 30.295 11.092 41.027s26.353 14.956 41.028 11.095l283.094-74.496c7.306-1.925 13.97-5.75 19.312-11.095l655.573-655.572c16.66-16.663 16.66-43.678 0-60.34l-208.599-208.597c-16.66-16.662-43.674-16.662-60.339 0zM151.928 733.783l138.288 138.286-187.675 49.388 49.387-187.674zM355.54 816.717l-148.257-148.26 416.461-416.459 148.255 148.258-416.458 416.461zM832.343 339.916l-148.26-148.258 88.653-88.652 148.255 148.258-88.648 88.652z"
      ],
      "tags": [
        "pencil-1--interface-essential"
      ],
      "defaultCode": 59869,
      "grid": 0
    },
    {
      "paths": [
        "M298.666 469.334c33.755 0 66.751-10.010 94.817-28.763s49.941-45.408 62.858-76.593c12.917-31.185 16.297-65.501 9.712-98.607s-22.84-63.516-46.708-87.384c-23.868-23.868-54.278-40.122-87.385-46.708s-67.421-3.206-98.607 9.712c-31.185 12.917-57.84 34.792-76.593 62.858s-28.763 61.063-28.763 94.817c0 45.264 17.981 88.674 49.987 120.68s75.416 49.987 120.679 49.987zM298.666 213.334c16.878 0 33.376 5.005 47.409 14.381s24.971 22.704 31.429 38.297c6.459 15.592 8.148 32.75 4.856 49.304s-11.42 31.758-23.354 43.692c-11.934 11.934-27.139 20.061-43.692 23.354s-33.711 1.603-49.303-4.856c-15.593-6.458-28.92-17.396-38.297-31.429s-14.381-30.531-14.381-47.409c0-22.631 8.99-44.337 24.993-60.34s37.708-24.993 60.34-24.993v0zM725.335 554.665c-33.756 0-66.755 10.010-94.817 28.764-28.068 18.755-49.94 45.409-62.858 76.595-12.918 31.181-16.297 65.5-9.713 98.606s22.84 63.514 46.705 87.383c23.869 23.869 54.282 40.12 87.388 46.71 33.106 6.584 67.42 3.205 98.606-9.713s57.841-34.796 76.59-62.858c18.755-28.068 28.764-61.066 28.764-94.817 0-45.266-17.981-88.673-49.987-120.684-32.005-32.005-75.418-49.987-120.678-49.987v0zM725.335 810.665c-16.881 0-33.377-5.002-47.411-14.377-14.034-9.38-24.97-22.707-31.427-38.298-6.461-15.596-8.151-32.753-4.859-49.306s11.423-31.759 23.357-43.689c11.93-11.935 27.136-20.065 43.689-23.357s33.71-1.603 49.306 4.859c15.59 6.456 28.918 17.393 38.292 31.427 9.38 14.034 14.382 30.531 14.382 47.411 0 22.63-8.991 44.334-24.991 60.339-16.005 16-37.709 24.991-60.339 24.991zM140.458 823.168l682.669-682.666 60.329 60.373-682.666 682.669-60.331-60.375z"
      ],
      "tags": [
        "percentage--business-products"
      ],
      "defaultCode": 59870,
      "grid": 0
    },
    {
      "paths": [
        "M938.665 0h-341.33c-22.636 0-44.339 8.99-60.339 24.994-16.005 16.003-24.996 37.708-24.996 60.34v426.666h85.335v-256h341.33v341.335h-256v85.33h256v85.335h-256v85.335h256c22.636 0 44.339-8.991 60.339-24.996 16.005-16 24.996-37.709 24.996-60.339v-682.666c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.704-24.994-60.339-24.994v0zM938.665 170.666h-341.33v-85.333h341.33v85.333zM341.334 256v85.334h-128c-11.316 0-22.169 4.495-30.17 12.496s-12.497 18.854-12.497 30.17v128h85.334v-85.334h85.334v85.334l128-128-128-128zM0 640v341.335c0 11.315 4.495 22.164 12.497 30.167s18.854 12.498 30.17 12.498h85.333v-85.335h-42.666v-256h42.666v-85.33h-85.333c-11.316 0-22.168 4.495-30.17 12.493-8.002 8.003-12.497 18.857-12.497 30.172v0z",
        "M554.665 597.335h-85.331v85.33h42.666v256h-42.666v85.335h85.331c11.315 0 22.17-4.495 30.172-12.498s12.498-18.852 12.498-30.167v-341.335c0-11.315-4.495-22.17-12.498-30.172-8.003-7.997-18.857-12.493-30.172-12.493zM341.334 597.335h-85.334v44.8c-25.923 5.263-48.966 19.968-64.654 41.267s-22.904 47.667-20.246 73.984c2.658 26.317 15.001 50.708 34.632 68.439s45.149 27.535 71.602 27.51h42.666c5.658 0 11.084 2.248 15.085 6.246s6.248 9.426 6.248 15.084c0 5.658-2.248 11.085-6.248 15.089-4.001 3.999-9.427 6.246-15.085 6.246h-149.333v85.335h85.333v42.665h85.334v-44.8c25.923-5.263 48.966-19.973 64.655-41.272 15.689-21.294 22.904-47.662 20.246-73.979-2.658-26.322-15.001-50.714-34.632-68.444s-45.149-27.53-71.602-27.505h-42.666c-5.658 0-11.084-2.248-15.085-6.246-4.001-4.004-6.248-9.431-6.248-15.089s2.248-11.085 6.248-15.084c4.001-3.999 9.427-6.246 15.085-6.246h149.334v-85.335h-85.334v-42.665z"
      ],
      "tags": [
        "phone-money-fund-transaction--business-products"
      ],
      "defaultCode": 59871,
      "grid": 0
    },
    {
      "paths": [
        "M341.334 213.334v85.334h-128c-11.316 0-22.169 4.495-30.17 12.497s-12.496 18.854-12.496 30.17v128h85.333v-85.333h85.334v85.333l128-128-128-128zM213.334 554.665c-42.193 0-83.439 12.513-118.522 35.953-35.082 23.444-62.426 56.76-78.572 95.744-16.147 38.979-20.371 81.874-12.14 123.259 8.232 41.38 28.55 79.396 58.385 109.23s67.848 50.15 109.23 58.383c41.383 8.233 84.277 4.009 123.258-12.14s72.3-43.489 95.741-78.572c23.441-35.082 35.953-76.329 35.953-118.523-0.068-56.561-22.565-110.781-62.558-150.774s-94.216-62.49-150.775-62.561v0zM213.334 896c-25.316 0-50.063-7.506-71.113-21.571s-37.455-34.058-47.143-57.446c-9.688-23.388-12.223-49.126-7.284-73.953 4.939-24.832 17.129-47.636 35.031-65.541 17.901-17.9 40.709-30.090 65.538-35.031 24.83-4.936 50.566-2.401 73.955 7.286s43.38 26.097 57.444 47.145c14.065 21.048 21.572 45.798 21.572 71.112 0 33.946-13.486 66.504-37.49 90.511-24.005 24.003-56.562 37.489-90.51 37.489zM938.665 85.334h-341.33c-22.636 0-44.339 8.991-60.339 24.994-16.005 16.003-24.996 37.708-24.996 60.34v682.668c0 22.63 8.991 44.334 24.996 60.339 16 16 37.704 24.991 60.339 24.991h341.33c22.636 0 44.339-8.991 60.339-24.991 16.005-16.005 24.996-37.709 24.996-60.339v-682.668c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.704-24.994-60.339-24.994zM938.665 170.667v85.334h-341.33v-85.334h341.33zM938.665 341.334v341.331h-341.33v-341.331h341.33zM597.335 853.335v-85.335h341.33v85.335h-341.33z"
      ],
      "tags": [
        "phone-money-fund-transaction-1--business-products"
      ],
      "defaultCode": 59872,
      "grid": 0
    },
    {
      "paths": [
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h554.668c23.562 0 42.665 19.103 42.665 42.667v298.667h-85.335v-256h-469.331v853.331h170.666v85.335h-213.333c-23.564 0-42.667-19.103-42.667-42.665v-938.668z",
        "M42.667 853.335h213.333v85.33h-213.333v-85.33z",
        "M341.334 469.334c0-23.564 19.102-42.666 42.666-42.666h597.335c23.562 0 42.665 19.102 42.665 42.666v512.002c0 23.562-19.103 42.665-42.665 42.665h-597.335c-23.564 0-42.666-19.103-42.666-42.665v-512.002zM426.666 512v426.665h511.998v-426.665h-511.998z",
        "M384 597.335h597.335v85.33h-597.335v-85.33z",
        "M853.335 853.335h-128v-85.335h128v85.335z"
      ],
      "tags": [
        "phone-receipt-register--shopping-ecommerce"
      ],
      "defaultCode": 59873,
      "grid": 0
    },
    {
      "paths": [
        "M268.512 12.482c8.010-8.003 18.873-12.493 30.197-12.482 61.713 0.060 121.892 19.236 172.263 54.89 41.966 29.705 75.404 69.632 97.292 115.776h114.401c90.527 0 177.347 35.962 241.362 99.974 64.010 64.013 99.973 150.832 99.973 241.359v42.66c0 0.005 0 0 0 0 0.005 47.744-10.040 94.956-29.481 138.563-17.27 38.743-41.62 73.871-71.747 103.598l-18.145 127.119c-0.005 0.020 0-0.015 0 0-3.937 27.766-17.766 53.228-38.938 71.619-21.181 18.401-48.297 28.534-76.355 28.534-28.063 0-55.178-10.132-76.36-28.534-21.171-18.391-34.99-43.796-38.927-71.562 0-0.015-0.005-0.036-0.005-0.056l-4.004-27.94h-188.088l-3.992 27.812c-0.003 0.020-0.005 0.041-0.008 0.056-3.936 27.761-17.757 53.171-38.927 71.562-21.183 18.401-48.298 28.534-76.358 28.534s-55.175-10.132-76.358-28.534c-21.171-18.391-34.993-43.802-38.927-71.567-0.002-0.015 0.003 0.015 0 0l-12.542-87.757c-42.296-28.764-77.596-66.627-103.325-110.771h-88.848c-23.564 0-42.667-19.103-42.667-42.67v-298.665c0-23.564 19.103-42.666 42.667-42.666h88.752c29.92-51.698 72.883-94.661 124.581-124.581v-174.085c0-11.323 4.501-22.182 12.512-30.185zM341.334 89.694v152.78c0 16.461-9.469 31.453-24.332 38.526-53.18 25.308-96.026 68.154-121.333 121.334-7.073 14.863-22.066 24.332-38.526 24.332h-71.808v213.334h71.808c16.406 0 31.358 9.405 38.461 24.197 21.947 45.696 56.909 83.896 100.494 109.788 11.101 6.595 18.618 17.864 20.445 30.643l15.327 107.249c1.049 7.424 4.742 14.213 10.4 19.128 5.659 4.92 12.902 7.624 20.398 7.624s14.739-2.703 20.398-7.624c5.659-4.915 9.352-11.704 10.401-19.128l0.013-0.092 9.258-64.512c3.015-21.007 21.011-36.608 42.234-36.608h237.694c6.298 0 12.78-0.456 20.782-1.101 22.461-1.802 42.455 14.177 45.65 36.485l9.436 65.956c1.050 7.424 4.746 14.213 10.404 19.128 5.658 4.92 12.902 7.624 20.398 7.624s14.735-2.703 20.398-7.624c5.658-4.915 9.349-11.704 10.399-19.128l0.010-0.061 20.265-141.952c1.413-9.917 6.272-19.016 13.727-25.708 26.604-23.905 47.882-53.14 62.449-85.811 14.561-32.666 22.088-68.035 22.083-103.803v-42.67c0-67.895-26.967-133.010-74.977-181.019s-113.126-74.981-181.023-74.981h-142.889c-18.084 0-34.2-11.397-40.226-28.445-14.694-41.56-41.901-77.547-77.88-103.014-24.207-17.135-51.587-28.942-80.336-34.847z",
        "M341.334 469.334c23.564 0 42.666-19.103 42.666-42.667s-19.103-42.666-42.666-42.666c-23.564 0-42.667 19.103-42.667 42.666s19.103 42.667 42.667 42.667z",
        "M768 426.668h-256v-85.333h256v85.333z"
      ],
      "tags": [
        "piggy-bank--business-products"
      ],
      "defaultCode": 59874,
      "grid": 0
    },
    {
      "paths": [
        "M307.504 439.162l128 128.001c8.002 8.003 12.497 18.852 12.497 30.167 0 11.32-4.495 22.17-12.497 30.172l-128 128-60.34-60.339 97.83-97.833-97.83-97.828 60.34-60.34zM448.001 725.33c0-23.562 19.103-42.665 42.667-42.665h255.997c23.567 0 42.67 19.103 42.67 42.665 0 23.567-19.103 42.67-42.67 42.67h-255.997c-23.564 0-42.667-19.103-42.667-42.67z",
        "M113.987 49.987c32.006-32.006 75.416-49.987 120.679-49.987h682.669v85.334h-682.669c-22.631 0-44.337 8.99-60.34 24.993s-24.993 37.708-24.993 60.34c0 22.632 8.99 44.337 24.993 60.34s37.708 24.994 60.34 24.994h639.998c23.567 0 42.67 19.103 42.67 42.666v682.669c0 23.562-19.103 42.665-42.67 42.665h-639.998c-45.263 0-88.673-17.981-120.679-49.987s-49.987-75.418-49.987-120.678v-682.669c0-45.263 17.981-88.673 49.987-120.679zM149.334 318.469v534.866c0 22.63 8.99 44.334 24.993 60.339 16.003 16 37.708 24.991 60.34 24.991h597.334v-597.331h-597.334c-30.218 0-59.609-8.014-85.333-22.865z"
      ],
      "tags": [
        "programming-book"
      ],
      "defaultCode": 59875,
      "grid": 0
    },
    {
      "paths": [
        "M0 1024v-1024h85.334v1024h-85.334zM359.006 426.666l97.83-97.83-60.34-60.34-128 128c-16.663 16.662-16.663 43.677 0 60.34l128 128.001 60.34-60.339-97.83-97.831zM627.502 268.497l128 128c16.666 16.662 16.666 43.677 0 60.34l-128 128.001-60.339-60.339 97.833-97.831-97.833-97.83 60.339-60.34z",
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h384c6.624 0 13.157 1.542 19.081 4.504l161.658 80.829h373.929c23.562 0 42.665 19.102 42.665 42.666v682.665c0 23.567-19.103 42.67-42.665 42.67h-384c-6.625 0-13.158-1.546-19.082-4.506l-161.658-80.829h-373.928c-23.564 0-42.667-19.103-42.667-42.665v-682.668zM85.334 85.334v597.331h341.333c6.624 0 13.157 1.546 19.081 4.506l161.658 80.829h331.259v-597.334h-341.33c-6.625 0-13.158-1.542-19.082-4.504l-161.658-80.829h-331.261z"
      ],
      "tags": [
        "programming-flag--programing-apps-websites"
      ],
      "defaultCode": 59876,
      "grid": 0
    },
    {
      "paths": [
        "M0 469.332c0-23.564 19.103-42.667 42.667-42.667h128c19.050 0 35.792 12.628 41.025 30.945l73.996 258.984 130.631-32.655c14.346-3.589 29.526 0.512 40.119 10.829s15.088 25.385 11.88 39.818l-85.333 384c-4.338 19.523-21.653 33.413-41.651 33.413h-170.667c-17.068 0-32.494-10.173-39.217-25.861l-128-298.665c-2.276-5.315-3.45-11.028-3.45-16.809v-341.332zM85.334 511.999v289.911l113.467 264.755h108.306l62.932-283.197-103.692 25.923c-22.324 5.581-45.051-7.542-51.373-29.67l-76.492-267.721h-53.15zM812.308 457.611c5.233-18.317 21.975-30.945 41.027-30.945h128c23.562 0 42.665 19.103 42.665 42.667v341.332c0 5.78-1.172 11.494-3.451 16.809l-128 298.665-78.433-33.613 124.549-290.616v-289.911h-53.146l-76.493 267.721c-6.323 22.129-29.051 35.251-51.374 29.67l-103.69-25.923 70.354 316.611-83.302 18.509-85.33-384c-3.21-14.433 1.285-29.501 11.878-39.818s25.774-14.418 40.12-10.829l130.632 32.655 73.994-258.984z",
        "M485.864 426.666l151.945-455.841-80.952-26.985-160.942 482.825h89.949zM695.163 72.836l140.498 140.497-140.498 140.497 60.339 60.34 170.67-170.666c7.997-8.002 12.493-18.854 12.493-30.17s-4.495-22.168-12.493-30.17l-170.67-170.666-60.339 60.34zM268.497 12.496l-170.666 170.666c-8.002 8.002-12.497 18.854-12.497 30.17s4.495 22.169 12.497 30.17l170.666 170.666 60.34-60.34-140.496-140.497 140.496-140.497-60.34-60.34z"
      ],
      "tags": [
        "programming-hold-code-2--programing-apps-websites"
      ],
      "defaultCode": 59877,
      "grid": 0
    },
    {
      "paths": [
        "M896 85.334c-11.315 0-22.17 4.495-30.172 12.496-7.997 8.002-12.493 18.854-12.493 30.17v682.665c0 42.194-12.513 83.441-35.953 118.523-23.444 35.082-56.76 62.428-95.744 78.572-38.979 16.148-81.874 20.372-123.259 12.14-3.215-0.635-6.405-1.352-9.58-2.135v6.236h-375.466c-56.58 0-110.842-22.477-150.85-62.484s-62.484-94.269-62.484-150.851c0-56.576 22.476-110.838 62.484-150.845s94.27-62.484 150.85-62.484h426.666c23.562 0 42.665 19.103 42.665 42.665s-19.103 42.665-42.665 42.665c-25.318 0-50.063 7.511-71.112 21.576s-37.458 34.053-47.145 57.441c-9.687 23.388-12.223 49.126-7.286 73.958 4.941 24.827 17.132 47.636 35.031 65.536 17.905 17.9 40.709 30.090 65.541 35.031 24.827 4.941 50.565 2.406 73.953-7.286 23.388-9.687 43.382-26.092 57.446-47.14 14.065-21.053 21.571-45.798 21.571-71.117v-682.665c0-33.948 13.486-66.505 37.489-90.51 24.008-24.005 56.566-37.49 90.511-37.49s66.504 13.486 90.511 37.49c24.003 24.004 37.489 56.562 37.489 90.51v128h-85.335v-128c0-11.316-4.495-22.169-12.493-30.17-8.003-8.002-18.857-12.496-30.172-12.496zM469.334 682.665h-256c-33.948 0-66.505 13.486-90.51 37.494-24.005 24.003-37.49 56.561-37.49 90.506 0 33.951 13.486 66.509 37.49 90.511s56.562 37.489 90.51 37.489h255.999c-19.082-25.441-32.313-54.938-38.567-86.38-8.231-41.38-4.006-84.275 12.14-123.259 6.871-16.589 15.769-32.148 26.428-46.362z",
        "M298.666 85.334c-11.316 0-22.169 4.495-30.17 12.496s-12.497 18.854-12.497 30.17v384h-85.333v-384c0-33.948 13.486-66.505 37.49-90.51s56.562-37.49 90.51-37.49h597.334v85.334h-597.334zM682.665 256h-341.332v-85.334h341.332v85.334zM597.335 426.666h-256.002v-85.333h256.002v85.333z"
      ],
      "tags": [
        "programming-language-code--programing-apps-websites"
      ],
      "defaultCode": 59878,
      "grid": 0
    },
    {
      "paths": [
        "M149.961 149.961c96.019-96.018 226.248-149.961 362.039-149.961 135.793 0 266.020 53.943 362.040 149.961 96.015 96.019 149.96 226.248 149.96 362.039 0 135.793-53.944 266.020-149.96 362.040-96.020 96.015-226.248 149.96-362.040 149.96-135.791 0-266.020-53.944-362.039-149.96-96.018-96.020-149.961-226.248-149.961-362.040 0-135.791 53.943-266.020 149.961-362.039zM512 85.334c-113.159 0-221.683 44.952-301.699 124.967s-124.967 188.54-124.967 301.699c0 113.157 44.952 221.686 124.967 301.701s188.54 124.964 301.699 124.964c113.157 0 221.686-44.948 301.701-124.964s124.964-188.544 124.964-301.701c0-113.159-44.948-221.683-124.964-301.699s-188.544-124.967-301.701-124.967z",
        "M514.278 277.465c-19.612-0.26-38.941 4.688-56.015 14.34s-31.282 23.661-41.173 40.597c-9.891 16.936-15.112 36.194-15.128 55.808l-85.504-0.073c0.029-34.742 9.276-68.855 26.797-98.855s42.688-54.816 72.933-71.912c30.245-17.096 64.484-25.861 99.222-25.401 34.739 0.46 68.736 10.13 98.519 28.022 29.778 17.891 54.282 43.365 70.999 73.819 16.722 30.455 25.062 64.8 24.172 99.531-0.896 34.731-10.982 68.604-29.245 98.161-18.253 29.551-44.022 53.732-74.675 70.070-14.976 7.992-27.505 19.901-36.244 34.452-8.735 14.556-13.358 31.206-13.373 48.184l-85.503-0.067c0.026-32.461 8.865-64.302 25.573-92.129 16.707-27.827 40.658-50.598 69.294-65.878l0.020-0.009c17.306-9.225 31.857-22.877 42.168-39.563 10.307-16.686 16.005-35.808 16.507-55.415s-4.204-38.996-13.645-56.189c-9.436-17.193-23.27-31.574-40.079-41.674-16.814-10.1-36.009-15.559-55.619-15.819z",
        "M458.667 778.665c0 14.147 5.619 27.709 15.621 37.714 10.002 9.999 23.567 15.621 37.712 15.621 14.147 0 27.709-5.622 37.714-15.621 9.999-10.004 15.621-23.567 15.621-37.714 0-14.141-5.622-27.709-15.621-37.709-10.004-10.004-23.567-15.621-37.714-15.621-14.145 0-27.71 5.617-37.712 15.621-10.002 9.999-15.621 23.567-15.621 37.709z"
      ],
      "tags": [
        "question-circle"
      ],
      "defaultCode": 59879,
      "grid": 0
    },
    {
      "paths": [
        "M-0.007 362.668c0-130.667 49.959-256.389 139.643-351.418l62.060 58.57c-74.738 79.191-116.369 183.959-116.369 292.848s41.632 213.66 116.369 292.851l-62.060 58.568c-89.685-95.027-139.643-220.751-139.643-351.418zM938.675 362.668c0-108.889-41.636-213.658-116.372-292.848l62.060-58.57c89.687 95.029 139.643 220.751 139.643 351.418s-49.956 256.391-139.643 351.418l-62.060-58.568c74.737-79.191 116.372-183.962 116.372-292.851zM191.954 362.711c0-83.761 32.842-164.183 91.474-224l60.94 59.733c-42.997 43.866-67.081 102.842-67.081 164.267s24.084 120.4 67.081 164.265l-60.94 59.735c-58.633-59.817-91.474-140.239-91.474-224zM746.711 362.711c0-61.425-24.084-120.401-67.082-164.267l60.943-59.733c58.634 59.817 91.474 140.239 91.474 224s-32.84 164.183-91.474 224l-60.943-59.735c42.998-43.865 67.082-102.84 67.082-164.265z",
        "M512 448.001c47.13 0 85.335-38.205 85.335-85.334s-38.205-85.333-85.335-85.333c-47.128 0-85.333 38.205-85.333 85.333s38.205 85.334 85.333 85.334z",
        "M512 320.002c-23.564 0-42.666 19.103-42.666 42.666s19.102 42.667 42.666 42.667c23.562 0 42.665-19.103 42.665-42.667s-19.103-42.666-42.665-42.666zM384 362.669c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.693-57.308 128-128 128s-128-57.307-128-128z",
        "M469.333 983.465v-554.665h85.332v554.665h-85.332z"
      ],
      "tags": [
        "radio-antenna-signal-1--interface-essential"
      ],
      "defaultCode": 59880,
      "grid": 0
    },
    {
      "paths": [
        "M-0.007 383.999c0-130.667 49.959-256.39 139.643-351.418l62.060 58.57c-74.738 79.191-116.369 183.96-116.369 292.849s41.632 213.658 116.369 292.849l-62.060 58.568c-89.685-95.027-139.643-220.749-139.643-351.417zM938.675 383.999c0-108.889-41.636-213.658-116.372-292.849l62.060-58.57c89.687 95.029 139.643 220.751 139.643 351.418 0 130.668-49.956 256.39-139.643 351.417l-62.060-58.568c74.737-79.191 116.372-183.96 116.372-292.849zM170.624 383.999c0-89.345 35.031-175.129 97.572-238.934l60.94 59.734c-46.906 47.854-73.179 112.191-73.179 179.2s26.273 131.344 73.179 179.201l-60.94 59.735c-62.541-63.805-97.572-149.591-97.572-238.936zM768.041 383.999c0-67.009-26.271-131.346-73.18-179.2l60.943-59.734c62.541 63.805 97.572 149.588 97.572 238.934s-35.031 175.13-97.572 238.936l-60.943-59.735c46.909-47.857 73.18-112.192 73.18-179.201zM512 298.666c18.089 0 34.212 11.408 40.233 28.467l256 725.335c4.608 13.056 2.596 27.54-5.402 38.84-7.997 11.305-20.987 18.028-34.831 18.028h-512c-13.847 0-26.833-6.723-34.83-18.028-7.998-11.3-10.013-25.784-5.404-38.84l255.999-725.335c6.021-17.059 22.145-28.467 40.234-28.467zM316.305 1024h391.392l-195.697-554.47-195.695 554.47z",
        "M512 469.332c47.13 0 85.335-38.205 85.335-85.334s-38.205-85.334-85.335-85.334c-47.128 0-85.333 38.205-85.333 85.334s38.205 85.334 85.333 85.334z",
        "M512 341.334c-23.564 0-42.666 19.102-42.666 42.666s19.102 42.666 42.666 42.666c23.562 0 42.665-19.102 42.665-42.666s-19.103-42.666-42.665-42.666zM384 384c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z",
        "M682.665 810.665h-341.332v-85.335h341.332v85.335z"
      ],
      "tags": [
        "radio-tower-signal-3--interface-essential"
      ],
      "defaultCode": 59881,
      "grid": 0
    },
    {
      "paths": [
        "M-0.007 383.999c0-130.667 49.959-256.39 139.643-351.418l62.060 58.57c-74.738 79.191-116.369 183.96-116.369 292.849s41.632 213.658 116.369 292.849l-62.060 58.568c-89.685-95.027-139.643-220.749-139.643-351.417zM938.675 383.999c0-108.889-41.636-213.658-116.372-292.849l62.060-58.57c89.687 95.029 139.643 220.751 139.643 351.418 0 130.668-49.956 256.39-139.643 351.417l-62.060-58.568c74.737-79.191 116.372-183.96 116.372-292.849zM170.624 383.999c0-89.345 35.031-175.129 97.572-238.934l60.94 59.734c-46.906 47.854-73.179 112.191-73.179 179.2s26.273 131.344 73.179 179.201l-60.94 59.735c-62.541-63.805-97.572-149.591-97.572-238.936zM768.041 383.999c0-67.009-26.271-131.346-73.18-179.2l60.943-59.734c62.541 63.805 97.572 149.588 97.572 238.934s-35.031 175.13-97.572 238.936l-60.943-59.735c46.909-47.857 73.18-112.192 73.18-179.201zM512 298.666c18.089 0 34.212 11.408 40.233 28.467l256 725.335c4.608 13.056 2.596 27.54-5.402 38.84-7.997 11.305-20.987 18.028-34.831 18.028h-512c-13.847 0-26.833-6.723-34.83-18.028-7.998-11.3-10.013-25.784-5.404-38.84l256-725.335c6.021-17.059 22.145-28.467 40.234-28.467zM316.305 1024h391.392l-195.697-554.47-195.695 554.47z",
        "M512 469.336c47.13 0 85.335-38.205 85.335-85.334s-38.205-85.334-85.335-85.334c-47.129 0-85.334 38.205-85.334 85.334s38.205 85.334 85.334 85.334z",
        "M512 341.334c-23.564 0-42.666 19.102-42.666 42.666s19.102 42.666 42.666 42.666c23.562 0 42.665-19.102 42.665-42.666s-19.103-42.666-42.665-42.666zM384 384c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z",
        "M682.665 810.665h-341.331v-85.335h341.331v85.335z"
      ],
      "tags": [
        "radio-tower-signal"
      ],
      "defaultCode": 59882,
      "grid": 0
    },
    {
      "paths": [
        "M341.334 42.667c0-23.564 19.102-42.667 42.666-42.667h256c23.562 0 42.665 19.103 42.665 42.667v42.667h85.335c23.562 0 42.665 19.102 42.665 42.666v426.665h170.67c23.562 0 42.665 19.103 42.665 42.67v384c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-384c0-23.567 19.103-42.67 42.667-42.67h170.667v-426.665c0-23.564 19.102-42.666 42.666-42.666h85.334v-42.667zM426.666 85.334v42.666c0 23.564-19.102 42.666-42.666 42.666h-85.334v426.669c0 23.562-19.102 42.665-42.666 42.665h-170.666v298.665h853.331v-298.665h-170.665c-23.562 0-42.665-19.103-42.665-42.665v-426.669h-85.335c-23.562 0-42.665-19.102-42.665-42.666v-42.666h-170.669z",
        "M384 810.665c0-23.562 19.103-42.665 42.666-42.665h170.669c23.562 0 42.665 19.103 42.665 42.665v170.67c0 23.562-19.103 42.665-42.665 42.665h-170.669c-23.564 0-42.666-19.103-42.666-42.665v-170.67zM469.334 853.335v85.33h85.331v-85.33h-85.331z",
        "M170.666 768h85.333v85.335h-85.333v-85.335zM768 768h85.335v85.335h-85.335v-85.335zM383.999 426.666h85.334v85.334h-85.334v-85.334zM554.665 426.666h85.335v85.334h-85.335v-85.334zM383.999 597.335h85.334v85.33h-85.334v-85.33zM554.665 597.335h85.335v85.33h-85.335v-85.33zM383.999 256h85.334v85.334h-85.334v-85.334zM554.665 256h85.335v85.334h-85.335v-85.334z"
      ],
      "tags": [
        "real-estate-building-5--building-construction"
      ],
      "defaultCode": 59883,
      "grid": 0
    },
    {
      "paths": [
        "M833.111 49.067c-6.19-3.825-13.251-6.006-20.516-6.335s-14.495 1.206-21.002 4.457l-148.521 74.24-107.392-71.594c-7.009-4.678-15.252-7.174-23.68-7.174-8.429 0-16.669 2.496-23.68 7.174l-107.392 71.594-148.522-74.24c-6.503-3.25-13.729-4.784-20.992-4.457s-14.321 2.505-20.506 6.326c-6.184 3.821-11.291 9.159-14.833 15.508s-5.404 13.497-5.408 20.767v853.332c0.004 7.27 1.865 14.418 5.408 20.767s8.648 11.689 14.833 15.508c6.185 3.825 13.244 6.001 20.506 6.328s14.489-1.208 20.992-4.46l148.522-74.24 107.392 71.552c7.011 4.68 15.251 7.178 23.68 7.178 8.428 0 16.671-2.499 23.68-7.178l107.351-71.552 148.562 74.24c6.508 3.251 13.732 4.787 20.992 4.46 7.265-0.328 14.321-2.504 20.506-6.328 6.185-3.82 11.295-9.16 14.833-15.508 3.543-6.349 5.407-13.496 5.412-20.767v-853.332c-0.005-7.267-1.864-14.412-5.402-20.76-3.543-6.347-8.643-11.684-14.822-15.507v0zM768 869.632l-108.928-54.441c-6.717-3.354-14.198-4.874-21.688-4.408s-14.725 2.898-20.977 7.050l-104.407 69.632-104.32-69.545c-7.003-4.705-15.243-7.229-23.68-7.255-6.624-0.005-13.156 1.546-19.072 4.526l-108.928 54.441v-715.222l108.928 54.4c6.72 3.345 14.203 4.857 21.694 4.385s14.726-2.912 20.973-7.073l104.405-69.59 104.32 69.504c6.246 4.162 13.481 6.602 20.972 7.074s14.976-1.041 21.693-4.386l109.015-54.314v715.222z",
        "M554.665 298.666h-85.331v44.842c-25.877 5.308-48.864 20.030-64.509 41.314s-22.837 47.617-20.182 73.898c2.655 26.282 14.968 50.644 34.555 68.367 19.587 17.725 45.053 27.551 71.469 27.576h42.669c5.658 0 11.085 2.248 15.084 6.252 3.999 3.999 6.246 9.426 6.246 15.084s-2.248 11.085-6.246 15.084c-3.999 4.004-9.426 6.252-15.084 6.252h-149.335v85.33h85.334v42.67h85.331v-44.846c25.876-5.309 48.865-20.029 64.512-41.313s22.835-47.616 20.183-73.897c-2.657-26.281-14.971-50.647-34.555-68.369-19.589-17.725-45.056-27.551-71.47-27.576h-42.669c-5.658 0-11.084-2.248-15.085-6.248s-6.248-9.427-6.248-15.085c0-5.658 2.247-11.084 6.248-15.085s9.427-6.248 15.085-6.248h149.334v-85.334h-85.335v-42.666z"
      ],
      "tags": [
        "receipt-dollar--shopping-ecommerce"
      ],
      "defaultCode": 59884,
      "grid": 0
    },
    {
      "paths": [
        "M512 85.206c-176.731 0-320.001 143.269-320.001 320 0 176.729 143.269 320.002 320.001 320.002 176.732 0 320-143.273 320-320.002 0-176.731-143.268-320-320-320zM106.666 405.206c0-223.86 181.474-405.333 405.334-405.333 223.862 0 405.335 181.474 405.335 405.333 0 223.858-181.473 405.331-405.335 405.331-223.86 0-405.334-181.473-405.334-405.331z",
        "M469.333 221.738h-51.2c-23.564 0-42.666 19.103-42.666 42.667v125.184c0 20.858 15.080 38.659 35.655 42.086l152.078 25.335v46.328h-102.401v-19.379h-85.333v62.047c0 23.562 19.102 42.665 42.666 42.665h51.2v51.2h85.332v-51.2h51.2c23.567 0 42.67-19.103 42.67-42.665v-125.143c0-20.858-15.084-38.659-35.656-42.086l-152.080-25.335v-46.37h102.401v19.926h85.335v-62.592c0-23.564-19.103-42.667-42.67-42.667h-51.2v-51.2h-85.332v51.2zM469.333 1023.872v-256h85.332v256h-85.332z",
        "M640 925.865v98.135h128.256c62.505-0.701 122.696-23.772 169.661-65.029 46.961-41.257 77.594-97.971 86.339-159.867l-384.256 126.761zM383.999 925.865v98.135h-128.255c-62.508-0.701-122.697-23.772-169.66-65.029s-77.593-97.971-86.34-159.867l384.256 126.761z"
      ],
      "tags": [
        "saving-profit-interest"
      ],
      "defaultCode": 59885,
      "grid": 0
    },
    {
      "paths": [
        "M469.334 85.334v-85.334h85.331v85.334h274.811c0.082-0.001 0.169-0.001 0.256 0h194.268v85.333h-130.125l126.781 301.051c2.207 5.242 3.343 10.872 3.343 16.56 0 56.578-22.477 110.839-62.484 150.847s-94.269 62.484-150.851 62.484c-56.576 0-110.838-22.477-150.845-62.484s-62.484-94.269-62.484-150.847c0-6.924 1.684-13.744 4.91-19.871l156.698-297.74h-204.278v810.669h-85.331v-810.669h-188.577l141.802 299.345c2.704 5.709 4.107 11.949 4.107 18.266 0 56.578-22.476 110.839-62.483 150.847s-94.27 62.484-150.85 62.484c-56.58 0-110.842-22.477-150.85-62.484s-62.484-94.269-62.484-150.847c0-6.318 1.403-12.557 4.108-18.266l141.802-299.345h-145.91v-85.333h469.334zM213.334 227.664l-103.243 217.947h206.487l-103.243-217.947zM334.013 530.944h-241.359c6.305 17.833 16.542 34.217 30.17 47.841 24.005 24.008 56.562 37.494 90.51 37.494s66.505-13.486 90.509-37.494c13.628-13.624 23.866-30.008 30.17-47.841zM825.324 227.756l-114.652 217.854h206.397l-91.745-217.854zM931.348 530.944h-241.362c6.303 17.833 16.543 34.217 30.172 47.841 24.003 24.008 56.561 37.494 90.506 37.494 33.951 0 66.509-13.486 90.511-37.494 13.629-13.624 23.864-30.008 30.172-47.841z",
        "M825.257 1024c-83.625-82.043-196.106-128.005-313.257-128.005-117.153 0-229.63 45.962-313.258 128.005h626.515z"
      ],
      "tags": [
        "scale--business-products"
      ],
      "defaultCode": 59886,
      "grid": 0
    },
    {
      "paths": [
        "M0 128.001c0-23.564 19.103-42.666 42.667-42.666h938.668c23.562 0 42.665 19.102 42.665 42.666v426.669h-85.335v-384.003h-853.331v341.332h341.333v85.335h-384c-23.564 0-42.667-19.103-42.667-42.665v-426.669z",
        "M255.999 426.666c47.129 0 85.334-38.205 85.334-85.333s-38.205-85.334-85.334-85.334c-47.128 0-85.333 38.205-85.333 85.334s38.205 85.333 85.333 85.333z",
        "M511.999 426.666c47.13 0 85.336-38.205 85.336-85.333s-38.205-85.334-85.336-85.334c-47.128 0-85.333 38.205-85.333 85.334s38.205 85.333 85.333 85.333z",
        "M768 426.666c47.13 0 85.335-38.205 85.335-85.333s-38.205-85.334-85.335-85.334c-47.13 0-85.335 38.205-85.335 85.334s38.205 85.333 85.335 85.333z",
        "M896 725.335h-341.335c-23.562 0-42.665 19.103-42.665 42.665v213.335c0 23.562 19.103 42.665 42.665 42.665h341.335c23.562 0 42.665-19.103 42.665-42.665v-213.335c0-23.562-19.103-42.665-42.665-42.665z",
        "M725.335 597.335c-22.636 0-44.339 8.991-60.344 24.991-16 16.005-24.991 37.709-24.991 60.339v42.67h-85.335v-42.67c0-45.261 17.981-88.673 49.987-120.678 32.010-32.005 75.418-49.987 120.684-49.987 45.261 0 88.673 17.981 120.678 49.987s49.987 75.418 49.987 120.678v42.67h-85.335v-42.67c0-22.63-8.991-44.334-24.991-60.339-16.005-16-37.709-24.991-60.339-24.991z"
      ],
      "tags": [
        "security-password-lock--programing-apps-websites"
      ],
      "defaultCode": 59887,
      "grid": 0
    },
    {
      "paths": [
        "M395.938 32.321c4.748-18.995 21.814-32.321 41.394-32.321h149.333c19.579 0 36.644 13.323 41.39 32.316l31.329 125.272c27.044 11.198 52.716 25.453 76.524 42.484l122.936-39.207c18.647-5.947 38.948 1.556 49.244 18.2l78.592 127.018c10.301 16.651 7.951 38.177-5.704 52.208l-90.030 92.504c3.302 20.183 4.997 40.61 5.053 61.087l-42.67 0.118 42.67 0.118c-0.056 20.475-1.751 40.904-5.053 61.087l90.030 92.503c13.65 14.029 16.005 35.548 5.714 52.198l-78.592 127.104c-10.301 16.66-30.623 24.166-49.28 18.202l-122.941-39.281c-23.798 17.004-49.464 31.232-76.493 42.409l-31.324 125.338c-4.746 18.995-21.816 32.323-41.395 32.323h-149.333c-19.577 0-36.642-13.322-41.392-32.317l-31.327-125.271c-27.045-11.197-52.722-25.457-76.529-42.486l-122.94 39.168c-18.642 5.944-38.935-1.562-49.232-18.196l-78.592-126.976c-10.306-16.65-7.954-38.18 5.704-52.214l89.994-92.467c-6.69-40.55-6.69-81.929 0-122.482l-89.994-92.467c-13.656-14.031-16.009-35.557-5.707-52.208l78.592-127.018c10.298-16.644 30.6-24.146 49.247-18.2l122.952 39.212c23.803-17.007 49.472-31.239 76.506-42.417l31.325-125.339zM810.665 512c-0.072-22.039-2.575-44.002-7.47-65.491-3.21-14.101 0.942-28.869 11.028-39.233l82.36-84.626-43.54-70.368-112.358 35.834c-13.711 4.372-28.703 1.539-39.869-7.536-27.218-22.115-58.117-39.264-91.279-50.661-13.665-4.695-24.023-15.985-27.525-30l-28.657-114.586h-82.707l-28.658 114.665c-3.506 14.026-13.875 25.322-27.55 30.013-33.16 11.374-64.058 28.498-91.28 50.587-11.167 9.061-26.147 11.887-39.847 7.518l-112.36-35.834-43.54 70.368 82.362 84.626c10.116 10.394 14.259 25.214 10.999 39.347-9.922 43.020-9.922 87.736 0 130.754 3.259 14.131-0.884 28.954-10.999 39.347l-82.359 84.623 43.536 70.339 112.371-35.804c13.708-4.367 28.694-1.536 39.86 7.537 27.216 22.118 58.115 39.265 91.28 50.662 13.662 4.695 24.021 15.985 27.526 29.998l28.655 114.586h82.706l28.657-114.662c3.507-14.029 13.875-25.324 27.551-30.013 33.162-11.377 64.061-28.498 91.279-50.586 11.177-9.068 26.163-11.894 39.869-7.511l112.338 35.891 43.551-70.426-82.371-84.634c-10.086-10.363-14.239-25.134-11.028-39.235 4.895-21.489 7.398-43.453 7.47-65.49z",
        "M511.999 383.999c-70.692 0-128 57.308-128 128s57.308 128.001 128 128.001c70.693 0 128.001-57.308 128.001-128.001s-57.308-128-128.001-128zM298.665 511.999c0-117.82 95.513-213.333 213.334-213.333 117.822 0 213.331 95.513 213.331 213.333 0 117.822-95.508 213.336-213.331 213.336-117.821 0-213.334-95.514-213.334-213.336z"
      ],
      "tags": [
        "settings-cog-1"
      ],
      "defaultCode": 59888,
      "grid": 0
    },
    {
      "paths": [
        "M0 341.334c0-23.564 19.103-42.667 42.667-42.667h639.998c23.567 0 42.67 19.103 42.67 42.667v640.002c0 23.562-19.103 42.665-42.67 42.665h-639.998c-23.564 0-42.667-19.103-42.667-42.665v-640.002zM85.334 384v554.665h554.666v-554.665h-554.666z",
        "M311.163 12.497c8.002-8.002 18.854-12.497 30.17-12.497h640.002c23.562 0 42.665 19.103 42.665 42.667v639.998c0 11.315-4.495 22.17-12.498 30.172l-298.665 298.665-60.339-60.339 286.167-286.167v-519.323l-225.828 225.83-60.339-60.34 225.828-225.83h-519.319l-286.17 286.17-60.34-60.34 298.667-298.667z"
      ],
      "tags": [
        "shape-3d-box"
      ],
      "defaultCode": 59889,
      "grid": 0
    },
    {
      "paths": [
        "M199.126 398.209c-62.846 0-113.792 50.946-113.792 113.791 0 62.848 50.946 113.792 113.792 113.792s113.792-50.944 113.792-113.792c0-62.845-50.947-113.791-113.792-113.791zM0 512c0-109.974 89.151-199.125 199.126-199.125s199.125 89.151 199.125 199.125c0 109.972-89.151 199.127-199.125 199.127s-199.126-89.155-199.126-199.127z",
        "M824.873 85.334c-62.843 0-113.792 50.946-113.792 113.792s50.949 113.792 113.792 113.792c62.848 0 113.792-50.947 113.792-113.792s-50.944-113.792-113.792-113.792zM625.751 199.126c0-109.974 89.149-199.126 199.122-199.126 109.978 0 199.127 89.151 199.127 199.126s-89.149 199.125-199.127 199.125c-109.972 0-199.122-89.151-199.122-199.125z",
        "M824.873 711.081c-62.843 0-113.792 50.949-113.792 113.792 0 62.848 50.949 113.792 113.792 113.792 62.848 0 113.792-50.944 113.792-113.792 0-62.843-50.944-113.792-113.792-113.792zM625.751 824.873c0-109.972 89.149-199.122 199.122-199.122 109.978 0 199.127 89.149 199.127 199.122 0 109.978-89.149 199.127-199.127 199.127-109.972 0-199.122-89.149-199.122-199.127z",
        "M723.308 249.936c10.537 21.077 1.992 46.705-19.087 57.241l-346.198 173.056c-21.078 10.536-46.705 1.991-57.242-19.087s-1.991-46.705 19.087-57.241l346.199-173.056c21.074-10.536 46.705-1.991 57.242 19.087zM357.9 543.683l346.494 173.271-38.164 76.324-346.496-173.271 38.166-76.324z"
      ],
      "tags": [
        "share--interface-essential"
      ],
      "defaultCode": 59890,
      "grid": 0
    },
    {
      "paths": [
        "M481.83 12.497c16.663-16.662 43.676-16.662 60.342 0l256 256-60.339 60.34-183.168-183.163v536.992h-85.331v-536.992l-183.163 183.163-60.34-60.34 256-256zM170.667 469.334c0-23.564 19.103-42.667 42.667-42.667h170.666v85.334h-127.999v426.665h511.999v-426.665h-128v-85.334h170.665c23.567 0 42.67 19.103 42.67 42.667v512.002c0 23.562-19.103 42.665-42.67 42.665h-597.331c-23.564 0-42.667-19.103-42.667-42.665v-512.002z"
      ],
      "tags": [
        "share-box-1--interface-essential"
      ],
      "defaultCode": 59891,
      "grid": 0
    },
    {
      "paths": [
        "M85.331 341.334h682.669v42.411h85.33v-85.078c0.020-0.255 0.020-0.513 0-0.768-0.108-4.954-1.091-9.85-2.898-14.464-0.471-1.194-1.111-2.262-1.664-3.414-0.691-1.734-1.505-3.417-2.432-5.034l-170.67-256c-3.912-5.866-9.221-10.67-15.442-13.984-6.226-3.313-13.174-5.032-20.224-5.003h-426.669c-7.023-0.001-13.937 1.731-20.129 5.043s-11.472 8.102-15.369 13.943l-170.667 256c-0.93 1.618-1.743 3.3-2.432 5.034-0.555 1.152-1.195 2.219-1.664 3.414-1.867 4.603-2.907 9.5-3.072 14.464-0.020 0.255-0.020 0.513 0 0.768v511.998c0 11.32 4.495 22.17 12.497 30.172s18.854 12.498 30.17 12.498h341.334v-85.335h-298.667v-426.666zM730.921 256.001h-261.59v-170.667h147.839l113.751 170.667zM236.158 85.334h147.84v170.667h-261.59l113.75-170.667zM1011.497 609.577l-128-127.998c-8.003-7.999-18.852-12.492-30.167-12.492-11.31 0-22.164 4.493-30.162 12.492l-298.67 298.668c-5.463 5.458-9.339 12.303-11.218 19.794l-42.669 170.67c-1.576 6.287-1.697 12.856-0.354 19.2 1.343 6.349 4.115 12.303 8.105 17.418 3.99 5.11 9.093 9.247 14.922 12.093 5.828 2.842 12.228 4.321 18.714 4.321 3.494-0.005 6.975-0.435 10.37-1.28l170.665-42.665c7.501-1.859 14.346-5.74 19.799-11.223l298.665-298.665c7.997-8.003 12.493-18.852 12.493-30.167s-4.495-22.164-12.493-30.167zM660.864 899.712l-90.199 22.569 22.528-90.24 132.265-132.265 67.671 67.625-132.265 132.311zM853.33 707.415l-67.666-67.671 67.666-67.625 67.671 67.625-67.671 67.671z"
      ],
      "tags": [
        "shipment-product-box-edit--shopping-ecommerce"
      ],
      "defaultCode": 59892,
      "grid": 0
    },
    {
      "paths": [
        "M323.66 512l-311.163-311.163 60.34-60.34 341.334 341.334c8.002 8.002 12.497 18.854 12.497 30.17s-4.495 22.17-12.497 30.172l-341.334 341.33-60.34-60.339 311.163-311.163zM624.594 480.392l325.97-339.285 61.537 59.12-297.743 309.902 297.917 313.828-61.885 58.752-325.975-343.383c-15.698-16.532-15.621-42.491 0.179-58.934z"
      ],
      "tags": [
        "shrink-horizontal-4--interface-essential"
      ],
      "defaultCode": 59893,
      "grid": 0
    },
    {
      "paths": [
        "M256 187.734c0-47.129 38.205-85.334 85.334-85.334h384.002c47.124 0 85.33 38.205 85.33 85.334v682.666c0 47.13-38.205 85.335-85.33 85.335h-384.002c-47.129 0-85.334-38.205-85.334-85.335v-682.666zM725.335 187.734h-384.002v682.666h384.002v-682.666z",
        "M256 315.732c0-23.564 19.103-42.667 42.666-42.667h469.334c23.562 0 42.665 19.103 42.665 42.667s-19.103 42.666-42.665 42.666h-469.334c-23.564 0-42.666-19.103-42.666-42.666zM768 785.065h-469.334v-85.335h469.334v85.335z"
      ],
      "tags": [
        "smartphone-action-money-fund--phones-mobile-devices"
      ],
      "defaultCode": 59894,
      "grid": 0
    },
    {
      "paths": [
        "M512 0c0.22 0 0.44 0.002 0.66 0.005 6.922 0.105 13.44 1.858 19.19 4.883zM531.85 4.888l425.897 212.949c14.454 7.227 23.588 22.002 23.588 38.162s-9.134 30.935-23.588 38.162l-403.082 201.54v58.962h128c2.335 0 4.664 0.195 6.963 0.573 90.88 15.027 171.244 41.631 230.164 77.512 57.247 34.862 104.207 85.151 104.207 149.801 0 42.056-20.306 78.428-49.362 107.52-28.882 28.928-68.536 53.012-114.13 72.325-91.361 38.697-214.605 61.604-348.508 61.604s-257.147-22.907-348.507-61.604c-45.597-19.313-85.247-43.397-114.133-72.325-29.054-29.092-49.36-65.464-49.36-107.52 0-64.65 46.962-114.939 104.208-149.801 58.919-35.881 139.282-62.484 230.164-77.512 2.301-0.379 4.629-0.573 6.961-0.573h128v-511.998c0-10.724 3.956-20.524 10.489-28.019 1.338-1.537 2.792-2.984 4.353-4.327 7.373-6.349 16.942-10.219 27.411-10.319zM554.665 400.297l288.594-144.297-288.594-144.297v288.595zM469.334 640h-124.454c-82.505 13.978-150.24 37.586-196.287 65.628-48.354 29.45-63.259 57.303-63.259 76.923 0 12.836 5.961 28.754 24.407 47.222 18.615 18.642 47.697 37.386 87.034 54.047 78.506 33.254 189.929 54.845 315.226 54.845s236.718-21.591 315.228-54.845c39.337-16.66 68.419-35.405 87.030-54.047 18.447-18.468 24.407-34.386 24.407-47.222 0-19.62-14.904-47.473-63.258-76.923-46.044-28.042-113.782-51.651-196.285-65.628h-124.457v170.665c0 23.567-19.103 42.67-42.665 42.67-23.564 0-42.666-19.103-42.666-42.67v-170.665z"
      ],
      "tags": [
        "sport-golf-hole--sports"
      ],
      "defaultCode": 59895,
      "grid": 0
    },
    {
      "paths": [
        "M512 0c16.323 0 31.217 9.315 38.364 23.993l142.792 293.359 290.816 18.004c15.964 0.988 30.034 10.823 36.449 25.476 6.41 14.653 4.091 31.662-6.011 44.062l-217.016 266.318 90.696 297.687c4.91 16.113-0.123 33.608-12.841 44.652-12.723 11.044-30.751 13.573-46.019 6.446l-317.23-148.040-317.232 148.040c-15.266 7.127-33.294 4.598-46.014-6.446s-17.753-28.539-12.843-44.652l90.695-297.687-217.014-266.318c-10.104-12.4-12.424-29.409-6.010-44.062s20.485-24.487 36.45-25.476l290.812-18.004 142.795-293.359c7.145-14.678 22.039-23.993 38.363-23.993zM512 140.154l-115.322 236.919c-6.73 13.826-20.379 22.961-35.727 23.911l-232.728 14.408 178.9 219.544c8.98 11.018 11.882 25.789 7.739 39.388l-69.42 227.855 248.515-115.968c11.437-5.34 24.648-5.34 36.086 0l248.515 115.968-69.422-227.855c-4.142-13.599-1.239-28.37 7.741-39.388l178.898-219.544-232.724-14.408c-15.35-0.95-29-10.085-35.727-23.911l-115.323-236.919z"
      ],
      "tags": [
        "star--rewards-rating"
      ],
      "defaultCode": 59896,
      "grid": 0
    },
    {
      "paths": [
        "M0 85.334c0-23.564 19.103-42.667 42.667-42.667h853.333c23.562 0 42.665 19.103 42.665 42.667v426.666h-85.33v-383.999h-768.002v597.335h298.666v85.33h-341.333c-23.564 0-42.667-19.103-42.667-42.665v-682.666z",
        "M445.923 481.027l-426.667-280.022 46.821-71.341 403.256 264.657 403.258-264.657 46.817 71.341-426.664 280.022c-14.213 9.328-32.608 9.328-46.821 0zM878.326 725.335l-97.828-97.833 60.339-60.339 170.665 170.67c16.666 16.66 16.666 43.674 0 60.339l-170.665 170.665-60.339-60.339 97.828-97.828h-366.326v-85.335h366.326z"
      ],
      "tags": [
        "streamline-icon-email-forward@20x20 1"
      ],
      "defaultCode": 59897,
      "grid": 0
    },
    {
      "paths": [
        "M343.935 313.771h-241.365v-241.366l241.365 241.366z",
        "M452.097 524.928v-256h85.334v213.334h128v85.331h-170.668c-23.564 0-42.666-19.103-42.666-42.665z",
        "M347.678 79.233c91.027-30.064 189.078-31.533 280.966-4.209s173.204 82.132 233.011 157.050c59.812 74.918 95.242 166.355 101.535 262.013 6.292 95.655-16.86 190.948-66.345 273.053-49.48 82.109-122.916 147.092-210.432 186.214-87.521 39.127-184.918 50.514-279.099 32.63s-180.627-64.179-247.712-132.659l60.957-59.715c54.888 56.028 125.617 93.906 202.674 108.539 77.058 14.628 156.746 5.315 228.354-26.696 71.603-32.010 131.686-85.181 172.175-152.361 40.484-67.174 59.423-145.142 54.277-223.406-5.146-78.265-34.135-153.077-83.072-214.374s-115.466-106.139-190.648-128.496c-75.177-22.356-155.402-21.155-229.879 3.443s-139.636 71.413-186.713 134.148l-68.253-51.217c57.538-76.677 137.176-133.895 228.204-163.959z"
      ],
      "tags": [
        "synchronize-arrow-time--interface-essential"
      ],
      "defaultCode": 59898,
      "grid": 0
    },
    {
      "paths": [
        "M413.367 9.584c99.795-19.596 203.163-9.030 296.925 30.352s173.676 105.796 229.545 190.773c55.875 84.977 85.171 184.668 84.163 286.364l-85.33-0.85c0.84-84.744-23.572-167.82-70.134-238.634-46.556-70.814-113.152-126.159-191.288-158.978s-164.275-41.624-247.438-25.293c-83.161 16.33-159.575 57.056-219.498 116.986l-66.401 66.358-60.32-60.359 66.378-66.335c0.004-0.004-0.004 0.004 0 0 71.907-71.909 163.61-120.788 263.398-140.383z",
        "M346.071 279.68h-265.515v-265.472l265.515 265.472z",
        "M84.167 793.262c-55.869-84.966-85.171-184.648-84.171-286.332l85.329 0.839c-0.834 84.738 23.585 167.805 70.142 238.609s113.144 126.147 191.273 158.961c78.129 32.819 164.26 41.626 247.415 25.303s159.565-57.037 219.489-116.951l66.396-66.355 60.324 60.36-66.386 66.34c-71.91 71.9-163.599 120.755-263.388 140.344-99.784 19.584-203.141 9.016-296.896-30.367-93.754-39.378-173.659-105.784-229.528-190.751z",
        "M943.447 1009.792v-265.472h-265.518l265.518 265.472z"
      ],
      "tags": [
        "synchronize-arrows-1--interface-essential"
      ],
      "defaultCode": 59899,
      "grid": 0
    },
    {
      "paths": [
        "M213.334 768c-25.316 0-50.063-7.506-71.113-21.571s-37.456-34.058-47.144-57.446c-9.688-23.388-12.222-49.126-7.284-73.953 4.939-24.832 17.129-47.636 35.031-65.541 17.901-17.9 40.708-30.090 65.538-35.031 24.829-4.937 50.566-2.401 73.955 7.286s43.38 26.097 57.445 47.145c14.065 21.048 21.572 45.793 21.572 71.112 0 33.946-13.486 66.504-37.49 90.511-24.005 24.003-56.562 37.489-90.51 37.489zM213.334 597.335c-8.438 0-16.688 2.499-23.704 7.188s-12.485 11.351-15.715 19.149c-3.229 7.798-4.074 16.374-2.428 24.653 1.647 8.274 5.71 15.877 11.677 21.847 5.967 5.965 13.57 10.030 21.846 11.674 8.276 1.649 16.855 0.804 24.652-2.427s14.46-8.699 19.148-15.713c4.688-7.020 7.191-15.268 7.191-23.706 0-11.315-4.495-22.17-12.497-30.172-8.002-7.997-18.854-12.493-30.17-12.493z",
        "M426.666 1024h-426.666v-42.665c0-56.581 22.476-110.843 62.484-150.851s94.27-62.484 150.85-62.484c56.58 0 110.841 22.477 150.85 62.484s62.483 94.269 62.483 150.851v42.665zM92.63 938.665h241.408c-8.813-24.97-25.155-46.597-46.773-61.891-21.618-15.299-47.449-23.511-73.931-23.511s-52.313 8.212-73.931 23.511c-21.619 15.293-37.96 36.92-46.773 61.891v0zM810.665 768c-25.313 0-50.063-7.506-71.112-21.571s-37.453-34.058-47.145-57.446c-9.687-23.388-12.221-49.126-7.281-73.953 4.936-24.832 17.126-47.636 35.031-65.541 17.9-17.9 40.709-30.090 65.536-35.031 24.832-4.937 50.565-2.401 73.953 7.286 23.393 9.687 43.382 26.097 57.446 47.145s21.571 45.793 21.571 71.112c0 33.946-13.486 66.504-37.489 90.511-24.003 24.003-56.561 37.489-90.511 37.489zM810.665 597.335c-8.438 0-16.686 2.499-23.7 7.188-7.020 4.69-12.488 11.351-15.718 19.149-3.226 7.798-4.070 16.374-2.427 24.653 1.649 8.274 5.709 15.877 11.679 21.847 5.965 5.965 13.568 10.030 21.847 11.674 8.274 1.649 16.855 0.804 24.648-2.427 7.798-3.231 14.464-8.699 19.149-15.713 4.69-7.020 7.194-15.268 7.194-23.706 0-11.315-4.495-22.17-12.498-30.172-8.003-7.997-18.857-12.493-30.172-12.493z",
        "M1024 1024h-426.665v-42.665c0-56.581 22.477-110.843 62.484-150.851s94.269-62.484 150.845-62.484c56.581 0 110.843 22.477 150.851 62.484s62.484 94.269 62.484 150.851v42.665zM689.961 938.665h241.408c-8.812-24.97-25.155-46.597-46.771-61.891-21.617-15.299-47.447-23.511-73.933-23.511-26.481 0-52.311 8.212-73.928 23.511-21.622 15.293-37.96 36.92-46.776 61.891zM554.665 0v362.666h128v106.667l192-106.667h149.335v-362.666h-469.335zM907.945 254.72l-45.225 45.226-73.385-73.344-73.39 73.344-45.225-45.226 73.344-73.386-73.344-73.387 45.225-45.226 73.39 73.344 73.385-73.344 45.225 45.226-73.344 73.387 73.344 73.386zM469.334 0h-469.334v362.666h149.334l192 106.667v-106.667h128v-362.666zM192 301.27l-107.946-107.99 45.226-45.226 62.72 62.677 148.054-148.010 45.226 45.226-193.28 193.323z"
      ],
      "tags": [
        "team-approve-disapprove--work-office"
      ],
      "defaultCode": 59900,
      "grid": 0
    },
    {
      "paths": [
        "M469.333 231.004l-158.17-158.17 60.34-60.34 140.496 140.497 140.498-140.497 60.339 60.34-158.172 158.17v207.091l179.343-103.544 57.887-216.060 82.427 22.085-51.42 191.918 191.918 51.421-22.088 82.426-216.059-57.89-179.343 103.546 179.343 103.545 216.059-57.887 22.088 82.422-191.918 51.425 51.42 191.918-82.427 22.083-57.887-216.059-179.343-103.547v207.094l158.172 158.172-60.339 60.339-140.498-140.498-140.496 140.498-60.34-60.339 158.17-158.172v-207.094l-179.34 103.547-57.89 216.059-82.426-22.083 51.421-191.918-191.918-51.425 22.085-82.422 216.060 57.887 179.342-103.545-179.342-103.546-216.060 57.89-22.085-82.426 191.918-51.421-51.421-191.918 82.426-22.085 57.89 216.059 179.34 103.545v-207.091z"
      ],
      "tags": [
        "temperature-snow-flake--weather"
      ],
      "defaultCode": 59901,
      "grid": 0
    },
    {
      "paths": [
        "M170.667 384h341.333v85.334h-341.333v-85.334zM170.667 554.665h256v85.335h-256v-85.335z",
        "M85.334 85.334h426.666v170.666h170.665v170.666h85.335v-230.997l-195.671-195.67h-486.995c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v768.002c0 22.63 8.99 44.334 24.994 60.339 16.003 16 37.708 24.991 60.34 24.991h512.002v-85.33h-512.002v-768.002z",
        "M896 725.335h-85.335c-11.315 0-22.164-4.495-30.167-12.498s-12.498-18.857-12.498-30.172c0-11.315 4.495-22.164 12.498-30.167s18.852-12.498 30.167-12.498h170.67v-85.335h-85.335v-42.665h-85.335v42.665c-33.946 0-66.504 13.486-90.506 37.494-24.008 24.003-37.494 56.561-37.494 90.506 0 33.951 13.486 66.509 37.494 90.511 24.003 24.003 56.561 37.489 90.506 37.489h85.335c11.315 0 22.17 4.495 30.172 12.498 7.997 8.003 12.493 18.857 12.493 30.172s-4.495 22.164-12.493 30.167c-8.003 8.003-18.857 12.498-30.172 12.498h-170.665v85.335h85.33v42.665h85.335v-42.665c33.946 0 66.504-13.486 90.511-37.494 24.003-24.003 37.489-56.561 37.489-90.506 0-33.951-13.486-66.509-37.489-90.511-24.008-24.003-56.566-37.489-90.511-37.489z"
      ],
      "tags": [
        "text-document-money-fund---files-&-folders"
      ],
      "defaultCode": 59902,
      "grid": 0
    },
    {
      "paths": [
        "M431.274 683.986h170.070c10.081 26.030 28.093 48.225 51.492 63.442s50.99 22.682 78.874 21.34c27.878-1.336 54.625-11.418 76.457-28.81 21.827-17.393 37.632-41.216 45.169-68.091h-128.256v-72.786h128.256c-7.537-26.875-23.342-50.698-45.169-68.091-21.832-17.393-48.579-27.471-76.457-28.812-27.884-1.34-55.475 6.127-78.874 21.347-23.398 15.217-41.411 37.412-51.492 63.437h-170.070c-10.079-26.025-28.094-48.22-51.492-63.437-23.398-15.22-50.992-22.687-78.871-21.347s-54.628 11.419-76.458 28.812c-21.83 17.393-37.632 41.216-45.168 68.091h128.256v72.786h-128.342c7.536 26.875 23.338 50.698 45.168 68.091s48.58 27.474 76.458 28.81c27.879 1.341 55.473-6.124 78.871-21.34s41.413-37.412 51.493-63.442h0.085z",
        "M280.994 24.994c16.003-16.003 37.708-24.994 60.34-24.994h341.331c22.636 0 44.339 8.99 60.339 24.994 16.005 16.003 24.996 37.708 24.996 60.34v128h213.335c23.562 0 42.665 19.102 42.665 42.666v725.335c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-725.335c0-23.564 19.103-42.666 42.667-42.666h213.333v-128c0-22.632 8.991-44.337 24.994-60.34zM341.334 213.334h341.331v-128h-341.331v128zM85.334 298.666v639.998h853.331v-639.998h-853.331z"
      ],
      "tags": [
        "tool-box--furnitures-tools"
      ],
      "defaultCode": 59903,
      "grid": 0
    },
    {
      "paths": [
        "M325.337 57.597c-51.202-5.788-102.927 4.685-147.845 29.935-10.995 6.181-18.462 17.151-20.18 29.647s2.512 25.075 11.43 33.993l111.442 111.442-22.397 22.386-111.497-111.433c-8.921-8.916-21.501-13.143-33.996-11.421s-23.464 9.193-29.641 20.189c-25.232 44.917-35.691 96.634-29.894 147.826s27.555 99.261 62.192 137.398c34.637 38.137 80.397 64.409 130.796 75.089 39.922 8.463 81.151 6.804 119.992-4.593l59.34-59.338-17.015-17.015c-7.559-7.56-17.812-11.806-28.503-11.806h-0.080c-5.606 0-11.15 1.169-16.279 3.433-31.65 13.971-66.894 17.63-100.739 10.456s-64.574-24.816-87.834-50.426c-23.26-25.61-37.872-57.891-41.764-92.268-1.736-15.325-1.302-30.721 1.214-45.751l95.216 95.161c15.74 15.731 41.25 15.731 56.99-0.001l79.408-79.368c7.562-7.559 11.812-17.812 11.813-28.505s-4.246-20.947-11.806-28.508l-95.189-95.188c15.036-2.521 30.438-2.959 45.77-1.226 34.384 3.887 66.673 18.498 92.29 41.76s43.262 53.998 50.436 87.849c7.174 33.851 3.511 69.102-10.468 100.756-6.724 15.225-3.399 33.018 8.371 44.787l17.015 17.015 59.38-59.379c11.372-38.811 13.020-80.004 4.567-119.892-10.68-50.408-36.958-96.177-75.104-130.818s-86.228-56.397-137.431-62.186zM710.436 515.84l-75.274 75.269 7.168 7.168c11.766 11.766 29.553 15.094 44.774 8.376 31.652-13.967 66.898-17.623 100.741-10.445 33.848 7.178 64.573 24.827 87.834 50.442 23.255 25.61 37.862 57.897 41.748 92.273 1.731 15.319 1.295 30.71-1.219 45.732l-95.14-95.165c-7.557-7.562-17.812-11.812-28.508-11.807-10.691 0-20.946 4.25-28.508 11.812l-79.365 79.406c-15.734 15.744-15.734 41.262 0.005 57.001l95.13 95.13c-15.022 2.514-30.408 2.944-45.727 1.208-34.376-3.891-66.657-18.504-92.268-41.764s-43.254-53.99-50.427-87.834c-7.173-33.843-3.517-69.089 10.455-100.741 6.723-15.222 3.395-33.014-8.371-44.78l-7.168-7.163-75.279 75.279c-5.546 30.996-5.108 62.956 1.5 94.121 10.68 50.396 36.951 96.159 75.090 130.796 38.134 34.637 86.205 56.397 137.395 62.193 51.195 5.796 102.912-4.664 147.83-29.896 10.998-6.18 18.468-17.147 20.188-29.645s-2.509-25.078-11.428-34.002l-111.416-111.416 22.369-22.385 111.401 111.437c8.919 8.919 21.504 13.153 34.002 11.433 12.493-1.715 23.465-9.185 29.645-20.183 25.242-44.913 35.712-96.63 29.921-147.825s-27.54-99.267-62.172-137.411c-34.632-38.144-80.389-64.42-130.785-75.11-31.171-6.61-63.135-7.051-94.141-1.505z",
        "M389.013 615.67l444.968-444.97 60.339 60.34-444.968 444.969 27.976 27.976c16.662 16.66 16.662 43.679 0 60.339l-246.488 246.487c-16.66 16.66-43.672 16.666-60.335 0.005l-116.331-116.291c-8.004-8.003-12.502-18.852-12.502-30.172-0.001-11.315 4.496-22.17 12.5-30.172l246.528-246.492c16.663-16.655 43.676-16.655 60.337 0.005l27.976 27.976zM330.865 678.2l-186.179 186.148 55.978 55.962 186.153-186.153-55.953-55.956z",
        "M906.921 300.59l-142.495-142.491 178.125-106.899 71.265 71.266-106.895 178.124z"
      ],
      "tags": [
        "tool-screwdriver-wrench--furnitures-tools"
      ],
      "defaultCode": 59904,
      "grid": 0
    },
    {
      "paths": [
        "M466.392 8.664c10.642 8.066 16.893 20.649 16.893 34.003v209.066h57.427v-209.066c0-13.353 6.252-25.937 16.896-34.003 10.639-8.066 24.448-10.685 37.304-7.076 61.343 17.218 115.717 53.301 155.412 103.137 39.7 49.837 62.71 110.901 65.772 174.542 3.067 63.641-13.972 126.633-48.696 180.054-29.286 45.053-69.903 81.372-117.545 105.461v321.362c0 36.562-14.525 71.624-40.376 97.48-25.856 25.851-60.918 40.376-97.48 40.376s-71.626-14.525-97.479-40.376c-25.853-25.856-40.377-60.918-40.377-97.48v-321.362c-47.641-24.090-88.257-60.408-117.543-105.461-34.726-53.42-51.764-116.412-48.7-180.054s26.075-124.706 65.773-174.542c39.698-49.837 94.070-85.92 155.415-103.137 12.856-3.608 26.661-0.99 37.303 7.076zM397.952 107.263c-21.883 13.272-41.394 30.37-57.531 50.629-28.539 35.828-45.082 79.727-47.285 125.479s10.045 91.037 35.011 129.441c24.965 38.404 61.38 67.98 104.088 84.537 16.421 6.366 27.244 22.167 27.244 39.779v349.015c0 13.932 5.534 27.29 15.384 37.14s23.209 15.38 37.139 15.38c13.932 0 27.29-5.53 37.14-15.38s15.38-23.209 15.38-37.14v-349.015c0-17.613 10.824-33.413 27.244-39.779 42.711-16.558 79.124-46.133 104.090-84.537s37.212-83.689 35.011-129.441c-2.202-45.752-18.744-89.651-47.283-125.479-16.138-20.259-35.651-37.357-57.533-50.629v187.138c0 23.564-19.103 42.666-42.665 42.666h-142.764c-23.564 0-42.667-19.102-42.667-42.666v-187.138z"
      ],
      "tags": [
        "tool-wrench-hand--furnitures-tools"
      ],
      "defaultCode": 59905,
      "grid": 0
    },
    {
      "paths": [
        "M0 256c0-23.564 19.103-42.667 42.667-42.667h938.668c23.562 0 42.665 19.103 42.665 42.667v384c0 23.562-19.103 42.665-42.665 42.665v298.67c0 23.562-19.103 42.665-42.67 42.665h-853.331c-23.564 0-42.667-19.103-42.667-42.665v-298.67c-23.564 0-42.667-19.103-42.667-42.665v-384zM128 682.665v256h768v-256h-768zM938.665 597.335v-298.669h-853.331v298.669h853.331z",
        "M426.666 554.665h170.669v170.67h-170.669v-170.67z",
        "M384 554.665c0-23.562 19.103-42.665 42.666-42.665h170.669c23.562 0 42.665 19.103 42.665 42.665v170.67c0 23.562-19.103 42.665-42.665 42.665h-170.669c-23.564 0-42.666-19.103-42.666-42.665v-170.67zM469.334 597.335v85.33h85.331v-85.33h-85.331z",
        "M298.666 42.667c0-23.564 19.103-42.667 42.667-42.667h341.331c23.567 0 42.67 19.103 42.67 42.667v213.333h-85.335v-170.666h-256v170.666h-85.334v-213.333z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        },
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(0, 0, 0)"
        }
      ],
      "isMulticolor": true,
      "colorPermutations": {
        "11761781811211211211125525525518485881": [
          {
            "f": 0
          },
          {
            "f": 4
          },
          {
            "f": 0
          },
          {
            "f": 0
          }
        ]
      },
      "tags": [
        "toolbox--interface-essential"
      ],
      "defaultCode": 59906,
      "grid": 0
    },
    {
      "paths": [
        "M522.189 267.206c-15.713 37.731-27.911 76.83-36.439 116.794h-110.168c32.049-55.402 84.263-97.679 146.607-116.794zM573.343 257.109c7.9-0.734 15.903-1.109 23.992-1.109s16.087 0.375 23.987 1.109c19.185 40.625 33.894 83.175 43.899 126.891h-135.777c10.004-43.716 24.714-86.265 43.899-126.891zM672.476 267.206c62.346 19.114 114.56 61.391 146.611 116.794h-110.172c-8.53-39.964-20.726-79.063-36.439-116.794zM838.769 426.667h-122.194c4.096 28.052 6.405 56.434 6.876 84.98l0.015 0.707h-0.015c-0.471 28.544-2.78 56.929-6.876 84.982h122.194c9.431-26.691 14.566-55.414 14.566-85.335s-5.135-58.643-14.566-85.333zM819.087 640h-110.172c-8.53 39.967-20.726 79.063-36.439 116.792 62.346-19.113 114.56-61.389 146.611-116.792zM621.322 766.889c-7.9 0.737-15.898 1.111-23.987 1.111s-16.092-0.374-23.992-1.111c-19.185-40.622-33.894-83.174-43.899-126.889h135.777c-10.004 43.715-24.714 86.267-43.899 126.889zM522.189 756.792c-62.344-19.113-114.558-61.389-146.607-116.792h110.168c8.528 39.967 20.725 79.063 36.439 116.792zM355.9 597.335h122.191c-4.095-28.052-6.405-56.438-6.878-84.982l-0.012-0.707 0.012 0.001c0.473-28.546 2.783-56.928 6.878-84.98h-122.191c-9.434 26.69-14.567 55.412-14.567 85.333s5.133 58.644 14.567 85.335zM513.879 512c0.492-28.686 2.964-57.194 7.363-85.333h152.182c4.398 28.138 6.871 56.647 7.363 85.333-0.492 28.687-2.964 57.196-7.363 85.335h-152.182c-4.398-28.14-6.871-56.648-7.363-85.335z",
        "M0 42.667c0-23.564 19.103-42.667 42.667-42.667h938.668c23.562 0 42.665 19.103 42.665 42.667v938.668c0 23.562-19.103 42.665-42.665 42.665h-938.668c-23.564 0-42.667-19.103-42.667-42.665v-938.668zM256 938.665h682.665v-853.331h-682.665v853.331zM170.666 85.334h-85.333v853.331h85.333v-853.331z"
      ],
      "tags": [
        "travel-passport-1--travel"
      ],
      "defaultCode": 59910,
      "grid": 0
    },
    {
      "paths": [
        "M554.67 85.334c-91.090 0.116-179.76 29.328-253.080 83.376s-127.457 130.106-154.516 217.083l-67.456-116.779-73.899 42.667 149.333 258.6 258.816-149.331-42.666-73.898-147.968 85.334c14.954-62.344 47.164-119.215 92.941-164.102s103.269-75.973 165.895-89.7c62.622-13.727 127.851-9.539 188.206 12.084s113.398 59.807 153.062 110.18c39.66 50.372 64.333 110.896 71.188 174.639 6.861 63.742-4.372 128.132-32.41 185.788s-71.747 106.25-126.121 140.216c-54.374 33.966-117.217 51.932-181.325 51.845v85.33c113.157 0 221.681-44.948 301.696-124.964s124.969-188.544 124.969-301.701c0-113.159-44.954-221.683-124.969-301.699s-188.539-124.968-301.696-124.968v0z"
      ],
      "tags": [
        "undo-arrow--interface-essential"
      ],
      "defaultCode": 59911,
      "grid": 0
    },
    {
      "paths": [
        "M158.033 403.487c31.059-12.865 64.349-19.487 97.967-19.487 67.895 0 133.010 26.971 181.019 74.981s74.981 113.123 74.981 181.019c0 23.562-19.103 42.665-42.666 42.665h-426.667c-11.316 0-22.168-4.495-30.17-12.493-8.002-8.003-12.497-18.857-12.497-30.172 0-67.896 26.971-133.010 74.981-181.019 23.772-23.772 51.993-42.629 83.052-55.494zM256 469.334c-22.412 0-44.605 4.414-65.311 12.991s-39.52 21.148-55.368 36.997c-21.741 21.74-37.010 48.742-44.569 78.013h330.496c-7.559-29.271-22.828-56.274-44.569-78.013-32.006-32.007-75.416-49.988-120.679-49.988z",
        "M256.001 85.334c-47.129 0-85.334 38.205-85.334 85.333s38.205 85.334 85.334 85.334c47.128 0 85.333-38.205 85.333-85.334s-38.205-85.333-85.333-85.333zM85.334 170.666c0-94.257 76.41-170.666 170.667-170.666s170.666 76.41 170.666 170.666c0 94.257-76.41 170.667-170.666 170.667s-170.667-76.41-170.667-170.667z",
        "M1024 853.335h-1024v-85.335h1024v85.335z",
        "M512 810.665l-170.666 213.335h341.331l-170.665-213.335z",
        "M810.665 127.999h-85.33c-23.567 0-42.67 19.103-42.67 42.667v170.666c0 20.857 15.078 38.658 35.656 42.086l220.344 36.724v91.856h-170.665v-51.201h-85.335v93.866c0 23.567 19.103 42.67 42.67 42.67h85.33v85.33h85.335v-85.33h85.335c23.562 0 42.665-19.103 42.665-42.67v-170.665c0-20.857-15.078-38.657-35.651-42.086l-220.349-36.725v-91.856h170.665v42.666h85.335v-85.333c0-23.564-19.103-42.667-42.665-42.667h-85.335v-85.333h-85.335v85.333z"
      ],
      "tags": [
        "user-cash-scale--business-products"
      ],
      "defaultCode": 59912,
      "grid": 0
    },
    {
      "paths": [
        "M512 512c-33.754 0-66.751-10.009-94.817-28.762s-49.941-45.407-62.858-76.593c-12.917-31.185-16.297-65.501-9.712-98.607s22.839-63.516 46.708-87.384c23.868-23.868 54.278-40.123 87.384-46.708s67.42-3.205 98.606 9.712c31.186 12.917 57.841 34.792 76.595 62.858 18.749 28.066 28.759 61.063 28.759 94.817 0 45.263-17.976 88.673-49.987 120.679-32.005 32.006-75.412 49.987-120.678 49.987zM512 256.001c-16.877 0-33.375 5.005-47.408 14.382s-24.97 22.704-31.429 38.296c-6.459 15.593-8.148 32.751-4.856 49.304s11.42 31.758 23.354 43.692c11.934 11.934 27.139 20.061 43.692 23.354s33.712 1.603 49.303-4.856c15.596-6.459 28.923-17.396 38.298-31.429s14.382-30.532 14.382-47.409c0-22.632-8.991-44.337-24.996-60.34-16-16.003-37.709-24.994-60.339-24.994v0zM853.335 853.335h-682.668v-42.67c0-150.738 140.374-256 341.333-256s341.335 105.262 341.335 256v42.67zM262.785 768h498.431c-25.6-77.143-120.873-128-249.216-128-128.341 0-223.701 50.857-249.215 128z"
      ],
      "tags": [
        "user-geometric-action---users"
      ],
      "defaultCode": 59913,
      "grid": 0
    },
    {
      "paths": [
        "M341.334 682.665c-33.755 0-66.751-10.010-94.817-28.759-28.066-18.755-49.941-45.409-62.858-76.595s-16.297-65.5-9.712-98.606c6.585-33.106 22.84-63.516 46.708-87.384s54.278-40.123 87.385-46.708c33.106-6.585 67.421-3.206 98.607 9.712s57.84 34.792 76.593 62.858c18.753 28.066 28.763 61.063 28.763 94.817 0 45.266-17.981 88.673-49.987 120.678-32.006 32.010-75.416 49.987-120.679 49.987zM341.334 426.667c-16.878 0-33.376 5.005-47.409 14.382s-24.971 22.704-31.429 38.296c-6.459 15.593-8.148 32.753-4.856 49.306s11.42 31.754 23.354 43.689c11.934 11.935 27.139 20.060 43.692 23.357 16.553 3.292 33.711 1.603 49.303-4.859 15.593-6.456 28.92-17.398 38.297-31.427 9.376-14.034 14.381-30.536 14.381-47.411 0-22.631-8.99-44.336-24.993-60.339s-37.708-24.994-60.34-24.994zM682.665 1024h-682.665v-42.665c0-150.743 140.374-256 341.334-256 200.962 0 341.331 105.257 341.331 256v42.665zM92.118 938.665h498.434c-25.6-77.138-120.877-128-249.218-128s-223.702 50.862-249.216 128zM938.665 298.667h-128v-128h-85.33v128h-128v85.334h128v127.999h85.33v-127.999h128v-85.334z"
      ],
      "tags": [
        "user-geometric-action-add"
      ],
      "defaultCode": 59914,
      "grid": 0
    },
    {
      "paths": [
        "M810.665 0c-28.575 0.555-56.765 6.734-82.949 18.186-26.189 11.451-49.869 27.95-69.678 48.553s-35.369 44.908-45.783 71.525c-10.419 26.617-15.488 55.026-14.92 83.603 0 166.4 213.33 332.798 213.33 332.798s213.335-166.398 213.335-332.798c0.568-28.577-4.506-56.986-14.92-83.603s-25.974-50.921-45.783-71.525c-19.809-20.603-43.489-37.102-69.678-48.553s-54.374-17.631-82.954-18.186v0zM810.665 298.666c-16.876 0-33.372-5.005-47.406-14.381s-24.97-22.704-31.432-38.297c-6.456-15.592-8.146-32.75-4.854-49.303s11.418-31.758 23.352-43.692c11.935-11.934 27.141-20.062 43.694-23.354s33.71-1.603 49.3 4.856c15.596 6.458 28.923 17.396 38.298 31.429 9.38 14.033 14.382 30.531 14.382 47.409 0 22.631-8.991 44.337-24.991 60.34-16.005 16.003-37.709 24.993-60.344 24.993zM554.665 469.334c0-33.755-10.010-66.751-28.759-94.817-18.755-28.066-45.409-49.941-76.594-62.858s-65.501-16.297-98.607-9.712c-33.106 6.585-63.516 22.84-87.384 46.708s-40.123 54.278-46.708 87.385c-6.585 33.106-3.206 67.421 9.712 98.608s34.792 57.841 62.858 76.59c28.066 18.755 61.063 28.764 94.817 28.764 45.264 0 88.673-17.981 120.679-49.987 32.009-32.005 49.985-75.418 49.985-120.68zM384.001 554.665c-16.878 0-33.376-5.002-47.409-14.382-14.033-9.375-24.97-22.702-31.429-38.294s-8.148-32.75-4.856-49.303c3.293-16.553 11.42-31.758 23.354-43.692s27.139-20.062 43.692-23.354c16.553-3.292 33.711-1.603 49.304 4.856s28.92 17.396 38.296 31.429c9.377 14.033 14.382 30.531 14.382 47.409 0 22.631-8.991 44.336-24.994 60.341-16.003 16-37.708 24.991-60.34 24.991zM384.001 640c-90.496 0.102-177.256 36.096-241.247 100.086s-99.985 150.753-100.087 241.249c0 11.315 4.495 22.164 12.497 30.167s18.854 12.498 30.17 12.498h597.331c11.32 0 22.17-4.495 30.172-12.498s12.498-18.852 12.498-30.167c-0.102-90.496-36.096-177.26-100.086-241.249s-150.753-99.983-241.249-100.086zM131.542 938.665c10.035-59.699 40.902-113.915 87.121-153.011 46.219-39.101 104.799-60.554 165.338-60.554s119.118 21.453 165.34 60.554c46.218 39.096 77.087 93.312 87.117 153.011h-504.915z"
      ],
      "tags": [
        "user-geometric-action-location---users"
      ],
      "defaultCode": 59915,
      "grid": 0
    },
    {
      "paths": [
        "M341.334 682.665c-33.755 0-66.751-10.010-94.817-28.759-28.066-18.755-49.941-45.409-62.858-76.595s-16.297-65.5-9.712-98.606c6.585-33.106 22.84-63.516 46.708-87.384s54.278-40.123 87.385-46.708c33.106-6.585 67.421-3.206 98.607 9.712s57.84 34.792 76.593 62.858c18.753 28.066 28.763 61.063 28.763 94.817 0 45.266-17.981 88.673-49.987 120.678s-75.416 49.987-120.679 49.987zM341.334 426.666c-16.878 0-33.376 5.005-47.409 14.382s-24.971 22.704-31.429 38.296c-6.459 15.593-8.148 32.748-4.856 49.306 3.293 16.553 11.42 31.754 23.354 43.689s27.139 20.060 43.692 23.352c16.553 3.297 33.711 1.603 49.303-4.854s28.92-17.398 38.297-31.432c9.376-14.029 14.381-30.531 14.381-47.406 0-22.632-8.99-44.337-24.993-60.34s-37.708-24.994-60.34-24.994zM682.665 1024h-682.665v-42.665c0-150.743 140.374-256 341.334-256 200.962 0 341.331 105.257 341.331 256v42.665zM92.118 938.665h498.434c-25.6-77.138-120.877-128-249.218-128s-223.702 50.862-249.216 128zM981.335 170.666c0-45.263-17.981-88.673-49.987-120.679-32.010-32.006-75.418-49.987-120.684-49.987-45.261 0-88.673 17.981-120.678 49.987s-49.987 75.416-49.987 120.679c-11.315 0-22.17 4.495-30.172 12.497-7.997 8.002-12.493 18.854-12.493 30.17v298.666c0 11.315 4.495 22.17 12.493 30.172 8.003 7.997 18.857 12.493 30.172 12.493h341.335c11.315 0 22.164-4.495 30.167-12.493 8.003-8.003 12.498-18.857 12.498-30.172v-298.666c0-11.316-4.495-22.169-12.498-30.17s-18.852-12.497-30.167-12.497v0zM810.665 85.334c22.636 0 44.339 8.99 60.339 24.993 16.005 16.003 24.996 37.708 24.996 60.34h-170.665c0-22.631 8.991-44.337 24.991-60.34 16.005-16.003 37.709-24.993 60.339-24.993v0zM938.665 469.334h-256v-213.334h256v213.334z",
        "M810.665 384.001c23.567 0 42.67-19.103 42.67-42.666s-19.103-42.667-42.67-42.667c-23.562 0-42.665 19.103-42.665 42.667s19.103 42.666 42.665 42.666z"
      ],
      "tags": [
        "user-geometric-action-lock---users"
      ],
      "defaultCode": 59916,
      "grid": 0
    },
    {
      "paths": [
        "M341.334 682.665c-33.755 0-66.751-10.010-94.817-28.759-28.066-18.755-49.941-45.409-62.858-76.595s-16.297-65.5-9.712-98.606c6.585-33.106 22.84-63.516 46.708-87.384s54.278-40.123 87.385-46.708c33.106-6.585 67.421-3.206 98.607 9.712s57.84 34.792 76.593 62.858c18.753 28.066 28.763 61.063 28.763 94.817 0 45.266-17.981 88.673-49.987 120.678s-75.416 49.987-120.679 49.987zM341.334 426.666c-16.878 0-33.376 5.005-47.409 14.382s-24.971 22.704-31.429 38.296c-6.459 15.593-8.148 32.748-4.856 49.306 3.293 16.553 11.42 31.754 23.354 43.689s27.139 20.060 43.692 23.352c16.553 3.297 33.711 1.603 49.303-4.854s28.92-17.398 38.297-31.427c9.376-14.034 14.381-30.536 14.381-47.411 0-22.632-8.99-44.337-24.993-60.34s-37.708-24.994-60.34-24.994zM682.665 1024h-682.665v-42.665c0-150.743 140.374-256 341.334-256 200.962 0 341.331 105.257 341.331 256v42.665zM92.118 938.665h498.434c-25.6-77.138-120.877-128-249.218-128s-223.702 50.862-249.216 128zM896 213.334h-85.335c-11.315 0-22.164-4.495-30.167-12.497s-12.498-18.854-12.498-30.17c0-11.316 4.495-22.168 12.498-30.17s18.852-12.497 30.167-12.497h170.67v-85.333h-85.335v-42.667h-85.335v42.667c-33.946 0-66.504 13.486-90.506 37.491-24.008 24.005-37.494 56.562-37.494 90.509s13.486 66.505 37.494 90.51c24.003 24.005 56.561 37.49 90.506 37.49h85.335c11.315 0 22.17 4.495 30.172 12.497 7.997 8.002 12.493 18.854 12.493 30.17s-4.495 22.168-12.493 30.17c-8.003 8.002-18.857 12.497-30.172 12.497h-170.665v85.334h85.33v42.666h85.335v-42.666c33.946 0 66.504-13.486 90.511-37.491 24.003-24.005 37.489-56.562 37.489-90.509s-13.486-66.505-37.489-90.51c-24.008-24.005-56.566-37.49-90.511-37.49z"
      ],
      "tags": [
        "user-geometric-action-money-fund---users"
      ],
      "defaultCode": 59917,
      "grid": 0
    },
    {
      "paths": [
        "M768 1024h-512v-85.335c0.068-56.556 22.565-110.781 62.559-150.774s94.216-62.49 150.775-62.556h85.331c56.561 0.067 110.781 22.564 150.779 62.556 39.992 39.992 62.49 94.218 62.556 150.774v85.335zM341.334 938.665h341.331c0-33.946-13.486-66.504-37.489-90.506-24.003-24.008-56.561-37.494-90.511-37.494h-85.331c-33.948 0-66.505 13.486-90.51 37.494-24.005 24.003-37.49 56.561-37.49 90.506zM170.666 938.665c0.090-28.913 4.402-57.661 12.8-85.33h-55.466c-33.948 0-66.505 13.481-90.51 37.489-24.005 24.003-37.49 56.561-37.49 90.511v42.665h170.666v-85.335zM320.982 679.849c-4.317-18.888-13.697-36.244-27.132-50.202-13.436-13.962-30.42-23.997-49.129-29.036-18.71-5.033-38.437-4.879-57.065 0.451s-35.452 15.631-48.667 29.798c-13.215 14.172-22.321 31.672-26.339 50.627s-2.8 38.646 3.528 56.96c6.327 18.309 17.523 34.555 32.385 46.986s32.829 20.577 51.973 23.567c26.263-54.17 68.236-99.18 120.448-129.152zM896 853.335h-55.465c8.371 27.674 12.682 56.417 12.8 85.33v85.335h170.665v-42.665c0-33.951-13.486-66.509-37.489-90.511-24.008-24.008-56.566-37.489-90.511-37.489zM814.592 597.335c-24.796 0.036-48.809 8.714-67.901 24.535s-32.077 37.801-36.716 62.162c49.183 30.111 88.658 73.748 113.705 125.696 27.438-2.196 52.956-14.945 71.188-35.569 18.237-20.618 27.766-47.508 26.588-75.008s-12.969-53.473-32.896-72.463c-19.932-18.985-46.444-29.507-73.969-29.353zM512 725.335c-25.316 0-50.063-7.511-71.113-21.576s-37.455-34.053-47.143-57.441c-9.688-23.388-12.223-49.126-7.284-73.958 4.939-24.827 17.129-47.636 35.031-65.537 17.901-17.901 40.709-30.092 65.538-35.031s50.567-2.404 73.955 7.284c23.388 9.688 43.382 26.094 57.446 47.142 14.065 21.053 21.571 45.798 21.571 71.117 0 33.946-13.486 66.504-37.489 90.506-24.008 24.008-56.566 37.494-90.511 37.494zM512 554.665c-8.439 0-16.688 2.504-23.705 7.194-7.016 4.685-12.485 11.351-15.714 19.149-3.229 7.793-4.074 16.374-2.428 24.648 1.646 8.279 5.71 15.882 11.677 21.847 5.967 5.97 13.57 10.030 21.846 11.679 8.276 1.644 16.854 0.799 24.652-2.427 7.798-3.231 14.459-8.699 19.149-15.718 4.69-7.014 7.188-15.263 7.188-23.7 0-11.32-4.495-22.17-12.493-30.172-8.003-8.003-18.857-12.498-30.172-12.498z",
        "M725.335 0h-426.669c-22.631 0-44.337 8.99-60.34 24.994s-24.993 37.708-24.993 60.34v469.331l128-127.998h384.002c22.63 0 44.334-8.99 60.339-24.993 16-16.003 24.991-37.708 24.991-60.34v-256c0-22.632-8.991-44.337-24.991-60.34-16.005-16.003-37.709-24.994-60.339-24.994v0zM682.665 341.334h-341.332v-85.334h341.332v85.334zM682.665 170.666h-341.332v-85.333h341.332v85.333z"
      ],
      "tags": [
        "user-group-chat---users"
      ],
      "defaultCode": 59918,
      "grid": 0
    },
    {
      "paths": [
        "M869.161 813.143c22.113-20.362 37.565-46.925 44.334-76.211 6.774-29.286 4.547-59.935-6.385-87.936-10.926-28.001-30.054-52.055-54.871-69.007-24.822-16.957-54.18-26.030-84.239-26.030s-59.418 9.073-84.239 26.030c-24.817 16.952-43.945 41.006-54.871 69.007-10.931 28.001-13.153 58.65-6.385 87.936s22.221 55.849 44.334 76.211c-63.063 22.825-112.174 66.642-112.174 125.522h85.335c0-25.6 60.288-57.897 128-57.897s128 32.297 128 57.897h85.335c0-58.88-49.111-102.697-112.174-125.522zM768 640c12.657 0 25.032 3.753 35.558 10.788 10.522 7.030 18.724 17.024 23.572 28.718 4.844 11.694 6.108 24.566 3.64 36.982-2.468 12.411-8.566 23.818-17.516 32.768s-20.357 15.043-32.768 17.516c-12.416 2.468-25.283 1.203-36.977-3.645-11.699-4.844-21.693-13.046-28.723-23.567-7.035-10.527-10.788-22.902-10.788-35.558 0-16.973 6.743-33.254 18.744-45.256s28.283-18.744 45.256-18.744zM357.163 813.143c22.111-20.362 37.562-46.925 44.333-76.211s4.546-59.935-6.383-87.936c-10.93-28.001-30.055-52.055-54.875-69.007-24.82-16.957-54.179-26.030-84.238-26.030s-59.418 9.073-84.238 26.030c-24.82 16.952-43.945 41.006-54.874 69.007s-13.154 58.65-6.384 87.936c6.771 29.286 22.222 55.849 44.333 76.211-63.062 22.825-112.171 66.642-112.171 125.522h85.333c0-25.6 60.288-57.897 128-57.897s128 32.297 128 57.897h85.334c0-58.88-49.11-102.697-112.171-125.522zM256.001 640c12.658 0 25.032 3.753 35.556 10.788 10.525 7.030 18.728 17.024 23.572 28.718s6.111 24.566 3.642 36.982c-2.469 12.411-8.565 23.818-17.516 32.768s-20.354 15.043-32.769 17.516c-12.414 2.468-25.283 1.203-36.977-3.645-11.695-4.844-21.69-13.046-28.723-23.567-7.032-10.527-10.786-22.902-10.786-35.558 0-16.973 6.743-33.254 18.745-45.256s28.281-18.744 45.255-18.744v0zM640 469.333h85.335c0-58.88-49.111-102.698-112.174-125.525 22.113-20.363 37.565-46.924 44.334-76.21 6.774-29.286 4.547-59.934-6.385-87.935-10.926-28.002-30.054-52.053-54.871-69.009-24.822-16.956-54.18-26.027-84.239-26.027-30.058 0-59.417 9.071-84.237 26.027s-43.945 41.007-54.874 69.009c-10.93 28.001-13.154 58.649-6.384 87.935s22.222 55.847 44.333 76.21c-63.062 22.826-112.171 66.645-112.171 125.525h85.334c0-25.6 60.288-57.898 127.999-57.898s128 32.298 128 57.898zM512 170.666c12.657 0 25.032 3.753 35.558 10.786 10.522 7.032 18.729 17.028 23.572 28.722s6.108 24.563 3.64 36.978c-2.468 12.415-8.566 23.819-17.516 32.769s-20.357 15.046-32.768 17.516c-12.416 2.469-25.285 1.202-36.979-3.642s-21.69-13.047-28.723-23.572c-7.032-10.525-10.786-22.898-10.786-35.556 0-16.974 6.743-33.252 18.745-45.255s28.281-18.745 45.254-18.745z"
      ],
      "tags": [
        "user-group"
      ],
      "defaultCode": 59919,
      "grid": 0
    },
    {
      "paths": [
        "M384 810.665c-1.326-17.147 1.076-34.376 7.039-50.509 5.964-16.128 15.348-30.781 27.509-42.941s26.81-21.545 42.942-27.51c16.131-5.965 33.362-8.366 50.509-7.040 17.147-1.326 34.376 1.075 50.509 7.040s30.781 15.35 42.941 27.51c12.16 12.16 21.545 26.813 27.51 42.941 5.965 16.133 8.366 33.362 7.040 50.509h-256z",
        "M511.999 640c47.13 0 85.336-38.205 85.336-85.335 0-47.127-38.205-85.332-85.336-85.332-47.128 0-85.333 38.205-85.333 85.332 0 47.13 38.205 85.335 85.333 85.335z",
        "M768 938.665h-512c-11.316 0-22.168-4.495-30.17-12.493-8.002-8.003-12.497-18.857-12.497-30.172v-298.665h-42.667c-16.874-0.005-33.369-5.012-47.399-14.387-14.030-9.38-24.964-22.702-31.421-38.292s-8.147-32.748-4.856-49.298c3.291-16.551 11.416-31.754 23.346-43.688l341.334-340.566c7.908-7.938 17.312-14.227 27.668-18.504s21.457-6.457 32.662-6.413c11.208-0.038 22.313 2.148 32.666 6.433 10.358 4.284 19.758 10.582 27.663 18.527l341.335 340.48c11.945 11.932 20.081 27.139 23.383 43.697 3.297 16.558 1.613 33.721-4.849 49.322-6.456 15.601-17.398 28.933-31.437 38.313-14.039 9.375-30.546 14.382-47.427 14.377h-42.67v298.665c0 11.315-4.495 22.17-12.493 30.172-8.003 7.997-18.857 12.493-30.172 12.493zM298.666 853.335h426.669v-298.67c0-11.315 4.495-22.164 12.493-30.167 8.003-8.003 18.857-12.498 30.172-12.498h85.335l-341.335-340.48-341.334 340.48h85.334c11.316 0 22.169 4.495 30.17 12.498s12.496 18.852 12.496 30.167v298.67z"
      ],
      "tags": [
        "user-home"
      ],
      "defaultCode": 59920,
      "grid": 0
    },
    {
      "paths": [
        "M853.335 256.001v511.999h-682.669v-511.999h682.669zM853.335 170.667h-682.669c-22.611 0.068-44.276 9.080-60.265 25.069s-25 37.654-25.068 60.265v511.999c0.068 22.61 9.080 44.278 25.068 60.268 15.989 15.985 37.654 25.001 60.265 25.068h682.669c22.61-0.067 44.273-9.083 60.262-25.068 15.99-15.99 25.001-37.658 25.068-60.268v-511.999c-0.067-22.611-9.078-44.277-25.068-60.265s-37.652-25.001-60.262-25.069z",
        "M597.335 469.335h170.665v85.336h-170.665v-85.336zM597.335 597.335h170.665v85.335h-170.665v-85.335zM256 682.67c-1.326-17.152 1.076-34.381 7.039-50.514 5.964-16.128 15.348-30.776 27.51-42.941 12.161-12.16 26.81-21.545 42.941-27.51 16.131-5.96 33.362-8.361 50.509-7.035 17.147-1.326 34.378 1.075 50.51 7.035 16.131 5.965 30.78 15.35 42.941 27.51 12.161 12.165 21.546 26.813 27.51 42.941 5.963 16.133 8.365 33.362 7.039 50.514h-256z",
        "M384 512c47.129 0 85.334-38.204 85.334-85.332s-38.205-85.333-85.334-85.333c-47.128 0-85.333 38.205-85.333 85.333s38.205 85.332 85.333 85.332z"
      ],
      "tags": [
        "user-id-card---users-1"
      ],
      "defaultCode": 59921,
      "grid": 0
    },
    {
      "paths": [
        "M853.335 256.001v511.999h-682.668v-511.999h682.668zM853.335 170.667h-682.668c-22.611 0.068-44.277 9.080-60.265 25.069s-25 37.654-25.068 60.265v511.999c0.068 22.61 9.080 44.278 25.068 60.268 15.989 15.985 37.655 25.001 60.265 25.068h682.668c22.61-0.067 44.278-9.083 60.262-25.068 15.99-15.99 25.001-37.658 25.068-60.268v-511.999c-0.067-22.611-9.078-44.277-25.068-60.265-15.985-15.989-37.652-25.001-60.262-25.069z",
        "M597.335 469.335h170.665v85.336h-170.665v-85.336zM597.335 597.335h170.665v85.335h-170.665v-85.335zM256 682.67c-1.326-17.152 1.076-34.381 7.039-50.514 5.964-16.128 15.348-30.776 27.509-42.941 12.161-12.16 26.81-21.545 42.942-27.51 16.131-5.96 33.362-8.361 50.509-7.035 17.147-1.326 34.378 1.075 50.509 7.035 16.132 5.965 30.781 15.35 42.942 27.51 12.161 12.165 21.545 26.813 27.509 42.941 5.964 16.133 8.366 33.362 7.039 50.514h-256z",
        "M384.001 512c47.128 0 85.334-38.204 85.334-85.332s-38.205-85.333-85.334-85.333c-47.128 0-85.334 38.205-85.334 85.333s38.205 85.332 85.334 85.332z"
      ],
      "tags": [
        "user-id-card---users"
      ],
      "defaultCode": 59922,
      "grid": 0
    },
    {
      "paths": [
        "M-15040-4416h18688v7936h-20736v-6144h2048v-1792zM-14997.35-4373.335v1792h-2048v6058.67h20650.685v-7850.67h-18602.685z",
        "M298.667 554.665c-17.147-1.326-34.378 1.080-50.509 7.040-16.131 5.965-30.78 15.35-42.941 27.51s-21.546 26.813-27.51 42.941c-5.964 16.133-8.365 33.362-7.039 50.509h256c1.326-17.147-1.076-34.376-7.039-50.509-5.964-16.128-15.349-30.781-27.51-42.941s-26.81-21.545-42.941-27.51c-16.132-5.96-33.362-8.366-50.51-7.040v0z",
        "M298.666 511.999c47.129 0 85.334-38.205 85.334-85.334s-38.205-85.333-85.334-85.333c-47.128 0-85.333 38.205-85.333 85.333s38.205 85.334 85.333 85.334z",
        "M938.665 128h-853.331c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34v725.331c0 11.315 4.495 22.17 12.497 30.172s18.854 12.498 30.17 12.498h170.667c11.316 0 22.168-4.495 30.17-12.498s12.497-18.857 12.497-30.172c0-11.315 4.495-22.164 12.497-30.167s18.854-12.498 30.17-12.498c11.316 0 22.169 4.495 30.17 12.498s12.497 18.852 12.497 30.167c0 11.315 4.495 22.17 12.496 30.172s18.854 12.498 30.17 12.498h256c11.315 0 22.17-4.495 30.172-12.498 7.997-8.003 12.493-18.857 12.493-30.172s4.495-22.164 12.498-30.167c8.003-8.003 18.857-12.498 30.172-12.498s22.164 4.495 30.167 12.498c8.003 8.003 12.498 18.852 12.498 30.167s4.495 22.17 12.498 30.172c8.003 8.003 18.852 12.498 30.167 12.498h170.67c11.315 0 22.164-4.495 30.167-12.498s12.498-18.857 12.498-30.172v-725.331c0-22.632-8.991-44.337-24.996-60.34-16-16.004-37.704-24.994-60.339-24.994zM938.665 896h-92.626c-8.806-24.986-25.144-46.628-46.771-61.937-21.622-15.304-47.462-23.526-73.953-23.526-26.496 0-52.337 8.223-73.958 23.526-21.627 15.309-37.965 36.951-46.771 61.937h-185.214c-8.813-24.97-25.155-46.597-46.773-61.891-21.618-15.299-47.449-23.511-73.931-23.511s-52.313 8.212-73.931 23.511c-21.618 15.293-37.96 36.92-46.773 61.891h-92.629v-682.666h853.331v682.666z",
        "M512 554.665h341.335v85.335h-341.335v-85.335zM597.335 384h256v85.334h-256v-85.334z"
      ],
      "tags": [
        "user-id-card"
      ],
      "defaultCode": 59923,
      "grid": 0
    },
    {
      "paths": [
        "M682.665 853.335h-511.998c-22.632 0-44.337-8.991-60.34-24.996s-24.994-37.709-24.994-60.339v-426.667h85.334v426.667h511.998v85.335z",
        "M896 682.665h-554.666c-22.632 0-44.337-8.991-60.34-24.991-16.004-16.005-24.994-37.709-24.994-60.339v-384.002c0-22.632 8.99-44.337 24.994-60.34s37.708-24.994 60.34-24.994h554.666c22.63 0 44.339 8.99 60.339 24.994 16.005 16.003 24.996 37.708 24.996 60.34v384.002c0 22.63-8.991 44.334-24.996 60.339-16 16-37.709 24.991-60.339 24.991zM341.334 213.334v384.002h554.666v-384.002h-554.666z",
        "M682.665 298.667h170.67v85.334h-170.67v-85.334zM682.665 469.334h170.67v85.331h-170.67v-85.331zM384 554.665c-1.326-17.147 1.076-34.376 7.039-50.507s15.348-30.78 27.509-42.941c12.161-12.162 26.81-21.546 42.942-27.51s33.362-8.365 50.509-7.039c17.147-1.326 34.376 1.076 50.509 7.039s30.781 15.348 42.941 27.51c12.16 12.161 21.545 26.81 27.51 42.941s8.366 33.36 7.040 50.507h-256z",
        "M512 426.666c47.13 0 85.335-38.205 85.335-85.333s-38.205-85.334-85.335-85.334c-47.128 0-85.333 38.205-85.333 85.334s38.205 85.333 85.333 85.333z"
      ],
      "tags": [
        "user-id-cards---users"
      ],
      "defaultCode": 59924,
      "grid": 0
    },
    {
      "paths": [
        "M-10944-4416h18688v7936h-20736v-6144h2048v-1792zM-10901.35-4373.335v1792h-2048v6058.67h20650.701v-7850.67h-18602.701z",
        "M298.666 597.335c33.755 0 66.751-10.010 94.817-28.764s49.941-45.409 62.858-76.593c12.917-31.185 16.297-65.501 9.712-98.607s-22.84-63.516-46.708-87.384c-23.868-23.868-54.278-40.122-87.385-46.708s-67.421-3.206-98.607 9.712c-31.185 12.917-57.84 34.792-76.593 62.858s-28.763 61.063-28.763 94.818c0 45.263 17.981 88.671 49.987 120.681 32.006 32.005 75.416 49.987 120.679 49.987zM298.666 341.334c16.878 0 33.376 5.005 47.409 14.381s24.971 22.704 31.429 38.297c6.459 15.592 8.148 32.75 4.856 49.304s-11.42 31.758-23.354 43.692c-11.934 11.934-27.139 20.061-43.692 23.354s-33.711 1.603-49.303-4.856c-15.593-6.458-28.92-17.396-38.297-31.429s-14.381-30.532-14.381-47.409c0-22.632 8.99-44.337 24.993-60.34s37.708-24.993 60.34-24.993v0zM298.666 640c-79.183 0.092-155.098 31.585-211.089 87.578s-87.487 131.907-87.577 211.087v85.335h597.335v-85.335c-0.092-79.181-31.585-155.095-87.579-211.087-55.991-55.992-131.906-87.485-211.089-87.578v0zM85.334 938.665c0-56.576 22.476-110.838 62.483-150.845s94.27-62.484 150.85-62.484c56.58 0 110.842 22.477 150.85 62.484s62.484 94.269 62.484 150.845h-426.666zM896 426.667c0-33.755-10.010-66.751-28.764-94.818-18.749-28.066-45.404-49.94-76.59-62.858s-65.5-16.297-98.606-9.712c-33.106 6.585-63.519 22.84-87.388 46.708-23.864 23.868-40.12 54.278-46.705 87.384s-3.205 67.422 9.713 98.607c12.918 31.183 34.79 57.838 62.858 76.593 28.063 18.755 61.061 28.764 94.817 28.764 45.261 0 88.673-17.981 120.678-49.987 32.005-32.010 49.987-75.418 49.987-120.681zM640 426.667c0-16.878 5.002-33.376 14.382-47.409 9.375-14.033 22.702-24.97 38.298-31.429 15.59-6.459 32.748-8.149 49.3-4.856s31.759 11.42 43.694 23.354c11.935 11.934 20.060 27.139 23.352 43.692s1.603 33.711-4.854 49.304c-6.461 15.592-17.398 28.92-31.432 38.297s-30.531 14.381-47.406 14.381c-22.636 0-44.339-8.99-60.339-24.993-16.005-16.003-24.996-37.708-24.996-60.34zM725.335 640c-33.91-0.010-67.574 5.76-99.543 17.065l28.416 80.471c32.179-11.331 66.601-14.781 100.388-10.071 33.787 4.705 65.956 17.444 93.809 37.135 27.858 19.697 50.586 45.778 66.289 76.063 15.708 30.285 23.926 63.887 23.972 98.002h-256v85.335h341.335v-85.335c-0.092-79.181-31.585-155.095-87.578-211.087s-131.907-87.485-211.087-87.578v0z"
      ],
      "tags": [
        "user-multiple"
      ],
      "defaultCode": 59925,
      "grid": 0
    },
    {
      "paths": [
        "M0 298.666c0-23.564 19.103-42.666 42.667-42.666h810.668c23.562 0 42.665 19.103 42.665 42.666v170.667h-85.335v-128h-725.331v597.331h725.331v-128h85.335v170.67c0 23.562-19.103 42.665-42.665 42.665h-810.668c-23.564 0-42.667-19.103-42.667-42.665v-682.669z",
        "M567.163 439.164c8.003-8.002 18.857-12.497 30.172-12.497h384c23.562 0 42.665 19.103 42.665 42.667v341.331c0 23.567-19.103 42.67-42.665 42.67h-384c-11.315 0-22.17-4.495-30.172-12.498l-170.666-170.665c-16.663-16.666-16.663-43.679 0-60.339l170.666-170.669zM615.004 512l-127.998 128 127.998 128h323.661v-256h-323.661z",
        "M682.665 704c35.348 0 64-28.652 64-64s-28.652-64-64-64c-35.343 0-64 28.652-64 64s28.657 64 64 64z",
        "M700.145 3.744c10.885 4.888 19.226 14.11 22.999 25.43l85.335 256-80.957 26.985-70.666-212.009-554.714 237.734-33.614-78.434 597.335-256c10.967-4.7 23.398-4.593 34.284 0.295z"
      ],
      "tags": [
        "wallet--business-products"
      ],
      "defaultCode": 59926,
      "grid": 0
    },
    {
      "paths": [
        "M0 576c0-23.562 19.103-42.665 42.667-42.665h170.667c23.564 0 42.666 19.103 42.666 42.665v426.665c0 23.567-19.103 42.67-42.666 42.67h-170.667c-23.564 0-42.667-19.103-42.667-42.67v-426.665zM85.334 618.665v341.335h85.333v-341.335h-85.333zM768 576c0-23.562 19.103-42.665 42.665-42.665h170.67c23.562 0 42.665 19.103 42.665 42.665v426.665c0 23.567-19.103 42.67-42.665 42.67h-170.67c-23.562 0-42.665-19.103-42.665-42.67v-426.665zM853.335 618.665v341.335h85.33v-341.335h-85.33z",
        "M400.297 746.665h-186.963v170.67h101.63l85.334-170.67zM410.369 917.335h117.928l85.335-170.67h-117.929l-85.334 170.67zM709.038 746.665l-85.335 170.67h186.962v-170.67h-101.627z",
        "M469.334 106.667h-85.333c-23.564 0-42.667 19.102-42.667 42.666v170.667c0 23.564 19.103 42.666 42.667 42.666h213.335v85.334h-256.002v85.335h128v85.33h85.331v-85.33h85.335c23.562 0 42.665-19.103 42.665-42.668v-170.666c0-23.564-19.103-42.667-42.665-42.667h-213.333v-85.333h255.998v-85.334h-128v-85.333h-85.331v85.333z"
      ],
      "tags": [
        "wayfinding-money-pass--travel"
      ],
      "defaultCode": 59927,
      "grid": 0
    },
    {
      "paths": [
        "M615.844 0.862c-86.369 5.019-170.063 31.843-243.259 77.968s-133.512 110.047-175.313 185.796c-41.801 75.749-63.725 160.856-63.725 247.373s21.924 171.622 63.725 247.373c41.801 75.75 102.116 139.674 175.313 185.795 73.197 46.126 156.89 72.95 243.259 77.972 86.374 5.018 172.605-11.935 250.655-49.27 17.080-8.172 26.732-26.624 23.706-45.312-3.031-18.693-18.017-33.152-36.803-35.512-92.836-11.658-178.217-56.806-240.113-126.971-61.901-70.159-96.051-160.507-96.041-254.070v-0.009c-0.010-93.562 34.14-183.91 96.041-254.072 61.896-70.162 147.277-115.313 240.113-126.971 18.785-2.359 33.772-16.818 36.803-35.509 3.026-18.691-6.625-37.143-23.706-45.314-78.049-37.336-164.28-54.286-250.655-49.267zM431.915 512.005c-0.009 114.35 41.731 224.773 117.379 310.523 42.025 47.636 92.908 85.837 149.284 112.829-25.702 3.22-51.732 4.106-77.783 2.591-71.977-4.183-141.72-26.537-202.717-64.973-60.997-38.441-111.259-91.704-146.094-154.829s-53.104-134.047-53.104-206.147c0-72.098 18.27-143.020 53.104-206.145s85.096-116.392 146.094-154.83c60.998-38.437 130.74-60.791 202.717-64.974 26.051-1.513 52.081-0.629 77.783 2.59-56.376 26.993-107.259 65.194-149.284 112.829-75.648 85.752-117.388 196.173-117.379 310.525z"
      ],
      "tags": [
        "weather-moon-crescent--weather"
      ],
      "defaultCode": 59928,
      "grid": 0
    },
    {
      "paths": [
        "M592.087 511.996c0.005-114.352-41.733-224.773-117.383-310.525-42.023-47.634-92.903-85.836-149.281-112.829zM592.087 512.005c0.005 114.35-41.733 224.773-117.383 310.523-42.023 47.636-92.903 85.837-149.281 112.829 25.701 3.22 51.734 4.106 77.783 2.591 71.976-4.183 141.721-26.537 202.716-64.973 61-38.441 111.263-91.704 146.094-154.829 34.836-63.124 53.105-134.047 53.105-206.147 0-72.098-18.268-143.020-53.105-206.145-34.831-63.124-85.094-116.392-146.094-154.83-60.995-38.437-130.739-60.791-202.716-64.974-26.049-1.513-52.082-0.629-77.783 2.59zM157.502 50.13c78.046-37.336 164.282-54.286 250.654-49.267s170.061 31.843 243.261 77.968c73.196 46.125 133.509 110.047 175.309 185.796 41.805 75.749 63.729 160.856 63.729 247.373s-21.924 171.622-63.729 247.373c-41.8 75.75-102.113 139.674-175.309 185.795-73.201 46.126-156.89 72.95-243.261 77.972-86.372 5.018-172.607-11.935-250.654-49.27-17.081-8.172-26.734-26.624-23.705-45.312 3.029-18.693 18.014-33.152 36.801-35.512 92.834-11.658 178.217-56.806 240.114-126.971 61.897-70.159 96.048-160.507 96.039-254.070v-0.009c0.009-93.562-34.142-183.91-96.039-254.072s-147.28-115.313-240.114-126.971c-18.787-2.359-33.772-16.818-36.801-35.509s6.624-37.143 23.705-45.314z"
      ],
      "tags": [
        "weather-moon-crescent-1--weather"
      ],
      "defaultCode": 59929,
      "grid": 0
    },
    {
      "paths": [
        "M512 341.334c-94.257 0-170.666 76.41-170.666 170.666 0 94.254 76.41 170.665 170.666 170.665 94.254 0 170.665-76.411 170.665-170.665 0-94.257-76.411-170.666-170.665-170.666zM256 512c0-141.385 114.615-256 256-256 141.384 0 256 114.615 256 256 0 141.384-114.616 256-256 256-141.385 0-256-114.616-256-256z",
        "M554.665 0v170.666h-85.331v-170.666h85.331zM904.197 180.143l-120.663 120.662-60.339-60.34 120.663-120.662 60.339 60.34zM180.143 119.803l120.662 120.662-60.34 60.34-120.662-120.662 60.34-60.34zM0 469.334h170.666v85.331h-170.666v-85.331zM1024 554.665h-170.665v-85.331h170.665v85.331zM119.803 843.858l120.662-120.663 60.34 60.339-120.662 120.663-60.34-60.339zM843.858 904.197l-120.663-120.663 60.339-60.339 120.663 120.663-60.339 60.339zM469.334 1024v-170.665h85.331v170.665h-85.331z"
      ],
      "tags": [
        "weather-sun--weather"
      ],
      "defaultCode": 59930,
      "grid": 0
    },
    {
      "paths": [
        "M624.471 405.334c-121.027 0-219.138 98.11-219.138 219.138 0 121.021 98.11 219.136 219.138 219.136 121.021 0 219.136-98.115 219.136-219.136 0-121.027-98.115-219.138-219.136-219.138zM320 624.471c0-168.156 136.315-304.471 304.471-304.471 168.151 0 304.466 136.315 304.466 304.471 0 168.151-136.315 304.466-304.466 304.466-168.156 0-304.471-136.315-304.471-304.466z",
        "M667.136 667.136v102.784h-85.335v-102.784h-102.782v-85.335h102.782v-102.782h85.335v102.782h102.784v85.335h-102.784zM972.498 1032.837l-193.070-193.065 60.344-60.344 193.065 193.070-60.339 60.339z",
        "M192.001 874.665h85.333v85.335h-85.333v-85.335zM21.334 916.864c0 11.438 4.545 22.41 12.634 30.5s19.062 12.636 30.502 12.636h42.198v-85.335h-85.333v42.199zM21.334 362.666h85.333v85.334h-85.333v-85.334zM21.334 533.335h85.333v85.33h-85.333v-85.33zM21.334 704h85.333v85.335h-85.333v-85.335zM21.334 191.999h85.333v85.334h-85.333v-85.334zM21.334 63.018v43.648h85.333v-85.333h-43.648c-5.476-0.006-10.899 1.069-15.959 3.162s-9.658 5.163-13.53 9.035c-3.872 3.872-6.942 8.47-9.035 13.53s-3.167 10.483-3.162 15.959v0zM960 63.018c0.005-5.476-1.070-10.899-3.159-15.959-2.094-5.060-5.166-9.658-9.037-13.53s-8.468-6.942-13.532-9.035c-5.059-2.093-10.481-3.167-15.959-3.162h-43.648v85.333h85.335v-43.648zM192.001 21.333h85.333v85.333h-85.333v-85.333zM362.667 21.333h85.334v85.333h-85.334v-85.333zM533.335 21.333h85.33v85.333h-85.33v-85.333zM704 21.333h85.335v85.333h-85.335v-85.333zM874.665 191.999h85.335v85.334h-85.335v-85.334z"
      ],
      "tags": [
        "zoom-in-page-selection--interface-essential"
      ],
      "defaultCode": 59931,
      "grid": 0
    },
    {
      "paths": [
        "M85.333 341.333H768V426.667H853.333V85.333C853.333 62.701 844.746 40.997 828.339 25.003C811.939 9.010 791.030 0 768 0L85.333 0C62.701 0 40.997 9.010 25.003 25.003C9.010 40.997 0 62.701 0 85.333L0 597.333C0 619.965 9.010 641.670 25.003 657.663C40.997 673.677 62.701 682.667 85.333 682.667H290.133V597.333H85.333V341.333ZM768 85.333V213.333H85.333V85.333H768Z",
        "M760.589 487.481C702.397 487.481 645.798 510.757 605.166 551.391C594.432 562.125 585.227 574.178 576.831 585.757C562.201 582.410 546.760 580.860 531.787 580.860C428.451 580.860 348.652 661.659 348.652 764.997C348.652 868.528 428.451 949.130 531.787 949.130H765.232C890.717 949.130 990.259 833.187 990.259 716.902C990.259 591.024 890.717 487.481 765.232 487.481C765.018 487.481 764.803 487.454 764.589 487.481ZM639.380 648.423C662.106 605.374 710.618 572.814 764.832 572.814C840.387 572.814 909.728 637.752 909.728 716.902C909.728 796.058 840.387 861.198 764.832 861.198H531.787C475.580 861.198 434.386 819.405 434.386 763.997C434.386 707.989 475.580 666.195 531.787 666.195C535.564 666.195 539.255 666.358 542.815 666.758C541.398 679.136 540.454 694.336 540.454 708.416H639.380C639.380 682.432 655.460 664.288 675.380 648.423Z"
      ],
      "tags": [
        "credit-card-virtual"
      ],
      "grid": 0
    },
    {
      "paths": [
        "M277.334 917.335h-170.666c-22.632 0-44.337-8.991-60.34-24.996s-24.994-37.709-24.994-60.339v-725.334c0-22.631 8.99-44.337 24.994-60.34s37.708-24.994 60.34-24.994h725.333c22.63 0 44.339 8.99 60.339 24.994 16.005 16.003 24.996 37.708 24.996 60.34v170.667h-85.335v-170.667h-725.333v725.334h170.666v85.335z",
        "M624.471 405.334c-121.027 0-219.138 98.11-219.138 219.138 0 121.021 98.11 219.136 219.138 219.136 121.021 0 219.136-98.115 219.136-219.136 0-121.027-98.115-219.138-219.136-219.138zM320 624.471c0-168.156 136.315-304.471 304.471-304.471 168.151 0 304.466 136.315 304.466 304.471 0 168.151-136.315 304.466-304.466 304.466-168.156 0-304.471-136.315-304.471-304.466z",
        "M479.018 581.801h290.902v85.335h-290.902v-85.335zM972.498 1032.837l-193.070-193.070 60.344-60.339 193.065 193.070-60.339 60.339z"
      ],
      "tags": [
        "zoom-out-page--interface-essential"
      ],
      "defaultCode": 59932,
      "grid": 0
    }
  ],
  "colorThemes": [
    [
      [
        0,
        0,
        0,
        1
      ],
      [
        84,
        85,
        88,
        1
      ],
      [
        176,
        178,
        181,
        1
      ],
      [
        211,
        211,
        211,
        1
      ],
      [
        255,
        255,
        255,
        1
      ]
    ]
  ],
  "colorThemeIdx": 0,
  "preferences": {
    "showGlyphs": true,
    "showQuickUse": true,
    "showQuickUse2": true,
    "showSVGs": true,
    "fontPref": {
      "prefix": "icon-",
      "metadata": {
        "fontFamily": "icomoon"
      },
      "metrics": {
        "emSize": 1024,
        "baseline": 6.25,
        "whitespace": 50
      },
      "embed": false
    },
    "imagePref": {
      "prefix": "icon-",
      "png": true,
      "useClassSelector": true,
      "color": 0,
      "bgColor": 16777215,
      "classSelector": ".icon"
    },
    "historySize": 50,
    "showCodes": true,
    "gridSize": 16
  },
  "IcoMoonType": "icon-set"
}